// src/index.ts
import JSBI17 from "jsbi";

// src/constants.ts
import JSBI from "jsbi";
var ChainId = /* @__PURE__ */ ((ChainId2) => {
  ChainId2[ChainId2["ETH_MAINNET"] = 1] = "ETH_MAINNET";
  ChainId2[ChainId2["ETH_RINKEBY"] = 4] = "ETH_RINKEBY";
  ChainId2[ChainId2["ETH_GOERLI"] = 5] = "ETH_GOERLI";
  ChainId2[ChainId2["ETH_KOVAN"] = 42] = "ETH_KOVAN";
  ChainId2[ChainId2["BSC_MAINNET"] = 56] = "BSC_MAINNET";
  ChainId2[ChainId2["BSC_TESTNET"] = 97] = "BSC_TESTNET";
  ChainId2[ChainId2["MATIC_MAINNET"] = 137] = "MATIC_MAINNET";
  ChainId2[ChainId2["MATIC_MUMBAI"] = 80001] = "MATIC_MUMBAI";
  ChainId2[ChainId2["AVAX_MAINNET"] = 43114] = "AVAX_MAINNET";
  ChainId2[ChainId2["AVAX_TESTNET"] = 43113] = "AVAX_TESTNET";
  ChainId2[ChainId2["HECO_MAINNET"] = 128] = "HECO_MAINNET";
  ChainId2[ChainId2["HECO_TESTNET"] = 256] = "HECO_TESTNET";
  ChainId2[ChainId2["OKEX_MAINNET"] = 66] = "OKEX_MAINNET";
  ChainId2[ChainId2["OKEX_TESTNET"] = 65] = "OKEX_TESTNET";
  ChainId2[ChainId2["BOBA_MAINNET"] = 288] = "BOBA_MAINNET";
  ChainId2[ChainId2["BOBA_BNB"] = 56288] = "BOBA_BNB";
  ChainId2[ChainId2["BOBA_AVALANCHE"] = 43288] = "BOBA_AVALANCHE";
  ChainId2[ChainId2["BOBA_RINKEBY"] = 28] = "BOBA_RINKEBY";
  ChainId2[ChainId2["MILKOMEDA_MAINNET"] = 2001] = "MILKOMEDA_MAINNET";
  ChainId2[ChainId2["MILKOMEDA_DEVNET"] = 200101] = "MILKOMEDA_DEVNET";
  ChainId2[ChainId2["BTC_MAINNET"] = 5555] = "BTC_MAINNET";
  ChainId2[ChainId2["BTC_TESTNET"] = 55555] = "BTC_TESTNET";
  ChainId2[ChainId2["AURORA_MAINNET"] = 1313161554] = "AURORA_MAINNET";
  ChainId2[ChainId2["AURORA_TESTNET"] = 1313161555] = "AURORA_TESTNET";
  ChainId2[ChainId2["TELOS_MAINNET"] = 40] = "TELOS_MAINNET";
  ChainId2[ChainId2["TELOS_TESTNET"] = 41] = "TELOS_TESTNET";
  ChainId2[ChainId2["SHARDEUM_TESTNET_2"] = 8081] = "SHARDEUM_TESTNET_2";
  ChainId2[ChainId2["KAVA_MAINNET"] = 2222] = "KAVA_MAINNET";
  ChainId2[ChainId2["SCROLL_TESTNET"] = 534353] = "SCROLL_TESTNET";
  ChainId2[ChainId2["SCROLL_SEPOLIA"] = 534351] = "SCROLL_SEPOLIA";
  ChainId2[ChainId2["ZKSYNC_MAINNET"] = 324] = "ZKSYNC_MAINNET";
  ChainId2[ChainId2["ARBITRUM_MAINNET"] = 42161] = "ARBITRUM_MAINNET";
  ChainId2[ChainId2["ARBITRUM_NOVA"] = 42170] = "ARBITRUM_NOVA";
  ChainId2[ChainId2["OPTIMISM_MAINNET"] = 10] = "OPTIMISM_MAINNET";
  ChainId2[ChainId2["ZETACHAIN_ATHENS_2"] = 7001] = "ZETACHAIN_ATHENS_2";
  ChainId2[ChainId2["POLYGON_ZK"] = 1101] = "POLYGON_ZK";
  ChainId2[ChainId2["TRON_MAINNET"] = 728126428] = "TRON_MAINNET";
  ChainId2[ChainId2["TRON_TESTNET"] = 2494104990] = "TRON_TESTNET";
  ChainId2[ChainId2["LINEA_TESTNET"] = 59140] = "LINEA_TESTNET";
  ChainId2[ChainId2["LINEA_MAINNET"] = 59144] = "LINEA_MAINNET";
  ChainId2[ChainId2["MANTLE_MAINNET"] = 5e3] = "MANTLE_MAINNET";
  ChainId2[ChainId2["MANTLE_TESTNET"] = 5001] = "MANTLE_TESTNET";
  ChainId2[ChainId2["BASE_MAINNET"] = 8453] = "BASE_MAINNET";
  ChainId2[ChainId2["SCROLL_MAINNET"] = 534352] = "SCROLL_MAINNET";
  return ChainId2;
})(ChainId || {});
var TradeType = /* @__PURE__ */ ((TradeType2) => {
  TradeType2[TradeType2["EXACT_INPUT"] = 0] = "EXACT_INPUT";
  TradeType2[TradeType2["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
  return TradeType2;
})(TradeType || {});
var Rounding = /* @__PURE__ */ ((Rounding4) => {
  Rounding4[Rounding4["ROUND_DOWN"] = 0] = "ROUND_DOWN";
  Rounding4[Rounding4["ROUND_HALF_UP"] = 1] = "ROUND_HALF_UP";
  Rounding4[Rounding4["ROUND_UP"] = 2] = "ROUND_UP";
  return Rounding4;
})(Rounding || {});
var FACTORY_ADDRESS = {
  [1 /* ETH_MAINNET */]: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  [4 /* ETH_RINKEBY */]: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  [5 /* ETH_GOERLI */]: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  [42 /* ETH_KOVAN */]: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  [56 /* BSC_MAINNET */]: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
  [97 /* BSC_TESTNET */]: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
  [137 /* MATIC_MAINNET */]: "0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32",
  [80001 /* MATIC_MUMBAI */]: "0x8a628F00710993c1cebbaa02338d2264ee7056C6",
  [43114 /* AVAX_MAINNET */]: "0xefa94DE7a4656D787667C749f7E1223D71E9FD88",
  [43113 /* AVAX_TESTNET */]: "0xb278D63e2E2a4aeb5A398eB87a91FF909B72C8D5",
  [128 /* HECO_MAINNET */]: "0x0000000000000000000000000000000000000000",
  // TODO
  [256 /* HECO_TESTNET */]: "0xca33f6D096BDD7FcB28d708f631cD76E73Ecfc2d",
  [66 /* OKEX_MAINNET */]: "0x0000000000000000000000000000000000000000",
  // TODO
  [65 /* OKEX_TESTNET */]: "0xD68B1DCDe3bAeB3FF1483Ad33c3efC6B6e0A8E4C",
  [288 /* BOBA_MAINNET */]: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
  [43288 /* BOBA_AVALANCHE */]: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
  [56288 /* BOBA_BNB */]: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
  [28 /* BOBA_RINKEBY */]: "0xab740666e226cb5b6b451eb943b0257a7cb3ce0a",
  [2001 /* MILKOMEDA_MAINNET */]: "0x2ef06A90b0E7Ae3ae508e83Ea6628a3987945460",
  [200101 /* MILKOMEDA_DEVNET */]: "0x428779a1a596c9cfdb68f5daef78b14901b95566",
  [5555 /* BTC_MAINNET */]: "0x0000000000000000000000000000000000000000",
  // TODO
  [55555 /* BTC_TESTNET */]: "0x0000000000000000000000000000000000000000",
  // TODO
  [1313161554 /* AURORA_MAINNET */]: "0xc66F594268041dB60507F00703b152492fb176E7",
  [1313161555 /* AURORA_TESTNET */]: "0x60913758635b54e6C9685f92201A5704eEe74748",
  [40 /* TELOS_MAINNET */]: "0xb630f53df13645bff0ef55eb44a8a490a7dd4514",
  [41 /* TELOS_TESTNET */]: "0x6db1D2C691DcdF4DA36d3497F68a63C7282a4a44",
  [8081 /* SHARDEUM_TESTNET_2 */]: "0x1DAcbaB28Decd115c8AA6F183877C71b942aE406",
  [2222 /* KAVA_MAINNET */]: "0xA138FAFc30f6Ec6980aAd22656F2F11C38B56a95",
  [534353 /* SCROLL_TESTNET */]: "0xF3Cfa393be621097669BcD2bD4923CEC347E1210",
  [534351 /* SCROLL_SEPOLIA */]: "0x0000000000000000000000000000000000000000",
  // TODO
  [324 /* ZKSYNC_MAINNET */]: "0x40be1cba6c5b47cdf9da7f963b6f761f4c60627d",
  [42161 /* ARBITRUM_MAINNET */]: "0xd394e9cc20f43d2651293756f8d320668e850f1b",
  // arbSwap
  [42170 /* ARBITRUM_NOVA */]: "0xf6239423fcf1c19ed2791d9648a90836074242fd",
  // arbSwap
  [10 /* OPTIMISM_MAINNET */]: "0x0000000000000000000000000000000000000000",
  // TODO
  [7001 /* ZETACHAIN_ATHENS_2 */]: "0x9fd96203f7b22bCF72d9DCb40ff98302376cE09c",
  [1101 /* POLYGON_ZK */]: "0x0000000000000000000000000000000000000000",
  // TODO
  [728126428 /* TRON_MAINNET */]: "0x689ABAEEED3F0BB3585773192E23224CAC25DD41",
  // sunswap.io - TKWJdrQkqHisa1X8HUdHEfREvTzw4pMAaY
  [2494104990 /* TRON_TESTNET */]: "0x1df14d5e036019f298d2a358bb234cf301e5e8e3",
  // sunswap.io - TChXfbQLafcoExbcXTtwNZMBKdeW2p1V5G
  [59140 /* LINEA_TESTNET */]: "0xe87BE5A98c65D8F81Ff6ab7dd11E9C3c12C35692",
  // echodex
  [59144 /* LINEA_MAINNET */]: "0x6D1063F2187442Cc9adbFAD2f55A96B846FCB399",
  // echodex
  [5e3 /* MANTLE_MAINNET */]: "0xE5020961fA51ffd3662CDf307dEf18F9a87Cce7c",
  // fusionX
  [5001 /* MANTLE_TESTNET */]: "0x272465431A6b86E3B9E5b9bD33f5D103a3F59eDb",
  // fusionX
  [8453 /* BASE_MAINNET */]: "0xFDa619b6d20975be80A10332cD39b9a4b0FAa8BB",
  // baseSwap
  [534352 /* SCROLL_MAINNET */]: "0x0000000000000000000000000000000000000000"
  // TODO
};
var INIT_CODE_HASH = {
  [1 /* ETH_MAINNET */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [4 /* ETH_RINKEBY */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [5 /* ETH_GOERLI */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [42 /* ETH_KOVAN */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [56 /* BSC_MAINNET */]: "0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5",
  [97 /* BSC_TESTNET */]: "0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66",
  [137 /* MATIC_MAINNET */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [80001 /* MATIC_MUMBAI */]: "0x85f8ad645fe62917d6939782650649d3d7c4b5f25d81415a9fac4a9f341793ca",
  [43114 /* AVAX_MAINNET */]: "0x40231f6b438bce0797c9ada29b718a87ea0a5cea3fe9a771abdd76bd41a3e545",
  [43113 /* AVAX_TESTNET */]: "0x85f8ad645fe62917d6939782650649d3d7c4b5f25d81415a9fac4a9f341793ca",
  [128 /* HECO_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  // TODO
  [256 /* HECO_TESTNET */]: "0x85f8ad645fe62917d6939782650649d3d7c4b5f25d81415a9fac4a9f341793ca",
  [66 /* OKEX_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  // TODO
  [65 /* OKEX_TESTNET */]: "0x7f08f1b43a5b37be17b2d24d4f2c6b1311e19eedc53cc4528f0e72cdfb5d8d37",
  [288 /* BOBA_MAINNET */]: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
  [43288 /* BOBA_AVALANCHE */]: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
  [56288 /* BOBA_BNB */]: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
  [28 /* BOBA_RINKEBY */]: "0x1db9efb13a1398e31bb71895c392fa1217130f78dc65080174491adcec5da9b9",
  [2001 /* MILKOMEDA_MAINNET */]: "0x0103d86123641edae209ed992b2bf060ae2baab6a28f5b1eb7dad61335915104",
  [200101 /* MILKOMEDA_DEVNET */]: "0x0103d86123641edae209ed992b2bf060ae2baab6a28f5b1eb7dad61335915104",
  [5555 /* BTC_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  // TODO
  [55555 /* BTC_TESTNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  // TODO
  [1313161554 /* AURORA_MAINNET */]: "0x754e1d90e536e4c1df81b7f030f47b4ca80c87120e145c294f098c83a6cb5ace",
  [1313161555 /* AURORA_TESTNET */]: "0x4a697f690d1f46e0f1a897a8662acae31ced3039b00c052392ed0bc179f9f28c",
  [40 /* TELOS_MAINNET */]: "0x73d5f9d3e0db97ca102c315a9a45dfebef394eae36edcce8853bcb1ee049a6dd",
  [41 /* TELOS_TESTNET */]: "0x4386561b28c0ca71b777ab3684458dd9f6c1b3b7fc609c5758f0f00a48625996",
  [8081 /* SHARDEUM_TESTNET_2 */]: "0x3bde95ed3dcb15c415ca128950d4807b9e3698b981ff73007c9d3c220a5b2f6f",
  [2222 /* KAVA_MAINNET */]: "0x851a56ac1b3682251d8341ad09c09bf45fca37af4451453063637d745a94fe1f",
  [534353 /* SCROLL_TESTNET */]: "0x4386561b28c0ca71b777ab3684458dd9f6c1b3b7fc609c5758f0f00a48625996",
  [534351 /* SCROLL_SEPOLIA */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  // TODO
  [324 /* ZKSYNC_MAINNET */]: "0x95d5c05820d58f1c8cc736b47fe10a29ddcd2cf73a0d842e8537b9fe510fc618",
  [42161 /* ARBITRUM_MAINNET */]: "0x8336ef61546f16041265cbd61fb71f00434b515a1f3dba059227802ec4a4be4f",
  // arbSwap
  [42170 /* ARBITRUM_NOVA */]: "0x70b19cf85a176c6b86e2d324be179104bdc8fafee13d548ae07d28b9f53cbc71",
  // arbSwap
  [10 /* OPTIMISM_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  // TODO
  [7001 /* ZETACHAIN_ATHENS_2 */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [1101 /* POLYGON_ZK */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  // TODO
  [59140 /* LINEA_TESTNET */]: "0x60431495276ec4b11356f2c6dd08f5f6c5b673a20a2847bbbd80fa3942100e4b",
  // echodex
  [59144 /* LINEA_MAINNET */]: "0x0b8162ee38463c04a0629406af3b667364e4487dca66c5c7485a4a5e997811ea",
  // echodex
  [5e3 /* MANTLE_MAINNET */]: "0x58c684aeb03fe49c8a3080db88e425fae262c5ef5bf0e8acffc0526c6e3c03a0",
  // fusionX
  [5001 /* MANTLE_TESTNET */]: "0x58c684aeb03fe49c8a3080db88e425fae262c5ef5bf0e8acffc0526c6e3c03a0",
  // fusionX
  [8453 /* BASE_MAINNET */]: "0xb618a2730fae167f5f8ac7bd659dd8436d571872655bcb6fd11f2158c8a64a3b",
  // baseSwap
  [728126428 /* TRON_MAINNET */]: "0x6d3f89421f83e4b62e628de8fc7ff2b014a79bf8fd8e8b0ea46e4a1d9409b67d",
  // sunswap.io
  [2494104990 /* TRON_TESTNET */]: "0x0e26acb4c8f8d3df2264904ab1e00efdc142a9f341741ca7e0a7ae5f9b0c0fa9",
  // sunswap.io
  [534352 /* SCROLL_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000"
  // TODO
};
var MINIMUM_LIQUIDITY = JSBI.BigInt(1e3);
var ZERO = JSBI.BigInt(0);
var ONE = JSBI.BigInt(1);
var TWO = JSBI.BigInt(2);
var THREE = JSBI.BigInt(3);
var FIVE = JSBI.BigInt(5);
var TEN = JSBI.BigInt(10);
var _100 = JSBI.BigInt(100);
var _998 = JSBI.BigInt(998);
var _1000 = JSBI.BigInt(1e3);
var SOLIDITY_TYPE_MAXIMA = {
  ["uint8" /* uint8 */]: JSBI.BigInt("0xff"),
  ["uint256" /* uint256 */]: JSBI.BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")
};

// src/errors.ts
var CAN_SET_PROTOTYPE = "setPrototypeOf" in Object;
var InsufficientReservesError = class extends Error {
  constructor() {
    super();
    this.isInsufficientReservesError = true;
    this.name = this.constructor.name;
    if (CAN_SET_PROTOTYPE)
      Object.setPrototypeOf(this, new.target.prototype);
  }
};
var InsufficientInputAmountError = class extends Error {
  constructor() {
    super();
    this.isInsufficientInputAmountError = true;
    this.name = this.constructor.name;
    if (CAN_SET_PROTOTYPE)
      Object.setPrototypeOf(this, new.target.prototype);
  }
};

// src/entities/chain.ts
var Chain = class {
  constructor(params) {
    this.id = params.id;
    this.name = params.name;
    this.disabled = params.disabled;
    this.explorer = params.explorer;
    this.icons = params.icons;
    this.swappable = params?.swappable !== false;
    this.evm = params?.evm !== false;
  }
};
var chains = [
  new Chain({
    id: 5555 /* BTC_MAINNET */,
    name: "Bitcoin",
    disabled: false,
    explorer: "https://www.blockchain.com/btc",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
    },
    evm: false
  }),
  new Chain({
    id: 55555 /* BTC_TESTNET */,
    name: "Bitcoin",
    disabled: false,
    explorer: "https://www.blockchain.com/btc-testnet",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
    },
    evm: false
  }),
  new Chain({
    id: 1 /* ETH_MAINNET */,
    name: "Ethereum",
    disabled: false,
    explorer: "https://etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 4 /* ETH_RINKEBY */,
    name: "Rinkeby",
    disabled: false,
    explorer: "https://rinkeby.etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 5 /* ETH_GOERLI */,
    name: "Goerli",
    disabled: false,
    explorer: "https://goerli.etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 42 /* ETH_KOVAN */,
    name: "Kovan",
    disabled: false,
    explorer: "https://kovan.etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 56 /* BSC_MAINNET */,
    name: "BNB",
    disabled: false,
    explorer: "https://bscscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png"
    }
  }),
  new Chain({
    id: 97 /* BSC_TESTNET */,
    name: "BNB",
    disabled: false,
    explorer: "https://testnet.bscscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png"
    }
  }),
  new Chain({
    id: 137 /* MATIC_MAINNET */,
    name: "Polygon",
    disabled: false,
    explorer: "https://polygonscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  new Chain({
    id: 80001 /* MATIC_MUMBAI */,
    name: "Mumbai",
    // Polygon Testnet
    disabled: false,
    explorer: "https://mumbai.polygonscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  new Chain({
    id: 43114 /* AVAX_MAINNET */,
    name: "Avalanche",
    disabled: false,
    explorer: "https://snowtrace.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png"
    }
  }),
  new Chain({
    id: 43113 /* AVAX_TESTNET */,
    name: "Fuji",
    disabled: false,
    explorer: "https://testnet.snowtrace.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png"
    }
  }),
  new Chain({
    id: 128 /* HECO_MAINNET */,
    name: "HECO",
    disabled: false,
    explorer: "https://hecoinfo.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png"
    }
  }),
  new Chain({
    id: 256 /* HECO_TESTNET */,
    name: "HECO",
    disabled: false,
    explorer: "https://testnet.hecoinfo.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png"
    }
  }),
  new Chain({
    id: 66 /* OKEX_MAINNET */,
    name: "OEC",
    disabled: false,
    explorer: "https://www.oklink.com/oec",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png",
      large: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png"
    }
  }),
  new Chain({
    id: 65 /* OKEX_TESTNET */,
    name: "OEC",
    disabled: false,
    explorer: "https://www.oklink.com/oec-test",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png",
      large: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png"
    }
  }),
  new Chain({
    id: 288 /* BOBA_MAINNET */,
    name: "Boba Ethereum",
    disabled: false,
    explorer: "https://blockexplorer.boba.network",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png"
    }
  }),
  new Chain({
    id: 28 /* BOBA_RINKEBY */,
    name: "Boba Rinkeby",
    disabled: false,
    explorer: "https://blockexplorer.rinkeby.boba.network",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png"
    }
  }),
  new Chain({
    id: 43288 /* BOBA_AVALANCHE */,
    name: "Boba Avalanche",
    disabled: false,
    explorer: "https://blockexplorer.avax.boba.network",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-avalanche/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-avalanche/logo.png"
    }
  }),
  new Chain({
    id: 56288 /* BOBA_BNB */,
    name: "Boba BNB",
    disabled: false,
    explorer: "https://blockexplorer.bnb.boba.network",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-bnb/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-bnb/logo.png"
    }
  }),
  new Chain({
    id: 2001 /* MILKOMEDA_MAINNET */,
    name: "Milkomeda",
    disabled: false,
    explorer: "https://explorer-mainnet-cardano-evm.c1.milkomeda.com",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png"
    }
  }),
  new Chain({
    id: 200101 /* MILKOMEDA_DEVNET */,
    name: "Milkomeda",
    disabled: false,
    explorer: "https://explorer-devnet-cardano-evm.c1.milkomeda.com",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png"
    }
  }),
  new Chain({
    id: 1313161554 /* AURORA_MAINNET */,
    name: "Aurora",
    disabled: false,
    explorer: "https://aurorascan.dev",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png"
    }
  }),
  new Chain({
    id: 1313161555 /* AURORA_TESTNET */,
    name: "Aurora",
    disabled: false,
    explorer: "https://testnet.aurorascan.dev",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png"
    }
  }),
  new Chain({
    id: 40 /* TELOS_MAINNET */,
    name: "Telos",
    disabled: false,
    explorer: "https://teloscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png"
    }
  }),
  new Chain({
    id: 41 /* TELOS_TESTNET */,
    name: "Telos",
    disabled: false,
    explorer: "https://testnet.teloscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png"
    }
  }),
  new Chain({
    id: 8081 /* SHARDEUM_TESTNET_2 */,
    name: "Shardeum Liberty 2.X",
    disabled: false,
    explorer: "https://explorer-liberty20.shardeum.org",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png"
    }
  }),
  new Chain({
    id: 2222 /* KAVA_MAINNET */,
    name: "KAVA EVM",
    disabled: false,
    explorer: "https://explorer.kava.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png"
    }
  }),
  new Chain({
    id: 534353 /* SCROLL_TESTNET */,
    name: "Scroll Alpha",
    disabled: false,
    explorer: "https://blockscout.scroll.io",
    icons: {
      small: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png",
      large: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png"
    }
  }),
  new Chain({
    id: 534351 /* SCROLL_SEPOLIA */,
    name: "Scroll Sepolia",
    disabled: false,
    explorer: "https://sepolia-blockscout.scroll.io",
    icons: {
      small: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png",
      large: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png"
    }
  }),
  new Chain({
    id: 324 /* ZKSYNC_MAINNET */,
    name: "ZkSync Era",
    disabled: false,
    explorer: "https://explorer.zksync.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/24091.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/24091.png"
    }
  }),
  new Chain({
    id: 42161 /* ARBITRUM_MAINNET */,
    name: "Arbitrum One",
    disabled: false,
    explorer: "https://arbiscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11841.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11841.png"
    }
  }),
  new Chain({
    id: 42170 /* ARBITRUM_NOVA */,
    name: "Arbitrum Nova",
    disabled: false,
    explorer: "https://nova.arbiscan.io",
    icons: {
      small: "https://l2beat.com/icons/nova.png",
      large: "https://l2beat.com/icons/nova.png"
    }
  }),
  new Chain({
    id: 10 /* OPTIMISM_MAINNET */,
    name: "Optimism",
    disabled: false,
    explorer: "https://optimistic.etherscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png"
    }
  }),
  new Chain({
    id: 7001 /* ZETACHAIN_ATHENS_2 */,
    name: "ZetaChain",
    disabled: false,
    explorer: "https://explorer.zetachain.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png"
    }
  }),
  new Chain({
    id: 1101 /* POLYGON_ZK */,
    name: "Polygon zkEVM",
    disabled: false,
    explorer: "https://zkevm.polygonscan.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png"
    }
  }),
  new Chain({
    id: 728126428 /* TRON_MAINNET */,
    name: "Tron",
    disabled: false,
    explorer: "https://tronscan.org",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    },
    evm: false
  }),
  new Chain({
    id: 2494104990 /* TRON_TESTNET */,
    name: "Tron Testnet",
    disabled: false,
    explorer: "https://shasta.tronscan.org",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    },
    evm: false
  }),
  new Chain({
    id: 59140 /* LINEA_TESTNET */,
    name: "Linea",
    disabled: false,
    explorer: "https://goerli.lineascan.build",
    icons: {
      small: "https://l2beat.com/icons/linea.png",
      large: "https://l2beat.com/icons/linea.png"
    }
  }),
  new Chain({
    id: 59144 /* LINEA_MAINNET */,
    name: "Linea",
    disabled: false,
    explorer: "https://lineascan.build",
    icons: {
      small: "https://l2beat.com/icons/linea.png",
      large: "https://l2beat.com/icons/linea.png"
    }
  }),
  new Chain({
    id: 5e3 /* MANTLE_MAINNET */,
    name: "Mantle",
    disabled: false,
    explorer: "https://explorer.mantle.xyz",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  new Chain({
    id: 5001 /* MANTLE_TESTNET */,
    name: "Mantle",
    disabled: false,
    explorer: "https://explorer.testnet.mantle.xyz",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  new Chain({
    id: 8453 /* BASE_MAINNET */,
    name: "Base",
    disabled: false,
    explorer: "https://basescan.org",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/base/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/base/logo.png"
    }
  }),
  new Chain({
    id: 534352 /* SCROLL_MAINNET */,
    name: "Scroll",
    disabled: false,
    explorer: "https://scroll.l2scan.co",
    icons: {
      small: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png",
      large: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png"
    }
  })
];
var getChainById = (chainId) => {
  if (!chainId)
    return void 0;
  return chains.find((chain) => chain.id === chainId);
};

// src/entities/fractions/fraction.ts
import invariant2 from "tiny-invariant";
import JSBI3 from "jsbi";
import _Decimal from "decimal.js-light";
import _Big from "big.js";
import toFormat from "toformat";

// src/utils.ts
import invariant from "tiny-invariant";
import JSBI2 from "jsbi";
import { getAddress } from "@ethersproject/address";
function validateSolidityTypeInstance(value, solidityType) {
  invariant(JSBI2.greaterThanOrEqual(value, ZERO), `${value} is not a ${solidityType}.`);
  invariant(JSBI2.lessThanOrEqual(value, SOLIDITY_TYPE_MAXIMA[solidityType]), `${value} is not a ${solidityType}.`);
}
function validateAndParseAddress(address) {
  if (address === "") {
    return address;
  }
  try {
    return getAddress(address);
  } catch (error) {
    invariant(false, `${address} is not a valid address.`);
  }
}
function parseBigintIsh(bigintIsh) {
  return bigintIsh instanceof JSBI2 ? bigintIsh : typeof bigintIsh === "bigint" ? JSBI2.BigInt(bigintIsh.toString()) : JSBI2.BigInt(bigintIsh);
}
function sqrt(y) {
  validateSolidityTypeInstance(y, "uint256" /* uint256 */);
  let z = ZERO;
  let x;
  if (JSBI2.greaterThan(y, THREE)) {
    z = y;
    x = JSBI2.add(JSBI2.divide(y, TWO), ONE);
    while (JSBI2.lessThan(x, z)) {
      z = x;
      x = JSBI2.divide(JSBI2.add(JSBI2.divide(y, x), x), TWO);
    }
  } else if (JSBI2.notEqual(y, ZERO)) {
    z = ONE;
  }
  return z;
}
function sortedInsert(items, add, maxSize, comparator) {
  invariant(maxSize > 0, "MAX_SIZE_ZERO");
  invariant(items.length <= maxSize, "ITEMS_SIZE");
  if (items.length === 0) {
    items.push(add);
    return null;
  } else {
    const isFull = items.length === maxSize;
    if (isFull && comparator(items[items.length - 1], add) <= 0) {
      return add;
    }
    let lo = 0, hi = items.length;
    while (lo < hi) {
      const mid = lo + hi >>> 1;
      if (comparator(items[mid], add) <= 0) {
        lo = mid + 1;
      } else {
        hi = mid;
      }
    }
    items.splice(lo, 0, add);
    return isFull ? items.pop() : null;
  }
}

// src/entities/fractions/fraction.ts
var Decimal = toFormat(_Decimal);
var Big = toFormat(_Big);
var toSignificantRounding = {
  [0 /* ROUND_DOWN */]: Decimal.ROUND_DOWN,
  [1 /* ROUND_HALF_UP */]: Decimal.ROUND_HALF_UP,
  [2 /* ROUND_UP */]: Decimal.ROUND_UP
};
var toFixedRounding = {
  [0 /* ROUND_DOWN */]: 0 /* RoundDown */,
  [1 /* ROUND_HALF_UP */]: 1 /* RoundHalfUp */,
  [2 /* ROUND_UP */]: 3 /* RoundUp */
};
var Fraction = class _Fraction {
  constructor(numerator, denominator = ONE) {
    this.numerator = parseBigintIsh(numerator);
    this.denominator = parseBigintIsh(denominator);
  }
  // performs floor division
  get quotient() {
    return JSBI3.divide(this.numerator, this.denominator);
  }
  // remainder after floor division
  get remainder() {
    return new _Fraction(JSBI3.remainder(this.numerator, this.denominator), this.denominator);
  }
  invert() {
    return new _Fraction(this.denominator, this.numerator);
  }
  add(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    if (JSBI3.equal(this.denominator, otherParsed.denominator)) {
      return new _Fraction(JSBI3.add(this.numerator, otherParsed.numerator), this.denominator);
    }
    return new _Fraction(
      JSBI3.add(
        JSBI3.multiply(this.numerator, otherParsed.denominator),
        JSBI3.multiply(otherParsed.numerator, this.denominator)
      ),
      JSBI3.multiply(this.denominator, otherParsed.denominator)
    );
  }
  subtract(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    if (JSBI3.equal(this.denominator, otherParsed.denominator)) {
      return new _Fraction(JSBI3.subtract(this.numerator, otherParsed.numerator), this.denominator);
    }
    return new _Fraction(
      JSBI3.subtract(
        JSBI3.multiply(this.numerator, otherParsed.denominator),
        JSBI3.multiply(otherParsed.numerator, this.denominator)
      ),
      JSBI3.multiply(this.denominator, otherParsed.denominator)
    );
  }
  lessThan(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return JSBI3.lessThan(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(otherParsed.numerator, this.denominator)
    );
  }
  equalTo(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return JSBI3.equal(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(otherParsed.numerator, this.denominator)
    );
  }
  greaterThan(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return JSBI3.greaterThan(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(otherParsed.numerator, this.denominator)
    );
  }
  multiply(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return new _Fraction(
      JSBI3.multiply(this.numerator, otherParsed.numerator),
      JSBI3.multiply(this.denominator, otherParsed.denominator)
    );
  }
  divide(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return new _Fraction(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(this.denominator, otherParsed.numerator)
    );
  }
  toSignificant(significantDigits, format = { groupSeparator: "" }, rounding = 1 /* ROUND_HALF_UP */) {
    invariant2(Number.isInteger(significantDigits), `${significantDigits} is not an integer.`);
    invariant2(significantDigits > 0, `${significantDigits} is not positive.`);
    Decimal.set({ precision: significantDigits + 1, rounding: toSignificantRounding[rounding] });
    const quotient = new Decimal(this.numerator.toString()).div(this.denominator.toString()).toSignificantDigits(significantDigits);
    return quotient.toFormat(quotient.decimalPlaces(), format);
  }
  toFixed(decimalPlaces, format = { groupSeparator: "" }, rounding = 1 /* ROUND_HALF_UP */) {
    invariant2(Number.isInteger(decimalPlaces), `${decimalPlaces} is not an integer.`);
    invariant2(decimalPlaces >= 0, `${decimalPlaces} is negative.`);
    Big.DP = decimalPlaces;
    Big.RM = toFixedRounding[rounding];
    return new Big(this.numerator.toString()).div(this.denominator.toString()).toFormat(decimalPlaces, format);
  }
  toExact(decimalPlaces, format = { groupSeparator: "" }) {
    Big.DP = decimalPlaces;
    return new Big(this.numerator.toString()).div(this.denominator.toString()).toFormat(format);
  }
};

// src/entities/fractions/percent.ts
var _100_PERCENT = new Fraction(_100);
var Percent = class extends Fraction {
  toSignificant(significantDigits = 5, format, rounding) {
    return this.multiply(_100_PERCENT).toSignificant(significantDigits, format, rounding);
  }
  toFixed(decimalPlaces = 2, format, rounding) {
    return this.multiply(_100_PERCENT).toFixed(decimalPlaces, format, rounding);
  }
};

// src/entities/fractions/tokenAmount.ts
import invariant3 from "tiny-invariant";
import JSBI4 from "jsbi";
var TokenAmount = class _TokenAmount extends Fraction {
  constructor(token, amount) {
    const parsedAmount = parseBigintIsh(amount);
    validateSolidityTypeInstance(parsedAmount, "uint256" /* uint256 */);
    super(parsedAmount, JSBI4.exponentiate(TEN, JSBI4.BigInt(token.decimals)));
    this.token = token;
  }
  get raw() {
    return this.numerator;
  }
  add(other) {
    invariant3(this.token.equals(other.token), "TOKEN");
    return new _TokenAmount(this.token, JSBI4.add(this.raw, other.raw));
  }
  subtract(other) {
    invariant3(this.token.equals(other.token), "TOKEN");
    return new _TokenAmount(this.token, JSBI4.subtract(this.raw, other.raw));
  }
  greaterThanOrEqual(amount) {
    return JSBI4.greaterThanOrEqual(this.raw, amount);
  }
  toSignificant(significantDigits = 6, format, rounding = 0 /* ROUND_DOWN */) {
    return super.toSignificant(significantDigits, format, rounding);
  }
  toFixed(decimalPlaces = this.token.decimals, format, rounding = 0 /* ROUND_DOWN */) {
    invariant3(decimalPlaces <= this.token.decimals, "DECIMALS");
    return super.toFixed(decimalPlaces, format, rounding);
  }
  toExact(decimalPlaces = this.token.decimals, format = { groupSeparator: "" }) {
    return super.toExact(decimalPlaces, format);
  }
};

// src/entities/token.ts
import JSBI5 from "jsbi";
import invariant4 from "tiny-invariant";

// src/crosschain/tron.ts
import { getAddress as getAddress2 } from "@ethersproject/address";
import { concat, hexDataSlice } from "@ethersproject/bytes";
import { keccak256 as kekKeccak256 } from "@ethersproject/keccak256";
import { utils } from "ethers";
import TronWeb from "tronweb";
function getFunctionSelector(abi) {
  abi.stateMutability = abi.stateMutability ? abi.stateMutability.toLowerCase() : "nonpayable";
  abi.type = abi.type ? abi.type.toLowerCase() : "";
  if (abi.type === "fallback" || abi.type === "receive")
    return "0x";
  const iface = new utils.Interface([abi]);
  if (abi.type === "event") {
    return iface.getEvent(abi.name).format(utils.FormatTypes.sighash);
  }
  return iface.getFunction(abi.name).format(utils.FormatTypes.sighash);
}
function prepareTronTransaction({
  chainId,
  tronWeb,
  abi,
  contractAddress,
  functionName,
  params,
  value,
  ownerAddress
}) {
  const functionFragment = abi.find((item) => item.type === "function" && item.name === functionName);
  if (!functionFragment) {
    throw new Error("Method not found in ABI");
  }
  const functionSelector = getFunctionSelector(functionFragment);
  const rawParameter = tronWeb.utils.abi.encodeParamsV2ByABI(functionFragment, params);
  return {
    chain_id: chainId,
    call_value: value?.toString() ?? 0,
    contract_address: TronWeb.address.fromHex(contractAddress),
    fee_limit: 2e8,
    // 200 TRX
    function_selector: functionSelector,
    owner_address: TronWeb.address.fromHex(ownerAddress),
    raw_parameter: rawParameter
  };
}
var ADDRESS_PREFIX_REGEX = /^(41)/;
function tronAddressToEvm(address) {
  return TronWeb.address.toHex(address).replace(ADDRESS_PREFIX_REGEX, "0x");
}
function isTronChainId(chainId) {
  return [728126428 /* TRON_MAINNET */, 2494104990 /* TRON_TESTNET */].includes(chainId);
}
function isTronChain(chain) {
  return isTronChainId(chain.id);
}
function isTronToken(token) {
  return isTronChainId(token.chainId);
}
async function getTransactionInfoById(tronWeb, txId) {
  const result = await tronWeb.fullNode.request("wallet/gettransactioninfobyid", { value: txId }, "post");
  if (result && Object.keys(result).length > 0) {
    return result;
  }
  return null;
}
function getTronCreate2Address(from, salt, initCodeHash) {
  return getAddress2(hexDataSlice(kekKeccak256(concat(["0x41", getAddress2(from), salt, initCodeHash])), 12));
}

// src/entities/token.ts
var Token = class {
  /**
   * Constructs an instance of the base class `Token`.
   * @param params TokenConstructor
   */
  constructor(params) {
    validateSolidityTypeInstance(JSBI5.BigInt(params.decimals), "uint8" /* uint8 */);
    this.decimals = params.decimals;
    this.symbol = params.symbol;
    this.name = params.name;
    this.chainId = params.chainId;
    this.isNative = !!params.isNative;
    this.icons = params.icons;
    this.chainFromId = params.chainFromId;
    this.userToken = params.userToken;
    this.deprecated = !!params.deprecated;
    if (isTronChainId(params.chainId)) {
      this.address = tronAddressToEvm(params.address);
      return;
    }
    this.address = validateAndParseAddress(params.address);
  }
  /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param other other token to compare
   */
  equals(other) {
    if (this === other) {
      return true;
    }
    return this.chainId === other.chainId && this.address === other.address;
  }
  /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */
  sortsBefore(other) {
    invariant4(this.chainId === other.chainId, "CHAIN_IDS");
    invariant4(this.address !== other.address, "ADDRESSES");
    return this.address.toLowerCase() < other.address.toLowerCase();
  }
  get isSynthetic() {
    return !!this.chainFromId;
  }
  get chain() {
    return getChainById(this.chainId);
  }
  get chainFrom() {
    return getChainById(this.chainFromId);
  }
};
function tokenEquals(tokenA, tokenB) {
  return tokenA.equals(tokenB);
}
var WETH = {
  [5555 /* BTC_MAINNET */]: new Token({
    chainId: 5555 /* BTC_MAINNET */,
    address: "",
    decimals: 8
  }),
  [55555 /* BTC_TESTNET */]: new Token({
    chainId: 55555 /* BTC_TESTNET */,
    address: "",
    decimals: 8
  }),
  [728126428 /* TRON_MAINNET */]: new Token({
    chainId: 728126428 /* TRON_MAINNET */,
    address: "0x891CDB91D149F23B1A45D9C5CA78A88D0CB44C18",
    decimals: 6,
    symbol: "WTRX",
    isNative: false,
    name: "Wrapped TRX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    }
  }),
  [1 /* ETH_MAINNET */]: new Token({
    chainId: 1 /* ETH_MAINNET */,
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [4 /* ETH_RINKEBY */]: new Token({
    chainId: 4 /* ETH_RINKEBY */,
    address: "0xc778417e063141139fce010982780140aa0cd5ab",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [5 /* ETH_GOERLI */]: new Token({
    chainId: 5 /* ETH_GOERLI */,
    address: "0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [42 /* ETH_KOVAN */]: new Token({
    chainId: 42 /* ETH_KOVAN */,
    address: "0xd0A1E359811322d97991E03f863a0C30C2cF029C",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [56 /* BSC_MAINNET */]: new Token({
    chainId: 56 /* BSC_MAINNET */,
    address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    decimals: 18,
    symbol: "WBNB",
    isNative: false,
    name: "Wrapped BNB",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png"
    }
  }),
  [97 /* BSC_TESTNET */]: new Token({
    chainId: 97 /* BSC_TESTNET */,
    address: "0xae13d989dac2f0debff460ac112a837c89baa7cd",
    decimals: 18,
    symbol: "WBNB",
    isNative: false,
    name: "Wrapped BNB",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png"
    }
  }),
  [137 /* MATIC_MAINNET */]: new Token({
    chainId: 137 /* MATIC_MAINNET */,
    address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    decimals: 18,
    symbol: "WMATIC",
    isNative: false,
    name: "Wrapped MATIC",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  [80001 /* MATIC_MUMBAI */]: new Token({
    chainId: 80001 /* MATIC_MUMBAI */,
    address: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889",
    decimals: 18,
    symbol: "WMATIC",
    isNative: false,
    name: "Wrapped MATIC",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  [43114 /* AVAX_MAINNET */]: new Token({
    chainId: 43114 /* AVAX_MAINNET */,
    address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    decimals: 18,
    symbol: "WAVAX",
    isNative: false,
    name: "Wrapped AVAX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png"
    }
  }),
  [43113 /* AVAX_TESTNET */]: new Token({
    chainId: 43113 /* AVAX_TESTNET */,
    address: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c",
    decimals: 18,
    symbol: "WAVAX",
    isNative: false,
    name: "Wrapped AVAX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png"
    }
  }),
  [128 /* HECO_MAINNET */]: new Token({
    chainId: 128 /* HECO_MAINNET */,
    address: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f",
    decimals: 18,
    symbol: "WHT",
    isNative: false,
    name: "Wrapped HT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png"
    }
  }),
  [256 /* HECO_TESTNET */]: new Token({
    chainId: 256 /* HECO_TESTNET */,
    address: "0x7aF326B6351C8A9b8fb8CD205CBe11d4Ac5FA836",
    decimals: 18,
    symbol: "WHT",
    isNative: false,
    name: "Wrapped HT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png"
    }
  }),
  [66 /* OKEX_MAINNET */]: new Token({
    chainId: 66 /* OKEX_MAINNET */,
    address: "0x8F8526dbfd6E38E3D8307702cA8469Bae6C56C15",
    decimals: 18,
    symbol: "WOKT",
    isNative: false,
    name: "Wrapped OKT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png"
    }
  }),
  [65 /* OKEX_TESTNET */]: new Token({
    chainId: 65 /* OKEX_TESTNET */,
    address: "0x2219845942d28716c0F7C605765fABDcA1a7d9E0",
    decimals: 18,
    symbol: "WOKT",
    isNative: false,
    name: "Wrapped OKT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png"
    }
  }),
  [288 /* BOBA_MAINNET */]: new Token({
    chainId: 288 /* BOBA_MAINNET */,
    address: "0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [43288 /* BOBA_AVALANCHE */]: new Token({
    chainId: 43288 /* BOBA_AVALANCHE */,
    address: "0x26c319B7B2cF823365414d082698C8ac90cbBA63",
    decimals: 18,
    symbol: "WBOBA",
    isNative: false,
    name: "Wrapped BOBA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png"
    }
  }),
  [56288 /* BOBA_BNB */]: new Token({
    chainId: 56288 /* BOBA_BNB */,
    address: "0xC58aaD327D6D58D979882601ba8DDa0685B505eA",
    decimals: 18,
    symbol: "WBOBA",
    isNative: false,
    name: "Wrapped BOBA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png"
    }
  }),
  [28 /* BOBA_RINKEBY */]: new Token({
    chainId: 28 /* BOBA_RINKEBY */,
    address: "0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [2001 /* MILKOMEDA_MAINNET */]: new Token({
    chainId: 2001 /* MILKOMEDA_MAINNET */,
    address: "0xAE83571000aF4499798d1e3b0fA0070EB3A3E3F9",
    decimals: 18,
    symbol: "WADA",
    isNative: false,
    name: "Wrapped ADA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png"
    }
  }),
  [200101 /* MILKOMEDA_DEVNET */]: new Token({
    chainId: 200101 /* MILKOMEDA_DEVNET */,
    // address: '0x65a51E52eCD17B641f8F0D1d56a6c9738951FDC9',
    address: "0x01bbbb9c97fc43e3393e860fc8bbead47b6960db",
    decimals: 18,
    symbol: "WTADA",
    isNative: false,
    name: "Wrapped TADA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png"
    }
  }),
  [1313161554 /* AURORA_MAINNET */]: new Token({
    chainId: 1313161554 /* AURORA_MAINNET */,
    address: "0xC9BdeEd33CD01541e1eeD10f90519d2C06Fe3feB",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png"
    }
  }),
  [1313161555 /* AURORA_TESTNET */]: new Token({
    chainId: 1313161555 /* AURORA_TESTNET */,
    address: "0x1b6A3d5B5DCdF7a37CFE35CeBC0C4bD28eA7e946",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png"
    }
  }),
  [40 /* TELOS_MAINNET */]: new Token({
    chainId: 40 /* TELOS_MAINNET */,
    address: "0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E",
    decimals: 18,
    symbol: "WTLOS",
    isNative: false,
    name: "Wrapped TLOS",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/18580.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/18580.png"
    }
  }),
  [41 /* TELOS_TESTNET */]: new Token({
    chainId: 41 /* TELOS_TESTNET */,
    address: "0xaE85Bf723A9e74d6c663dd226996AC1b8d075AA9",
    decimals: 18,
    symbol: "WTLOS",
    isNative: false,
    name: "Wrapped TLOS",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/18580.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/18580.png"
    }
  }),
  [8081 /* SHARDEUM_TESTNET_2 */]: new Token({
    chainId: 8081 /* SHARDEUM_TESTNET_2 */,
    address: "0xb6204c4b6b2545cF23F5EC0Bf8AEB8cB56E13C15",
    decimals: 18,
    symbol: "WSHM",
    isNative: false,
    name: "Wrapped SHM",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png"
    }
  }),
  [2222 /* KAVA_MAINNET */]: new Token({
    chainId: 2222 /* KAVA_MAINNET */,
    address: "0xc86c7C0eFbd6A49B35E8714C5f59D99De09A225b",
    decimals: 18,
    symbol: "WKAVA",
    isNative: false,
    name: "Wrapped KAVA",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png"
    }
  }),
  [534353 /* SCROLL_TESTNET */]: new Token({
    chainId: 534353 /* SCROLL_TESTNET */,
    address: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [534351 /* SCROLL_SEPOLIA */]: new Token({
    chainId: 534351 /* SCROLL_SEPOLIA */,
    address: "0x5300000000000000000000000000000000000004",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [324 /* ZKSYNC_MAINNET */]: new Token({
    chainId: 324 /* ZKSYNC_MAINNET */,
    address: "0x5aea5775959fbc2557cc8789bc1bf90a239d9a91",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [42161 /* ARBITRUM_MAINNET */]: new Token({
    chainId: 42161 /* ARBITRUM_MAINNET */,
    address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [42170 /* ARBITRUM_NOVA */]: new Token({
    chainId: 42170 /* ARBITRUM_NOVA */,
    address: "0x722e8bdd2ce80a4422e880164f2079488e115365",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [10 /* OPTIMISM_MAINNET */]: new Token({
    chainId: 10 /* OPTIMISM_MAINNET */,
    address: "0x4200000000000000000000000000000000000006",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [7001 /* ZETACHAIN_ATHENS_2 */]: new Token({
    chainId: 7001 /* ZETACHAIN_ATHENS_2 */,
    address: "0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf",
    decimals: 18,
    symbol: "WZETA",
    isNative: false,
    name: "Wrapped ZETA",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png"
    }
  }),
  [1101 /* POLYGON_ZK */]: new Token({
    chainId: 1101 /* POLYGON_ZK */,
    address: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [2494104990 /* TRON_TESTNET */]: new Token({
    chainId: 2494104990 /* TRON_TESTNET */,
    address: "0xf060b2655346cf3f825c3300177dff8a2acd89aa",
    decimals: 6,
    symbol: "WTRX",
    isNative: false,
    name: "Wrapped TRX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    }
  }),
  [59140 /* LINEA_TESTNET */]: new Token({
    chainId: 59140 /* LINEA_TESTNET */,
    address: "0x2C1b868d6596a18e32E61B901E4060C872647b6C",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [59144 /* LINEA_MAINNET */]: new Token({
    chainId: 59144 /* LINEA_MAINNET */,
    address: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [5e3 /* MANTLE_MAINNET */]: new Token({
    chainId: 5e3 /* MANTLE_MAINNET */,
    address: "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8",
    decimals: 18,
    symbol: "WMNT",
    isNative: false,
    name: "Wrapped MNT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  [5001 /* MANTLE_TESTNET */]: new Token({
    chainId: 5001 /* MANTLE_TESTNET */,
    address: "0x8734110e5e1dcF439c7F549db740E546fea82d66",
    decimals: 18,
    symbol: "WBIT",
    isNative: false,
    name: "Wrapped BIT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  [8453 /* BASE_MAINNET */]: new Token({
    chainId: 8453 /* BASE_MAINNET */,
    address: "0x4200000000000000000000000000000000000006",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [534352 /* SCROLL_MAINNET */]: new Token({
    chainId: 534352 /* SCROLL_MAINNET */,
    address: "0x5300000000000000000000000000000000000004",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  })
};

// src/entities/fractions/price.ts
import invariant5 from "tiny-invariant";
import JSBI6 from "jsbi";
var Price = class _Price extends Fraction {
  // denominator and numerator _must_ be raw, i.e. in the native representation
  constructor(baseToken, quoteToken, denominator, numerator) {
    super(numerator, denominator);
    this.baseToken = baseToken;
    this.quoteToken = quoteToken;
    this.scalar = new Fraction(
      JSBI6.exponentiate(TEN, JSBI6.BigInt(baseToken.decimals)),
      JSBI6.exponentiate(TEN, JSBI6.BigInt(quoteToken.decimals))
    );
  }
  // used to adjust the raw fraction w/r/t the decimals of the {base,quote}Token
  static fromRoute(route) {
    const prices = [];
    for (const [i, pair] of route.pairs.entries()) {
      prices.push(
        route.path[i].equals(pair.token0) ? new _Price(pair.reserve0.token, pair.reserve1.token, pair.reserve0.raw, pair.reserve1.raw) : new _Price(pair.reserve1.token, pair.reserve0.token, pair.reserve1.raw, pair.reserve0.raw)
      );
    }
    return prices.slice(1).reduce((accumulator, currentValue) => accumulator.multiply(currentValue), prices[0]);
  }
  get raw() {
    return new Fraction(this.numerator, this.denominator);
  }
  get adjusted() {
    return super.multiply(this.scalar);
  }
  invert() {
    return new _Price(this.quoteToken, this.baseToken, this.numerator, this.denominator);
  }
  multiply(other) {
    invariant5(tokenEquals(this.quoteToken, other.baseToken), "TOKEN");
    const fraction = super.multiply(other);
    return new _Price(this.baseToken, other.quoteToken, fraction.denominator, fraction.numerator);
  }
  // performs floor division on overflow
  quote(tokenAmount) {
    invariant5(tokenEquals(tokenAmount.token, this.baseToken), "TOKEN");
    return new TokenAmount(this.quoteToken, super.multiply(tokenAmount.raw).quotient);
  }
  toSignificant(significantDigits = 6, format, rounding) {
    return this.adjusted.toSignificant(significantDigits, format, rounding);
  }
  toFixed(decimalPlaces = 4, format, rounding) {
    return this.adjusted.toFixed(decimalPlaces, format, rounding);
  }
};

// src/entities/pair.ts
import invariant6 from "tiny-invariant";
import JSBI7 from "jsbi";
import { keccak256, pack } from "@ethersproject/solidity";
import { getCreate2Address as getEvmCreate2Address } from "@ethersproject/address";
var PAIR_ADDRESS_CACHE = {};
var Pair = class _Pair {
  static getAddress(tokenA, tokenB) {
    const tokens = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
    const chainId = tokens[0].chainId;
    let types = ["address", "address"];
    let params = [tokens[0].address, tokens[1].address];
    if (chainId === 2222 /* KAVA_MAINNET */) {
      types = [...types, "bool"];
      params = [...params, false];
    }
    if (PAIR_ADDRESS_CACHE?.[tokens[0].address]?.[tokens[1].address] === void 0) {
      const getCreate2Address = isTronToken(tokenA) ? getTronCreate2Address : getEvmCreate2Address;
      PAIR_ADDRESS_CACHE = {
        ...PAIR_ADDRESS_CACHE,
        [tokens[0].address]: {
          ...PAIR_ADDRESS_CACHE?.[tokens[0].address],
          [tokens[1].address]: getCreate2Address(
            FACTORY_ADDRESS[chainId],
            keccak256(["bytes"], [pack(types, params)]),
            INIT_CODE_HASH[chainId]
          )
        }
      };
    }
    return PAIR_ADDRESS_CACHE[tokens[0].address][tokens[1].address];
  }
  constructor(tokenAmountA, tokenAmountB) {
    const tokenAmounts = tokenAmountA.token.sortsBefore(tokenAmountB.token) ? [tokenAmountA, tokenAmountB] : [tokenAmountB, tokenAmountA];
    this.liquidityToken = new Token({
      chainId: tokenAmounts[0].token.chainId,
      address: _Pair.getAddress(tokenAmounts[0].token, tokenAmounts[1].token),
      decimals: 18,
      symbol: "UNI-V2",
      name: "Uniswap V2"
    });
    this.tokenAmounts = tokenAmounts;
  }
  /**
   * Returns true if the token is either token0 or token1
   * @param token to check
   */
  involvesToken(token) {
    return token.equals(this.token0) || token.equals(this.token1);
  }
  /**
   * Returns the current mid price of the pair in terms of token0, i.e. the ratio of reserve1 to reserve0
   */
  get token0Price() {
    return new Price(this.token0, this.token1, this.tokenAmounts[0].raw, this.tokenAmounts[1].raw);
  }
  /**
   * Returns the current mid price of the pair in terms of token1, i.e. the ratio of reserve0 to reserve1
   */
  get token1Price() {
    return new Price(this.token1, this.token0, this.tokenAmounts[1].raw, this.tokenAmounts[0].raw);
  }
  /**
   * Return the price of the given token in terms of the other token in the pair.
   * @param token token to return price of
   */
  priceOf(token) {
    invariant6(this.involvesToken(token), "TOKEN");
    return token.equals(this.token0) ? this.token0Price : this.token1Price;
  }
  /**
   * Returns the chain ID of the tokens in the pair.
   */
  get chainId() {
    return this.token0.chainId;
  }
  get token0() {
    return this.tokenAmounts[0].token;
  }
  get token1() {
    return this.tokenAmounts[1].token;
  }
  get reserve0() {
    return this.tokenAmounts[0];
  }
  get reserve1() {
    return this.tokenAmounts[1];
  }
  reserveOf(token) {
    invariant6(this.involvesToken(token), "TOKEN");
    return token.equals(this.token0) ? this.reserve0 : this.reserve1;
  }
  getOutputAmount(inputAmount) {
    invariant6(this.involvesToken(inputAmount.token), "TOKEN");
    if (JSBI7.equal(this.reserve0.raw, ZERO) || JSBI7.equal(this.reserve1.raw, ZERO)) {
      throw new InsufficientReservesError();
    }
    const inputReserve = this.reserveOf(inputAmount.token);
    const outputReserve = this.reserveOf(inputAmount.token.equals(this.token0) ? this.token1 : this.token0);
    const inputAmountWithFee = JSBI7.multiply(inputAmount.raw, _998);
    const numerator = JSBI7.multiply(inputAmountWithFee, outputReserve.raw);
    const denominator = JSBI7.add(JSBI7.multiply(inputReserve.raw, _1000), inputAmountWithFee);
    const outputAmount = new TokenAmount(
      inputAmount.token.equals(this.token0) ? this.token1 : this.token0,
      JSBI7.divide(numerator, denominator)
    );
    if (JSBI7.equal(outputAmount.raw, ZERO)) {
      throw new InsufficientInputAmountError();
    }
    return [outputAmount, new _Pair(inputReserve.add(inputAmount), outputReserve.subtract(outputAmount))];
  }
  getInputAmount(outputAmount) {
    invariant6(this.involvesToken(outputAmount.token), "TOKEN");
    if (JSBI7.equal(this.reserve0.raw, ZERO) || JSBI7.equal(this.reserve1.raw, ZERO) || JSBI7.greaterThanOrEqual(outputAmount.raw, this.reserveOf(outputAmount.token).raw)) {
      throw new InsufficientReservesError();
    }
    const outputReserve = this.reserveOf(outputAmount.token);
    const inputReserve = this.reserveOf(outputAmount.token.equals(this.token0) ? this.token1 : this.token0);
    const numerator = JSBI7.multiply(JSBI7.multiply(inputReserve.raw, outputAmount.raw), _1000);
    const denominator = JSBI7.multiply(JSBI7.subtract(outputReserve.raw, outputAmount.raw), _998);
    const inputAmount = new TokenAmount(
      outputAmount.token.equals(this.token0) ? this.token1 : this.token0,
      JSBI7.add(JSBI7.divide(numerator, denominator), ONE)
    );
    return [inputAmount, new _Pair(inputReserve.add(inputAmount), outputReserve.subtract(outputAmount))];
  }
  getLiquidityMinted(totalSupply, tokenAmountA, tokenAmountB) {
    invariant6(totalSupply.token.equals(this.liquidityToken), "LIQUIDITY");
    const tokenAmounts = tokenAmountA.token.sortsBefore(tokenAmountB.token) ? [tokenAmountA, tokenAmountB] : [tokenAmountB, tokenAmountA];
    invariant6(tokenAmounts[0].token.equals(this.token0) && tokenAmounts[1].token.equals(this.token1), "TOKEN");
    let liquidity;
    if (JSBI7.equal(totalSupply.raw, ZERO)) {
      liquidity = JSBI7.subtract(sqrt(JSBI7.multiply(tokenAmounts[0].raw, tokenAmounts[1].raw)), MINIMUM_LIQUIDITY);
    } else {
      const amount0 = JSBI7.divide(JSBI7.multiply(tokenAmounts[0].raw, totalSupply.raw), this.reserve0.raw);
      const amount1 = JSBI7.divide(JSBI7.multiply(tokenAmounts[1].raw, totalSupply.raw), this.reserve1.raw);
      liquidity = JSBI7.lessThanOrEqual(amount0, amount1) ? amount0 : amount1;
    }
    if (!JSBI7.greaterThan(liquidity, ZERO)) {
      throw new InsufficientInputAmountError();
    }
    return new TokenAmount(this.liquidityToken, liquidity);
  }
  getLiquidityValue(token, totalSupply, liquidity, feeOn = false, kLast) {
    invariant6(this.involvesToken(token), "TOKEN");
    invariant6(totalSupply.token.equals(this.liquidityToken), "TOTAL_SUPPLY");
    invariant6(liquidity.token.equals(this.liquidityToken), "LIQUIDITY");
    invariant6(JSBI7.lessThanOrEqual(liquidity.raw, totalSupply.raw), "LIQUIDITY");
    let totalSupplyAdjusted;
    if (!feeOn) {
      totalSupplyAdjusted = totalSupply;
    } else {
      invariant6(!!kLast, "K_LAST");
      const kLastParsed = parseBigintIsh(kLast);
      if (!JSBI7.equal(kLastParsed, ZERO)) {
        const rootK = sqrt(JSBI7.multiply(this.reserve0.raw, this.reserve1.raw));
        const rootKLast = sqrt(kLastParsed);
        if (JSBI7.greaterThan(rootK, rootKLast)) {
          const numerator = JSBI7.multiply(totalSupply.raw, JSBI7.subtract(rootK, rootKLast));
          const denominator = JSBI7.add(JSBI7.multiply(rootK, FIVE), rootKLast);
          const feeLiquidity = JSBI7.divide(numerator, denominator);
          totalSupplyAdjusted = totalSupply.add(new TokenAmount(this.liquidityToken, feeLiquidity));
        } else {
          totalSupplyAdjusted = totalSupply;
        }
      } else {
        totalSupplyAdjusted = totalSupply;
      }
    }
    return new TokenAmount(
      token,
      JSBI7.divide(JSBI7.multiply(liquidity.raw, this.reserveOf(token).raw), totalSupplyAdjusted.raw)
    );
  }
};

// src/entities/route.ts
import invariant7 from "tiny-invariant";
var Route = class {
  constructor(pairs, input, output) {
    invariant7(pairs.length > 0, "PAIRS");
    invariant7(
      pairs.every((pair) => pair.chainId === pairs[0].chainId),
      "CHAIN_IDS"
    );
    invariant7(
      pairs[0].involvesToken(input) || input.isNative && pairs[0].involvesToken(WETH[pairs[0].chainId]),
      "INPUT"
    );
    invariant7(
      typeof output === "undefined" || pairs[pairs.length - 1].involvesToken(output) || output.isNative && pairs[pairs.length - 1].involvesToken(WETH[pairs[0].chainId]),
      "OUTPUT"
    );
    const path = [input.isNative ? WETH[pairs[0].chainId] : input];
    for (const [i, pair] of pairs.entries()) {
      const currentInput = path[i];
      invariant7(currentInput.equals(pair.token0) || currentInput.equals(pair.token1), "PATH");
      const output2 = currentInput.equals(pair.token0) ? pair.token1 : pair.token0;
      path.push(output2);
    }
    this.pairs = pairs;
    this.path = path;
    this.midPrice = Price.fromRoute(this);
    this.input = input;
    this.output = output ?? path[path.length - 1];
  }
  get chainId() {
    return this.pairs[0].chainId;
  }
};

// src/entities/gasToken.ts
var GAS = (chainId, symbol, iconId, decimals = 18) => new Token({
  isNative: true,
  name: symbol,
  symbol,
  address: "",
  chainId,
  decimals,
  icons: {
    small: `https://s2.coinmarketcap.com/static/img/coins/64x64/${iconId}.png`,
    large: `https://s2.coinmarketcap.com/static/img/coins/64x64/${iconId}.png`
  }
});
var GAS_TOKEN = {
  [1 /* ETH_MAINNET */]: GAS(1 /* ETH_MAINNET */, "ETH", 1027),
  [4 /* ETH_RINKEBY */]: GAS(4 /* ETH_RINKEBY */, "ETH", 1027),
  [5 /* ETH_GOERLI */]: GAS(5 /* ETH_GOERLI */, "ETH", 1027),
  [42 /* ETH_KOVAN */]: GAS(42 /* ETH_KOVAN */, "ETH", 1027),
  [56 /* BSC_MAINNET */]: GAS(56 /* BSC_MAINNET */, "BNB", 1839),
  [97 /* BSC_TESTNET */]: GAS(97 /* BSC_TESTNET */, "BNB", 1839),
  [137 /* MATIC_MAINNET */]: GAS(137 /* MATIC_MAINNET */, "MATIC", 3890),
  [80001 /* MATIC_MUMBAI */]: GAS(80001 /* MATIC_MUMBAI */, "MATIC", 3890),
  [43114 /* AVAX_MAINNET */]: GAS(43114 /* AVAX_MAINNET */, "AVAX", 5805),
  [43113 /* AVAX_TESTNET */]: GAS(43113 /* AVAX_TESTNET */, "AVAX", 5805),
  [128 /* HECO_MAINNET */]: GAS(128 /* HECO_MAINNET */, "HT", 2502),
  [256 /* HECO_TESTNET */]: GAS(256 /* HECO_TESTNET */, "HT", 2502),
  [66 /* OKEX_MAINNET */]: GAS(66 /* OKEX_MAINNET */, "OKT", 8267),
  [65 /* OKEX_TESTNET */]: GAS(65 /* OKEX_TESTNET */, "OKT", 8267),
  [288 /* BOBA_MAINNET */]: GAS(288 /* BOBA_MAINNET */, "ETH", 1027),
  [28 /* BOBA_RINKEBY */]: GAS(28 /* BOBA_RINKEBY */, "ETH", 1027),
  [56288 /* BOBA_BNB */]: GAS(56288 /* BOBA_BNB */, "BOBA", 14556),
  [43288 /* BOBA_AVALANCHE */]: GAS(43288 /* BOBA_AVALANCHE */, "BOBA", 14556),
  [2001 /* MILKOMEDA_MAINNET */]: GAS(2001 /* MILKOMEDA_MAINNET */, "MilkADA", 0),
  // FIXME iconId
  [200101 /* MILKOMEDA_DEVNET */]: GAS(200101 /* MILKOMEDA_DEVNET */, "MilktADA", 0),
  // FIXME iconId
  [5555 /* BTC_MAINNET */]: GAS(5555 /* BTC_MAINNET */, "BTC", 1, 8),
  [55555 /* BTC_TESTNET */]: GAS(55555 /* BTC_TESTNET */, "BTC", 1, 8),
  [1313161554 /* AURORA_MAINNET */]: GAS(1313161554 /* AURORA_MAINNET */, "ETH", 1027),
  [1313161555 /* AURORA_TESTNET */]: GAS(1313161555 /* AURORA_TESTNET */, "ETH", 1027),
  [40 /* TELOS_MAINNET */]: GAS(40 /* TELOS_MAINNET */, "TLOS", 4660),
  [41 /* TELOS_TESTNET */]: GAS(41 /* TELOS_TESTNET */, "TLOS", 4660),
  [8081 /* SHARDEUM_TESTNET_2 */]: GAS(8081 /* SHARDEUM_TESTNET_2 */, "SHM", 22353),
  [2222 /* KAVA_MAINNET */]: GAS(2222 /* KAVA_MAINNET */, "KAVA", 4846),
  [534353 /* SCROLL_TESTNET */]: GAS(534353 /* SCROLL_TESTNET */, "ETH", 1027),
  [534351 /* SCROLL_SEPOLIA */]: GAS(534351 /* SCROLL_SEPOLIA */, "ETH", 1027),
  [324 /* ZKSYNC_MAINNET */]: GAS(324 /* ZKSYNC_MAINNET */, "ETH", 1027),
  [42161 /* ARBITRUM_MAINNET */]: GAS(42161 /* ARBITRUM_MAINNET */, "ETH", 1027),
  [42170 /* ARBITRUM_NOVA */]: GAS(42170 /* ARBITRUM_NOVA */, "ETH", 1027),
  [10 /* OPTIMISM_MAINNET */]: GAS(10 /* OPTIMISM_MAINNET */, "ETH", 1027),
  [7001 /* ZETACHAIN_ATHENS_2 */]: GAS(7001 /* ZETACHAIN_ATHENS_2 */, "ZETA", 21259),
  [1101 /* POLYGON_ZK */]: GAS(1101 /* POLYGON_ZK */, "ETH", 1027),
  [59144 /* LINEA_MAINNET */]: GAS(59144 /* LINEA_MAINNET */, "ETH", 1027),
  [59140 /* LINEA_TESTNET */]: GAS(59140 /* LINEA_TESTNET */, "ETH", 1027),
  [5e3 /* MANTLE_MAINNET */]: GAS(5e3 /* MANTLE_MAINNET */, "MNT", 27075),
  [5001 /* MANTLE_TESTNET */]: GAS(5001 /* MANTLE_TESTNET */, "MNT", 27075),
  [8453 /* BASE_MAINNET */]: GAS(8453 /* BASE_MAINNET */, "ETH", 1027),
  [2494104990 /* TRON_TESTNET */]: GAS(2494104990 /* TRON_TESTNET */, "TRX", 1958, 6),
  [728126428 /* TRON_MAINNET */]: GAS(728126428 /* TRON_MAINNET */, "TRX", 1958, 6),
  [534352 /* SCROLL_MAINNET */]: GAS(534352 /* SCROLL_MAINNET */, "ETH", 1027)
};

// src/entities/trade.ts
import invariant8 from "tiny-invariant";
function computePriceImpact(midPrice, inputAmount, outputAmount) {
  const exactQuote = midPrice.raw.multiply(inputAmount.raw);
  const slippage = exactQuote.subtract(outputAmount.raw).divide(exactQuote);
  return new Percent(slippage.numerator, slippage.denominator);
}
function inputOutputComparator(a, b) {
  invariant8(tokenEquals(a.inputAmount.token, b.inputAmount.token), "INPUT_CURRENCY");
  invariant8(tokenEquals(a.outputAmount.token, b.outputAmount.token), "OUTPUT_CURRENCY");
  if (a.outputAmount.equalTo(b.outputAmount)) {
    if (a.inputAmount.equalTo(b.inputAmount)) {
      return 0;
    }
    if (a.inputAmount.lessThan(b.inputAmount)) {
      return -1;
    } else {
      return 1;
    }
  } else {
    if (a.outputAmount.lessThan(b.outputAmount)) {
      return 1;
    } else {
      return -1;
    }
  }
}
function tradeComparator(a, b) {
  const ioComp = inputOutputComparator(a, b);
  if (ioComp !== 0) {
    return ioComp;
  }
  if (a.priceImpact.lessThan(b.priceImpact)) {
    return -1;
  } else if (a.priceImpact.greaterThan(b.priceImpact)) {
    return 1;
  }
  return a.route.path.length - b.route.path.length;
}
function wrappedAmount(tokenAmount) {
  return tokenAmount.token.isNative ? new TokenAmount(WETH[tokenAmount.token.chainId], tokenAmount.raw) : tokenAmount;
}
function wrappedToken(token) {
  return token.isNative ? WETH[token.chainId] : token;
}
var Trade = class _Trade {
  /**
   * Constructs an exact in trade with the given amount in and route
   * @param route route of the exact in trade
   * @param amountIn the amount being passed in
   */
  static exactIn(route, amountIn) {
    return new _Trade(route, amountIn, 0 /* EXACT_INPUT */);
  }
  /**
   * Constructs an exact out trade with the given amount out and route
   * @param route route of the exact out trade
   * @param amountOut the amount returned by the trade
   */
  static exactOut(route, amountOut) {
    return new _Trade(route, amountOut, 1 /* EXACT_OUTPUT */);
  }
  constructor(route, amount, tradeType) {
    const amounts = new Array(route.path.length);
    const nextPairs = new Array(route.pairs.length);
    if (tradeType === 0 /* EXACT_INPUT */) {
      invariant8(tokenEquals(amount.token, route.input), "INPUT");
      amounts[0] = wrappedAmount(amount);
      for (let i = 0; i < route.path.length - 1; i++) {
        const pair = route.pairs[i];
        const [outputAmount, nextPair] = pair.getOutputAmount(amounts[i]);
        amounts[i + 1] = outputAmount;
        nextPairs[i] = nextPair;
      }
    } else {
      invariant8(tokenEquals(amount.token, route.output), "OUTPUT");
      amounts[amounts.length - 1] = wrappedAmount(amount);
      for (let i = route.path.length - 1; i > 0; i--) {
        const pair = route.pairs[i - 1];
        const [inputAmount, nextPair] = pair.getInputAmount(amounts[i]);
        amounts[i - 1] = inputAmount;
        nextPairs[i - 1] = nextPair;
      }
    }
    this.route = route;
    this.tradeType = tradeType;
    this.inputAmount = tradeType === 0 /* EXACT_INPUT */ ? amount : new TokenAmount(route.input, amounts[0].raw);
    this.outputAmount = tradeType === 1 /* EXACT_OUTPUT */ ? amount : new TokenAmount(route.output, amounts[amounts.length - 1].raw);
    this.executionPrice = new Price(
      this.inputAmount.token,
      this.outputAmount.token,
      this.inputAmount.raw,
      this.outputAmount.raw
    );
    this.nextMidPrice = Price.fromRoute(new Route(nextPairs, route.input));
    this.priceImpact = computePriceImpact(route.midPrice, this.inputAmount, this.outputAmount);
  }
  /**
   * Get the minimum amount that must be received from this trade for the given slippage tolerance
   * @param slippageTolerance tolerance of unfavorable slippage from the execution price of this trade
   */
  minimumAmountOut(slippageTolerance) {
    invariant8(!slippageTolerance.lessThan(ZERO), "SLIPPAGE_TOLERANCE");
    if (this.tradeType === 1 /* EXACT_OUTPUT */) {
      return this.outputAmount;
    } else {
      const slippageAdjustedAmountOut = new Fraction(ONE).add(slippageTolerance).invert().multiply(this.outputAmount.raw).quotient;
      return new TokenAmount(this.outputAmount.token, slippageAdjustedAmountOut);
    }
  }
  /**
   * Get the maximum amount in that can be spent via this trade for the given slippage tolerance
   * @param slippageTolerance tolerance of unfavorable slippage from the execution price of this trade
   */
  maximumAmountIn(slippageTolerance) {
    invariant8(!slippageTolerance.lessThan(ZERO), "SLIPPAGE_TOLERANCE");
    if (this.tradeType === 0 /* EXACT_INPUT */) {
      return this.inputAmount;
    } else {
      const slippageAdjustedAmountIn = new Fraction(ONE).add(slippageTolerance).multiply(this.inputAmount.raw).quotient;
      return new TokenAmount(this.inputAmount.token, slippageAdjustedAmountIn);
    }
  }
  /**
   * Given a list of pairs, and a fixed amount in, returns the top `maxNumResults` trades that go from an input token
   * amount to an output token, making at most `maxHops` hops.
   * Note this does not consider aggregation, as routes are linear. It's possible a better route exists by splitting
   * the amount in among multiple routes.
   * @param pairs the pairs to consider in finding the best trade
   * @param tokenAmountIn exact amount of input token to spend
   * @param tokenOut the desired token out
   * @param maxNumResults maximum number of results to return
   * @param maxHops maximum number of hops a returned trade can make, e.g. 1 hop goes through a single pair
   * @param currentPairs used in recursion; the current list of pairs
   * @param originalAmountIn used in recursion; the original value of the tokenAmountIn parameter
   * @param bestTrades used in recursion; the current list of best trades
   */
  static bestTradeExactIn(pairs, tokenAmountIn, tokenOut, { maxNumResults = 3, maxHops = 3 } = {}, currentPairs = [], originalAmountIn = tokenAmountIn, bestTrades = []) {
    invariant8(pairs.length > 0, "PAIRS");
    invariant8(maxHops > 0, "MAX_HOPS");
    invariant8(originalAmountIn === tokenAmountIn || currentPairs.length > 0, "INVALID_RECURSION");
    const amountIn = wrappedAmount(tokenAmountIn);
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i];
      if (!pair.token0.equals(amountIn.token) && !pair.token1.equals(amountIn.token))
        continue;
      if (pair.reserve0.equalTo(ZERO) || pair.reserve1.equalTo(ZERO))
        continue;
      let amountOut;
      try {
        ;
        [amountOut] = pair.getOutputAmount(amountIn);
      } catch (error) {
        if (error.isInsufficientInputAmountError) {
          continue;
        }
        throw error;
      }
      if (amountOut.token.equals(wrappedToken(tokenOut))) {
        sortedInsert(
          bestTrades,
          new _Trade(
            new Route([...currentPairs, pair], originalAmountIn.token, tokenOut),
            originalAmountIn,
            0 /* EXACT_INPUT */
          ),
          maxNumResults,
          tradeComparator
        );
      } else if (maxHops > 1 && pairs.length > 1) {
        const pairsExcludingThisPair = pairs.slice(0, i).concat(pairs.slice(i + 1, pairs.length));
        _Trade.bestTradeExactIn(
          pairsExcludingThisPair,
          amountOut,
          tokenOut,
          {
            maxNumResults,
            maxHops: maxHops - 1
          },
          [...currentPairs, pair],
          originalAmountIn,
          bestTrades
        );
      }
    }
    return bestTrades;
  }
  /**
   * similar to the above method but instead targets a fixed output amount
   * given a list of pairs, and a fixed amount out, returns the top `maxNumResults` trades that go from an input token
   * to an output token amount, making at most `maxHops` hops
   * note this does not consider aggregation, as routes are linear. it's possible a better route exists by splitting
   * the amount in among multiple routes.
   * @param pairs the pairs to consider in finding the best trade
   * @param tokenIn the token to spend
   * @param tokenAmountOut the exact amount of token out
   * @param maxNumResults maximum number of results to return
   * @param maxHops maximum number of hops a returned trade can make, e.g. 1 hop goes through a single pair
   * @param currentPairs used in recursion; the current list of pairs
   * @param originalAmountOut used in recursion; the original value of the currencyAmountOut parameter
   * @param bestTrades used in recursion; the current list of best trades
   */
  static bestTradeExactOut(pairs, tokenIn, tokenAmountOut, { maxNumResults = 3, maxHops = 3 } = {}, currentPairs = [], originalAmountOut = tokenAmountOut, bestTrades = []) {
    invariant8(pairs.length > 0, "PAIRS");
    invariant8(maxHops > 0, "MAX_HOPS");
    invariant8(originalAmountOut === tokenAmountOut || currentPairs.length > 0, "INVALID_RECURSION");
    const amountOut = wrappedAmount(tokenAmountOut);
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i];
      if (!pair.token0.equals(amountOut.token) && !pair.token1.equals(amountOut.token))
        continue;
      if (pair.reserve0.equalTo(ZERO) || pair.reserve1.equalTo(ZERO))
        continue;
      let amountIn;
      try {
        ;
        [amountIn] = pair.getInputAmount(amountOut);
      } catch (error) {
        if (error.isInsufficientReservesError) {
          continue;
        }
        throw error;
      }
      if (amountIn.token.equals(wrappedToken(tokenIn))) {
        sortedInsert(
          bestTrades,
          new _Trade(
            new Route([pair, ...currentPairs], tokenIn, originalAmountOut.token),
            originalAmountOut,
            1 /* EXACT_OUTPUT */
          ),
          maxNumResults,
          tradeComparator
        );
      } else if (maxHops > 1 && pairs.length > 1) {
        const pairsExcludingThisPair = pairs.slice(0, i).concat(pairs.slice(i + 1, pairs.length));
        _Trade.bestTradeExactOut(
          pairsExcludingThisPair,
          tokenIn,
          amountIn,
          {
            maxNumResults,
            maxHops: maxHops - 1
          },
          [pair, ...currentPairs],
          originalAmountOut,
          bestTrades
        );
      }
    }
    return bestTrades;
  }
};

// src/router.ts
import invariant9 from "tiny-invariant";
function toHex(tokenAmount) {
  return `0x${tokenAmount.raw.toString(16)}`;
}
var ZERO_HEX = "0x0";
var Router = class {
  /**
   * Produces the on-chain method name to call and the hex encoded parameters to pass as arguments for a given trade.
   * @param trade to produce call parameters for
   * @param options options for the call parameters
   */
  static swapCallParameters(trade, options) {
    invariant9(!(trade.inputAmount.token.isNative && trade.outputAmount.token.isNative), "ETHER_IN_OUT");
    invariant9(options.ttl > 0, "TTL");
    const to = validateAndParseAddress(options.recipient);
    const amountIn = toHex(trade.maximumAmountIn(options.allowedSlippage));
    const amountOut = toHex(trade.minimumAmountOut(options.allowedSlippage));
    let path;
    if (trade.inputAmount.token.chainId === 2222 /* KAVA_MAINNET */) {
      const routes = [];
      for (let i = 0; i < trade.route.path.length - 1; i++) {
        routes.push({
          from: trade.route.path[i].address,
          to: trade.route.path[i + 1].address,
          stable: false
        });
      }
      path = routes;
    } else {
      path = trade.route.path.map((token) => token.address);
    }
    const deadline = `0x${(Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) + options.ttl).toString(16)}`;
    const useFeeOnTransfer = Boolean(options.feeOnTransfer);
    let methodName;
    let args;
    let value;
    let offset;
    switch (trade.tradeType) {
      case 0 /* EXACT_INPUT */:
        if (trade.inputAmount.token.isNative) {
          methodName = useFeeOnTransfer ? "swapExactETHForTokensSupportingFeeOnTransferTokens" : "swapExactETHForTokens";
          args = [amountOut, path, to, deadline];
          value = amountIn;
          offset = 0;
        } else if (trade.outputAmount.token.isNative) {
          methodName = useFeeOnTransfer ? "swapExactTokensForETHSupportingFeeOnTransferTokens" : "swapExactTokensForETH";
          args = [amountIn, amountOut, path, to, deadline];
          value = ZERO_HEX;
          offset = 36;
        } else {
          methodName = useFeeOnTransfer ? "swapExactTokensForTokensSupportingFeeOnTransferTokens" : "swapExactTokensForTokens";
          args = [amountIn, amountOut, path, to, deadline];
          value = ZERO_HEX;
          offset = 36;
        }
        break;
      case 1 /* EXACT_OUTPUT */:
        invariant9(!useFeeOnTransfer, "EXACT_OUT_FOT");
        if (trade.inputAmount.token.isNative) {
          methodName = "swapETHForExactTokens";
          args = [amountOut, path, to, deadline];
          value = amountIn;
          offset = 0;
        } else if (trade.outputAmount.token.isNative) {
          methodName = "swapTokensForExactETH";
          args = [amountOut, amountIn, path, to, deadline];
          value = ZERO_HEX;
          offset = 68;
        } else {
          methodName = "swapTokensForExactTokens";
          args = [amountOut, amountIn, path, to, deadline];
          value = ZERO_HEX;
          offset = 68;
        }
        break;
    }
    return {
      methodName,
      args,
      value,
      offset
    };
  }
};

// src/fetcher.ts
import { Contract } from "@ethersproject/contracts";
import { getNetwork } from "@ethersproject/networks";
import { getDefaultProvider } from "@ethersproject/providers";
import invariant10 from "tiny-invariant";

// src/abis/IPancakePair.json
var IPancakePair_default = {
  abi: [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "Approval",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "Burn",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      name: "Mint",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0In",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1In",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0Out",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1Out",
          type: "uint256"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "Swap",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint112",
          name: "reserve0",
          type: "uint112"
        },
        {
          indexed: false,
          internalType: "uint112",
          name: "reserve1",
          type: "uint112"
        }
      ],
      name: "Sync",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "Transfer",
      type: "event"
    },
    {
      constant: true,
      inputs: [],
      name: "DOMAIN_SEPARATOR",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "MINIMUM_LIQUIDITY",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "PERMIT_TYPEHASH",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          internalType: "address",
          name: "spender",
          type: "address"
        }
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        }
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "burn",
      outputs: [
        {
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "factory",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "getReserves",
      outputs: [
        {
          internalType: "uint112",
          name: "reserve0",
          type: "uint112"
        },
        {
          internalType: "uint112",
          name: "reserve1",
          type: "uint112"
        },
        {
          internalType: "uint32",
          name: "blockTimestampLast",
          type: "uint32"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        },
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "initialize",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "kLast",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "mint",
      outputs: [
        {
          internalType: "uint256",
          name: "liquidity",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        }
      ],
      name: "nonces",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "deadline",
          type: "uint256"
        },
        {
          internalType: "uint8",
          name: "v",
          type: "uint8"
        },
        {
          internalType: "bytes32",
          name: "r",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "s",
          type: "bytes32"
        }
      ],
      name: "permit",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "price0CumulativeLast",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "price1CumulativeLast",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "skim",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "uint256",
          name: "amount0Out",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "amount1Out",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "data",
          type: "bytes"
        }
      ],
      name: "swap",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: false,
      inputs: [],
      name: "sync",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "token0",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "token1",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    }
  ],
  evm: {
    bytecode: {
      linkReferences: {},
      object: "",
      opcodes: "",
      sourceMap: ""
    },
    deployedBytecode: {
      linkReferences: {},
      object: "",
      opcodes: "",
      sourceMap: ""
    }
  },
  metadata: '{"compiler":{"version":"0.5.16+commit.9c3226ce"},"language":"Solidity","output":{"abi":[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"reserve0","type":"uint112"},{"internalType":"uint112","name":"reserve1","type":"uint112"},{"internalType":"uint32","name":"blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}],"devdoc":{"methods":{}},"userdoc":{"methods":{}}},"settings":{"compilationTarget":{"contracts/interfaces/IPancakePair.sol":"IPancakePair"},"evmVersion":"istanbul","libraries":{},"optimizer":{"enabled":true,"runs":999999},"remappings":[]},"sources":{"contracts/interfaces/IPancakePair.sol":{"keccak256":"0xc432aeec5c038f15c3670ee6128ce41dbfa1f7a9979dc37b967213436ae77b33","urls":["bzz-raw://3bb06c5526b4691a4128f4f8f6a2ecca9af5f149848a2ec4cb60bd775d94568b","dweb:/ipfs/QmRYv5qt1TzSEPYhSXvfejncnGwZV5o6twDrTmtVg2Rx74"]}},"version":1}',
  interface: [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "Approval",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "Burn",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      name: "Mint",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0In",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1In",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0Out",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1Out",
          type: "uint256"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "Swap",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint112",
          name: "reserve0",
          type: "uint112"
        },
        {
          indexed: false,
          internalType: "uint112",
          name: "reserve1",
          type: "uint112"
        }
      ],
      name: "Sync",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "Transfer",
      type: "event"
    },
    {
      constant: true,
      inputs: [],
      name: "DOMAIN_SEPARATOR",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "MINIMUM_LIQUIDITY",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "PERMIT_TYPEHASH",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          internalType: "address",
          name: "spender",
          type: "address"
        }
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        }
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "burn",
      outputs: [
        {
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "factory",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "getReserves",
      outputs: [
        {
          internalType: "uint112",
          name: "reserve0",
          type: "uint112"
        },
        {
          internalType: "uint112",
          name: "reserve1",
          type: "uint112"
        },
        {
          internalType: "uint32",
          name: "blockTimestampLast",
          type: "uint32"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        },
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "initialize",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "kLast",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "mint",
      outputs: [
        {
          internalType: "uint256",
          name: "liquidity",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        }
      ],
      name: "nonces",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "deadline",
          type: "uint256"
        },
        {
          internalType: "uint8",
          name: "v",
          type: "uint8"
        },
        {
          internalType: "bytes32",
          name: "r",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "s",
          type: "bytes32"
        }
      ],
      name: "permit",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "price0CumulativeLast",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "price1CumulativeLast",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        }
      ],
      name: "skim",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "uint256",
          name: "amount0Out",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "amount1Out",
          type: "uint256"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "bytes",
          name: "data",
          type: "bytes"
        }
      ],
      name: "swap",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      payable: false,
      stateMutability: "pure",
      type: "function"
    },
    {
      constant: false,
      inputs: [],
      name: "sync",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "token0",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "token1",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    }
  ],
  bytecode: ""
};

// src/abis/ERC20.json
var ERC20_default = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ name: "", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  }
];

// src/fetcher.ts
var TOKEN_DECIMALS_CACHE = {
  [56 /* BSC_MAINNET */]: {
    "0xE0B7927c4aF23765Cb51314A0E0521A9645F0E2A": 9
    // DGD
  }
};
var Fetcher = class {
  /**
   * Fetch information for a given token on the given chain, using the given ethers provider.
   * @param chainId chain of the token
   * @param address address of the token on the chain
   * @param provider provider used to fetch the token
   * @param symbol optional symbol of the token
   * @param name optional name of the token
   */
  static async fetchTokenData(chainId, address, provider = getDefaultProvider(getNetwork(chainId)), symbol, name) {
    const parsedDecimals = typeof TOKEN_DECIMALS_CACHE?.[chainId]?.[address] === "number" ? TOKEN_DECIMALS_CACHE[chainId][address] : await new Contract(address, ERC20_default, provider).decimals().then((decimals) => {
      TOKEN_DECIMALS_CACHE = {
        ...TOKEN_DECIMALS_CACHE,
        [chainId]: {
          ...TOKEN_DECIMALS_CACHE?.[chainId],
          [address]: decimals
        }
      };
      return decimals;
    });
    return new Token({ chainId, address, decimals: parsedDecimals, symbol, name });
  }
  /**
   * Fetches information about a pair and constructs a pair from the given two tokens.
   * @param tokenA first token
   * @param tokenB second token
   * @param provider the provider to use to fetch the data
   */
  static async fetchPairData(tokenA, tokenB, provider = getDefaultProvider(getNetwork(tokenA.chainId))) {
    invariant10(tokenA.chainId === tokenB.chainId, "CHAIN_ID");
    const address = Pair.getAddress(tokenA, tokenB);
    const [reserves0, reserves1] = await new Contract(address, IPancakePair_default.abi, provider).getReserves();
    const balances = tokenA.sortsBefore(tokenB) ? [reserves0, reserves1] : [reserves1, reserves0];
    return new Pair(new TokenAmount(tokenA, balances[0]), new TokenAmount(tokenB, balances[1]));
  }
};

// src/crosschain/symbiosis.ts
import { StaticJsonRpcProvider } from "@ethersproject/providers";
import { BigNumber as BigNumber9, utils as utils33 } from "ethers";
import JSBI15 from "jsbi";
import TronWeb2 from "tronweb";

// src/crosschain/bridging.ts
import { MaxUint256 } from "@ethersproject/constants";
import { BigNumber as BigNumber2 } from "ethers";

// src/crosschain/tronAbis/tronPortalAbi.ts
var TRON_PORTAL_ABI = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_wrapper",
        type: "address"
      },
      {
        internalType: "address",
        name: "_whitelistedToken",
        type: "address"
      },
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BurnCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "clientId",
        type: "bytes32"
      }
    ],
    name: "ClientIdLog",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "MetaRevertRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "RevertBurnRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "RevertSynthesizeCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metaRouter",
        type: "address"
      }
    ],
    name: "SetMetaRouter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      }
    ],
    name: "SetTokenThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "activate",
        type: "bool"
      }
    ],
    name: "SetWhitelistToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SynthesizeRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getChainID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "internalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "managerChainBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "sourceChainBridge",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "managerChainId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "sourceChainId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "router",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "swapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "sourceChainSynthesis",
            type: "address"
          },
          {
            internalType: "address",
            name: "burnToken",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "burnCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRevertTransaction",
        name: "_metaRevertTransaction",
        type: "tuple"
      }
    ],
    name: "metaRevertRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouter",
    outputs: [
      {
        internalType: "contract IMetaRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "rtoken",
            type: "address"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "syntCaller",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaSynthesizeTransaction",
        name: "_metaSynthesizeTransaction",
        type: "tuple"
      }
    ],
    name: "metaSynthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_rToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_finalReceiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_finalCalldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_finalOffset",
        type: "uint256"
      }
    ],
    name: "metaUnsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "requestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "address",
        name: "chain2address",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "rtoken",
        type: "address"
      },
      {
        internalType: "enum Portal.RequestState",
        name: "state",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainId",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertBurnRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "setMetaRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_threshold",
        type: "uint256"
      }
    ],
    name: "setTokenThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_activate",
        type: "bool"
      }
    ],
    name: "setWhitelistToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesizeNative",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "approvalData",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct Portal.SynthesizeWithPermitTransaction",
        name: "_syntWithPermitTx",
        type: "tuple"
      }
    ],
    name: "synthesizeWithPermit",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "unsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "unsynthesizeStates",
    outputs: [
      {
        internalType: "enum Portal.UnsynthesizeState",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "wrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/crosschain/tronAbis/tronTRC20Abi.ts
var TRON_TRC20_ABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "spender", type: "address" },
      { name: "value", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { name: "value", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    outputs: [{ type: "uint256" }],
    constant: true,
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" }
    ],
    name: "allowance",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "spender", type: "address" },
      { name: "value", type: "uint256" }
    ],
    name: "approve",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    outputs: [{ type: "uint256" }],
    constant: true,
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "uint8" }],
    inputs: [],
    constant: true,
    name: "decimals",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "spender", type: "address" },
      { name: "subtractedValue", type: "uint256" }
    ],
    name: "decreaseAllowance",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "spender", type: "address" },
      { name: "addedValue", type: "uint256" }
    ],
    name: "increaseAllowance",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    outputs: [{ type: "string" }],
    constant: true,
    name: "name",
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    outputs: [{ type: "string" }],
    constant: true,
    name: "symbol",
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    outputs: [{ type: "uint256" }],
    constant: true,
    name: "totalSupply",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transfer",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/crosschain/tronAbis/tronMetaRouterAbi.ts
var TRON_METAROUTER_ABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_calldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_offset",
        type: "uint256"
      }
    ],
    name: "externalCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "externalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "tokenReal",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "to",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaMintTransaction",
        name: "_metaMintTransaction",
        type: "tuple"
      }
    ],
    name: "metaMintSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "firstSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address[]",
            name: "approvedTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "firstDexRouter",
            type: "address"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "nativeIn",
            type: "bool"
          },
          {
            internalType: "address",
            name: "relayRecipient",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "otherSideCalldata",
            type: "bytes"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRouteTransaction",
        name: "_metarouteTransaction",
        type: "tuple"
      }
    ],
    name: "metaRoute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouterGateway",
    outputs: [
      {
        internalType: "contract MetaRouterGateway",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_router",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_swapCalldata",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_burnToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_burnCalldata",
        type: "bytes"
      }
    ],
    name: "returnSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/crosschain/utils.ts
import { parseUnits } from "@ethersproject/units";
import { BigNumber, utils as utils2 } from "ethers";
import JSBI9 from "jsbi";

// src/crosschain/constants.ts
import { AddressZero } from "@ethersproject/constants";
import JSBI8 from "jsbi";
var CHAINS_PRIORITY = [
  1 /* ETH_MAINNET */,
  4 /* ETH_RINKEBY */,
  42 /* ETH_KOVAN */,
  5 /* ETH_GOERLI */,
  56 /* BSC_MAINNET */,
  // ChainId.BSC_TESTNET, // NOTE it is a manager chain
  43114 /* AVAX_MAINNET */,
  43113 /* AVAX_TESTNET */,
  288 /* BOBA_MAINNET */,
  43288 /* BOBA_AVALANCHE */,
  // ChainId.BOBA_BNB, // NOTE it is a manager chain
  28 /* BOBA_RINKEBY */,
  1313161554 /* AURORA_MAINNET */,
  1313161555 /* AURORA_TESTNET */,
  40 /* TELOS_MAINNET */,
  41 /* TELOS_TESTNET */,
  137 /* MATIC_MAINNET */,
  80001 /* MATIC_MUMBAI */,
  2001 /* MILKOMEDA_MAINNET */,
  200101 /* MILKOMEDA_DEVNET */,
  66 /* OKEX_MAINNET */,
  65 /* OKEX_TESTNET */,
  128 /* HECO_MAINNET */,
  256 /* HECO_TESTNET */,
  8081 /* SHARDEUM_TESTNET_2 */,
  2222 /* KAVA_MAINNET */,
  534353 /* SCROLL_TESTNET */,
  534351 /* SCROLL_SEPOLIA */,
  324 /* ZKSYNC_MAINNET */,
  42161 /* ARBITRUM_MAINNET */,
  42170 /* ARBITRUM_NOVA */,
  10 /* OPTIMISM_MAINNET */,
  7001 /* ZETACHAIN_ATHENS_2 */,
  1101 /* POLYGON_ZK */,
  728126428 /* TRON_MAINNET */,
  2494104990 /* TRON_TESTNET */,
  59140 /* LINEA_TESTNET */,
  59144 /* LINEA_MAINNET */,
  5e3 /* MANTLE_MAINNET */,
  5001 /* MANTLE_TESTNET */,
  8453 /* BASE_MAINNET */,
  534352 /* SCROLL_MAINNET */
];
var ONE_INCH_CHAINS = [
  1 /* ETH_MAINNET */,
  56 /* BSC_MAINNET */,
  137 /* MATIC_MAINNET */,
  10 /* OPTIMISM_MAINNET */,
  42161 /* ARBITRUM_MAINNET */,
  43114 /* AVAX_MAINNET */,
  324 /* ZKSYNC_MAINNET */,
  8453 /* BASE_MAINNET */
];
var ONE_INCH_ORACLE_MAP = {
  [1 /* ETH_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [56 /* BSC_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [137 /* MATIC_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [10 /* OPTIMISM_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [42161 /* ARBITRUM_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [43114 /* AVAX_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [324 /* ZKSYNC_MAINNET */]: "0xC762d56614D3411eC6fABD56cb075D904b801613",
  [8453 /* BASE_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B"
};
var WETH_ONLY = {
  [1 /* ETH_MAINNET */]: [WETH[1 /* ETH_MAINNET */]],
  [4 /* ETH_RINKEBY */]: [WETH[4 /* ETH_RINKEBY */]],
  [5 /* ETH_GOERLI */]: [WETH[5 /* ETH_GOERLI */]],
  [42 /* ETH_KOVAN */]: [WETH[42 /* ETH_KOVAN */]],
  [56 /* BSC_MAINNET */]: [WETH[56 /* BSC_MAINNET */]],
  [97 /* BSC_TESTNET */]: [WETH[97 /* BSC_TESTNET */]],
  [137 /* MATIC_MAINNET */]: [WETH[137 /* MATIC_MAINNET */]],
  [80001 /* MATIC_MUMBAI */]: [WETH[80001 /* MATIC_MUMBAI */]],
  [43114 /* AVAX_MAINNET */]: [WETH[43114 /* AVAX_MAINNET */]],
  [43113 /* AVAX_TESTNET */]: [WETH[43113 /* AVAX_TESTNET */]],
  [128 /* HECO_MAINNET */]: [WETH[128 /* HECO_MAINNET */]],
  [256 /* HECO_TESTNET */]: [WETH[256 /* HECO_TESTNET */]],
  [66 /* OKEX_MAINNET */]: [WETH[66 /* OKEX_MAINNET */]],
  [65 /* OKEX_TESTNET */]: [WETH[65 /* OKEX_TESTNET */]],
  [288 /* BOBA_MAINNET */]: [WETH[288 /* BOBA_MAINNET */]],
  [43288 /* BOBA_AVALANCHE */]: [WETH[43288 /* BOBA_AVALANCHE */]],
  [56288 /* BOBA_BNB */]: [WETH[56288 /* BOBA_BNB */]],
  [28 /* BOBA_RINKEBY */]: [WETH[28 /* BOBA_RINKEBY */]],
  [2001 /* MILKOMEDA_MAINNET */]: [WETH[2001 /* MILKOMEDA_MAINNET */]],
  [200101 /* MILKOMEDA_DEVNET */]: [WETH[200101 /* MILKOMEDA_DEVNET */]],
  [1313161554 /* AURORA_MAINNET */]: [WETH[1313161554 /* AURORA_MAINNET */]],
  [1313161555 /* AURORA_TESTNET */]: [WETH[1313161555 /* AURORA_TESTNET */]],
  [40 /* TELOS_MAINNET */]: [WETH[40 /* TELOS_MAINNET */]],
  [41 /* TELOS_TESTNET */]: [WETH[41 /* TELOS_TESTNET */]],
  [8081 /* SHARDEUM_TESTNET_2 */]: [WETH[8081 /* SHARDEUM_TESTNET_2 */]],
  [2222 /* KAVA_MAINNET */]: [WETH[2222 /* KAVA_MAINNET */]],
  [534353 /* SCROLL_TESTNET */]: [WETH[534353 /* SCROLL_TESTNET */]],
  [534351 /* SCROLL_SEPOLIA */]: [WETH[534351 /* SCROLL_SEPOLIA */]],
  [324 /* ZKSYNC_MAINNET */]: [WETH[324 /* ZKSYNC_MAINNET */]],
  [42161 /* ARBITRUM_MAINNET */]: [WETH[42161 /* ARBITRUM_MAINNET */]],
  [42170 /* ARBITRUM_NOVA */]: [WETH[42170 /* ARBITRUM_NOVA */]],
  [10 /* OPTIMISM_MAINNET */]: [WETH[10 /* OPTIMISM_MAINNET */]],
  [7001 /* ZETACHAIN_ATHENS_2 */]: [WETH[7001 /* ZETACHAIN_ATHENS_2 */]],
  [1101 /* POLYGON_ZK */]: [WETH[1101 /* POLYGON_ZK */]],
  [59140 /* LINEA_TESTNET */]: [WETH[59140 /* LINEA_TESTNET */]],
  [59144 /* LINEA_MAINNET */]: [WETH[59144 /* LINEA_MAINNET */]],
  [5e3 /* MANTLE_MAINNET */]: [WETH[5e3 /* MANTLE_MAINNET */]],
  [5001 /* MANTLE_TESTNET */]: [WETH[5001 /* MANTLE_TESTNET */]],
  [8453 /* BASE_MAINNET */]: [WETH[8453 /* BASE_MAINNET */]],
  [728126428 /* TRON_MAINNET */]: [WETH[728126428 /* TRON_MAINNET */]],
  [2494104990 /* TRON_TESTNET */]: [WETH[2494104990 /* TRON_TESTNET */]],
  [534352 /* SCROLL_MAINNET */]: [WETH[534352 /* SCROLL_MAINNET */]]
};
var DEX_TOKENS_TO_CHECK_TRADES_AGAINST = {
  [1 /* ETH_MAINNET */]: [
    new Token({
      chainId: 1 /* ETH_MAINNET */,
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      decimals: 18,
      symbol: "DAI",
      name: "Dai Stablecoin"
    }),
    new Token({
      chainId: 1 /* ETH_MAINNET */,
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      decimals: 6,
      symbol: "USDC",
      name: "USD//C"
    }),
    new Token({
      chainId: 1 /* ETH_MAINNET */,
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    })
    // new Token({
    //     chainId: ChainId.ETH_MAINNET,
    //     address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    //     decimals: 8,
    //     symbol: 'WBTC',
    //     name: 'Wrapped BTC',
    // }),
  ],
  [56 /* BSC_MAINNET */]: [
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    //     decimals: 18,
    //     symbol: 'CAKE',
    //     name: 'PancakeSwap Token',
    // }),
    new Token({
      chainId: 56 /* BSC_MAINNET */,
      address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
      decimals: 18,
      symbol: "BUSD",
      name: "Binance USD"
    }),
    new Token({
      chainId: 56 /* BSC_MAINNET */,
      address: "0x55d398326f99059fF775485246999027B3197955",
      decimals: 18,
      symbol: "USDT",
      name: "Tether USD"
    }),
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    //     decimals: 18,
    //     symbol: 'BTCB',
    //     name: 'Binance BTC',
    // }),
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x23396cF899Ca06c4472205fC903bDB4de249D6fC',
    //     decimals: 18,
    //     symbol: 'UST',
    //     name: 'Wrapped UST Token',
    // }),
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    //     decimals: 18,
    //     symbol: 'ETH',
    //     name: 'Binance-Peg Ethereum Token',
    // }),
    new Token({
      chainId: 56 /* BSC_MAINNET */,
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      decimals: 18,
      symbol: "USDC",
      name: "Binance-Peg USD Coin"
    })
  ],
  [43114 /* AVAX_MAINNET */]: [
    // new Token({
    //     chainId: ChainId.AVAX_MAINNET,
    //     address: '0x60781C2586D68229fde47564546784ab3fACA982',
    //     decimals: 18,
    //     symbol: 'PNG',
    //     name: 'Pangolin',
    // }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xc7198437980c041c805A1EDcbA50c1Ce5db95118",
      decimals: 6,
      symbol: "USDT.e",
      name: "Tether USD"
    }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70",
      decimals: 18,
      symbol: "DAI.e",
      name: "Dai Stablecoin"
    }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin"
    }),
    // new Token({
    //     chainId: ChainId.AVAX_MAINNET,
    //     address: '0x260Bbf5698121EB85e7a74f2E45E16Ce762EbE11',
    //     decimals: 6,
    //     symbol: 'UST',
    //     name: 'Axelar Wrapped UST',
    // }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [137 /* MATIC_MAINNET */]: [
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      decimals: 6,
      symbol: "USDC",
      name: "USDC"
    }),
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    }),
    // new Token({
    //     chainId: ChainId.MATIC_MAINNET,
    //     address: '0x831753DD7087CaC61aB5644b308642cc1c33Dc13',
    //     decimals: 18,
    //     symbol: 'QUICK',
    //     name: 'QuickSwap',
    // }),
    // new Token({
    //     chainId: ChainId.MATIC_MAINNET,
    //     address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    //     decimals: 18,
    //     symbol: 'ETH',
    //     name: 'Ether',
    // }),
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
      decimals: 18,
      symbol: "wBTC",
      name: "Wrapped Bitcoin"
    }),
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
      decimals: 18,
      symbol: "DAI",
      name: "Dai Stablecoin"
    })
  ],
  [43288 /* BOBA_AVALANCHE */]: [],
  [56288 /* BOBA_BNB */]: [],
  [288 /* BOBA_MAINNET */]: [
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "DAI",
      name: "Dai Stablecoin",
      address: "0xf74195Bb8a5cf652411867c5C2C5b8C2a402be35",
      decimals: 18
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "WBTC",
      name: "Wrapped BTC",
      address: "0xdc0486f8bf31DF57a952bcd3c1d3e166e3d9eC8b",
      decimals: 8
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      name: "USD Coin",
      address: "0x66a2A913e447d6b4BF33EFbec43aAeF87890FBbc",
      symbol: "USDC",
      decimals: 6
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "USDT",
      name: "Tether USD",
      address: "0x5DE1677344D3Cb0D7D465c10b72A8f60699C062d",
      decimals: 6
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "BOBA",
      name: "Boba Token",
      address: "0xa18bF3994C0Cc6E3b63ac420308E5383f53120D7",
      decimals: 18
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "OLO",
      name: "OolongSwap Token",
      address: "0x5008F837883EA9a07271a1b5eB0658404F5a9610",
      decimals: 18
    })
  ],
  [2001 /* MILKOMEDA_MAINNET */]: [
    new Token({
      chainId: 2001 /* MILKOMEDA_MAINNET */,
      symbol: "sUSDC",
      name: "USDC from Ethereum",
      address: "0x42110A5133F91B49E32B671Db86E2C44Edc13832",
      decimals: 6
    }),
    new Token({
      chainId: 2001 /* MILKOMEDA_MAINNET */,
      symbol: "SIS",
      name: "SIS from Ethereum",
      address: "0xedd4D7DAa6bf8746997CEbbF974a60B838757601",
      decimals: 18
    })
  ],
  [1313161554 /* AURORA_MAINNET */]: [
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "USDC",
      name: "USD Coin",
      address: "0xB12BFcA5A55806AaF64E99521918A4bf0fC40802",
      decimals: 6
    }),
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "USDT",
      name: "Tether USD",
      address: "0x4988a896b1227218e4A686fdE5EabdcAbd91571f",
      decimals: 6
    }),
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "wNEAR",
      name: "Wrapped NEAR",
      address: "0xC42C30aC6Cc15faC9bD938618BcaA1a1FaE8501d",
      decimals: 24
    }),
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "AURORA",
      name: "AURORA",
      address: "0x8BEc47865aDe3B172A928df8f990Bc7f2A3b9f79",
      decimals: 18
    })
  ],
  [2222 /* KAVA_MAINNET */]: [
    new Token({
      chainId: 2222 /* KAVA_MAINNET */,
      address: "0xfA9343C3897324496A05fC75abeD6bAC29f8A40f",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [534353 /* SCROLL_TESTNET */]: [],
  [534351 /* SCROLL_SEPOLIA */]: [],
  [324 /* ZKSYNC_MAINNET */]: [
    new Token({
      chainId: 324 /* ZKSYNC_MAINNET */,
      address: "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [42161 /* ARBITRUM_MAINNET */]: [
    new Token({
      chainId: 42161 /* ARBITRUM_MAINNET */,
      address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [42170 /* ARBITRUM_NOVA */]: [
    new Token({
      chainId: 42170 /* ARBITRUM_NOVA */,
      address: "0x750ba8b76187092B0D1E87E28daaf484d1b5273b",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [10 /* OPTIMISM_MAINNET */]: [
    new Token({
      chainId: 10 /* OPTIMISM_MAINNET */,
      address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [7001 /* ZETACHAIN_ATHENS_2 */]: [],
  [1101 /* POLYGON_ZK */]: [],
  [2494104990 /* TRON_TESTNET */]: [
    new Token({
      chainId: 2494104990 /* TRON_TESTNET */,
      address: "TG3XXyExBkPp9nzdajDZsozEu4BkaSJozs",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    })
  ],
  [728126428 /* TRON_MAINNET */]: [
    new Token({
      chainId: 728126428 /* TRON_MAINNET */,
      address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    })
  ],
  [59140 /* LINEA_TESTNET */]: [],
  [59144 /* LINEA_MAINNET */]: [],
  [5e3 /* MANTLE_MAINNET */]: [],
  [5001 /* MANTLE_TESTNET */]: [],
  [8453 /* BASE_MAINNET */]: [],
  [534352 /* SCROLL_MAINNET */]: []
};
var BASES_TO_CHECK_TRADES_AGAINST = {
  ...WETH_ONLY,
  [1 /* ETH_MAINNET */]: [WETH[1 /* ETH_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1 /* ETH_MAINNET */]],
  [56 /* BSC_MAINNET */]: [WETH[56 /* BSC_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[56 /* BSC_MAINNET */]],
  [43114 /* AVAX_MAINNET */]: [WETH[43114 /* AVAX_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[43114 /* AVAX_MAINNET */]],
  [137 /* MATIC_MAINNET */]: [
    WETH[137 /* MATIC_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[137 /* MATIC_MAINNET */]
  ],
  [288 /* BOBA_MAINNET */]: [WETH[288 /* BOBA_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[288 /* BOBA_MAINNET */]],
  [43288 /* BOBA_AVALANCHE */]: [
    WETH[43288 /* BOBA_AVALANCHE */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[43288 /* BOBA_AVALANCHE */]
  ],
  [56288 /* BOBA_BNB */]: [WETH[56288 /* BOBA_BNB */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[56288 /* BOBA_BNB */]],
  [1313161554 /* AURORA_MAINNET */]: [
    WETH[1313161554 /* AURORA_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1313161554 /* AURORA_MAINNET */]
  ],
  [2222 /* KAVA_MAINNET */]: [WETH[2222 /* KAVA_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[2222 /* KAVA_MAINNET */]],
  [324 /* ZKSYNC_MAINNET */]: [
    WETH[324 /* ZKSYNC_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[324 /* ZKSYNC_MAINNET */]
  ],
  [42161 /* ARBITRUM_MAINNET */]: [
    WETH[42161 /* ARBITRUM_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[42161 /* ARBITRUM_MAINNET */]
  ],
  [42170 /* ARBITRUM_NOVA */]: [
    WETH[42170 /* ARBITRUM_NOVA */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[42170 /* ARBITRUM_NOVA */]
  ],
  [10 /* OPTIMISM_MAINNET */]: [
    WETH[10 /* OPTIMISM_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[10 /* OPTIMISM_MAINNET */]
  ],
  [1101 /* POLYGON_ZK */]: [WETH[1101 /* POLYGON_ZK */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1101 /* POLYGON_ZK */]],
  [2494104990 /* TRON_TESTNET */]: [WETH[2494104990 /* TRON_TESTNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[2494104990 /* TRON_TESTNET */]]
};
var CUSTOM_BASES = {
  [56 /* BSC_MAINNET */]: {}
};
var ONE_BIPS = new Percent(JSBI8.BigInt(1), JSBI8.BigInt(1e4));
var BIPS_BASE = JSBI8.BigInt(1e4);
var MULTICALL_ADDRESSES = {
  [1 /* ETH_MAINNET */]: "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
  [4 /* ETH_RINKEBY */]: "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
  [5 /* ETH_GOERLI */]: "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
  [42 /* ETH_KOVAN */]: "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
  [56 /* BSC_MAINNET */]: "0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B",
  [97 /* BSC_TESTNET */]: "0xbC4F726A6dB460DcFE49E6a56886470B94Dfc302",
  [137 /* MATIC_MAINNET */]: "0x275617327c958bD06b5D6b871E7f491D76113dd8",
  [80001 /* MATIC_MUMBAI */]: "0xe9939e7Ea7D7fb619Ac57f648Da7B1D425832631",
  [43114 /* AVAX_MAINNET */]: "0x29b6603d17b9d8f021ecb8845b6fd06e1adf89de",
  [43113 /* AVAX_TESTNET */]: "0x9A9b5Ef5CeAbaC69d3B4A71c4da782554A35B638",
  [128 /* HECO_MAINNET */]: AddressZero,
  // TODO
  [256 /* HECO_TESTNET */]: "0x9a9b5ef5ceabac69d3b4a71c4da782554a35b638",
  [66 /* OKEX_MAINNET */]: AddressZero,
  // TODO
  [65 /* OKEX_TESTNET */]: "0x9A9b5Ef5CeAbaC69d3B4A71c4da782554A35B638",
  [288 /* BOBA_MAINNET */]: "0xaeD5b25BE1c3163c907a471082640450F928DDFE",
  [43288 /* BOBA_AVALANCHE */]: "0x92C5b5B66988E6B8931a8CD3faa418b42003DF2F",
  [56288 /* BOBA_BNB */]: "0x31cCe73DA4365342bd081F6a748AAdb7c7a49b7E",
  [28 /* BOBA_RINKEBY */]: "0x773ccf8ba321c9f96a100b4b0fa1ecf7046645f5",
  [2001 /* MILKOMEDA_MAINNET */]: "0xa46157Cda2D019Ba4cDcd8cE12A04760c15C355b",
  [200101 /* MILKOMEDA_DEVNET */]: "0x41b5984f45AfB2560a0ED72bB69A98E8b32B3cCA",
  [1313161554 /* AURORA_MAINNET */]: "0xbf69a56d35b8d6f5a8e0e96b245a72f735751e54",
  [1313161555 /* AURORA_TESTNET */]: "0x4a5143B13C84DB00E6d8c19b9EA00f3b91416d20",
  [40 /* TELOS_MAINNET */]: "0x53dC7535028e2fcaCa0d847AD108b9240C0801b1",
  [41 /* TELOS_TESTNET */]: "0x9a01bf917477dd9f5d715d188618fc8b7350cd22",
  [8081 /* SHARDEUM_TESTNET_2 */]: "0x41b5984f45AfB2560a0ED72bB69A98E8b32B3cCA",
  [2222 /* KAVA_MAINNET */]: "0x30A62aA52Fa099C4B227869EB6aeaDEda054d121",
  [534353 /* SCROLL_TESTNET */]: "0x41b5984f45AfB2560a0ED72bB69A98E8b32B3cCA",
  [534351 /* SCROLL_SEPOLIA */]: "0xF3Cfa393be621097669BcD2bD4923CEC347E1210",
  [324 /* ZKSYNC_MAINNET */]: "0x52192C3De01535a9Ad2743A5Fe4f774868103C20",
  [42161 /* ARBITRUM_MAINNET */]: "0x80c7dd17b01855a6d2347444a0fcc36136a314de",
  [42170 /* ARBITRUM_NOVA */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [10 /* OPTIMISM_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [7001 /* ZETACHAIN_ATHENS_2 */]: "0x9a01bf917477dD9F5D715D188618fc8B7350cd22",
  [1101 /* POLYGON_ZK */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [2494104990 /* TRON_TESTNET */]: "0x00e08cb2cd7480ddf6c54430207dff81ce359887",
  [728126428 /* TRON_MAINNET */]: "0x32A4F47A74A6810BD0BF861CABAB99656A75DE9E",
  [59140 /* LINEA_TESTNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [59144 /* LINEA_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [5e3 /* MANTLE_MAINNET */]: "0xb55cc6B5B402437b66c13c0CEd0EF367aa7c26da",
  [5001 /* MANTLE_TESTNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [8453 /* BASE_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [534352 /* SCROLL_MAINNET */]: "0x81aB74A9f9d7457fF47dfD102e78A340cF72EC39"
};

// src/crosschain/types.ts
var Field = /* @__PURE__ */ ((Field2) => {
  Field2["INPUT"] = "INPUT";
  Field2["OUTPUT"] = "OUTPUT";
  return Field2;
})(Field || {});

// src/crosschain/utils.ts
import flatMap from "lodash.flatmap";

// src/crosschain/error.ts
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2[ErrorCode2["DEFAULT"] = 0] = "DEFAULT";
  ErrorCode2[ErrorCode2["NO_ROUTE"] = 1] = "NO_ROUTE";
  ErrorCode2[ErrorCode2["AMOUNT_TOO_LOW"] = 2] = "AMOUNT_TOO_LOW";
  ErrorCode2[ErrorCode2["AMOUNT_TOO_HIGH"] = 3] = "AMOUNT_TOO_HIGH";
  ErrorCode2[ErrorCode2["AMOUNT_LESS_THAN_FEE"] = 4] = "AMOUNT_LESS_THAN_FEE";
  ErrorCode2[ErrorCode2["NO_TRANSIT_TOKEN"] = 5] = "NO_TRANSIT_TOKEN";
  ErrorCode2[ErrorCode2["NO_TRANSIT_POOL"] = 6] = "NO_TRANSIT_POOL";
  return ErrorCode2;
})(ErrorCode || {});
var Error2 = class {
  constructor(message, code) {
    this.code = code || 0 /* DEFAULT */;
    this.message = message;
  }
};

// src/crosschain/utils.ts
var canOneInch = (chainId) => {
  return ONE_INCH_CHAINS.includes(chainId);
};
function getInternalId({ contractAddress, requestCount, chainId }) {
  return utils2.solidityKeccak256(["address", "uint256", "uint256"], [contractAddress, requestCount, chainId]);
}
function getExternalId({
  internalId,
  contractAddress,
  revertableAddress,
  chainId
}) {
  return utils2.solidityKeccak256(
    ["bytes32", "address", "address", "uint256"],
    [internalId, contractAddress, revertableAddress, chainId]
  );
}
function calculateGasMargin(value) {
  return value.mul(BigNumber.from(1e4).add(BigNumber.from(1e3))).div(BigNumber.from(1e4));
}
function computeTradePriceBreakdown(trade, dexFee) {
  const BASE_FEE = new Percent(JSBI9.BigInt(dexFee || 30), JSBI9.BigInt(1e4));
  const ONE_HUNDRED_PERCENT = new Percent(JSBI9.BigInt(1e4), JSBI9.BigInt(1e4));
  const INPUT_FRACTION_AFTER_FEE = ONE_HUNDRED_PERCENT.subtract(BASE_FEE);
  const realizedLPFee = !trade ? void 0 : ONE_HUNDRED_PERCENT.subtract(
    trade.route.pairs.reduce(
      (currentFee) => currentFee.multiply(INPUT_FRACTION_AFTER_FEE),
      ONE_HUNDRED_PERCENT
    )
  );
  const priceImpactWithoutFeeFraction = trade && realizedLPFee ? trade.priceImpact.subtract(realizedLPFee) : void 0;
  const priceImpactWithoutFeePercent = priceImpactWithoutFeeFraction ? new Percent(priceImpactWithoutFeeFraction?.numerator, priceImpactWithoutFeeFraction?.denominator) : void 0;
  const realizedLPFeeAmount = realizedLPFee && trade && new TokenAmount(trade.inputAmount.token, realizedLPFee.multiply(trade.inputAmount.raw).quotient);
  return {
    priceImpactWithoutFee: priceImpactWithoutFeePercent,
    realizedLPFee: realizedLPFeeAmount
  };
}
function basisPointsToPercent(num) {
  return new Percent(JSBI9.BigInt(Math.floor(num)), JSBI9.BigInt(1e4));
}
function getMinAmount(slippage, amount) {
  const slippageTolerance = basisPointsToPercent(slippage);
  return new Fraction(ONE).subtract(slippageTolerance).multiply(amount).quotient;
}
function computeSlippageAdjustedAmounts(trade, allowedSlippage) {
  const pct = basisPointsToPercent(allowedSlippage);
  return {
    ["INPUT" /* INPUT */]: trade?.maximumAmountIn(pct),
    ["OUTPUT" /* OUTPUT */]: trade?.minimumAmountOut(pct)
  };
}
function calculatePriceImpact(tokenAmountIn, tokenAmountOut) {
  const typedValueParsed = parseUnits(
    tokenAmountOut.toExact(tokenAmountIn.token.decimals),
    tokenAmountIn.token.decimals
  ).toString();
  if (typedValueParsed === "0") {
    throw new Error2("Cannot parse amountOut with decimals");
  }
  const amountIn = tokenAmountIn.raw;
  const amountOut = JSBI9.BigInt(typedValueParsed);
  const diff = JSBI9.subtract(amountIn, amountOut);
  const value = JSBI9.divide(JSBI9.multiply(diff, BIPS_BASE), amountIn);
  return new Percent(value, BIPS_BASE);
}
var GetLogTimeoutExceededError = class extends Error2 {
  constructor(filter) {
    super(`Timed out waiting for logs matching filter: ${JSON.stringify(filter)}`);
    this.filter = filter;
  }
};
var DEFAULT_EXCEED_DELAY = 1e3 * 60 * 20;
async function getLogWithTimeout({
  symbiosis,
  chainId,
  filter,
  exceedDelay: exceedTimeout = DEFAULT_EXCEED_DELAY
}) {
  const provider = symbiosis.getProvider(chainId);
  let activeFilter = filter;
  if (!activeFilter.fromBlock) {
    const fromBlock = await symbiosis.getFromBlockWithOffset(chainId);
    activeFilter = { ...filter, fromBlock };
  }
  return new Promise((resolve, reject) => {
    const period = 1e3 * 60;
    let pastTime = 0;
    const interval = setInterval(() => {
      pastTime += period;
      if (pastTime > exceedTimeout) {
        clearInterval(interval);
        provider.off(activeFilter, listener);
        reject(new GetLogTimeoutExceededError(activeFilter));
        return;
      }
      provider.getLogs(activeFilter).then((logs) => {
        if (logs.length > 0) {
          resolve(logs[0]);
          clearInterval(interval);
          provider.off(activeFilter, listener);
        }
      }).catch((error) => {
        reject(error);
      });
    }, period);
    const listener = (log) => {
      clearInterval(interval);
      resolve(log);
    };
    provider.once(activeFilter, listener);
  });
}
var TELOS_MPC_ADDRESS = "0xDcB7d65b15436CE9B608864ACcff75871C6556FC";
async function prepareTransactionRequest(transactionRequest, signer) {
  const { provider } = signer;
  if (!provider) {
    throw new Error2("Signer has no provider");
  }
  const preparedTransactionRequest = { ...transactionRequest };
  let { from } = transactionRequest;
  if (transactionRequest.chainId === 40 /* TELOS_MAINNET */) {
    from = TELOS_MPC_ADDRESS;
  }
  const gasLimit = await provider.estimateGas({ ...transactionRequest, from });
  preparedTransactionRequest.gasLimit = calculateGasMargin(gasLimit);
  const { chainId: requestChainId } = preparedTransactionRequest;
  if (requestChainId === 137 /* MATIC_MAINNET */ || requestChainId === 80001 /* MATIC_MUMBAI */) {
    const gasPrice = await signer.getGasPrice();
    preparedTransactionRequest.gasPrice = gasPrice.mul(2);
  }
  return preparedTransactionRequest;
}
function getAllPairCombinations(tokenIn, tokenOut) {
  const chainId = tokenIn.chainId;
  const bases = BASES_TO_CHECK_TRADES_AGAINST[chainId];
  if (!bases) {
    throw new Error2("Bases not found");
  }
  const basePairs = flatMap(
    bases,
    (base) => bases.map((otherBase) => [base, otherBase])
  ).filter(([t0, t1]) => t0.address !== t1.address);
  const [tokenA, tokenB] = [wrappedToken(tokenIn), wrappedToken(tokenOut)];
  if (!tokenA || !tokenB) {
    return [];
  }
  return [
    // the direct pair
    [tokenA, tokenB],
    // token A against all bases
    ...bases.map((base) => [tokenA, base]),
    // token B against all bases
    ...bases.map((base) => [tokenB, base]),
    // each base against all bases
    ...basePairs
  ].filter((tokens) => Boolean(tokens[0] && tokens[1])).filter(([t0, t1]) => t0.address !== t1.address).filter(([t0, t1]) => {
    if (!chainId)
      return true;
    const customBases = CUSTOM_BASES[chainId];
    if (!customBases)
      return true;
    const customBasesA = customBases[t0.address];
    const customBasesB = customBases[t1.address];
    if (!customBasesA && !customBasesB)
      return true;
    if (customBasesA && !customBasesA.find((base) => t1.equals(base)))
      return false;
    if (customBasesB && !customBasesB.find((base) => t0.equals(base)))
      return false;
    return true;
  });
}
function splitSlippage(totalSlippage, hasTradeA, hasTradeC) {
  const MINIMUM_SLIPPAGE = 20;
  if (totalSlippage < MINIMUM_SLIPPAGE) {
    throw new Error2("Slippage cannot be less than 0.2%");
  }
  let swapsCount = 1;
  let extraSwapsCount = 0;
  if (hasTradeA) {
    extraSwapsCount += 1;
  }
  if (hasTradeC) {
    extraSwapsCount += 1;
  }
  swapsCount += extraSwapsCount;
  const slippage = Math.floor(totalSlippage / swapsCount);
  let aMul = 1;
  let cMul = 1;
  if (extraSwapsCount == 2) {
    aMul = 0.8;
    cMul = 1.2;
  }
  const MAX_STABLE_SLIPPAGE = 50;
  if (slippage > MAX_STABLE_SLIPPAGE) {
    const diff = slippage - MAX_STABLE_SLIPPAGE;
    const addition = extraSwapsCount > 0 ? diff / extraSwapsCount : 0;
    return {
      A: hasTradeA ? (slippage + addition) * aMul : 0,
      B: MAX_STABLE_SLIPPAGE,
      C: hasTradeC ? (slippage + addition) * cMul : 0
    };
  }
  return {
    A: hasTradeA ? slippage * aMul : 0,
    B: slippage,
    C: hasTradeC ? slippage * cMul : 0
  };
}

// src/crosschain/revertRequest.ts
import { parseUnits as parseUnits2 } from "@ethersproject/units";

// src/crosschain/contracts/factories/Aave__factory.ts
import { Contract as Contract2, utils as utils3 } from "ethers";
var _abi = [
  {
    inputs: [
      {
        internalType: "contract IPoolAddressesProvider",
        name: "provider",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "backer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "BackUnbacked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "enum DataTypes.InterestRateMode",
        name: "interestRateMode",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "borrowRate",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "Borrow",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "initiator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "enum DataTypes.InterestRateMode",
        name: "interestRateMode",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "premium",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "FlashLoan",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalDebt",
        type: "uint256"
      }
    ],
    name: "IsolationModeTotalDebtUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "collateralAsset",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "debtAsset",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "debtToCover",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidatedCollateralAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "receiveAToken",
        type: "bool"
      }
    ],
    name: "LiquidationCall",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "MintUnbacked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountMinted",
        type: "uint256"
      }
    ],
    name: "MintedToTreasury",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "RebalanceStableBorrowRate",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "repayer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "useATokens",
        type: "bool"
      }
    ],
    name: "Repay",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidityRate",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableBorrowRate",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "variableBorrowRate",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidityIndex",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "variableBorrowIndex",
        type: "uint256"
      }
    ],
    name: "ReserveDataUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "ReserveUsedAsCollateralDisabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "ReserveUsedAsCollateralEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "Supply",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum DataTypes.InterestRateMode",
        name: "interestRateMode",
        type: "uint8"
      }
    ],
    name: "SwapBorrowRateMode",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "categoryId",
        type: "uint8"
      }
    ],
    name: "UserEModeSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "reserve",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Withdraw",
    type: "event"
  },
  {
    inputs: [],
    name: "ADDRESSES_PROVIDER",
    outputs: [
      {
        internalType: "contract IPoolAddressesProvider",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "BRIDGE_PROTOCOL_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "FLASHLOAN_PREMIUM_TOTAL",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "FLASHLOAN_PREMIUM_TO_PROTOCOL",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_NUMBER_RESERVES",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_STABLE_RATE_BORROW_SIZE_PERCENT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "POOL_REVISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "backUnbacked",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "interestRateMode",
        type: "uint256"
      },
      {
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      }
    ],
    name: "borrow",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "id",
        type: "uint8"
      },
      {
        components: [
          {
            internalType: "uint16",
            name: "ltv",
            type: "uint16"
          },
          {
            internalType: "uint16",
            name: "liquidationThreshold",
            type: "uint16"
          },
          {
            internalType: "uint16",
            name: "liquidationBonus",
            type: "uint16"
          },
          {
            internalType: "address",
            name: "priceSource",
            type: "address"
          },
          {
            internalType: "string",
            name: "label",
            type: "string"
          }
        ],
        internalType: "struct DataTypes.EModeCategory",
        name: "category",
        type: "tuple"
      }
    ],
    name: "configureEModeCategory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "dropReserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "balanceFromBefore",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "balanceToBefore",
        type: "uint256"
      }
    ],
    name: "finalizeTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiverAddress",
        type: "address"
      },
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "interestRateModes",
        type: "uint256[]"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "params",
        type: "bytes"
      },
      {
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "flashLoan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiverAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "params",
        type: "bytes"
      },
      {
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "flashLoanSimple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "getConfiguration",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "data",
            type: "uint256"
          }
        ],
        internalType: "struct DataTypes.ReserveConfigurationMap",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "id",
        type: "uint8"
      }
    ],
    name: "getEModeCategoryData",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "ltv",
            type: "uint16"
          },
          {
            internalType: "uint16",
            name: "liquidationThreshold",
            type: "uint16"
          },
          {
            internalType: "uint16",
            name: "liquidationBonus",
            type: "uint16"
          },
          {
            internalType: "address",
            name: "priceSource",
            type: "address"
          },
          {
            internalType: "string",
            name: "label",
            type: "string"
          }
        ],
        internalType: "struct DataTypes.EModeCategory",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16"
      }
    ],
    name: "getReserveAddressById",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "getReserveData",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "data",
                type: "uint256"
              }
            ],
            internalType: "struct DataTypes.ReserveConfigurationMap",
            name: "configuration",
            type: "tuple"
          },
          {
            internalType: "uint128",
            name: "liquidityIndex",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "currentLiquidityRate",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "variableBorrowIndex",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "currentVariableBorrowRate",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "currentStableBorrowRate",
            type: "uint128"
          },
          {
            internalType: "uint40",
            name: "lastUpdateTimestamp",
            type: "uint40"
          },
          {
            internalType: "uint16",
            name: "id",
            type: "uint16"
          },
          {
            internalType: "address",
            name: "aTokenAddress",
            type: "address"
          },
          {
            internalType: "address",
            name: "stableDebtTokenAddress",
            type: "address"
          },
          {
            internalType: "address",
            name: "variableDebtTokenAddress",
            type: "address"
          },
          {
            internalType: "address",
            name: "interestRateStrategyAddress",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "accruedToTreasury",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "unbacked",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "isolationModeTotalDebt",
            type: "uint128"
          }
        ],
        internalType: "struct DataTypes.ReserveData",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "getReserveNormalizedIncome",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "getReserveNormalizedVariableDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getReservesList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "getUserAccountData",
    outputs: [
      {
        internalType: "uint256",
        name: "totalCollateralBase",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "totalDebtBase",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "availableBorrowsBase",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "currentLiquidationThreshold",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "ltv",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "healthFactor",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "getUserConfiguration",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "data",
            type: "uint256"
          }
        ],
        internalType: "struct DataTypes.UserConfigurationMap",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "getUserEMode",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "address",
        name: "aTokenAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "stableDebtAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "variableDebtAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "interestRateStrategyAddress",
        type: "address"
      }
    ],
    name: "initReserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IPoolAddressesProvider",
        name: "provider",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collateralAsset",
        type: "address"
      },
      {
        internalType: "address",
        name: "debtAsset",
        type: "address"
      },
      {
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "debtToCover",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "receiveAToken",
        type: "bool"
      }
    ],
    name: "liquidationCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]"
      }
    ],
    name: "mintToTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "mintUnbacked",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "rebalanceStableBorrowRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "interestRateMode",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      }
    ],
    name: "repay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "interestRateMode",
        type: "uint256"
      }
    ],
    name: "repayWithATokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "interestRateMode",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "permitV",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "permitR",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "permitS",
        type: "bytes32"
      }
    ],
    name: "repayWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "rescueTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "resetIsolationModeTotalDebt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "data",
            type: "uint256"
          }
        ],
        internalType: "struct DataTypes.ReserveConfigurationMap",
        name: "configuration",
        type: "tuple"
      }
    ],
    name: "setConfiguration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "address",
        name: "rateStrategyAddress",
        type: "address"
      }
    ],
    name: "setReserveInterestRateStrategyAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "categoryId",
        type: "uint8"
      }
    ],
    name: "setUserEMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "bool",
        name: "useAsCollateral",
        type: "bool"
      }
    ],
    name: "setUserUseReserveAsCollateral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      }
    ],
    name: "supply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "onBehalfOf",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "referralCode",
        type: "uint16"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "permitV",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "permitR",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "permitS",
        type: "bytes32"
      }
    ],
    name: "supplyWithPermit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "interestRateMode",
        type: "uint256"
      }
    ],
    name: "swapBorrowRateMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "protocolFee",
        type: "uint256"
      }
    ],
    name: "updateBridgeProtocolFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "flashLoanPremiumTotal",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "flashLoanPremiumToProtocol",
        type: "uint128"
      }
    ],
    name: "updateFlashloanPremiums",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var Aave__factory = class {
  static createInterface() {
    return new utils3.Interface(_abi);
  }
  static connect(address, signerOrProvider) {
    return new Contract2(address, _abi, signerOrProvider);
  }
};
Aave__factory.abi = _abi;

// src/crosschain/contracts/factories/AdaRouter__factory.ts
import { Contract as Contract3, utils as utils4 } from "ethers";
var _abi2 = [
  {
    type: "constructor",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "_factory",
        internalType: "address"
      },
      {
        type: "address",
        name: "_WADA",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address"
      }
    ],
    name: "WADA",
    inputs: []
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "amountADesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidityADA",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "amountTokenDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address"
      }
    ],
    name: "factory",
    inputs: []
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      }
    ],
    name: "getAmountIn",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveOut",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      }
    ],
    name: "getAmountOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveOut",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "getAmountsIn",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "getAmountsOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "quote",
    inputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveB",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADA",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADASupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADAWithPermit",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADAWithPermitSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityWithPermit",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapADAForExactTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactADAForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [],
    name: "swapExactADAForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForADA",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForADASupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapTokensForExactADA",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountInMax",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapTokensForExactTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountInMax",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "receive",
    stateMutability: "payable"
  }
];
var AdaRouter__factory = class {
  static createInterface() {
    return new utils4.Interface(_abi2);
  }
  static connect(address, signerOrProvider) {
    return new Contract3(address, _abi2, signerOrProvider);
  }
};
AdaRouter__factory.abi = _abi2;

// src/crosschain/contracts/factories/AvaxRouter__factory.ts
import { Contract as Contract4, utils as utils5 } from "ethers";
var _abi3 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WAVAX",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WAVAX",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityAVAX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityAVAX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityAVAXSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityAVAXWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityAVAXWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapAVAXForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactAVAXForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactAVAXForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForAVAX",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForAVAXSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactAVAX",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var AvaxRouter__factory = class {
  static createInterface() {
    return new utils5.Interface(_abi3);
  }
  static connect(address, signerOrProvider) {
    return new Contract4(address, _abi3, signerOrProvider);
  }
};
AvaxRouter__factory.abi = _abi3;

// src/crosschain/contracts/factories/BeefyVault__factory.ts
import { Contract as Contract5, utils as utils6 } from "ethers";
var _abi4 = [
  {
    inputs: [
      {
        internalType: "contract IStrategy",
        name: "_strategy",
        type: "address"
      },
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "_approvalDelay",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "NewStratCandidate",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "UpgradeStrat",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "approvalDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "available",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "balance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "depositAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "earn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "getPricePerFullShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "inCaseTokensGetStuck",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_implementation",
        type: "address"
      }
    ],
    name: "proposeStrat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "stratCandidate",
    outputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "proposedTime",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "strategy",
    outputs: [
      {
        internalType: "contract IStrategy",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "upgradeStrat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "want",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_shares",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var BeefyVault__factory = class {
  static createInterface() {
    return new utils6.Interface(_abi4);
  }
  static connect(address, signerOrProvider) {
    return new Contract5(address, _abi4, signerOrProvider);
  }
};
BeefyVault__factory.abi = _abi4;

// src/crosschain/contracts/factories/BenqiQiErc20__factory.ts
import { Contract as Contract6, utils as utils7 } from "ethers";
var _abi5 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "underlying_",
        type: "address"
      },
      {
        internalType: "contract ComptrollerInterface",
        name: "comptroller_",
        type: "address"
      },
      {
        internalType: "contract InterestRateModel",
        name: "interestRateModel_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "initialExchangeRateMantissa_",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "uint8",
        name: "decimals_",
        type: "uint8"
      },
      {
        internalType: "address payable",
        name: "admin_",
        type: "address"
      },
      {
        internalType: "address",
        name: "implementation_",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "becomeImplementationData",
        type: "bytes"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "cashPrior",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestAccumulated",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "borrowIndex",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalBorrows",
        type: "uint256"
      }
    ],
    name: "AccrueInterest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "accountBorrows",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalBorrows",
        type: "uint256"
      }
    ],
    name: "Borrow",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "error",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "info",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "detail",
        type: "uint256"
      }
    ],
    name: "Failure",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "qiTokenCollateral",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seizeTokens",
        type: "uint256"
      }
    ],
    name: "LiquidateBorrow",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "minter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintTokens",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldAdmin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "NewAdmin",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ComptrollerInterface",
        name: "oldComptroller",
        type: "address"
      },
      {
        indexed: false,
        internalType: "contract ComptrollerInterface",
        name: "newComptroller",
        type: "address"
      }
    ],
    name: "NewComptroller",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldImplementation",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "NewImplementation",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract InterestRateModel",
        name: "oldInterestRateModel",
        type: "address"
      },
      {
        indexed: false,
        internalType: "contract InterestRateModel",
        name: "newInterestRateModel",
        type: "address"
      }
    ],
    name: "NewMarketInterestRateModel",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldPendingAdmin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newPendingAdmin",
        type: "address"
      }
    ],
    name: "NewPendingAdmin",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldProtocolSeizeShareMantissa",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newProtocolSeizeShareMantissa",
        type: "uint256"
      }
    ],
    name: "NewProtocolSeizeShare",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldReserveFactorMantissa",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newReserveFactorMantissa",
        type: "uint256"
      }
    ],
    name: "NewReserveFactor",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "redeemer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "redeemAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "redeemTokens",
        type: "uint256"
      }
    ],
    name: "Redeem",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "accountBorrows",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalBorrows",
        type: "uint256"
      }
    ],
    name: "RepayBorrow",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "benefactor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTotalReserves",
        type: "uint256"
      }
    ],
    name: "ReservesAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reduceAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTotalReserves",
        type: "uint256"
      }
    ],
    name: "ReservesReduced",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    payable: true,
    stateMutability: "payable",
    type: "fallback"
  },
  {
    constant: false,
    inputs: [],
    name: "_acceptAdmin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "addAmount",
        type: "uint256"
      }
    ],
    name: "_addReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "reduceAmount",
        type: "uint256"
      }
    ],
    name: "_reduceReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract ComptrollerInterface",
        name: "newComptroller",
        type: "address"
      }
    ],
    name: "_setComptroller",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "implementation_",
        type: "address"
      },
      {
        internalType: "bool",
        name: "allowResign",
        type: "bool"
      },
      {
        internalType: "bytes",
        name: "becomeImplementationData",
        type: "bytes"
      }
    ],
    name: "_setImplementation",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract InterestRateModel",
        name: "newInterestRateModel",
        type: "address"
      }
    ],
    name: "_setInterestRateModel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address payable",
        name: "newPendingAdmin",
        type: "address"
      }
    ],
    name: "_setPendingAdmin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "newProtocolSeizeShareMantissa",
        type: "uint256"
      }
    ],
    name: "_setProtocolSeizeShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "newReserveFactorMantissa",
        type: "uint256"
      }
    ],
    name: "_setReserveFactor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "accrualBlockTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "accrueInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256"
      }
    ],
    name: "borrow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "borrowBalanceCurrent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "borrowBalanceStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "borrowIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "borrowRatePerTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "comptroller",
    outputs: [
      {
        internalType: "contract ComptrollerInterface",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "delegateToImplementation",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "delegateToViewImplementation",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "exchangeRateCurrent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "exchangeRateStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "getAccountSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getCash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "implementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "interestRateModel",
    outputs: [
      {
        internalType: "contract InterestRateModel",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "isQiToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      },
      {
        internalType: "contract QiTokenInterface",
        name: "qiTokenCollateral",
        type: "address"
      }
    ],
    name: "liquidateBorrow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "pendingAdmin",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "protocolSeizeShareMantissa",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "redeemTokens",
        type: "uint256"
      }
    ],
    name: "redeem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "redeemAmount",
        type: "uint256"
      }
    ],
    name: "redeemUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      }
    ],
    name: "repayBorrow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      }
    ],
    name: "repayBorrowBehalf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "reserveFactorMantissa",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "seizeTokens",
        type: "uint256"
      }
    ],
    name: "seize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "supplyRatePerTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract EIP20NonStandardInterface",
        name: "token",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalBorrows",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "totalBorrowsCurrent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "underlying",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  }
];
var BenqiQiErc20__factory = class {
  static createInterface() {
    return new utils7.Interface(_abi5);
  }
  static connect(address, signerOrProvider) {
    return new Contract6(address, _abi5, signerOrProvider);
  }
};
BenqiQiErc20__factory.abi = _abi5;

// src/crosschain/contracts/factories/Bridge__factory.ts
import { utils as utils8, Contract as Contract7, ContractFactory } from "ethers";
var _abi6 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldMPC",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newMPC",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "effectiveTime",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      }
    ],
    name: "LogChangeMPC",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bridge",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "callData",
        type: "bytes"
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiveSide",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oppositeBridge",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      }
    ],
    name: "OracleRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "permission",
        type: "bool"
      }
    ],
    name: "SetAdminPermission",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "transmitter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "SetTransmitterStatus",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newMPC",
        type: "address"
      }
    ],
    name: "changeMPC",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newMPC",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "changeMPCSigned",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "currentChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mpc",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isTransmitter",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mpc",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "newMPC",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "newMPCEffectiveTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oldMPC",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_callData",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      }
    ],
    name: "receiveRequestV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_callData",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "receiveRequestV2Signed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_permission",
        type: "bool"
      }
    ],
    name: "setAdminPermission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_transmitter",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_status",
        type: "bool"
      }
    ],
    name: "setTransmitterStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_callData",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainId",
        type: "uint256"
      }
    ],
    name: "transmitRequestV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawFee",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode = "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";
var isSuperArgs = (xs) => xs.length > 1;
var Bridge__factory = class extends ContractFactory {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs(args)) {
      __super(...args);
    } else {
      __super(_abi6, _bytecode, args[0]);
    }
    this.contractName = "Bridge";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils8.Interface(_abi6);
  }
  static connect(address, signerOrProvider) {
    return new Contract7(address, _abi6, signerOrProvider);
  }
};
Bridge__factory.bytecode = _bytecode;
Bridge__factory.abi = _abi6;

// src/crosschain/contracts/factories/CreamCErc20__factory.ts
import { Contract as Contract8, utils as utils9 } from "ethers";
var _abi7 = [
  {
    inputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "cashPrior",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestAccumulated",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "borrowIndex",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalBorrows",
        type: "uint256"
      }
    ],
    name: "AccrueInterest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "accountBorrows",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalBorrows",
        type: "uint256"
      }
    ],
    name: "Borrow",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "error",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "info",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "detail",
        type: "uint256"
      }
    ],
    name: "Failure",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reservesFee",
        type: "uint256"
      }
    ],
    name: "Flashloan",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "cTokenCollateral",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seizeTokens",
        type: "uint256"
      }
    ],
    name: "LiquidateBorrow",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "minter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintTokens",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldAdmin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "NewAdmin",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newCap",
        type: "uint256"
      }
    ],
    name: "NewCollateralCap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ComptrollerInterface",
        name: "oldComptroller",
        type: "address"
      },
      {
        indexed: false,
        internalType: "contract ComptrollerInterface",
        name: "newComptroller",
        type: "address"
      }
    ],
    name: "NewComptroller",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract InterestRateModel",
        name: "oldInterestRateModel",
        type: "address"
      },
      {
        indexed: false,
        internalType: "contract InterestRateModel",
        name: "newInterestRateModel",
        type: "address"
      }
    ],
    name: "NewMarketInterestRateModel",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldPendingAdmin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newPendingAdmin",
        type: "address"
      }
    ],
    name: "NewPendingAdmin",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldReserveFactorMantissa",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newReserveFactorMantissa",
        type: "uint256"
      }
    ],
    name: "NewReserveFactor",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "redeemer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "redeemAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "redeemTokens",
        type: "uint256"
      }
    ],
    name: "Redeem",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "accountBorrows",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalBorrows",
        type: "uint256"
      }
    ],
    name: "RepayBorrow",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "benefactor",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTotalReserves",
        type: "uint256"
      }
    ],
    name: "ReservesAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reduceAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTotalReserves",
        type: "uint256"
      }
    ],
    name: "ReservesReduced",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newCollateralTokens",
        type: "uint256"
      }
    ],
    name: "UserCollateralChanged",
    type: "event"
  },
  {
    constant: false,
    inputs: [],
    name: "_acceptAdmin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "addAmount",
        type: "uint256"
      }
    ],
    name: "_addReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "_becomeImplementation",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "reduceAmount",
        type: "uint256"
      }
    ],
    name: "_reduceReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "_resignImplementation",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "newCollateralCap",
        type: "uint256"
      }
    ],
    name: "_setCollateralCap",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract ComptrollerInterface",
        name: "newComptroller",
        type: "address"
      }
    ],
    name: "_setComptroller",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract InterestRateModel",
        name: "newInterestRateModel",
        type: "address"
      }
    ],
    name: "_setInterestRateModel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address payable",
        name: "newPendingAdmin",
        type: "address"
      }
    ],
    name: "_setPendingAdmin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "newReserveFactorMantissa",
        type: "uint256"
      }
    ],
    name: "_setReserveFactor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "accountCollateralTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "accrualBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "accrueInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256"
      }
    ],
    name: "borrow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "borrowBalanceCurrent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "borrowBalanceStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "borrowIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "borrowRatePerBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "collateralCap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "comptroller",
    outputs: [
      {
        internalType: "contract ComptrollerInterface",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "uint256",
        name: "change",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "repay",
        type: "bool"
      }
    ],
    name: "estimateBorrowRatePerBlockAfterChange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "uint256",
        name: "change",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "repay",
        type: "bool"
      }
    ],
    name: "estimateSupplyRatePerBlockAfterChange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "exchangeRateCurrent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "exchangeRateStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "flashFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "flashFeeBips",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract ERC3156FlashBorrowerInterface",
        name: "receiver",
        type: "address"
      },
      {
        internalType: "address",
        name: "initiator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "flashLoan",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "getAccountSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getCash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "gulp",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "implementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "underlying_",
        type: "address"
      },
      {
        internalType: "contract ComptrollerInterface",
        name: "comptroller_",
        type: "address"
      },
      {
        internalType: "contract InterestRateModel",
        name: "interestRateModel_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "initialExchangeRateMantissa_",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "uint8",
        name: "decimals_",
        type: "uint8"
      }
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract ComptrollerInterface",
        name: "comptroller_",
        type: "address"
      },
      {
        internalType: "contract InterestRateModel",
        name: "interestRateModel_",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "initialExchangeRateMantissa_",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "uint8",
        name: "decimals_",
        type: "uint8"
      }
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "interestRateModel",
    outputs: [
      {
        internalType: "contract InterestRateModel",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "internalCash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "isCToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isCollateralTokenInit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      },
      {
        internalType: "contract CTokenInterface",
        name: "cTokenCollateral",
        type: "address"
      }
    ],
    name: "liquidateBorrow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "maxFlashLoan",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "pendingAdmin",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "redeemTokens",
        type: "uint256"
      }
    ],
    name: "redeem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "redeemAmount",
        type: "uint256"
      }
    ],
    name: "redeemUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "registerCollateral",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      }
    ],
    name: "repayBorrow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      }
    ],
    name: "repayBorrowBehalf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "reserveFactorMantissa",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "seizeTokens",
        type: "uint256"
      }
    ],
    name: "seize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "supplyRatePerBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalBorrows",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "totalBorrowsCurrent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalCollateralTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalReserves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "underlying",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "unregisterCollateral",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];
var CreamCErc20__factory = class {
  static createInterface() {
    return new utils9.Interface(_abi7);
  }
  static connect(address, signerOrProvider) {
    return new Contract8(address, _abi7, signerOrProvider);
  }
};
CreamCErc20__factory.abi = _abi7;

// src/crosschain/contracts/factories/CreamComptroller__factory.ts
import { Contract as Contract9, utils as utils10 } from "ethers";
var _abi8 = [
  {
    inputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "action",
        type: "string"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "pauseState",
        type: "bool"
      }
    ],
    name: "ActionPaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "action",
        type: "string"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "pauseState",
        type: "bool"
      }
    ],
    name: "ActionPaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "compDelta",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "compBorrowIndex",
        type: "uint256"
      }
    ],
    name: "DistributedBorrowerComp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "supplier",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "compDelta",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "compSupplyIndex",
        type: "uint256"
      }
    ],
    name: "DistributedSupplierComp",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "error",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "info",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "detail",
        type: "uint256"
      }
    ],
    name: "Failure",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      }
    ],
    name: "MarketDelisted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "MarketEntered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "MarketExited",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      }
    ],
    name: "MarketListed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBorrowCap",
        type: "uint256"
      }
    ],
    name: "NewBorrowCap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldBorrowCapGuardian",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newBorrowCapGuardian",
        type: "address"
      }
    ],
    name: "NewBorrowCapGuardian",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum ComptrollerV2Storage.Version",
        name: "oldVersion",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "enum ComptrollerV2Storage.Version",
        name: "newVersion",
        type: "uint8"
      }
    ],
    name: "NewCTokenVersion",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldCloseFactorMantissa",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newCloseFactorMantissa",
        type: "uint256"
      }
    ],
    name: "NewCloseFactor",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldCollateralFactorMantissa",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newCollateralFactorMantissa",
        type: "uint256"
      }
    ],
    name: "NewCollateralFactor",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldLiquidationIncentiveMantissa",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newLiquidationIncentiveMantissa",
        type: "uint256"
      }
    ],
    name: "NewLiquidationIncentive",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldLiquidityMining",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newLiquidityMining",
        type: "address"
      }
    ],
    name: "NewLiquidityMining",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldPauseGuardian",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newPauseGuardian",
        type: "address"
      }
    ],
    name: "NewPauseGuardian",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract PriceOracle",
        name: "oldPriceOracle",
        type: "address"
      },
      {
        indexed: false,
        internalType: "contract PriceOracle",
        name: "newPriceOracle",
        type: "address"
      }
    ],
    name: "NewPriceOracle",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newSupplyCap",
        type: "uint256"
      }
    ],
    name: "NewSupplyCap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldSupplyCapGuardian",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newSupplyCapGuardian",
        type: "address"
      }
    ],
    name: "NewSupplyCapGuardian",
    type: "event"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract Unitroller",
        name: "unitroller",
        type: "address"
      }
    ],
    name: "_become",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "_borrowGuardianPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      }
    ],
    name: "_delistMarket",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "_mintGuardianPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newBorrowCapGuardian",
        type: "address"
      }
    ],
    name: "_setBorrowCapGuardian",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "bool",
        name: "state",
        type: "bool"
      }
    ],
    name: "_setBorrowPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "newCloseFactorMantissa",
        type: "uint256"
      }
    ],
    name: "_setCloseFactor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "newCollateralFactorMantissa",
        type: "uint256"
      }
    ],
    name: "_setCollateralFactor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "bool",
        name: "state",
        type: "bool"
      }
    ],
    name: "_setFlashloanPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "newLiquidationIncentiveMantissa",
        type: "uint256"
      }
    ],
    name: "_setLiquidationIncentive",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newLiquidityMining",
        type: "address"
      }
    ],
    name: "_setLiquidityMining",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken[]",
        name: "cTokens",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "newBorrowCaps",
        type: "uint256[]"
      }
    ],
    name: "_setMarketBorrowCaps",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken[]",
        name: "cTokens",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "newSupplyCaps",
        type: "uint256[]"
      }
    ],
    name: "_setMarketSupplyCaps",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "bool",
        name: "state",
        type: "bool"
      }
    ],
    name: "_setMintPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newPauseGuardian",
        type: "address"
      }
    ],
    name: "_setPauseGuardian",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract PriceOracle",
        name: "newOracle",
        type: "address"
      }
    ],
    name: "_setPriceOracle",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bool",
        name: "state",
        type: "bool"
      }
    ],
    name: "_setSeizePaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "newSupplyCapGuardian",
        type: "address"
      }
    ],
    name: "_setSupplyCapGuardian",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "bool",
        name: "state",
        type: "bool"
      }
    ],
    name: "_setTransferPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "enum ComptrollerV2Storage.Version",
        name: "version",
        type: "uint8"
      }
    ],
    name: "_supportMarket",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "accountAssets",
    outputs: [
      {
        internalType: "contract CToken",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "allMarkets",
    outputs: [
      {
        internalType: "contract CToken",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256"
      }
    ],
    name: "borrowAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "borrowCapGuardian",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "borrowCaps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "borrowGuardianPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256"
      }
    ],
    name: "borrowVerify",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "contract CToken",
        name: "cToken",
        type: "address"
      }
    ],
    name: "checkMembership",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address[]",
        name: "holders",
        type: "address[]"
      },
      {
        internalType: "contract CToken[]",
        name: "cTokens",
        type: "address[]"
      },
      {
        internalType: "bool",
        name: "borrowers",
        type: "bool"
      },
      {
        internalType: "bool",
        name: "suppliers",
        type: "bool"
      }
    ],
    name: "claimComp",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "holder",
        type: "address"
      }
    ],
    name: "claimComp",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "closeFactorMantissa",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "compAccrued",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "compBorrowState",
    outputs: [
      {
        internalType: "uint224",
        name: "index",
        type: "uint224"
      },
      {
        internalType: "uint32",
        name: "block",
        type: "uint32"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "compBorrowerIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "compInitialIndex",
    outputs: [
      {
        internalType: "uint224",
        name: "",
        type: "uint224"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "compRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "compSpeeds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "compSupplierIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "compSupplyState",
    outputs: [
      {
        internalType: "uint224",
        name: "index",
        type: "uint224"
      },
      {
        internalType: "uint32",
        name: "block",
        type: "uint32"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "comptrollerImplementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address[]",
        name: "cTokens",
        type: "address[]"
      }
    ],
    name: "enterMarkets",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cTokenAddress",
        type: "address"
      }
    ],
    name: "exitMarket",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "params",
        type: "bytes"
      }
    ],
    name: "flashloanAllowed",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "flashloanGuardianPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "getAccountLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getAllMarkets",
    outputs: [
      {
        internalType: "contract CToken[]",
        name: "",
        type: "address[]"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "getAssetsIn",
    outputs: [
      {
        internalType: "contract CToken[]",
        name: "",
        type: "address[]"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getCompAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "cTokenModify",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "redeemTokens",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "borrowAmount",
        type: "uint256"
      }
    ],
    name: "getHypotheticalAccountLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "isComptroller",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "cTokenAddress",
        type: "address"
      }
    ],
    name: "isMarketListed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cTokenBorrowed",
        type: "address"
      },
      {
        internalType: "address",
        name: "cTokenCollateral",
        type: "address"
      },
      {
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      }
    ],
    name: "liquidateBorrowAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cTokenBorrowed",
        type: "address"
      },
      {
        internalType: "address",
        name: "cTokenCollateral",
        type: "address"
      },
      {
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "actualRepayAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "seizeTokens",
        type: "uint256"
      }
    ],
    name: "liquidateBorrowVerify",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "cTokenBorrowed",
        type: "address"
      },
      {
        internalType: "address",
        name: "cTokenCollateral",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "actualRepayAmount",
        type: "uint256"
      }
    ],
    name: "liquidateCalculateSeizeTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "liquidationIncentiveMantissa",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "liquidityMining",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "markets",
    outputs: [
      {
        internalType: "bool",
        name: "isListed",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "collateralFactorMantissa",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "isComped",
        type: "bool"
      },
      {
        internalType: "enum ComptrollerV2Storage.Version",
        name: "version",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "maxAssets",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "minter",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256"
      }
    ],
    name: "mintAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "mintGuardianPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "minter",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "actualMintAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "mintTokens",
        type: "uint256"
      }
    ],
    name: "mintVerify",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "oracle",
    outputs: [
      {
        internalType: "contract PriceOracle",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "pauseGuardian",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "pendingAdmin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "pendingComptrollerImplementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "redeemer",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "redeemTokens",
        type: "uint256"
      }
    ],
    name: "redeemAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "redeemer",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "redeemAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "redeemTokens",
        type: "uint256"
      }
    ],
    name: "redeemVerify",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "payer",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "repayAmount",
        type: "uint256"
      }
    ],
    name: "repayBorrowAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "payer",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "actualRepayAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "borrowerIndex",
        type: "uint256"
      }
    ],
    name: "repayBorrowVerify",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cTokenCollateral",
        type: "address"
      },
      {
        internalType: "address",
        name: "cTokenBorrowed",
        type: "address"
      },
      {
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "seizeTokens",
        type: "uint256"
      }
    ],
    name: "seizeAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "seizeGuardianPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cTokenCollateral",
        type: "address"
      },
      {
        internalType: "address",
        name: "cTokenBorrowed",
        type: "address"
      },
      {
        internalType: "address",
        name: "liquidator",
        type: "address"
      },
      {
        internalType: "address",
        name: "borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "seizeTokens",
        type: "uint256"
      }
    ],
    name: "seizeVerify",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "supplyCapGuardian",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "supplyCaps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "transferTokens",
        type: "uint256"
      }
    ],
    name: "transferAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "transferGuardianPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "src",
        type: "address"
      },
      {
        internalType: "address",
        name: "dst",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "transferTokens",
        type: "uint256"
      }
    ],
    name: "transferVerify",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "cToken",
        type: "address"
      },
      {
        internalType: "enum ComptrollerV2Storage.Version",
        name: "newVersion",
        type: "uint8"
      }
    ],
    name: "updateCTokenVersion",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];
var CreamComptroller__factory = class {
  static createInterface() {
    return new utils10.Interface(_abi8);
  }
  static connect(address, signerOrProvider) {
    return new Contract9(address, _abi8, signerOrProvider);
  }
};
CreamComptroller__factory.abi = _abi8;

// src/crosschain/contracts/factories/Fabric__factory.ts
import { utils as utils11, Contract as Contract10, ContractFactory as ContractFactory2 } from "ethers";
var _abi9 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "sToken",
        type: "address"
      }
    ],
    name: "RepresentationCreated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rtoken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "_stokenName",
        type: "string"
      },
      {
        internalType: "string",
        name: "_stokenSymbol",
        type: "string"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    name: "createRepresentationByAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_syntTokenAdr",
        type: "address"
      }
    ],
    name: "getRealRepresentation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_realTokenAdr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      }
    ],
    name: "getSyntRepresentation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32"
      }
    ],
    name: "getSyntRepresentationByKey",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "synthesis",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      }
    ],
    name: "synthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      }
    ],
    name: "unsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode2 = "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";
var isSuperArgs2 = (xs) => xs.length > 1;
var Fabric__factory = class extends ContractFactory2 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs2(args)) {
      __super(...args);
    } else {
      __super(_abi9, _bytecode2, args[0]);
    }
    this.contractName = "Fabric";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils11.Interface(_abi9);
  }
  static connect(address, signerOrProvider) {
    return new Contract10(address, _abi9, signerOrProvider);
  }
};
Fabric__factory.bytecode = _bytecode2;
Fabric__factory.abi = _abi9;

// src/crosschain/contracts/factories/IzumiFactory__factory.ts
import { Contract as Contract11, utils as utils12 } from "ethers";
var _abi10 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_chargeReceiver",
        type: "address"
      },
      {
        internalType: "address",
        name: "_swapX2YModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_swapY2XModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_liquidityModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_limitOrderModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_flashModule",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        indexed: false,
        internalType: "uint24",
        name: "pointDelta",
        type: "uint24"
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address"
      }
    ],
    name: "NewPool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "chargeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint24",
        name: "pointDelta",
        type: "uint24"
      }
    ],
    name: "enableFeeAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    name: "fee2pointDelta",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "flashModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "limitOrderModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "liquidityModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_chargeReceiver",
        type: "address"
      }
    ],
    name: "modifyChargeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "int24",
        name: "currentPoint",
        type: "int24"
      }
    ],
    name: "newPool",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "only_addr_",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "swapX2YModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "swapY2XModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var IzumiFactory__factory = class {
  static createInterface() {
    return new utils12.Interface(_abi10);
  }
  static connect(address, signerOrProvider) {
    return new Contract11(address, _abi10, signerOrProvider);
  }
};
IzumiFactory__factory.abi = _abi10;

// src/crosschain/contracts/factories/IzumiPool__factory.ts
import { Contract as Contract12, utils as utils13 } from "ethers";
var _abi11 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "_fee",
        type: "uint24"
      },
      {
        internalType: "int24",
        name: "currentPoint",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "_pointDelta",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sellXEarnY",
        type: "bool"
      }
    ],
    name: "AddLimitOrder",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sellXEarnY",
        type: "bool"
      }
    ],
    name: "DecLimitOrder",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paidX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paidY",
        type: "uint256"
      }
    ],
    name: "Flash",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sellXEarnY",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "amountX",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "addLimOrderWithX",
    outputs: [
      {
        internalType: "uint128",
        name: "orderX",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "acquireY",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "amountY",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "addLimOrderWithY",
    outputs: [
      {
        internalType: "uint128",
        name: "orderY",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "acquireX",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "assignX",
        type: "uint128"
      }
    ],
    name: "assignLimOrderEarnX",
    outputs: [
      {
        internalType: "uint128",
        name: "actualAssignX",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "assignY",
        type: "uint128"
      }
    ],
    name: "assignLimOrderEarnY",
    outputs: [
      {
        internalType: "uint128",
        name: "actualAssignY",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "leftPt",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPt",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "liquidDelta",
        type: "uint128"
      }
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "leftPt",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPt",
        type: "int24"
      },
      {
        internalType: "uint256",
        name: "amountXLim",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountYLim",
        type: "uint256"
      }
    ],
    name: "collect",
    outputs: [
      {
        internalType: "uint256",
        name: "actualAmountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "actualAmountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "collectFeeCharged",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "collectDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "collectEarn",
        type: "uint128"
      },
      {
        internalType: "bool",
        name: "isEarnY",
        type: "bool"
      }
    ],
    name: "collectLimOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "actualCollectDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "actualCollectEarn",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "deltaX",
        type: "uint128"
      }
    ],
    name: "decLimOrderWithX",
    outputs: [
      {
        internalType: "uint128",
        name: "actualDeltaX",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "deltaY",
        type: "uint128"
      }
    ],
    name: "decLimOrderWithY",
    outputs: [
      {
        internalType: "uint128",
        name: "actualDeltaY",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "newNextQueueLen",
        type: "uint16"
      }
    ],
    name: "expandObservationQueue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeChargePercent",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeScaleX_128",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeScaleY_128",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "flash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "leftMostPt",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    name: "limitOrderData",
    outputs: [
      {
        internalType: "uint128",
        name: "sellingX",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnY",
        type: "uint128"
      },
      {
        internalType: "uint256",
        name: "accEarnY",
        type: "uint256"
      },
      {
        internalType: "uint128",
        name: "sellingY",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnX",
        type: "uint128"
      },
      {
        internalType: "uint256",
        name: "accEarnX",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      }
    ],
    name: "limitOrderSnapshot",
    outputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "sellingX",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "earnY",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "accEarnY",
            type: "uint256"
          },
          {
            internalType: "uint128",
            name: "sellingY",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "earnX",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "accEarnX",
            type: "uint256"
          }
        ],
        internalType: "struct IiZiSwapPool.LimitOrderStruct[]",
        name: "limitOrders",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "liquidity",
    outputs: [
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        internalType: "uint256",
        name: "lastFeeScaleX_128",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lastFeeScaleY_128",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "tokenOwedX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "tokenOwedY",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      }
    ],
    name: "liquiditySnapshot",
    outputs: [
      {
        internalType: "int128[]",
        name: "deltaLiquidities",
        type: "int128[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "maxLiquidPt",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "leftPt",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPt",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "liquidDelta",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "observations",
    outputs: [
      {
        internalType: "uint32",
        name: "timestamp",
        type: "uint32"
      },
      {
        internalType: "int56",
        name: "accPoint",
        type: "int56"
      },
      {
        internalType: "bool",
        name: "init",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32[]",
        name: "secondsAgos",
        type: "uint32[]"
      }
    ],
    name: "observe",
    outputs: [
      {
        internalType: "int56[]",
        name: "accPoints",
        type: "int56[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    name: "orderOrEndpoint",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int16",
        name: "",
        type: "int16"
      }
    ],
    name: "pointBitmap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pointDelta",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    name: "points",
    outputs: [
      {
        internalType: "uint128",
        name: "liquidSum",
        type: "uint128"
      },
      {
        internalType: "int128",
        name: "liquidDelta",
        type: "int128"
      },
      {
        internalType: "uint256",
        name: "accFeeXOut_128",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "accFeeYOut_128",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "isEndpt",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rightMostPt",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "sqrtRate_96",
    outputs: [
      {
        internalType: "uint160",
        name: "",
        type: "uint160"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "state",
    outputs: [
      {
        internalType: "uint160",
        name: "sqrtPrice_96",
        type: "uint160"
      },
      {
        internalType: "int24",
        name: "currentPoint",
        type: "int24"
      },
      {
        internalType: "uint16",
        name: "observationCurrentIndex",
        type: "uint16"
      },
      {
        internalType: "uint16",
        name: "observationQueueLen",
        type: "uint16"
      },
      {
        internalType: "uint16",
        name: "observationNextQueueLen",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool"
      },
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "liquidityX",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapX2Y",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "desireY",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapX2YDesireY",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapY2X",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "desireX",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapY2XDesireX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenX",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalFeeXCharged",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalFeeYCharged",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "userEarnX",
    outputs: [
      {
        internalType: "uint256",
        name: "lastAccEarn",
        type: "uint256"
      },
      {
        internalType: "uint128",
        name: "sellingRemain",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "sellingDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earn",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnAssign",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "userEarnY",
    outputs: [
      {
        internalType: "uint256",
        name: "lastAccEarn",
        type: "uint256"
      },
      {
        internalType: "uint128",
        name: "sellingRemain",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "sellingDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earn",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnAssign",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var IzumiPool__factory = class {
  static createInterface() {
    return new utils13.Interface(_abi11);
  }
  static connect(address, signerOrProvider) {
    return new Contract12(address, _abi11, signerOrProvider);
  }
};
IzumiPool__factory.abi = _abi11;

// src/crosschain/contracts/factories/IzumiQuoter__factory.ts
import { Contract as Contract13, utils as utils14 } from "ethers";
var _abi12 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      }
    ],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "acquire",
        type: "uint256"
      },
      {
        internalType: "int24[]",
        name: "pointAfterList",
        type: "int24[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "desire",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapDesire",
    outputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256"
      },
      {
        internalType: "int24[]",
        name: "pointAfterList",
        type: "int24[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      }
    ],
    name: "swapX2Y",
    outputs: [
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapX2YCallback",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "desireY",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      }
    ],
    name: "swapX2YDesireY",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      }
    ],
    name: "swapY2X",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapY2XCallback",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "desireX",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      }
    ],
    name: "swapY2XDesireX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var IzumiQuoter__factory = class {
  static createInterface() {
    return new utils14.Interface(_abi12);
  }
  static connect(address, signerOrProvider) {
    return new Contract13(address, _abi12, signerOrProvider);
  }
};
IzumiQuoter__factory.abi = _abi12;

// src/crosschain/contracts/factories/IzumiSwap__factory.ts
import { Contract as Contract14, utils as utils15 } from "ethers";
var _abi13 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      }
    ],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapAmountParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "swapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "acquire",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "desire",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapDesireParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "swapDesire",
    outputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "acquire",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapX2Y",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapX2YCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapX2YDesireY",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapY2X",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapY2XCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapY2XDesireX",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var IzumiSwap__factory = class {
  static createInterface() {
    return new utils15.Interface(_abi13);
  }
  static connect(address, signerOrProvider) {
    return new Contract14(address, _abi13, signerOrProvider);
  }
};
IzumiSwap__factory.abi = _abi13;

// src/crosschain/contracts/factories/KavaRouter__factory.ts
import { Contract as Contract15, utils as utils16 } from "ethers";
var _abi14 = [
  {
    type: "constructor",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "_factory",
        internalType: "address"
      },
      {
        type: "address",
        name: "_weth",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "",
        internalType: "uint256[]"
      }
    ],
    name: "UNSAFE_swapExactTokensForTokens",
    inputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "amountADesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidityETH",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "amountTokenDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address"
      }
    ],
    name: "factory",
    inputs: []
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "amount",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      }
    ],
    name: "getAmountOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "tokenIn",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenOut",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "getAmountsOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "reserveA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveB",
        internalType: "uint256"
      }
    ],
    name: "getReserves",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool"
      }
    ],
    name: "isPair",
    inputs: [
      {
        type: "address",
        name: "pair",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "pair",
        internalType: "address"
      }
    ],
    name: "pairFor",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "quoteAddLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "amountADesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBDesired",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "quoteRemoveLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityWithPermit",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "address",
        name: "token0",
        internalType: "address"
      },
      {
        type: "address",
        name: "token1",
        internalType: "address"
      }
    ],
    name: "sortTokens",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactETHForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForETH",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForTokensSimple",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "tokenFrom",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenTo",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "contract IWETH"
      }
    ],
    name: "weth",
    inputs: []
  },
  {
    type: "receive",
    stateMutability: "payable"
  }
];
var KavaRouter__factory = class {
  static createInterface() {
    return new utils16.Interface(_abi14);
  }
  static connect(address, signerOrProvider) {
    return new Contract15(address, _abi14, signerOrProvider);
  }
};
KavaRouter__factory.abi = _abi14;

// src/crosschain/contracts/factories/MetaRouter__factory.ts
import { utils as utils17, Contract as Contract16, ContractFactory as ContractFactory3 } from "ethers";
var _abi15 = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "TransitTokenSent",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_calldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_offset",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "externalCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "externalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "tokenReal",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "to",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaMintTransaction",
        name: "_metaMintTransaction",
        type: "tuple"
      }
    ],
    name: "metaMintSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "firstSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address[]",
            name: "approvedTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "firstDexRouter",
            type: "address"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "nativeIn",
            type: "bool"
          },
          {
            internalType: "address",
            name: "relayRecipient",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "otherSideCalldata",
            type: "bytes"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRouteTransaction",
        name: "_metarouteTransaction",
        type: "tuple"
      }
    ],
    name: "metaRoute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouterGateway",
    outputs: [
      {
        internalType: "contract MetaRouterGateway",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_router",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_swapCalldata",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_burnToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_burnCalldata",
        type: "bytes"
      }
    ],
    name: "returnSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode3 = "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";
var isSuperArgs3 = (xs) => xs.length > 1;
var MetaRouter__factory = class extends ContractFactory3 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs3(args)) {
      __super(...args);
    } else {
      __super(_abi15, _bytecode3, args[0]);
    }
    this.contractName = "MetaRouter";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils17.Interface(_abi15);
  }
  static connect(address, signerOrProvider) {
    return new Contract16(address, _abi15, signerOrProvider);
  }
};
MetaRouter__factory.bytecode = _bytecode3;
MetaRouter__factory.abi = _abi15;

// src/crosschain/contracts/factories/Multicall__factory.ts
import { Contract as Contract17, utils as utils18 } from "ethers";
var _abi16 = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "returnData",
        type: "bytes[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "blockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool"
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      }
    ],
    name: "getBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockCoinbase",
    outputs: [
      {
        internalType: "address",
        name: "coinbase",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockDifficulty",
    outputs: [
      {
        internalType: "uint256",
        name: "difficulty",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockGasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "gaslimit",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getEthBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getLastBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool"
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryAggregate",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool"
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool"
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryBlockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool"
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var Multicall__factory = class {
  static createInterface() {
    return new utils18.Interface(_abi16);
  }
  static connect(address, signerOrProvider) {
    return new Contract17(address, _abi16, signerOrProvider);
  }
};
Multicall__factory.abi = _abi16;

// src/crosschain/contracts/factories/MulticallRouter__factory.ts
import { utils as utils19, Contract as Contract18, ContractFactory as ContractFactory4 } from "ethers";
var _abi17 = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "_calldata",
        type: "bytes[]"
      },
      {
        internalType: "address[]",
        name: "_receiveSides",
        type: "address[]"
      },
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "_offset",
        type: "uint256[]"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "multicall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode4 = "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";
var isSuperArgs4 = (xs) => xs.length > 1;
var MulticallRouter__factory = class extends ContractFactory4 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs4(args)) {
      __super(...args);
    } else {
      __super(_abi17, _bytecode4, args[0]);
    }
    this.contractName = "MulticallRouter";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils19.Interface(_abi17);
  }
  static connect(address, signerOrProvider) {
    return new Contract18(address, _abi17, signerOrProvider);
  }
};
MulticallRouter__factory.bytecode = _bytecode4;
MulticallRouter__factory.abi = _abi17;

// src/crosschain/contracts/factories/OmniPool__factory.ts
import { utils as utils20, Contract as Contract19, ContractFactory as ContractFactory5 } from "ethers";
var _abi18 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "AssetAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "AssetStatusChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "FillPool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "NewA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "lpDividendRatio",
        type: "uint256"
      }
    ],
    name: "NewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "NewFeeTo",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "NewLPFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newMaxSupply",
        type: "uint256"
      }
    ],
    name: "NewMaxSupply",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "NewMintFeeThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newVeSIS",
        type: "address"
      }
    ],
    name: "NewVeSIS",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "fromToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "toToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fromAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toAmount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Withdraw",
    type: "event"
  },
  {
    inputs: [],
    name: "a",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_maxSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    name: "addAssetOcto",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "assetToIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_newMaxSupply",
        type: "uint256"
      }
    ],
    name: "changeMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minimumLiquidity",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256"
      }
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "devaddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeTo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "globalEquilCovRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "equilCovRatio",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "indexToAsset",
    outputs: [
      {
        internalType: "uint256",
        name: "cash",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liability",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "totalSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "bool",
        name: "active",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_a",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_lpFee",
        type: "uint256"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpDividendRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      }
    ],
    name: "mintFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintFeeThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newA",
        type: "uint256"
      }
    ],
    name: "setA",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "_active",
        type: "bool"
      }
    ],
    name: "setAssetStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newLpDividendRatio",
        type: "uint256"
      }
    ],
    name: "setFeeRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newFeeTo",
        type: "address"
      }
    ],
    name: "setFeeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newLpFee",
        type: "uint256"
      }
    ],
    name: "setLPFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newMintFeeThreshold",
        type: "uint256"
      }
    ],
    name: "setMintFeeThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newVeSIS",
        type: "address"
      }
    ],
    name: "setVeSISAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "spreadAccumulatedError",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fromID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_toID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fromAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minToAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256"
      }
    ],
    name: "swap",
    outputs: [
      {
        internalType: "uint256",
        name: "actualToAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lpFeeAmount",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "veSIS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode5 = "0x608060405234801561001057600080fd5b50614695806100206000396000f3fe608060405234801561001057600080fd5b50600436106102475760003560e01c80638456cb591161013b578063d043c565116100b8578063f242432a1161007c578063f242432a146105b9578063f2fde38b146105cc578063f3f6f0d7146105df578063f46901ed146105e8578063f6f70eaf146105fb57600080fd5b8063d043c56514610530578063d49e77cd14610543578063e4a3011614610557578063e985e9c51461056a578063ee919d50146105a657600080fd5b80638f6bdeaa116100ff5780638f6bdeaa146104455780639eeb6a2214610458578063a22cb465146104f6578063ce016ea114610509578063cfc399ea1461051c57600080fd5b80638456cb59146103fe5780638a2dfe09146104065780638a35ace31461040e5780638c9a4bb8146104215780638da5cb5b1461043457600080fd5b80633f4ba83a116101c95780635cfe092e1161018d5780635cfe092e146103c65780635f4b9bde146103d0578063704ce43e146103e3578063715018a6146103ec578063815bfd29146103f457600080fd5b80633f4ba83a146103585780634422a8dd146103605780634e1273f41461038857806353cb6a5e146103a85780635c975abb146103bb57600080fd5b806319f4ff2f1161021057806319f4ff2f146102ea57806324e75ca0146102ff578063265e7bde146103125780632eb2c2d61461032557806339e599451461033857600080fd5b8062fdd58e1461024c578063017e7e581461027257806301ffc9a71461029e5780630dbe671f146102c15780630e89341c146102ca575b600080fd5b61025f61025a366004613b2a565b61060e565b6040519081526020015b60405180910390f35b61010354610286906001600160a01b031681565b6040516001600160a01b039091168152602001610269565b6102b16102ac366004613c88565b6106a9565b6040519015158152602001610269565b61025f60fe5481565b6102dd6102d8366004613cc2565b6106f9565b6040516102699190613f26565b6102fd6102f8366004613cc2565b61078d565b005b6102fd61030d366004613cf4565b610802565b6102fd610320366004613d19565b61089c565b6102fd6103333660046139e4565b6109e6565b61025f610346366004613996565b60fc6020526000908152604090205481565b6102fd610a32565b61037361036e366004613d3b565b610a44565b60408051928352602083019190915201610269565b61039b610396366004613b9a565b610c5b565b6040516102699190613eee565b6102fd6103b6366004613cc2565b610d85565b60655460ff166102b1565b61025f6101015481565b6103736103de366004613d3b565b610dea565b61025f60ff5481565b6102fd611102565b61025f6101005481565b6102fd611114565b610373611124565b6102fd61041c366004613cc2565b611168565b6102fd61042f366004613d19565b611174565b6033546001600160a01b0316610286565b610373610453366004613d82565b611352565b6104b3610466366004613cc2565b60fb60205260009081526040902080546001820154600283015460038401546004909401549293919290919060ff808216916001600160a01b0361010082041691600160a81b9091041687565b60408051978852602088019690965294860193909352606085019190915260ff1660808401526001600160a01b031660a0830152151560c082015260e001610269565b6102fd610504366004613af3565b611693565b6102fd610517366004613b54565b61169e565b61010454610286906001600160a01b031681565b6102fd61053e366004613cc2565b61187d565b61010254610286906001600160a01b031681565b6102fd610565366004613d19565b6118bb565b6102b16105783660046139b1565b6001600160a01b03918216600090815260ca6020908152604080832093909416825291909152205460ff1690565b6102fd6105b4366004613cc2565b611a71565b6102fd6105c7366004613a8e565b611ad6565b6102fd6105da366004613996565b611b1b565b61025f60fd5481565b6102fd6105f6366004613996565b611b91565b6102fd610609366004613996565b611c0c565b60006001600160a01b03831661067e5760405162461bcd60e51b815260206004820152602a60248201527f455243313135353a2061646472657373207a65726f206973206e6f742061207660448201526930b634b21037bbb732b960b11b60648201526084015b60405180910390fd5b50600081815260c9602090815260408083206001600160a01b03861684529091529020545b92915050565b60006001600160e01b03198216636cdb3d1360e11b14806106da57506001600160e01b031982166303a24d0760e21b145b806106a357506301ffc9a760e01b6001600160e01b03198316146106a3565b606060cb805461070890614476565b80601f016020809104026020016040519081016040528092919081815260200182805461073490614476565b80156107815780601f1061075657610100808354040283529160200191610781565b820191906000526020600020905b81548152906001019060200180831161076457829003601f168201915b50505050509050919050565b610795611c87565b670de0b6b3a76400008111156107bd5760405162461bcd60e51b8152600401610675906140bc565b6107c5611ce1565b6101008190556040518181527f63fe946ed58429ac3c5e64d4356ff92c26d7fa1e73586515df8ba9f059ab54a5906020015b60405180910390a150565b61080a611c87565b600082815260fb602052604090206004015460ff600160a81b9091041615158115151461089857600082815260fb6020526040808220600401805460ff60a81b1916600160a81b8515159081029190911791829055915191926101009091046001600160a01b0316917f409295ac74e8693e50d9c1104ed31735b01ce0bbb0772e2fc4392180993c8a949190a35b5050565b6108a4611c87565b600082815260fb60205260408120600401546108c490839060ff16611d09565b90506108d6816001600160ff1b031190565b6109225760405162461bcd60e51b815260206004820152601760248201527f4e6577206d617820737570706c7920746f6f20686967680000000000000000006044820152606401610675565b600083815260fb60205260409020548110156109905760405162461bcd60e51b815260206004820152602760248201527f43757272656e742062616c616e6365206578636565647320676976656e206d6160448201526678537570706c7960c81b6064820152608401610675565b600083815260fb60205260408082206002810184905560040154905183926101009092046001600160a01b0316917fc5d8aa673058ca711657496eae7c88ab5e64efd2f3391dcb3ed365b93ecb184f91a3505050565b6001600160a01b038516331480610a025750610a028533610578565b610a1e5760405162461bcd60e51b815260040161067590613f70565b610a2b8585858585611d71565b5050505050565b610a3a611c87565b610a42611f51565b565b600080610a4f611fa3565b82428111610a6f5760405162461bcd60e51b8152600401610675906140e3565b846001600160a01b038116610a965760405162461bcd60e51b815260040161067590614007565b600089815260fb60205260409020610aaf338b8b611fe9565b610ab88a61216d565b6000610ac48b8b61229e565b6004850154929850965091508690610ae0908b9060ff16611d09565b10610afd5760405162461bcd60e51b815260040161067590614158565b85826000016000828254610b119190614410565b9250508190555080826001016000828254610b2c9190614410565b9250508190555089826003016000828254610b479190614410565b909155505060018201541580610b7e5750610b6b6064670de0b6b3a764000061422b565b60018301548354610b7b91612454565b10155b610bb65760405162461bcd60e51b81526020600482015260096024820152682337b93134b23232b760b91b6044820152606401610675565b6004820154610be9908990610bcf90899060ff1661248f565b600485015461010090046001600160a01b031691906124bf565b5060048101546001600160a01b038089169161010081049091169082907ffb80d861da582b723be2d19507ce3e03851820c464abea89156ec77e089b1ad990610c36908a9060ff1661248f565b60408051918252602082018f9052015b60405180910390a45050509550959350505050565b60608151835114610cc05760405162461bcd60e51b815260206004820152602960248201527f455243313135353a206163636f756e747320616e6420696473206c656e677468604482015268040dad2e6dac2e8c6d60bb1b6064820152608401610675565b6000835167ffffffffffffffff811115610cdc57610cdc614558565b604051908082528060200260200182016040528015610d05578160200160208202803683370190505b50905060005b8451811015610d7d57610d50858281518110610d2957610d29614542565b6020026020010151858381518110610d4357610d43614542565b602002602001015161060e565b828281518110610d6257610d62614542565b6020908102919091010152610d76816144de565b9050610d0b565b509392505050565b610d8d611c87565b670de0b6b3a7640000811115610db55760405162461bcd60e51b8152600401610675906140bc565b60ff8190556040518181527f0df0ce83543295289f05f3782542da3058e533082716a3b74f8913499444f3c5906020016107f7565b600080610df5611fa3565b82428111610e155760405162461bcd60e51b8152600401610675906140e3565b846001600160a01b038116610e3c5760405162461bcd60e51b815260040161067590614007565b600089815260fb6020526040902060040154600160a81b900460ff16610e745760405162461bcd60e51b815260040161067590613f39565b600089815260fb602052604090206002810154600490910154610e9b908a9060ff16611d09565b60008b815260fb6020526040902054610eb491906141e5565b1115610f025760405162461bcd60e51b815260206004820152601e60248201527f466f7262696464656e3a206d617820737570706c7920657863656564656400006044820152606401610675565b610f0b8961216d565b600089815260fb6020526040812060040154610f36908b90610f31908c9060ff16611d09565b612522565b9196509094509050848810610f5d5760405162461bcd60e51b815260040161067590614158565b60008a815260fb6020526040902060010154610f8a90610f7e9083906141e5565b6001600160ff1b031190565b610fcb5760405162461bcd60e51b8152602060048201526012602482015271098d2c2c4d2d8d2e8f240e8dede40d0d2ced60731b6044820152606401610675565b60008a815260fb6020526040902060040154610feb908a9060ff16611d09565b60008b815260fb6020526040812080549091906110099084906141e5565b909155505060008a815260fb60205260408120600101805483929061102f9084906141e5565b909155505060008a815260fb6020526040812060030180548792906110559084906141e5565b92505081905550611077878b876040518060200160405280600081525061273d565b60008a815260fb60205260409020600401546110a39061010090046001600160a01b031633308c61284a565b60008a815260fb60209081526040918290206004015482518c81529182018890526001600160a01b038a811693610100909204169133917ff5dd9317b9e63ac316ce44acc85f670b54b339cfa3e9076e1dd55065b922314b9101610c46565b61110a611c87565b610a426000612888565b61111c611c87565b610a426128da565b600080600080611132612917565b8092508193505050600061115161114c848460fe546129d0565b6129fb565b90508061115d846129fb565b945094505050509091565b6111718161216d565b50565b61117c611c87565b6000828152610105602090815260408083205460fb909252808320805460049182015492516370a0823160e01b815230928101929092529161122b9160ff82169161010090046001600160a01b0316906370a082319060240160206040518083038186803b1580156111ed57600080fd5b505afa158015611201573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112259190613cdb565b90611d09565b6112359190614410565b61123f9190614410565b9050808211156112615760405162461bcd60e51b8152600401610675906140bc565b600083815260fb60205260408120805484929061127f9084906141e5565b9091555050600083815260fb60205260409020546001600160ff1b03116112f75760405162461bcd60e51b815260206004820152602660248201527f496d706f737369626c6520746f2073707265616420616363756d756c617465646044820152651032b93937b960d11b6064820152608401610675565b600083815260fb60209081526040918290206004015491518481526101009092046001600160a01b0316917f4941e18a2bcbb0f9fa0081238f26793a8ad8c202b913ae8bf5f7e523f68ff137910160405180910390a2505050565b60008061135d611fa3565b8242811161137d5760405162461bcd60e51b8152600401610675906140e3565b846001600160a01b0381166113a45760405162461bcd60e51b815260040161067590614007565b60008a815260fb6020526040902060040154600160a81b900460ff166113dc5760405162461bcd60e51b815260040161067590613f39565b600089815260fb6020526040902060040154600160a81b900460ff166114145760405162461bcd60e51b815260040161067590613f39565b600089815260fb60205260408082206004908101548d84529190922090910154610100918290046001600160a01b03908116929091041614156114885760405162461bcd60e51b815260206004820152600c60248201526b53616d65206164647265737360a01b6044820152606401610675565b60008a815260fb6020526040902060028101546004909101546114af908a9060ff16611d09565b60008c815260fb60205260409020546114c891906141e5565b11156115165760405162461bcd60e51b815260206004820152601e60248201527f466f7262696464656e3a206d617820737570706c7920657863656564656400006044820152606401610675565b60008a815260fb6020526040902060040154611563908b908b9061153e908c9060ff16611d09565b60008d815260fb602052604090206004015461155e908c9060ff16611d09565b612a4a565b60008b815260fb6020526040902060040154919550935061158890859060ff1661248f565b60008a815260fb60205260409020600401549094506115ab90849060ff1661248f565b60008b815260fb60205260409020600401549093506115da9061010090046001600160a01b031633308b61284a565b600089815260fb60205260409020600401546116059061010090046001600160a01b031687866124bf565b60008a815260fb602090815260408083206004908101548d855293829020015481516001600160a01b0361010095869004811682529490910484169281019290925281018a9052606081018690529087169033907f54787c404bb33c88e86f4baf88183a3b0141d0a848e6a9f7a13b66ae3a9b73d19060800160405180910390a35050965096945050505050565b610898338383612bd6565b6116a6611c87565b826001600160a01b0381166116cd5760405162461bcd60e51b815260040161067590614007565b6001600160a01b03808516600081815260fc6020908152604080832054835260fb9091529020600401546101009004909116141561174d5760405162461bcd60e51b815260206004820152601c60248201527f41737365742068617320616c7265616479206265656e206164646564000000006044820152606401610675565b6040805160e0810182526000808252602082015290810161176e8585611d09565b81526000602080830182905260ff8087166040808601919091526001600160a01b03808b166060808801919091526001608097880181905260fd8054885260fb87528488208a518155968a0151918701919091559288015160028601558701516003850155948601516004909301805460a088015160c0909801511515600160a81b0260ff60a81b1998909716610100026001600160a81b031990911694909316939093179190911794909416929092179091558154919061182f836144de565b909155506001600160a01b038516600081815260fc602052604080822093909355915190917f0e3c58ebfb2e7465fbb1c32e6b4f40c3c4f5ca77e8218a386aff8617831260d791a250505050565b611885611c87565b6101018190556040518181527f71592c407ca0abb34bb7ada163a2a8b25a2e58342a3c0926df1b9ce73cb214a5906020016107f7565b600054610100900460ff16158080156118db5750600054600160ff909116105b806118f55750303b1580156118f5575060005460ff166001145b6119585760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b6064820152608401610675565b6000805460ff19166001179055801561197b576000805461ff0019166101001790555b611983612cb7565b61198b612ce6565b6119ac60405180606001604052806027815260200161463960279139612d19565b670de0b6b3a76400008311156119d45760405162461bcd60e51b8152600401610675906140bc565b670de0b6b3a76400008211156119fc5760405162461bcd60e51b8152600401610675906140bc565b60fe83905560ff829055670de0b6b3a76400006101005561010480546001600160a01b031916331790558015611a6c576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b505050565b611a79611c87565b670de0b6b3a7640000811115611aa15760405162461bcd60e51b8152600401610675906140bc565b60fe8190556040518181527f3f4ccc115548cf9126e487dcdf7c805dbb3578de78180051ace88afa59675e9c906020016107f7565b6001600160a01b038516331480611af25750611af28533610578565b611b0e5760405162461bcd60e51b815260040161067590613f70565b610a2b8585858585612d49565b611b23611c87565b6001600160a01b038116611b885760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610675565b61117181612888565b611b99611c87565b806001600160a01b038116611bc05760405162461bcd60e51b815260040161067590614007565b61010380546001600160a01b0319166001600160a01b0384169081179091556040517fd7ecd1f497e38c39a3455e0704e1bddc382baa8059756b571ff24b92cab7ff5490600090a25050565b611c14611c87565b806001600160a01b038116611c3b5760405162461bcd60e51b815260040161067590614007565b61010480546001600160a01b0319166001600160a01b0384169081179091556040517f698bdbadb3d770955212e2624318544242e40229072137a1dd6ac7edc93d847890600090a25050565b6033546001600160a01b03163314610a425760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610675565b60005b60fd5481101561117157611cf78161216d565b80611d01816144de565b915050611ce4565b600060128260ff161015611d3e57611d22826012614427565b611d2d90600a614282565b611d3790846143b2565b90506106a3565b60128260ff161115611d6a57611d55601283614427565b611d6090600a614282565b611d37908461422b565b5090919050565b8151835114611dd35760405162461bcd60e51b815260206004820152602860248201527f455243313135353a2069647320616e6420616d6f756e7473206c656e677468206044820152670dad2e6dac2e8c6d60c31b6064820152608401610675565b6001600160a01b038416611df95760405162461bcd60e51b81526004016106759061402d565b3360005b8451811015611ee3576000858281518110611e1a57611e1a614542565b602002602001015190506000858381518110611e3857611e38614542565b602090810291909101810151600084815260c9835260408082206001600160a01b038e168352909352919091205490915081811015611e895760405162461bcd60e51b815260040161067590614072565b600083815260c9602090815260408083206001600160a01b038e8116855292528083208585039055908b16825281208054849290611ec89084906141e5565b9250508190555050505080611edc906144de565b9050611dfd565b50846001600160a01b0316866001600160a01b0316826001600160a01b03167f4a39dc06d4c0dbc64b70af90fd698a233a518aa5d07e595d983b8c0526c8f7fb8787604051611f33929190613f01565b60405180910390a4611f49818787878787612e77565b505050505050565b611f59612fe2565b6065805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b60655460ff1615610a425760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b6044820152606401610675565b6001600160a01b03831661204b5760405162461bcd60e51b815260206004820152602360248201527f455243313135353a206275726e2066726f6d20746865207a65726f206164647260448201526265737360e81b6064820152608401610675565b3360006120578461302b565b905060006120648461302b565b604080516020808201835260009182905288825260c981528282206001600160a01b038b16835290522054909150848110156120ee5760405162461bcd60e51b8152602060048201526024808201527f455243313135353a206275726e20616d6f756e7420657863656564732062616c604482015263616e636560e01b6064820152608401610675565b600086815260c9602090815260408083206001600160a01b038b81168086529184528285208a8703905582518b81529384018a90529092908816917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a46040805160208101909152600090525b50505050505050565b6000818152610105602052604090205480158061218c57506101015481105b15612195575050565b60006121b861010054670de0b6b3a76400006121b19190614410565b8390613076565b905080156122195761010454600084815260fb6020526040902060040154612219916001600160a01b0316906121f290849060ff1661248f565b600086815260fb602052604090206004015461010090046001600160a01b031691906124bf565b60006122258284614410565b905080156122895760006122398583612522565b50600087815260fb6020526040812060010180549294508493509161225f9084906141e5565b9091555050600085815260fb6020526040812080548492906122829084906141e5565b9091555050505b50505060009081526101056020526040812055565b600082815260fb602052604081206003810154600190910154829182916122c69086906143b2565b6122d0919061422b565b9150816123105760405162461bcd60e51b815260206004820152600e60248201526d5a65726f206c697175696469747960901b6044820152606401610675565b600061231b83613096565b612324906144f9565b600087815260fb60205260408120549192509061234090613096565b600088815260fb60205260408120600101549192509061235f90613096565b60fe54909150600061237185846141a4565b9050600061237f8585613100565b905060006123a16123908584613100565b61239a90846143d1565b8690613134565b9050600060026123c36123bc87670de0b6b3a76400006143d1565b8a90613134565b6123cd90846141a4565b6123d791906141fd565b9050600061240d826123f36123ec888061432d565b8990613134565b6123fd858061432d565b61240791906141a4565b90613154565b61241790836141a4565b905061242661114c828a6143d1565b9b508b8b10612440576124398c8c614410565b9950612444565b8a9b505b5050505050505050509250925092565b60008161246260028261422b565b612474670de0b6b3a7640000866143b2565b61247e91906141e5565b612488919061422b565b9392505050565b600060128260ff1610156124a857611d55826012614427565b60128260ff161115611d6a57611d22601283614427565b6040516001600160a01b038316602482015260448101829052611a6c90849063a9059cbb60e01b906064015b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b031990931692909217909152613218565b60008060008061253185613096565b600087815260fb60205260408120549192509061254d90613096565b600088815260fb60205260408120600101549192509061256c90613096565b60fe546000955090915081612583578795506126cc565b600061258f85856141a4565b12156125ad5760405162461bcd60e51b8152600401610675906140bc565b60006125b98484613100565b905060006125c785876141a4565b905060006125d58486613134565b6125e090600261432d565b6125fc6125f586670de0b6b3a76400006143d1565b8490613134565b61260691906141a4565b9050600061261e866126188782613134565b90613134565b6126288480613134565b61264a866126368a8a61432d565b61264091906141fd565b61239a908b6143d1565b61265491906143d1565b61265e91906141a4565b905060008161266e87600461432d565b612678919061432d565b612682848061432d565b61268c91906143d1565b90506126c460026126ba886126a18588613154565b6126aa886144f9565b6126b491906141a4565b90613100565b61114c91906141fd565b9a5050505050505b8786106126e4576126dd8887614410565b94506126e8565b8795505b600089815260fb6020526040902060010154801561272d5760008a815260fb6020526040902060030154819061271e90896143b2565b612728919061422b565b61272f565b865b975050505050509250925092565b6001600160a01b03841661279d5760405162461bcd60e51b815260206004820152602160248201527f455243313135353a206d696e7420746f20746865207a65726f206164647265736044820152607360f81b6064820152608401610675565b3360006127a98561302b565b905060006127b68561302b565b9050600086815260c9602090815260408083206001600160a01b038b168452909152812080548792906127ea9084906141e5565b909155505060408051878152602081018790526001600160a01b03808a1692600092918716917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a4612164836000898989896132ea565b6040516001600160a01b03808516602483015283166044820152606481018290526128829085906323b872dd60e01b906084016124eb565b50505050565b603380546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6128e2611fa3565b6065805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258611f863390565b60fe546000908190815b60fd548110156129ca57600081815260fb602052604081205461294390613096565b600083815260fb60205260408120600101549192509061296290613096565b9050806129705750506129b8565b600061297c8383613100565b905061298882876141a4565b95506129a86129978683613100565b6129a190836143d1565b8390613134565b6129b290886141a4565b96505050505b806129c2816144de565b915050612921565b50509091565b6000806129dd8585613100565b6129e6906144f9565b90506129f281846133b4565b95945050505050565b600080821215612a465760405162461bcd60e51b815260206004820152601660248201527576616c7565206d75737420626520706f73697469766560501b6044820152606401610675565b5090565b600084815260fb60205260408120548190612a6990610f7e90866141e5565b612ab55760405162461bcd60e51b815260206004820152601760248201527f496e697469616c20616d6f756e7420746f6f20686967680000000000000000006044820152606401610675565b612ac88686612ac387613096565b6133ef565b9092509050818310612aec5760405162461bcd60e51b815260040161067590614158565b6000858152610105602052604081208054839290612b0b9084906141e5565b9091555050600086815260fb602052604081208054869290612b2e9084906141e5565b90915550612b3e905081836141e5565b600086815260fb602052604081208054909190612b5c908490614410565b90915550612b7590506064670de0b6b3a764000061422b565b600086815260fb6020526040902060018101549054612b9391612454565b1015612bcd5760405162461bcd60e51b81526020600482015260096024820152682337b93134b23232b760b91b6044820152606401610675565b94509492505050565b816001600160a01b0316836001600160a01b03161415612c4a5760405162461bcd60e51b815260206004820152602960248201527f455243313135353a2073657474696e6720617070726f76616c20737461747573604482015268103337b91039b2b63360b91b6064820152608401610675565b6001600160a01b03838116600081815260ca6020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b600054610100900460ff16612cde5760405162461bcd60e51b81526004016106759061410d565b610a4261360b565b600054610100900460ff16612d0d5760405162461bcd60e51b81526004016106759061410d565b6065805460ff19169055565b600054610100900460ff16612d405760405162461bcd60e51b81526004016106759061410d565b6111718161363b565b6001600160a01b038416612d6f5760405162461bcd60e51b81526004016106759061402d565b336000612d7b8561302b565b90506000612d888561302b565b9050600086815260c9602090815260408083206001600160a01b038c16845290915290205485811015612dcd5760405162461bcd60e51b815260040161067590614072565b600087815260c9602090815260408083206001600160a01b038d8116855292528083208985039055908a16825281208054889290612e0c9084906141e5565b909155505060408051888152602081018890526001600160a01b03808b16928c821692918816917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a4612e6c848a8a8a8a8a6132ea565b505050505050505050565b6001600160a01b0384163b15611f495760405163bc197c8160e01b81526001600160a01b0385169063bc197c8190612ebb9089908990889088908890600401613e56565b602060405180830381600087803b158015612ed557600080fd5b505af1925050508015612f05575060408051601f3d908101601f19168201909252612f0291810190613ca5565b60015b612fb257612f1161456e565b806308c379a01415612f4b5750612f2661458a565b80612f315750612f4d565b8060405162461bcd60e51b81526004016106759190613f26565b505b60405162461bcd60e51b815260206004820152603460248201527f455243313135353a207472616e7366657220746f206e6f6e20455243313135356044820152732932b1b2b4bb32b91034b6b83632b6b2b73a32b960611b6064820152608401610675565b6001600160e01b0319811663bc197c8160e01b146121645760405162461bcd60e51b815260040161067590613fbf565b60655460ff16610a425760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b6044820152606401610675565b6040805160018082528183019092526060916000919060208083019080368337019050509050828160008151811061306557613065614542565b602090810291909101015292915050565b6000670de0b6b3a764000061308c60028261422b565b61247484866143b2565b60006001600160ff1b03821115612a465760405162461bcd60e51b815260206004820152602860248201527f53616665436173743a2076616c756520646f65736e27742066697420696e2061604482015267371034b73a191a9b60c11b6064820152608401610675565b60008161310e6002826141fd565b613120670de0b6b3a76400008661432d565b61312a91906141a4565b61248891906141fd565b6000670de0b6b3a764000061314a6002826141fd565b613120848661432d565b600060038313156132095760008213801561316f5750828213155b1561317b5750806131ab565b600082128015613193575082613190836144f9565b13155b156131a8576131a1826144f9565b90506131ab565b50815b60006002826131ba81876141fd565b6131c491906141a4565b6131ce91906141fd565b90505b818114613203579050806002816131e881876141fd565b6131f291906141a4565b6131fc91906141fd565b90506131d1565b506106a3565b82156106a35750600192915050565b600061326d826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b031661366b9092919063ffffffff16565b805190915015611a6c578080602001905181019061328b9190613c6b565b611a6c5760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b6064820152608401610675565b6001600160a01b0384163b15611f495760405163f23a6e6160e01b81526001600160a01b0385169063f23a6e619061332e9089908990889088908890600401613eb4565b602060405180830381600087803b15801561334857600080fd5b505af1925050508015613378575060408051601f3d908101601f1916820190925261337591810190613ca5565b60015b61338457612f1161456e565b6001600160e01b0319811663f23a6e6160e01b146121645760405162461bcd60e51b815260040161067590613fbf565b60006002836133e581670de0b6b3a76400006133d187600461432d565b6133db919061432d565b6123fd888061432d565b61312a91906143d1565b600082815260fb6020526040812054819081908161340c82613096565b600089815260fb60205260408120549192509061342890613096565b60008a815260fb60205260408120600101549192509061344790613096565b60008a815260fb60205260408120600101549192509061346690613096565b60fe54909150811580159061347a57508215155b6134965760405162461bcd60e51b8152600401610675906140bc565b60006134cf866134a6858061432d565b6134b091906141fd565b866134bb878061432d565b6134c591906141fd565b6129a191906141a4565b6134d987876141a4565b6134e391906143d1565b905060006134f5856126b48e896141a4565b905060006135038386613100565b8561350e8685613100565b61351890856143d1565b613522908961432d565b61352c91906141fd565b61353691906143d1565b9050600061354482866133b4565b90506000896135538884613134565b61355d91906143d1565b9050600081121561357b5761357461114c826144f9565b9b50613587565b613584816129fb565b9b505b8b8b10156135c95760405162461bcd60e51b815260206004820152600f60248201526e09cdee840cadcdeeaced040c6c2e6d608b1b6044820152606401610675565b60ff546135d7908d90613076565b9c5060008f13156135f3576135ec8d8d614410565b9d506135f7565b8b9d505b505050505050505050505050935093915050565b600054610100900460ff166136325760405162461bcd60e51b81526004016106759061410d565b610a4233612888565b600054610100900460ff166136625760405162461bcd60e51b81526004016106759061410d565b61117181613682565b606061367a8484600085613695565b949350505050565b80516108989060cb9060208401906137ff565b6060824710156136f65760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6044820152651c8818d85b1b60d21b6064820152608401610675565b6001600160a01b0385163b61374d5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606401610675565b600080866001600160a01b031685876040516137699190613e3a565b60006040518083038185875af1925050503d80600081146137a6576040519150601f19603f3d011682016040523d82523d6000602084013e6137ab565b606091505b50915091506137bb8282866137c6565b979650505050505050565b606083156137d5575081612488565b8251156137e55782518084602001fd5b8160405162461bcd60e51b81526004016106759190613f26565b82805461380b90614476565b90600052602060002090601f01602090048101928261382d5760008555613873565b82601f1061384657805160ff1916838001178555613873565b82800160010185558215613873579182015b82811115613873578251825591602001919060010190613858565b50612a469291505b80821115612a46576000815560010161387b565b80356001600160a01b03811681146138a657600080fd5b919050565b600082601f8301126138bc57600080fd5b813560206138c982614180565b6040516138d682826144b1565b8381528281019150858301600585901b870184018810156138f657600080fd5b60005b85811015613915578135845292840192908401906001016138f9565b5090979650505050505050565b600082601f83011261393357600080fd5b813567ffffffffffffffff81111561394d5761394d614558565b604051613964601f8301601f1916602001826144b1565b81815284602083860101111561397957600080fd5b816020850160208301376000918101602001919091529392505050565b6000602082840312156139a857600080fd5b6124888261388f565b600080604083850312156139c457600080fd5b6139cd8361388f565b91506139db6020840161388f565b90509250929050565b600080600080600060a086880312156139fc57600080fd5b613a058661388f565b9450613a136020870161388f565b9350604086013567ffffffffffffffff80821115613a3057600080fd5b613a3c89838a016138ab565b94506060880135915080821115613a5257600080fd5b613a5e89838a016138ab565b93506080880135915080821115613a7457600080fd5b50613a8188828901613922565b9150509295509295909350565b600080600080600060a08688031215613aa657600080fd5b613aaf8661388f565b9450613abd6020870161388f565b93506040860135925060608601359150608086013567ffffffffffffffff811115613ae757600080fd5b613a8188828901613922565b60008060408385031215613b0657600080fd5b613b0f8361388f565b91506020830135613b1f81614614565b809150509250929050565b60008060408385031215613b3d57600080fd5b613b468361388f565b946020939093013593505050565b600080600060608486031215613b6957600080fd5b613b728461388f565b925060208401359150604084013560ff81168114613b8f57600080fd5b809150509250925092565b60008060408385031215613bad57600080fd5b823567ffffffffffffffff80821115613bc557600080fd5b818501915085601f830112613bd957600080fd5b81356020613be682614180565b604051613bf382826144b1565b8381528281019150858301600585901b870184018b1015613c1357600080fd5b600096505b84871015613c3d57613c298161388f565b835260019690960195918301918301613c18565b5096505086013592505080821115613c5457600080fd5b50613c61858286016138ab565b9150509250929050565b600060208284031215613c7d57600080fd5b815161248881614614565b600060208284031215613c9a57600080fd5b813561248881614622565b600060208284031215613cb757600080fd5b815161248881614622565b600060208284031215613cd457600080fd5b5035919050565b600060208284031215613ced57600080fd5b5051919050565b60008060408385031215613d0757600080fd5b823591506020830135613b1f81614614565b60008060408385031215613d2c57600080fd5b50508035926020909101359150565b600080600080600060a08688031215613d5357600080fd5b853594506020860135935060408601359250613d716060870161388f565b949793965091946080013592915050565b60008060008060008060c08789031215613d9b57600080fd5b86359550602087013594506040870135935060608701359250613dc06080880161388f565b915060a087013590509295509295509295565b600081518084526020808501945080840160005b83811015613e0357815187529582019590820190600101613de7565b509495945050505050565b60008151808452613e2681602086016020860161444a565b601f01601f19169290920160200192915050565b60008251613e4c81846020870161444a565b9190910192915050565b6001600160a01b0386811682528516602082015260a060408201819052600090613e8290830186613dd3565b8281036060840152613e948186613dd3565b90508281036080840152613ea88185613e0e565b98975050505050505050565b6001600160a01b03868116825285166020820152604081018490526060810183905260a0608082018190526000906137bb90830184613e0e565b6020815260006124886020830184613dd3565b604081526000613f146040830185613dd3565b82810360208401526129f28185613dd3565b6020815260006124886020830184613e0e565b6020808252601e908201527f417373657420776173206465616374697661746564206279206f776e65720000604082015260600190565b6020808252602f908201527f455243313135353a2063616c6c6572206973206e6f7420746f6b656e206f776e60408201526e195c881b9bdc88185c1c1c9bdd9959608a1b606082015260800190565b60208082526028908201527f455243313135353a204552433131353552656365697665722072656a656374656040820152676420746f6b656e7360c01b606082015260800190565b6020808252600c908201526b5a65726f206164647265737360a01b604082015260600190565b60208082526025908201527f455243313135353a207472616e7366657220746f20746865207a65726f206164604082015264647265737360d81b606082015260800190565b6020808252602a908201527f455243313135353a20696e73756666696369656e742062616c616e636520666f60408201526939103a3930b739b332b960b11b606082015260800190565b6020808252600d908201526c496e76616c69642076616c756560981b604082015260600190565b60208082526010908201526f111958591b1a5b99481b9bdd081b595d60821b604082015260600190565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b606082015260800190565b6020808252600e908201526d416d6f756e7420746f6f206c6f7760901b604082015260600190565b600067ffffffffffffffff82111561419a5761419a614558565b5060051b60200190565b600080821280156001600160ff1b03849003851316156141c6576141c6614516565b600160ff1b83900384128116156141df576141df614516565b50500190565b600082198211156141f8576141f8614516565b500190565b60008261420c5761420c61452c565b600160ff1b82146000198414161561422657614226614516565b500590565b60008261423a5761423a61452c565b500490565b600181815b8085111561427a57816000190482111561426057614260614516565b8085161561426d57918102915b93841c9390800290614244565b509250929050565b600061248860ff84168360008261429b575060016106a3565b816142a8575060006106a3565b81600181146142be57600281146142c8576142e4565b60019150506106a3565b60ff8411156142d9576142d9614516565b50506001821b6106a3565b5060208310610133831016604e8410600b8410161715614307575081810a6106a3565b614311838361423f565b806000190482111561432557614325614516565b029392505050565b60006001600160ff1b038184138284138082168684048611161561435357614353614516565b600160ff1b600087128281168783058912161561437257614372614516565b6000871292508782058712848416161561438e5761438e614516565b878505871281841616156143a4576143a4614516565b505050929093029392505050565b60008160001904831182151516156143cc576143cc614516565b500290565b60008083128015600160ff1b8501841216156143ef576143ef614516565b6001600160ff1b038401831381161561440a5761440a614516565b50500390565b60008282101561442257614422614516565b500390565b600060ff821660ff84168082101561444157614441614516565b90039392505050565b60005b8381101561446557818101518382015260200161444d565b838111156128825750506000910152565b600181811c9082168061448a57607f821691505b602082108114156144ab57634e487b7160e01b600052602260045260246000fd5b50919050565b601f8201601f1916810167ffffffffffffffff811182821017156144d7576144d7614558565b6040525050565b60006000198214156144f2576144f2614516565b5060010190565b6000600160ff1b82141561450f5761450f614516565b5060000390565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052601260045260246000fd5b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052604160045260246000fd5b600060033d11156145875760046000803e5060005160e01c5b90565b600060443d10156145985790565b6040516003193d81016004833e81513d67ffffffffffffffff81602484011181841117156145c857505050505090565b82850191508151818111156145e05750505050505090565b843d87010160208285010111156145fa5750505050505090565b614609602082860101876144b1565b509095945050505050565b801515811461117157600080fd5b6001600160e01b03198116811461117157600080fdfe68747470733a2f2f6f63746f6e6674732e73796d62696f7369732e66696e616e63652f7b69647da264697066735822122024564eb74644f14216c8d97a92ce81d620b3e57c547e0af319e32b20a8c7c9fd64736f6c63430008050033";
var isSuperArgs5 = (xs) => xs.length > 1;
var OmniPool__factory = class extends ContractFactory5 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs5(args)) {
      __super(...args);
    } else {
      __super(_abi18, _bytecode5, args[0]);
    }
    this.contractName = "OmniPool";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils20.Interface(_abi18);
  }
  static connect(address, signerOrProvider) {
    return new Contract19(address, _abi18, signerOrProvider);
  }
};
OmniPool__factory.bytecode = _bytecode5;
OmniPool__factory.abi = _abi18;

// src/crosschain/contracts/factories/OmniPoolOracle__factory.ts
import { utils as utils21, Contract as Contract20, ContractFactory as ContractFactory6 } from "ethers";
var _abi19 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [],
    name: "a",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devaddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "lastIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpDividendRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "poolDev",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "quoteDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "lpTokenToMint",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liabilityToMint",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fromAsset",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_toAsset",
        type: "uint256"
      },
      {
        internalType: "int256",
        name: "_fromAmount",
        type: "int256"
      }
    ],
    name: "quoteFrom",
    outputs: [
      {
        internalType: "uint256",
        name: "actualToAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lpFeeAmount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_liquidity",
        type: "uint256"
      }
    ],
    name: "quoteWithdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liabilityToBurn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode6 = "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";
var isSuperArgs6 = (xs) => xs.length > 1;
var OmniPoolOracle__factory = class extends ContractFactory6 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs6(args)) {
      __super(...args);
    } else {
      __super(_abi19, _bytecode6, args[0]);
    }
    this.contractName = "OmniPoolOracle";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils21.Interface(_abi19);
  }
  static connect(address, signerOrProvider) {
    return new Contract20(address, _abi19, signerOrProvider);
  }
};
OmniPoolOracle__factory.bytecode = _bytecode6;
OmniPoolOracle__factory.abi = _abi19;

// src/crosschain/contracts/factories/OneInchOracle__factory.ts
import { Contract as Contract21, utils as utils22 } from "ethers";
var _abi20 = [
  {
    inputs: [
      {
        internalType: "contract MultiWrapper",
        name: "_multiWrapper",
        type: "address"
      },
      {
        internalType: "contract IOracle[]",
        name: "existingOracles",
        type: "address[]"
      },
      {
        internalType: "enum OffchainOracle.OracleType[]",
        name: "oracleTypes",
        type: "uint8[]"
      },
      {
        internalType: "contract IERC20[]",
        name: "existingConnectors",
        type: "address[]"
      },
      {
        internalType: "contract IERC20",
        name: "wBase",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "ConnectorAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "ConnectorRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract MultiWrapper",
        name: "multiWrapper",
        type: "address"
      }
    ],
    name: "MultiWrapperUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleType",
        type: "uint8"
      }
    ],
    name: "OracleAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleType",
        type: "uint8"
      }
    ],
    name: "OracleRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "addConnector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleKind",
        type: "uint8"
      }
    ],
    name: "addOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "connectors",
    outputs: [
      {
        internalType: "contract IERC20[]",
        name: "allConnectors",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "srcToken",
        type: "address"
      },
      {
        internalType: "contract IERC20",
        name: "dstToken",
        type: "address"
      },
      {
        internalType: "bool",
        name: "useWrappers",
        type: "bool"
      }
    ],
    name: "getRate",
    outputs: [
      {
        internalType: "uint256",
        name: "weightedRate",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "srcToken",
        type: "address"
      },
      {
        internalType: "bool",
        name: "useSrcWrappers",
        type: "bool"
      }
    ],
    name: "getRateToEth",
    outputs: [
      {
        internalType: "uint256",
        name: "weightedRate",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "multiWrapper",
    outputs: [
      {
        internalType: "contract MultiWrapper",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oracles",
    outputs: [
      {
        internalType: "contract IOracle[]",
        name: "allOracles",
        type: "address[]"
      },
      {
        internalType: "enum OffchainOracle.OracleType[]",
        name: "oracleTypes",
        type: "uint8[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "removeConnector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleKind",
        type: "uint8"
      }
    ],
    name: "removeOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract MultiWrapper",
        name: "_multiWrapper",
        type: "address"
      }
    ],
    name: "setMultiWrapper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var OneInchOracle__factory = class {
  static createInterface() {
    return new utils22.Interface(_abi20);
  }
  static connect(address, signerOrProvider) {
    return new Contract21(address, _abi20, signerOrProvider);
  }
};
OneInchOracle__factory.abi = _abi20;

// src/crosschain/contracts/factories/Pair__factory.ts
import { Contract as Contract22, utils as utils23 } from "ethers";
var _abi21 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      }
    ],
    name: "Sync",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    constant: true,
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "MINIMUM_LIQUIDITY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getReserves",
    outputs: [
      {
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      },
      {
        internalType: "uint32",
        name: "blockTimestampLast",
        type: "uint32"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "kLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "price0CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "price1CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "skim",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swap",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "sync",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "token0",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "token1",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];
var Pair__factory = class {
  static createInterface() {
    return new utils23.Interface(_abi21);
  }
  static connect(address, signerOrProvider) {
    return new Contract22(address, _abi21, signerOrProvider);
  }
};
Pair__factory.abi = _abi21;

// src/crosschain/contracts/factories/Portal__factory.ts
import { utils as utils24, Contract as Contract23, ContractFactory as ContractFactory7 } from "ethers";
var _abi22 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BurnCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "clientId",
        type: "bytes32"
      }
    ],
    name: "ClientIdLog",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "MetaRevertRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "RevertBurnRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "RevertSynthesizeCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metaRouter",
        type: "address"
      }
    ],
    name: "SetMetaRouter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      }
    ],
    name: "SetTokenThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "activate",
        type: "bool"
      }
    ],
    name: "SetWhitelistToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SynthesizeRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address"
      },
      {
        internalType: "address",
        name: "_wrapper",
        type: "address"
      },
      {
        internalType: "address",
        name: "_whitelistedToken",
        type: "address"
      },
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address"
      }
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "internalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "managerChainBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "sourceChainBridge",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "managerChainId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "sourceChainId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "router",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "swapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "sourceChainSynthesis",
            type: "address"
          },
          {
            internalType: "address",
            name: "burnToken",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "burnCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRevertTransaction",
        name: "_metaRevertTransaction",
        type: "tuple"
      }
    ],
    name: "metaRevertRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouter",
    outputs: [
      {
        internalType: "contract IMetaRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "rtoken",
            type: "address"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "syntCaller",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaSynthesizeTransaction",
        name: "_metaSynthesizeTransaction",
        type: "tuple"
      }
    ],
    name: "metaSynthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_rToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_finalReceiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_finalCalldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_finalOffset",
        type: "uint256"
      }
    ],
    name: "metaUnsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "requestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "address",
        name: "chain2address",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "rtoken",
        type: "address"
      },
      {
        internalType: "enum Portal.RequestState",
        name: "state",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainId",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertBurnRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "setMetaRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_threshold",
        type: "uint256"
      }
    ],
    name: "setTokenThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_activate",
        type: "bool"
      }
    ],
    name: "setWhitelistToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesizeNative",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "approvalData",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct Portal.SynthesizeWithPermitTransaction",
        name: "_syntWithPermitTx",
        type: "tuple"
      }
    ],
    name: "synthesizeWithPermit",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "unsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "unsynthesizeStates",
    outputs: [
      {
        internalType: "enum Portal.UnsynthesizeState",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "wrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var _bytecode7 = "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";
var isSuperArgs7 = (xs) => xs.length > 1;
var Portal__factory = class extends ContractFactory7 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs7(args)) {
      __super(...args);
    } else {
      __super(_abi22, _bytecode7, args[0]);
    }
    this.contractName = "Portal";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils24.Interface(_abi22);
  }
  static connect(address, signerOrProvider) {
    return new Contract23(address, _abi22, signerOrProvider);
  }
};
Portal__factory.bytecode = _bytecode7;
Portal__factory.abi = _abi22;

// src/crosschain/contracts/factories/SyncSwapLaunchPool__factory.ts
import { Contract as Contract24, utils as utils25 } from "ethers";
var _abi23 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_saleToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_saleAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_paymentToken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_paymentTokenCap",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_endTime",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "ETHTransferFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "TransferFailed",
    type: "error"
  },
  {
    inputs: [],
    name: "TransferFromFailed",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "userSaleAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalPaymentAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "userPaymentAmount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Claim",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paymentTmount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Contribute",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paymentTmount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Refund",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "SetClaimEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256"
      }
    ],
    name: "SetEndTime",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "SetEnded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SetPaymentToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "cap",
        type: "uint256"
      }
    ],
    name: "SetPaymentTokenCap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "SetRefundEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "SetSaleAmount",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SetSaleToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "startTime",
        type: "uint256"
      }
    ],
    name: "SetStartTime",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "SetStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "SetWithdrawEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paymentTmount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Withdraw",
    type: "event"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "claimEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "contribute",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "contributeWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "contributeWithPermitAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "endTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isLaunchActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isLaunchEnded",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isUser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastSnapshotTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "paymentToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "paymentTokenCap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "refund",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "refundEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "saleAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "saleToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_claimEnabled",
        type: "bool"
      }
    ],
    name: "setClaimEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_endTime",
        type: "uint256"
      }
    ],
    name: "setEndTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "setEnded",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_setEnded",
        type: "bool"
      }
    ],
    name: "setLaunchEnded",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_setStarted",
        type: "bool"
      }
    ],
    name: "setLaunchStarted",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_endTime",
        type: "uint256"
      }
    ],
    name: "setLaunchTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "setPaymentToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_paymentTokenCap",
        type: "uint256"
      }
    ],
    name: "setPaymentTokenCap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_refundEnabled",
        type: "bool"
      }
    ],
    name: "setRefundEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "setSaleAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "setSaleToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256"
      }
    ],
    name: "setStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "setStarted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_withdrawEnabled",
        type: "bool"
      }
    ],
    name: "setWithdrawEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "snapshotTimes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "snapshotTimesLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "time",
        type: "uint256"
      }
    ],
    name: "snapshots",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "time",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          }
        ],
        internalType: "struct ILaunchPool.Snapshot",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "startTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalPaymentAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "userData",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "paymentAmount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "saleAmount",
            type: "uint256"
          }
        ],
        internalType: "struct ILaunchPool.UserData",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "users",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "usersLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var SyncSwapLaunchPool__factory = class {
  static createInterface() {
    return new utils25.Interface(_abi23);
  }
  static connect(address, signerOrProvider) {
    return new Contract24(address, _abi23, signerOrProvider);
  }
};
SyncSwapLaunchPool__factory.abi = _abi23;

// src/crosschain/contracts/factories/Synthesis__factory.ts
import { utils as utils26, Contract as Contract25, ContractFactory as ContractFactory8 } from "ethers";
var _abi24 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BurnRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "clientId",
        type: "bytes32"
      }
    ],
    name: "ClientIdLog",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "externalID",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "internalId",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "RevertBurnAndBurnRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "RevertBurnCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "RevertSynthesizeRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "fabric",
        type: "address"
      }
    ],
    name: "SetFabric",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metaRouter",
        type: "address"
      }
    ],
    name: "SetMetaRouter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      }
    ],
    name: "SetTokenThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SynthesizeCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "burnSyntheticToken",
    outputs: [
      {
        internalType: "bytes32",
        name: "internalID",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "fabric",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address"
      },
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address"
      }
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "syntCaller",
            type: "address"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "sToken",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCallData",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaBurnTransaction",
        name: "_metaBurnTransaction",
        type: "tuple"
      }
    ],
    name: "metaBurnSyntheticToken",
    outputs: [
      {
        internalType: "bytes32",
        name: "internalID",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "externalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "tokenReal",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "to",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaMintTransaction",
        name: "_metaMintTransaction",
        type: "tuple"
      }
    ],
    name: "metaMintSyntheticToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouter",
    outputs: [
      {
        internalType: "contract IMetaRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_tokenReal",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "mintSyntheticToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "requestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "address",
        name: "chain2address",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address",
        name: "stoken",
        type: "address"
      },
      {
        internalType: "enum Synthesis.RequestState",
        name: "state",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      }
    ],
    name: "revertBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      }
    ],
    name: "revertBurnAndBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_router",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_swapCalldata",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      },
      {
        internalType: "address",
        name: "_burnToken",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_burnCalldata",
        type: "bytes"
      }
    ],
    name: "revertMetaBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesizeRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_sender",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesizeRequestByBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_fabric",
        type: "address"
      }
    ],
    name: "setFabric",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "setMetaRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_threshold",
        type: "uint256"
      }
    ],
    name: "setTokenThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "synthesizeStates",
    outputs: [
      {
        internalType: "enum Synthesis.SynthesizeState",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  }
];
var _bytecode8 = "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";
var isSuperArgs8 = (xs) => xs.length > 1;
var Synthesis__factory = class extends ContractFactory8 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs8(args)) {
      __super(...args);
    } else {
      __super(_abi24, _bytecode8, args[0]);
    }
    this.contractName = "Synthesis";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils26.Interface(_abi24);
  }
  static connect(address, signerOrProvider) {
    return new Contract25(address, _abi24, signerOrProvider);
  }
};
Synthesis__factory.bytecode = _bytecode8;
Synthesis__factory.abi = _abi24;

// src/crosschain/contracts/factories/UniLikeRouter__factory.ts
import { Contract as Contract26, utils as utils27 } from "ethers";
var _abi25 = [
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapETHForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var UniLikeRouter__factory = class {
  static createInterface() {
    return new utils27.Interface(_abi25);
  }
  static connect(address, signerOrProvider) {
    return new Contract26(address, _abi25, signerOrProvider);
  }
};
UniLikeRouter__factory.abi = _abi25;

// src/crosschain/contracts/factories/Unwrapper__factory.ts
import { Contract as Contract27, utils as utils28 } from "ethers";
var _abi26 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_wrapper",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newWrapper",
        type: "address"
      }
    ],
    name: "setWrapper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var Unwrapper__factory = class {
  static createInterface() {
    return new utils28.Interface(_abi26);
  }
  static connect(address, signerOrProvider) {
    return new Contract27(address, _abi26, signerOrProvider);
  }
};
Unwrapper__factory.abi = _abi26;

// src/crosschain/contracts/factories/Weth__factory.ts
import { Contract as Contract28, utils as utils29 } from "ethers";
var _abi27 = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "guy",
        type: "address"
      },
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "src",
        type: "address"
      },
      {
        name: "dst",
        type: "address"
      },
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "dst",
        type: "address"
      },
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "deposit",
    outputs: [],
    payable: true,
    stateMutability: "payable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "",
        type: "address"
      },
      {
        name: "",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    payable: true,
    stateMutability: "payable",
    type: "fallback"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        name: "guy",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "src",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Withdrawal",
    type: "event"
  }
];
var Weth__factory = class {
  static createInterface() {
    return new utils29.Interface(_abi27);
  }
  static connect(address, signerOrProvider) {
    return new Contract28(address, _abi27, signerOrProvider);
  }
};
Weth__factory.abi = _abi27;

// src/crosschain/revertRequest.ts
import { utils as utils30 } from "ethers";
var PendingRequestState = /* @__PURE__ */ ((PendingRequestState2) => {
  PendingRequestState2[PendingRequestState2["Default"] = 0] = "Default";
  PendingRequestState2[PendingRequestState2["Sent"] = 1] = "Sent";
  PendingRequestState2[PendingRequestState2["Reverted"] = 2] = "Reverted";
  return PendingRequestState2;
})(PendingRequestState || {});
var findSourceChainData = async (symbiosis, chainIdFrom, chainIdTo, txHash, revertableAddress, omniPoolConfig, synthesizeRequestFinder) => {
  const synthesis = symbiosis.synthesis(omniPoolConfig.chainId);
  const filter = synthesis.filters.SynthesizeCompleted();
  const tx = await synthesis.provider.getTransactionReceipt(txHash);
  const foundSynthesizeCompleted = tx.logs.find((i) => {
    return i.topics[0] === filter.topics?.[0];
  });
  if (!foundSynthesizeCompleted)
    return void 0;
  const externalId = foundSynthesizeCompleted.topics?.[1];
  let sourceChainId = void 0;
  let fromAddress = void 0;
  const chains2 = symbiosis.chains();
  for (let i = 0; i < chains2.length; i++) {
    const chainId = chains2[i].id;
    if (chainId === chainIdFrom || chainId === chainIdTo) {
      continue;
    }
    const foundSynthesizeRequest = await findSynthesizeRequestOnChain(
      symbiosis,
      chainId,
      revertableAddress,
      externalId,
      omniPoolConfig
    );
    if (foundSynthesizeRequest !== void 0) {
      sourceChainId = chainId;
      fromAddress = foundSynthesizeRequest.args.from;
      break;
    }
  }
  if (!fromAddress && synthesizeRequestFinder) {
    const data = await synthesizeRequestFinder(externalId);
    sourceChainId = data?.sourceChainId;
    fromAddress = data?.fromAddress;
  }
  if (!fromAddress || !sourceChainId) {
    return;
  }
  return {
    sourceChainId,
    fromAddress
  };
};
var findSynthesizeRequestOnChain = async (symbiosis, chainId, revertableAddress, originExternalId, omniPoolConfig) => {
  const portal = symbiosis.portal(chainId);
  const eventFragment = portal.interface.getEvent("SynthesizeRequest");
  const topics = portal.interface.encodeFilterTopics(eventFragment, [
    void 0,
    void 0,
    // from
    omniPoolConfig.chainId,
    // chains IDs
    revertableAddress
    // revertableAddress
  ]);
  const blockOffset = symbiosis.filterBlockOffset(chainId);
  const toBlock = await portal.provider.getBlockNumber();
  const fromBlock = toBlock - blockOffset;
  const events = await portal.queryFilter({ topics }, fromBlock, toBlock);
  const synthesis = symbiosis.synthesis(omniPoolConfig.chainId);
  return events.find((e) => {
    const { id } = e.args;
    const externalId = getExternalId({
      internalId: id,
      contractAddress: synthesis.address,
      revertableAddress,
      chainId: omniPoolConfig.chainId
    });
    return originExternalId === externalId;
  });
};
var isSynthesizeV2 = async (symbiosis, chainId, txHash) => {
  const id = utils30.id(
    "metaBurnSyntheticToken((uint256,uint256,address,address,address,bytes,uint256,address,address,address,address,uint256,bytes32))"
  );
  const hash = id.slice(2, 10);
  const tx = await symbiosis.getProvider(chainId).getTransaction(txHash);
  return tx.data.includes(hash);
};
var RevertRequest = class {
  constructor(symbiosis, chainId, transactionHash) {
    this.symbiosis = symbiosis;
    this.chainId = chainId;
    this.transactionHash = transactionHash;
  }
  async init({ validateState = false, synthesizeRequestFinder }) {
    const provider = this.symbiosis.getProvider(this.chainId);
    await provider.ready;
    const receipt = await provider.getTransactionReceipt(this.transactionHash);
    if (!receipt) {
      throw new Error2(
        `Tx ${this.transactionHash} does not exist on chain ${this.chainId}. Provider ${provider.connection.url}`
      );
    }
    let type = "synthesize";
    let log = this.findSynthesizeRequest(receipt);
    if (!log) {
      type = "burn";
      log = this.findBurnRequest(receipt);
    }
    if (!log) {
      throw new Error2("Tx does not contain mint/burn event and cannot be reverted");
    }
    const { id, amount, token: tokenAddress, from: fromOrigin, to, chainID, revertableAddress } = log.args;
    const chainIdTo = chainID.toNumber();
    let chainIdFrom = this.chainId;
    let from = fromOrigin;
    const token = this.symbiosis.findToken(tokenAddress, this.chainId);
    if (!token) {
      throw new Error2(`Cannot find token ${tokenAddress} at chain ${this.chainId}`);
    }
    const omniPoolConfig = this.symbiosis.getOmniPoolByToken(token);
    if (!omniPoolConfig) {
      throw new Error2(
        `Cannot find omni pool config for chain ${chainIdTo} with token ${tokenAddress}`,
        6 /* NO_TRANSIT_POOL */
      );
    }
    let fromTokenAmount = new TokenAmount(token, amount);
    const originalFromTokenAmount = fromTokenAmount;
    if (type === "synthesize") {
      const isV2 = await isSynthesizeV2(this.symbiosis, this.chainId, receipt.transactionHash);
      if (isV2) {
        type = "synthesize-v2";
      }
    }
    if (type === "burn") {
      const metaRouterAddress = this.symbiosis.metaRouter(omniPoolConfig.chainId).address;
      if (from.toLowerCase() === metaRouterAddress.toLowerCase()) {
        type = "burn-v2";
        const data = await findSourceChainData(
          this.symbiosis,
          this.chainId,
          chainIdTo,
          receipt.transactionHash,
          revertableAddress,
          omniPoolConfig,
          synthesizeRequestFinder
        );
        if (data) {
          const { sourceChainId, fromAddress } = data;
          from = fromAddress;
          const sourceChainToken = await this.symbiosis.transitToken(sourceChainId, omniPoolConfig);
          chainIdFrom = sourceChainToken.chainId;
          fromTokenAmount = new TokenAmount(
            sourceChainToken,
            parseUnits2(
              fromTokenAmount.toExact(sourceChainToken.decimals),
              sourceChainToken.decimals
            ).toString()
          );
        } else {
          const transitToken = await this.symbiosis.transitToken(chainIdTo, omniPoolConfig);
          type = "burn-v2-revert";
          fromTokenAmount = new TokenAmount(transitToken, fromTokenAmount.raw);
        }
      }
    }
    let contractAddress;
    if (["synthesize", "synthesize-v2"].includes(type)) {
      contractAddress = this.symbiosis.synthesis(chainIdTo).address;
    } else {
      contractAddress = this.symbiosis.portal(chainIdTo).address;
    }
    const externalId = getExternalId({
      internalId: id,
      contractAddress,
      revertableAddress,
      chainId: chainIdTo
    });
    let state = 0 /* Default */;
    if (validateState) {
      if (["synthesize", "synthesize-v2"].includes(type)) {
        state = await this.symbiosis.synthesis(chainIdTo).synthesizeStates(externalId);
      } else {
        state = await this.symbiosis.portal(chainIdTo).unsynthesizeStates(externalId);
      }
      if (state === 1) {
        throw new Error2(`Tx is success and cannot be reverted.`);
      }
    }
    let revertChainId = chainIdTo;
    if (type === "synthesize-v2") {
      revertChainId = this.chainId;
    }
    return {
      internalId: id,
      externalId,
      transactionHash: this.transactionHash,
      state,
      type,
      from,
      to,
      revertableAddress,
      chainIdFrom,
      chainIdTo,
      fromTokenAmount,
      revertChainId,
      originalFromTokenAmount
    };
  }
  findSynthesizeRequest(receipt) {
    const contract = Portal__factory.createInterface();
    const event = contract.events["SynthesizeRequest(bytes32,address,uint256,address,address,uint256,address)"];
    const log = receipt.logs.find((log2) => {
      const topic = contract.getEventTopic(event);
      return log2.topics[0].toLowerCase() === topic.toLowerCase();
    });
    if (!log)
      return null;
    return contract.parseLog(log);
  }
  findBurnRequest(receipt) {
    const contract = Synthesis__factory.createInterface();
    const burnRequest = contract.events["BurnRequest(bytes32,address,uint256,address,address,uint256,address)"];
    const log = receipt.logs.find((log2) => {
      const topic = contract.getEventTopic(burnRequest);
      return log2.topics[0].toLowerCase() === topic.toLowerCase();
    });
    if (!log)
      return null;
    return contract.parseLog(log);
  }
};

// src/crosschain/waitForComplete.ts
var TransactionStuckError = class extends Error {
  constructor(pendingRequest) {
    super(`Transaction stuck: ${JSON.stringify(pendingRequest)}`);
    this.pendingRequest = pendingRequest;
  }
};
var WaitForComplete = class {
  constructor({ direction, symbiosis, chainIdOut, revertableAddress, chainIdIn }) {
    this.direction = direction;
    this.symbiosis = symbiosis;
    this.chainIdOut = chainIdOut;
    this.revertableAddress = revertableAddress;
    this.chainIdIn = chainIdIn;
  }
  async waitForComplete(receipt) {
    const filter = this.buildOtherSideFilter(receipt);
    return getLogWithTimeout({
      symbiosis: this.symbiosis,
      chainId: this.chainIdOut,
      filter
    }).catch((e) => {
      if (!(e instanceof GetLogTimeoutExceededError)) {
        throw e;
      }
      const pendingRequest = this.getPendingRequest(receipt);
      if (!pendingRequest) {
        throw e;
      }
      throw new TransactionStuckError(pendingRequest);
    });
  }
  getRequestArgs(receipt) {
    let contract;
    let eventName;
    if (this.direction === "burn") {
      contract = this.symbiosis.synthesis(this.chainIdIn);
      eventName = "BurnRequest";
    } else {
      contract = this.symbiosis.portal(this.chainIdIn);
      eventName = "SynthesizeRequest";
    }
    let args;
    receipt.logs.forEach((log) => {
      let event;
      try {
        event = contract.interface.parseLog(log);
      } catch {
        return;
      }
      if (event.name === eventName) {
        args = event.args;
      }
    });
    return args;
  }
  buildOtherSideFilter(receipt) {
    if (!this.chainIdOut) {
      throw new Error("Tokens are not set");
    }
    const args = this.getRequestArgs(receipt);
    if (!args) {
      throw new Error("Log not found");
    }
    const requestId = args.id;
    const receiveSide = this.direction === "burn" ? this.symbiosis.portal(this.chainIdOut).address : this.symbiosis.synthesis(this.chainIdOut).address;
    const externalId = getExternalId({
      internalId: requestId,
      contractAddress: receiveSide,
      revertableAddress: this.revertableAddress,
      chainId: this.chainIdOut
    });
    const event = this.direction === "burn" ? this.symbiosis.portal(this.chainIdOut).filters.BurnCompleted() : this.symbiosis.synthesis(this.chainIdOut).filters.SynthesizeCompleted();
    if (!event || !event.topics || event.topics.length === 0) {
      throw new Error("Event not found");
    }
    const topic0 = event.topics[0];
    return {
      address: receiveSide,
      topics: [topic0, externalId]
    };
  }
  getPendingRequest(receipt) {
    const args = this.getRequestArgs(receipt);
    if (!args) {
      return;
    }
    const { id, amount: amountFrom, token: tokenIdFrom, from, to, chainID, revertableAddress } = args;
    const chainId = chainID.toNumber();
    const fromToken = this.symbiosis.findToken(tokenIdFrom, this.chainIdIn);
    if (!fromToken) {
      return;
    }
    const fromTokenAmount = new TokenAmount(fromToken, amountFrom.toHexString());
    let contractAddress;
    let type;
    if (this.direction === "burn") {
      contractAddress = this.symbiosis.synthesis(this.chainIdIn).address;
      type = "burn";
    } else {
      contractAddress = this.symbiosis.portal(this.chainIdIn).address;
      type = "synthesize";
    }
    const externalId = getExternalId({
      internalId: id,
      contractAddress,
      revertableAddress,
      chainId
    });
    return {
      chainIdFrom: this.chainIdIn,
      chainIdTo: chainId,
      externalId,
      from,
      fromTokenAmount,
      internalId: id,
      revertableAddress,
      state: 0 /* Default */,
      to,
      transactionHash: receipt.transactionHash,
      type,
      revertChainId: chainId,
      // FIXME depends of type
      originalFromTokenAmount: fromTokenAmount
      // FIXME depends of type
    };
  }
};

// src/crosschain/bridging.ts
var Bridging = class {
  constructor(symbiosis) {
    this.symbiosis = symbiosis;
  }
  async exactIn({ from, tokenAmountIn, tokenOut, to }) {
    this.symbiosis.validateSwapAmounts(tokenAmountIn);
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.from = tronAddressToEvm(from);
    this.to = tronAddressToEvm(to);
    this.direction = tokenAmountIn.token.isSynthetic ? "burn" : "mint";
    if (isTronToken(this.tokenAmountIn.token) || isTronToken(this.tokenOut)) {
      this.revertableAddress = this.symbiosis.getRevertableAddress(this.tokenOut.chainId);
    } else {
      this.revertableAddress = this.from;
    }
    const fee = await this.getFee();
    const tokenAmountOut = new TokenAmount(this.tokenOut, this.tokenAmountIn.raw);
    if (tokenAmountOut.lessThan(fee)) {
      throw new Error2(
        `Amount ${tokenAmountOut.toSignificant()} ${tokenAmountOut.token.symbol} less than fee ${fee.toSignificant()} ${fee.token.symbol}`,
        4 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    this.tokenAmountOut = tokenAmountOut.subtract(fee);
    if (isTronToken(this.tokenAmountIn.token)) {
      const transactionRequest2 = this.getTronTransactionRequest(fee);
      return {
        fee,
        tokenAmountOut: this.tokenAmountOut,
        transactionRequest: transactionRequest2,
        type: "tron"
      };
    }
    const transactionRequest = this.getEvmTransactionRequest(fee);
    return {
      execute: (signer) => this.execute(transactionRequest, signer),
      fee,
      tokenAmountOut: this.tokenAmountOut,
      transactionRequest,
      type: "evm"
    };
  }
  async getFee() {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    if (this.direction === "mint") {
      return await this.getMintFee();
    }
    return await this.getBurnFee();
  }
  async execute(transactionRequest, signer) {
    const preparedTransactionRequest = await prepareTransactionRequest(transactionRequest, signer);
    const response = await signer.sendTransaction(preparedTransactionRequest);
    return {
      response,
      waitForMined: (confirmations = 1) => this.waitForMined(confirmations, response)
    };
  }
  async waitForMined(confirmations, response) {
    const receipt = await response.wait(confirmations);
    return {
      receipt,
      waitForComplete: () => this.waitForComplete(receipt)
    };
  }
  getTronTransactionRequest(fee) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const { chainId } = this.tokenAmountIn.token;
    const portalAddress = this.symbiosis.chainConfig(chainId).portal;
    if (this.direction === "burn") {
      throw new Error2("Burn is not supported on Tron");
    }
    return prepareTronTransaction({
      chainId,
      abi: TRON_PORTAL_ABI,
      ownerAddress: this.from,
      contractAddress: portalAddress,
      functionName: "synthesize",
      params: [
        fee.raw.toString(),
        this.tokenAmountIn.token.address,
        this.tokenAmountIn.raw.toString(),
        this.to,
        this.symbiosis.synthesis(this.tokenOut.chainId).address,
        this.symbiosis.bridge(this.tokenOut.chainId).address,
        this.revertableAddress,
        this.tokenOut.chainId.toString(),
        this.symbiosis.clientId
      ],
      tronWeb: this.symbiosis.tronWeb(chainId)
    });
  }
  getEvmTransactionRequest(fee) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const { chainId } = this.tokenAmountIn.token;
    if (this.direction === "burn") {
      const synthesis = this.symbiosis.synthesis(chainId);
      const portalAddress = this.symbiosis.chainConfig(this.tokenOut.chainId).portal;
      const bridgeAddress = this.symbiosis.chainConfig(this.tokenOut.chainId).bridge;
      return {
        chainId,
        to: synthesis.address,
        data: synthesis.interface.encodeFunctionData("burnSyntheticToken", [
          fee.raw.toString(),
          this.tokenAmountIn.token.address,
          this.tokenAmountIn.raw.toString(),
          this.to,
          portalAddress,
          bridgeAddress,
          this.revertableAddress,
          this.tokenOut.chainId,
          this.symbiosis.clientId
        ])
      };
    }
    const portal = this.symbiosis.portal(chainId);
    if (this.tokenAmountIn.token.isNative) {
      return {
        chainId,
        to: portal.address,
        data: portal.interface.encodeFunctionData("synthesizeNative", [
          fee.raw.toString(),
          this.to,
          this.symbiosis.synthesis(this.tokenOut.chainId).address,
          this.symbiosis.bridge(this.tokenOut.chainId).address,
          this.revertableAddress,
          this.tokenOut.chainId,
          this.symbiosis.clientId
        ]),
        value: BigNumber2.from(this.tokenAmountIn.raw.toString())
      };
    }
    return {
      chainId,
      to: portal.address,
      data: portal.interface.encodeFunctionData("synthesize", [
        fee.raw.toString(),
        this.tokenAmountIn.token.address,
        this.tokenAmountIn.raw.toString(),
        this.to,
        this.symbiosis.synthesis(this.tokenOut.chainId).address,
        this.symbiosis.bridge(this.tokenOut.chainId).address,
        this.revertableAddress,
        this.tokenOut.chainId,
        this.symbiosis.clientId
      ])
    };
  }
  async getMintFee() {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.tokenOut.chainId;
    const portalAddress = this.symbiosis.chainConfig(chainIdIn).portal;
    const synthesisAddress = this.symbiosis.chainConfig(chainIdOut).synthesis;
    const synthesisInterface = Synthesis__factory.createInterface();
    const internalId = getInternalId({
      contractAddress: portalAddress,
      requestCount: MaxUint256,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: synthesisAddress,
      revertableAddress: this.revertableAddress,
      chainId: chainIdOut
    });
    const token = wrappedToken(this.tokenAmountIn.token);
    const calldata = synthesisInterface.encodeFunctionData("mintSyntheticToken", [
      "1",
      // _stableBridgingFee,
      externalId,
      // externalID,
      token.address,
      // _token,
      chainIdIn,
      // block.chainid,
      this.tokenAmountIn.raw.toString(),
      // _amount,
      this.to
      // _chain2address
    ]);
    const fee = await this.symbiosis.getBridgeFee({
      receiveSide: synthesisAddress,
      calldata,
      chainIdFrom: this.tokenAmountIn.token.chainId,
      chainIdTo: this.tokenOut.chainId
    });
    return new TokenAmount(this.tokenOut, fee.toString());
  }
  async getBurnFee() {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.tokenOut.chainId;
    const synthesis = this.symbiosis.synthesis(chainIdIn);
    const portalAddress = this.symbiosis.chainConfig(chainIdOut).portal;
    const internalId = getInternalId({
      contractAddress: synthesis.address,
      requestCount: MaxUint256,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: portalAddress,
      revertableAddress: this.revertableAddress,
      chainId: chainIdOut
    });
    const portalInterface = Portal__factory.createInterface();
    const calldata = portalInterface.encodeFunctionData("unsynthesize", [
      "1",
      // _stableBridgingFee,
      externalId,
      // externalID,
      this.tokenOut.address,
      // rtoken,
      this.tokenAmountIn.raw.toString(),
      // _amount,
      this.to
      // _chain2address
    ]);
    const fee = await this.symbiosis.getBridgeFee({
      receiveSide: portalAddress,
      calldata,
      chainIdFrom: chainIdIn,
      chainIdTo: chainIdOut
    });
    return new TokenAmount(this.tokenOut, fee.toString());
  }
  async waitForComplete(receipt) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    return new WaitForComplete({
      direction: this.direction,
      chainIdOut: this.tokenOut.chainId,
      symbiosis: this.symbiosis,
      revertableAddress: this.revertableAddress,
      chainIdIn: this.tokenAmountIn.token.chainId
    }).waitForComplete(receipt);
  }
};

// src/crosschain/revert.ts
import { MaxUint256 as MaxUint2562 } from "@ethersproject/constants";
import { AddressZero as AddressZero2 } from "@ethersproject/constants/lib/addresses";
import JSBI12 from "jsbi";

// src/crosschain/trade/aggregatorTrade.ts
import { utils as utils31 } from "ethers";

// src/crosschain/trade/oneInchTrade.ts
import fetch2 from "isomorphic-unfetch";

// src/crosschain/trade/getTradePriceImpact.ts
import { BigNumber as BigNumber3 } from "@ethersproject/bignumber";
import { formatUnits } from "@ethersproject/units";
import JSBI10 from "jsbi";

// src/crosschain/multicall.ts
var NoMulticallAddressError = class extends Error {
  constructor(chainId) {
    super(
      `Failed to create Multicall instance. We do not know the multicall address on this network. ChainId: ${chainId}`
    );
  }
};
async function getMulticall(provider) {
  const { chainId } = await provider.getNetwork();
  const address = MULTICALL_ADDRESSES[chainId];
  if (!address) {
    throw new NoMulticallAddressError(chainId);
  }
  return Multicall__factory.connect(address, provider);
}

// src/crosschain/trade/getTradePriceImpact.ts
async function getRateToEth(tokens, oracle) {
  const calls = tokens.map((token) => ({
    target: oracle.address,
    callData: oracle.interface.encodeFunctionData(
      "getRateToEth",
      [token.address, true]
      // use wrapper
    )
  }));
  const multicall = await getMulticall(oracle.provider);
  return multicall.callStatic.tryAggregate(false, calls);
}
async function getTradePriceImpact({
  dataProvider,
  oracle,
  tokenAmountIn,
  tokenAmountOut
}) {
  const tokens = [wrappedToken(tokenAmountIn.token), wrappedToken(tokenAmountOut.token)];
  const aggregated = await dataProvider.getOneInchRateToEth(tokens, oracle);
  const denominator = BigNumber3.from(10).pow(18);
  const data = aggregated.map(([success, returnData], i) => {
    if (!success || returnData === "0x")
      return;
    const result = oracle.interface.decodeFunctionResult("getRateToEth", returnData);
    const numerator = BigNumber3.from(10).pow(tokens[i].decimals);
    return BigNumber3.from(result.weightedRate).mul(numerator).div(denominator);
  });
  if (!data[0] || !data[1]) {
    throw new Error("OneInch oracle: cannot to receive rate to ETH");
  }
  const multiplierPow = 18;
  const multiplier = BigNumber3.from(10).pow(multiplierPow);
  const spot = data[1].mul(multiplier).div(data[0]);
  const inBn = BigNumber3.from(tokenAmountIn.raw.toString()).mul(BigNumber3.from(10).pow(tokenAmountOut.token.decimals));
  const outBn = BigNumber3.from(tokenAmountOut.raw.toString()).mul(
    BigNumber3.from(10).pow(tokenAmountIn.token.decimals)
  );
  const real = inBn.mul(multiplier).div(outBn);
  const impact = real.mul(multiplier).div(spot);
  const impactNumber = 1 - Number.parseFloat(formatUnits(impact, multiplierPow));
  return new Percent(parseInt(`${impactNumber * JSBI10.toNumber(BIPS_BASE)}`).toString(), BIPS_BASE);
}

// src/crosschain/trade/oneInchTrade.ts
var API_URL = "https://api-v2.symbiosis.finance/crosschain/v1/inch/";
var NATIVE_TOKEN_ADDRESS = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
var OneInchTrade = class {
  constructor(tokenAmountIn, tokenOut, from, to, slippage, oracle, dataProvider, protocols) {
    this.tradeType = "1inch";
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.from = from;
    this.to = to;
    this.slippage = slippage;
    this.oracle = oracle;
    this.dataProvider = dataProvider;
    this.protocols = protocols || [];
  }
  static isAvailable(chainId) {
    return canOneInch(chainId);
  }
  async init() {
    let fromTokenAddress = this.tokenAmountIn.token.address;
    if (this.tokenAmountIn.token.isNative) {
      fromTokenAddress = NATIVE_TOKEN_ADDRESS;
    }
    let toTokenAddress = this.tokenOut.address;
    if (this.tokenOut.isNative) {
      toTokenAddress = NATIVE_TOKEN_ADDRESS;
    }
    const protocolsOrigin = await this.dataProvider.getOneInchProtocols(this.tokenAmountIn.token.chainId);
    let protocols = this.protocols.filter((x) => protocolsOrigin.includes(x));
    if (protocols.length === 0) {
      protocols = protocolsOrigin;
    }
    const url = new URL(`${this.tokenAmountIn.token.chainId}/swap`, API_URL);
    url.searchParams.set("src", fromTokenAddress);
    url.searchParams.set("dst", toTokenAddress);
    url.searchParams.set("amount", this.tokenAmountIn.raw.toString());
    url.searchParams.set("from", this.from);
    url.searchParams.set("slippage", (this.slippage / 100).toString());
    url.searchParams.set("receiver", this.to);
    url.searchParams.set("disableEstimate", "true");
    url.searchParams.set("allowPartialFill", "false");
    url.searchParams.set("usePatching", "true");
    url.searchParams.set("protocols", protocols.join(","));
    const response = await fetch2(url.toString());
    const json = await response.json();
    if (response.status === 400) {
      throw new Error(`Cannot build 1inch trade: ${json["description"]}`);
    }
    const tx = json["tx"];
    const amountOutRaw = json["toAmount"];
    this.routerAddress = tx.to;
    this.callData = tx.data;
    this.callDataOffset = this.getOffset(tx.data);
    this.amountOut = new TokenAmount(this.tokenOut, amountOutRaw);
    const amountOutMinRaw = getMinAmount(this.slippage, amountOutRaw);
    this.amountOutMin = new TokenAmount(this.tokenOut, amountOutMinRaw);
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    this.priceImpact = await getTradePriceImpact({
      dataProvider: this.dataProvider,
      oracle: this.oracle,
      tokenAmountIn: this.tokenAmountIn,
      tokenAmountOut: this.amountOut
    });
    return this;
  }
  static async getProtocols(chainId) {
    const url = new URL(`${chainId}/liquidity-sources`, API_URL);
    const response = await fetch2(url.toString());
    const json = await response.json();
    if (response.status === 400) {
      throw new Error(`Cannot get 1inch protocols: ${json["description"]}`);
    }
    return json["protocols"].reduce((acc, protocol) => {
      if (protocol.id.includes("ONE_INCH_LIMIT_ORDER")) {
        return acc;
      }
      if (protocol.id.includes("PMM")) {
        return acc;
      }
      acc.push(protocol.id);
      return acc;
    }, []);
  }
  getOffset(callData) {
    const methods = [
      // V4
      {
        // swap(address,(address,address,address,address,uint256,uint256,uint256,bytes),bytes)
        sigHash: "7c025200",
        offset: 260
      },
      {
        // clipperSwapTo(address,address,address,uint256,uint256)
        sigHash: "9994dd15",
        offset: 132
      },
      {
        // fillOrderRFQTo((uint256,address,address,address,address,uint256,uint256),bytes,uint256,uint256,address)
        sigHash: "baba5855",
        offset: 292
      },
      {
        // uniswapV3SwapTo(address,uint256,uint256,uint256[])
        sigHash: "bc80f1a8",
        offset: 68
      },
      // V5
      {
        // clipperSwapTo(address,address,address,address,uint256,uint256,uint256,bytes32,bytes32)
        sigHash: "093d4fa5",
        offset: 164
        // +
      },
      {
        // swap(address,(address,address,address,address,uint256,uint256,uint256),bytes,bytes)
        sigHash: "12aa3caf",
        offset: 196
        // +/-
      },
      {
        // fillOrderRFQTo((uint256,address,address,address,address,uint256,uint256),bytes,uint256,address)
        sigHash: "5a099843",
        offset: 196
      },
      {
        // unoswapTo(address,address,uint256,uint256,uint256[])
        sigHash: "f78dc253",
        offset: 100
      },
      {
        // uniswapV3SwapTo(address,uint256,uint256,uint256[])
        sigHash: "bc80f1a8",
        offset: 68
      }
    ];
    const sigHash = callData.slice(2, 10);
    const method = methods.find((i) => {
      return i.sigHash === sigHash;
    });
    return method?.offset;
  }
};

// src/crosschain/trade/openOceanTrade.ts
import fetch3 from "isomorphic-unfetch";
import BigNumber4 from "bignumber.js";
var OPEN_OCEAN_NETWORKS = {
  [1 /* ETH_MAINNET */]: "eth",
  [56 /* BSC_MAINNET */]: "bsc",
  [137 /* MATIC_MAINNET */]: "polygon",
  [43114 /* AVAX_MAINNET */]: "avax",
  [1313161554 /* AURORA_MAINNET */]: "aurora",
  [128 /* HECO_MAINNET */]: "heco",
  [2222 /* KAVA_MAINNET */]: "kava",
  [42161 /* ARBITRUM_MAINNET */]: "arbitrum",
  [10 /* OPTIMISM_MAINNET */]: "optimism",
  [324 /* ZKSYNC_MAINNET */]: "zksync",
  [1101 /* POLYGON_ZK */]: "polygon_zkevm",
  [59144 /* LINEA_MAINNET */]: "linea",
  [8453 /* BASE_MAINNET */]: "base"
};
var NATIVE_TOKEN_ADDRESS2 = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
var BASE_URL = "https://open-api.openocean.finance/v3";
var OpenOceanTrade = class {
  constructor({ tokenAmountIn, tokenOut, to, slippage, dataProvider }) {
    this.tradeType = "open-ocean";
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.to = to;
    this.slippage = slippage;
    this.dataProvider = dataProvider;
    this.callDataOffset = 4 + 8 * 32;
    this.endpoint = BASE_URL;
  }
  static isAvailable(chainId) {
    return Object.keys(OPEN_OCEAN_NETWORKS).includes(chainId.toString());
  }
  async init() {
    this.chain = OPEN_OCEAN_NETWORKS[this.tokenAmountIn.token.chainId];
    if (!this.chain) {
      throw new Error("Unsupported chain");
    }
    this.endpoint = `${BASE_URL}/${this.chain}`;
    let fromTokenAddress = this.tokenAmountIn.token.address;
    if (this.tokenAmountIn.token.isNative) {
      fromTokenAddress = NATIVE_TOKEN_ADDRESS2;
    }
    let toTokenAddress = this.tokenOut.address;
    if (this.tokenOut.isNative) {
      toTokenAddress = NATIVE_TOKEN_ADDRESS2;
    }
    const url = new URL(`${this.endpoint}/swap_quote`);
    url.searchParams.set("inTokenAddress", fromTokenAddress);
    url.searchParams.set("outTokenAddress", toTokenAddress);
    url.searchParams.set("amount", this.tokenAmountIn.toFixed());
    url.searchParams.set("gasPrice", "5");
    url.searchParams.set("slippage", (this.slippage / 100).toString());
    url.searchParams.set("account", this.to);
    url.searchParams.set("referrer", "0x3254aE00947e44B7fD03F50b93B9acFEd59F9620");
    const response = await fetch3(url.toString());
    const json = await response.json();
    if (!response.ok) {
      throw new Error(`Cannot build OpenOcean trade: ${json}`);
    }
    const { data, outAmount, to } = json.data;
    this.routerAddress = to;
    this.callData = data;
    this.amountOut = new TokenAmount(this.tokenOut, outAmount);
    const amountOutMinRaw = getMinAmount(this.slippage, outAmount);
    this.amountOutMin = new TokenAmount(this.tokenOut, amountOutMinRaw);
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    this.priceImpact = await this.getPriceImpact({
      tokenAmountIn: this.tokenAmountIn,
      tokenAmountOut: this.amountOut,
      dataProvider: this.dataProvider
    });
    return this;
  }
  async getPriceImpact({ tokenAmountIn, tokenAmountOut }) {
    const getTokensResponse = await fetch3(`${this.endpoint}/specify_tokenList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        tokens: [tokenAmountIn.token.symbol, tokenAmountOut.token.symbol]
      })
    });
    if (!getTokensResponse.ok) {
      throw new Error(`Cannot get OpenOcean tokenList`);
    }
    const tokens = await getTokensResponse.json();
    const inPrice = tokens.data.find(
      (token) => token.symbol.toLowerCase() === tokenAmountIn.token.symbol?.toLowerCase()
    )?.usd;
    const outPrice = tokens.data.find(
      (token) => token.symbol.toLowerCase() === tokenAmountOut.token.symbol?.toLowerCase()
    )?.usd;
    if (inPrice === void 0 || outPrice === void 0) {
      throw new Error(`Cannot find OpenOcean token prices`);
    }
    const spot = outPrice / inPrice;
    const outDecimals = new BigNumber4(10).pow(tokenAmountOut.token.decimals);
    const inBn = new BigNumber4(tokenAmountIn.raw.toString()).multipliedBy(outDecimals);
    const inDecimals = new BigNumber4(10).pow(tokenAmountIn.token.decimals);
    const outBn = new BigNumber4(tokenAmountOut.raw.toString()).multipliedBy(inDecimals);
    const real = inBn.div(outBn);
    const impact = new BigNumber4(1).minus(real.div(spot));
    return new Percent(impact.multipliedBy(BIPS_BASE.toString()).integerValue().toString(), BIPS_BASE);
  }
};

// src/crosschain/trade/aggregatorTrade.ts
var TradeNotInitializedError = class extends Error {
  constructor() {
    super("Trade is not initialized");
  }
};
var OPEN_OCEAN_CLIENT_ID = utils31.formatBytes32String("open-ocean");
var AggregatorTrade = class {
  constructor(params) {
    this.params = params;
  }
  static isAvailable(chainId) {
    return OneInchTrade.isAvailable(chainId) || OpenOceanTrade.isAvailable(chainId);
  }
  async init() {
    const { dataProvider, from, slippage, symbiosis, to, tokenAmountIn, tokenOut, clientId } = this.params;
    const aggregators = [];
    if (clientId !== OPEN_OCEAN_CLIENT_ID && OneInchTrade.isAvailable(tokenAmountIn.token.chainId)) {
      const oracle = symbiosis.oneInchOracle(this.params.tokenAmountIn.token.chainId);
      const oneInchTrade = new OneInchTrade(
        tokenAmountIn,
        tokenOut,
        from,
        to,
        slippage,
        oracle,
        dataProvider,
        this.params.oneInchProtocols
      );
      aggregators.push(oneInchTrade.init());
    }
    if (OpenOceanTrade.isAvailable(tokenAmountIn.token.chainId)) {
      const openOceanTrade = new OpenOceanTrade({
        slippage,
        to,
        tokenAmountIn,
        tokenOut,
        dataProvider
      });
      const promises = [openOceanTrade.init()];
      if (clientId !== OPEN_OCEAN_CLIENT_ID) {
        const limitPromise = new Promise((_resolve, reject) => {
          setTimeout(() => {
            reject("Timeout OO");
          }, 5 * 1e3);
        });
        promises.push(limitPromise);
      }
      aggregators.push(Promise.race(promises));
    }
    if (aggregators.length === 0) {
      throw new Error("No aggregators available for this trade");
    }
    const tradesResults = await Promise.allSettled(aggregators);
    let bestTrade;
    for (const trade of tradesResults) {
      if (trade.status === "rejected") {
        continue;
      }
      if (!bestTrade) {
        bestTrade = trade.value;
        continue;
      }
      if (trade.value.amountOut.greaterThan(bestTrade.amountOut)) {
        bestTrade = trade.value;
      }
    }
    if (!bestTrade) {
      throw new Error("No aggregators available for this trade");
    }
    this.trade = bestTrade;
    return this;
  }
  assertTradeInitialized() {
    if (!this.trade) {
      throw new TradeNotInitializedError();
    }
  }
  /**
   * TODO: Use proxy to avoid code duplication
   */
  get callData() {
    this.assertTradeInitialized();
    return this.trade.callData;
  }
  get callDataOffset() {
    this.assertTradeInitialized();
    return this.trade.callDataOffset || 0;
  }
  get tokenAmountIn() {
    this.assertTradeInitialized();
    return this.trade.tokenAmountIn;
  }
  get amountOut() {
    this.assertTradeInitialized();
    return this.trade.amountOut;
  }
  get amountOutMin() {
    this.assertTradeInitialized();
    return this.trade.amountOutMin;
  }
  get routerAddress() {
    this.assertTradeInitialized();
    return this.trade.routerAddress;
  }
  get priceImpact() {
    this.assertTradeInitialized();
    return this.trade.priceImpact;
  }
  get route() {
    this.assertTradeInitialized();
    return this.trade.route;
  }
  get tradeType() {
    this.assertTradeInitialized();
    return this.trade.tradeType;
  }
};

// src/crosschain/trade/omniTrade.ts
var OmniTrade = class {
  constructor(tokenAmountIn, tokenAmountInMin, tokenOut, slippage, deadline, symbiosis, to, omniPoolConfig) {
    this.tokenAmountIn = tokenAmountIn;
    this.tokenAmountInMin = tokenAmountInMin;
    this.tokenOut = tokenOut;
    this.slippage = slippage;
    this.deadline = deadline;
    this.symbiosis = symbiosis;
    this.to = to;
    this.omniPoolConfig = omniPoolConfig;
    this.pool = this.symbiosis.omniPool(omniPoolConfig);
    this.poolOracle = this.symbiosis.omniPoolOracle(omniPoolConfig);
  }
  async init() {
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    const indexIn = this.symbiosis.getOmniPoolTokenIndex(this.omniPoolConfig, this.tokenAmountIn.token);
    const indexOut = this.symbiosis.getOmniPoolTokenIndex(this.omniPoolConfig, this.tokenOut);
    const quote = await this.poolOracle.quoteFrom(indexIn, indexOut, this.tokenAmountIn.raw.toString());
    let quoteMin = quote;
    if (!this.tokenAmountIn.equalTo(this.tokenAmountInMin)) {
      quoteMin = await this.poolOracle.quoteFrom(indexIn, indexOut, this.tokenAmountInMin.raw.toString());
    }
    this.amountOut = new TokenAmount(this.tokenOut, quote.actualToAmount.toString());
    const amountOutMinRaw = getMinAmount(this.slippage, quoteMin.actualToAmount.toString());
    this.amountOutMin = new TokenAmount(this.tokenOut, amountOutMinRaw);
    this.callData = this.pool.interface.encodeFunctionData("swap", [
      indexIn,
      indexOut,
      this.tokenAmountIn.raw.toString(),
      amountOutMinRaw.toString(),
      this.to,
      this.deadline
    ]);
    const priceImpact = calculatePriceImpact(this.tokenAmountIn, this.amountOut);
    if (!priceImpact) {
      throw new Error("Cannot calculate priceImpact");
    }
    this.priceImpact = priceImpact;
    return this;
  }
};

// src/crosschain/trade/uniLikeTrade.ts
import JSBI11 from "jsbi";
var UniLikeTrade = class _UniLikeTrade {
  constructor(tokenAmountIn, tokenOut, to, slippage, deadline, router, dexFee) {
    this.tradeType = "dex";
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.to = to;
    this.slippage = slippage;
    this.deadline = deadline;
    this.router = router;
    this.routerAddress = router.address;
    this.dexFee = dexFee;
  }
  async init(dataProvider) {
    if (dataProvider) {
      this.pairs = await dataProvider.getPairs(this.tokenAmountIn.token, this.tokenOut);
    } else {
      this.pairs = await _UniLikeTrade.getPairs(this.router.provider, this.tokenAmountIn.token, this.tokenOut);
    }
    const [trade] = Trade.bestTradeExactIn(this.pairs, this.tokenAmountIn, this.tokenOut, {
      maxHops: 3,
      maxNumResults: 1
    });
    if (!trade) {
      throw new Error("Cannot create trade");
    }
    this.trade = trade;
    const priceImpact = computeTradePriceBreakdown(this.trade, this.dexFee).priceImpactWithoutFee;
    if (!priceImpact) {
      throw new Error("Cannot calculate priceImpact");
    }
    this.priceImpact = priceImpact;
    this.route = trade.route.path;
    this.amountOut = trade.outputAmount;
    const amountOutMin = computeSlippageAdjustedAmounts(trade, this.slippage).OUTPUT;
    if (!amountOutMin) {
      throw new Error("Cannot compute amountOutMin");
    }
    this.amountOutMin = amountOutMin;
    const { data, offset } = this.buildCallData(trade);
    this.callData = data;
    this.callDataOffset = offset;
    if (!this.callData) {
      throw new Error("Cannot build callData");
    }
    return this;
  }
  buildCallData(trade) {
    const { methodName, args, offset } = Router.swapCallParameters(trade, {
      allowedSlippage: new Percent(JSBI11.BigInt(Math.floor(this.slippage)), BIPS_BASE),
      recipient: this.to,
      ttl: this.deadline
    });
    let method = methodName;
    if (trade.inputAmount.token.chainId === 43114 /* AVAX_MAINNET */) {
      method = methodName.replace("ETH", "AVAX");
    } else if ([200101 /* MILKOMEDA_DEVNET */, 2001 /* MILKOMEDA_MAINNET */].includes(trade.inputAmount.token.chainId)) {
      method = methodName.replace("ETH", "ADA");
    }
    return {
      data: this.router.interface.encodeFunctionData(method, args),
      offset
    };
  }
  static async getPairs(provider, tokenIn, tokenOut) {
    const allPairCombinations = getAllPairCombinations(tokenIn, tokenOut);
    return await _UniLikeTrade.allPairs(provider, allPairCombinations);
  }
  static async allPairs(provider, tokens) {
    const wrappedTokens = tokens.map(([tokenA, tokenB]) => [wrappedToken(tokenA), wrappedToken(tokenB)]);
    const multicall = await getMulticall(provider);
    const pairAddresses = wrappedTokens.map(([tokenA, tokenB]) => {
      if (!tokenA || !tokenB)
        throw new Error();
      if (tokenA.chainId !== tokenB.chainId)
        throw new Error();
      if (tokenA.equals(tokenB))
        throw new Error();
      return Pair.getAddress(tokenA, tokenB);
    });
    const pairInterface = Pair__factory.createInterface();
    const getReservesData = pairInterface.encodeFunctionData("getReserves");
    const calls = pairAddresses.map((pairAddress) => ({
      target: pairAddress,
      callData: getReservesData
    }));
    const aggregateResult = await multicall.callStatic.tryAggregate(false, calls);
    const validPairs = /* @__PURE__ */ new Map();
    aggregateResult.forEach(([success, returnData], i) => {
      if (!success || returnData === "0x") {
        return;
      }
      const tokenA = wrappedTokens[i][0];
      const tokenB = wrappedTokens[i][1];
      if (!tokenA || !tokenB || tokenA.equals(tokenB)) {
        return;
      }
      const reserve = pairInterface.decodeFunctionResult("getReserves", returnData);
      const { reserve0, reserve1 } = reserve;
      const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
      const pair = new Pair(
        new TokenAmount(token0, reserve0.toString()),
        new TokenAmount(token1, reserve1.toString())
      );
      validPairs.set(pair.liquidityToken.address, pair);
    });
    return Array.from(validPairs.values());
  }
};

// src/crosschain/trade/izumiTrade.ts
import BNJS from "bignumber.js";
import { BigNumber as BigNumber5 } from "ethers";
import { AbiCoder } from "ethers/lib/utils";
var POSSIBLE_FEES = [100, 400, 500, 2e3, 3e3, 1e4];
var IZUMI_ADDRESSES = {
  [5e3 /* MANTLE_MAINNET */]: {
    factory: "0x45e5F26451CDB01B0fA1f8582E0aAD9A6F27C218",
    quoter: "0x032b241De86a8660f1Ae0691a4760B426EA246d7",
    swap: "0x25C030116Feb2E7BbA054b9de0915E5F51b03e31",
    baseTokens: [
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0x201eba5cc46d216ce6dc03f6a759e8e766e956ae",
        decimals: 6,
        symbol: "USDT",
        name: "USDT"
      }),
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111",
        decimals: 18,
        symbol: "WETH",
        name: "Wrapped Ether"
      }),
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8",
        decimals: 18,
        symbol: "WMNT",
        name: "WMNT"
      }),
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0x0a3bb08b3a15a19b4de82f8acfc862606fb69a2d",
        decimals: 18,
        symbol: "iUSD",
        name: "iZUMi Bond USD"
      })
    ]
  },
  [59144 /* LINEA_MAINNET */]: {
    factory: "0x45e5F26451CDB01B0fA1f8582E0aAD9A6F27C218",
    quoter: "0xe6805638db944eA605e774e72c6F0D15Fb6a1347",
    swap: "0x032b241De86a8660f1Ae0691a4760B426EA246d7",
    baseTokens: [
      new Token({
        chainId: 59144 /* LINEA_MAINNET */,
        name: "Wrapped Ether",
        symbol: "WETH",
        address: "0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f",
        decimals: 18
      }),
      new Token({
        chainId: 59144 /* LINEA_MAINNET */,
        name: "iZUMi Bond USD",
        symbol: "iUSD",
        address: "0x0a3bb08b3a15a19b4de82f8acfc862606fb69a2d",
        decimals: 18
      })
    ]
  },
  [534352 /* SCROLL_MAINNET */]: {
    factory: "0x8c7d3063579BdB0b90997e18A770eaE32E1eBb08",
    quoter: "0x33531bDBFE34fa6Fd5963D0423f7699775AacaaF",
    swap: "0x2db0AFD0045F3518c77eC6591a542e326Befd3D7",
    baseTokens: [
      new Token({
        chainId: 534352 /* SCROLL_MAINNET */,
        name: "Wrapped Ether",
        symbol: "WETH",
        address: "0x5300000000000000000000000000000000000004",
        decimals: 18
      }),
      new Token({
        chainId: 534352 /* SCROLL_MAINNET */,
        name: "USD Coin",
        symbol: "USDC",
        address: "0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4",
        decimals: 18
      })
    ]
  }
};
var IzumiTrade = class {
  constructor(params) {
    this.tradeType = "izumi";
    this.priceImpact = new Percent("0");
    const { symbiosis, tokenAmountIn, tokenOut, slippage, ttl, to } = params;
    this.symbiosis = symbiosis;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.slippage = slippage;
    this.ttl = ttl;
    this.to = to;
  }
  static isSupported(chainId) {
    return !!IZUMI_ADDRESSES[chainId];
  }
  async init() {
    const addresses = IZUMI_ADDRESSES[this.tokenAmountIn.token.chainId];
    if (!addresses) {
      throw new Error("Unsupported chain");
    }
    const { quoter, swap } = addresses;
    const allRoutes = [];
    const tokenIn = this.tokenAmountIn.token;
    const tokenOut = this.tokenOut;
    POSSIBLE_FEES.forEach((fee) => {
      const path2 = getTokenChainPath([tokenIn, tokenOut], [fee]);
      allRoutes.push({ tokens: [tokenIn, tokenOut], path: path2, fees: [fee] });
    });
    for (const baseToken of addresses.baseTokens) {
      if (baseToken.equals(this.tokenAmountIn.token) || baseToken.equals(this.tokenOut)) {
        continue;
      }
      POSSIBLE_FEES.forEach((firstFee) => {
        POSSIBLE_FEES.forEach((secondFee) => {
          const fees = [firstFee, secondFee];
          const path2 = getTokenChainPath([tokenIn, baseToken, tokenOut], fees);
          allRoutes.push({ tokens: [tokenIn, baseToken, tokenOut], path: path2, fees });
        });
      });
    }
    const provider = this.symbiosis.getProvider(this.tokenAmountIn.token.chainId);
    const multicall = await getMulticall(provider);
    const quoterInterface = IzumiQuoter__factory.createInterface();
    const calls = allRoutes.map(({ path: path2 }) => ({
      target: quoter,
      callData: quoterInterface.encodeFunctionData("swapAmount", [this.tokenAmountIn.raw.toString(), path2])
    }));
    const maxChunkLength = 100;
    const chunks = Math.floor(calls.length / maxChunkLength) + 1;
    let results = [];
    for (let i = 0; i < chunks; i++) {
      const from = i * maxChunkLength;
      let to = (i + 1) * maxChunkLength;
      if (to > calls.length) {
        to = calls.length;
      }
      const callsPart = calls.slice(from, to);
      const part = await multicall.callStatic.tryAggregate(false, callsPart);
      results = [...results, ...part];
    }
    let bestRoute;
    let bestOutput;
    for (let i = 0; i < results.length; i++) {
      const [success, returnData] = results[i];
      if (!success) {
        continue;
      }
      const { acquire } = quoterInterface.decodeFunctionResult("swapAmount", returnData);
      if (!bestOutput || BigNumber5.from(acquire).gt(bestOutput)) {
        bestRoute = allRoutes[i];
        bestOutput = acquire;
      }
    }
    if (!bestRoute || !bestOutput) {
      throw new Error("No path found");
    }
    const { path, tokens } = bestRoute;
    const pointsBefore = await this.getCurrentPoolPoints(bestRoute);
    const initDecimalPriceEndByStart = getPriceDecimalEndByStart(bestRoute, pointsBefore);
    const spotPriceBNJS = new BNJS(this.tokenAmountIn.raw.toString()).dividedBy(10 ** this.tokenAmountIn.token.decimals).dividedBy(initDecimalPriceEndByStart);
    const bestOutputBNJS = new BNJS(bestOutput.toString()).dividedBy(10 ** this.tokenOut.decimals);
    const impactBNJS = spotPriceBNJS.minus(bestOutputBNJS).div(bestOutputBNJS).negated();
    this.priceImpact = new Percent(impactBNJS.times(BIPS_BASE.toString()).toFixed(0).toString(), BIPS_BASE);
    this.amountOut = new TokenAmount(this.tokenOut, bestOutput.toString());
    const minAcquired = getMinAmount(this.slippage, bestOutput.toString());
    this.amountOutMin = new TokenAmount(this.tokenOut, minAcquired.toString());
    const outputToken = tokens[tokens.length - 1];
    const finalRecipientAddress = this.to;
    const innerRecipientAddress = outputToken.isNative ? "0x0000000000000000000000000000000000000000" : finalRecipientAddress;
    const swapInterface = IzumiSwap__factory.createInterface();
    const swapCalls = [];
    const swapData = swapInterface.encodeFunctionData("swapAmount", [
      {
        path,
        recipient: innerRecipientAddress,
        amount: this.tokenAmountIn.raw.toString(),
        minAcquired: minAcquired.toString(),
        deadline: Math.floor(Date.now() / 1e3) + this.ttl
      }
    ]);
    swapCalls.push(swapData);
    if (outputToken.isNative) {
      swapCalls.push(swapInterface.encodeFunctionData("unwrapWETH9", ["0", finalRecipientAddress]));
    }
    let callData;
    if (swapCalls.length === 1) {
      callData = swapCalls[0];
    } else {
      callData = swapInterface.encodeFunctionData("multicall", [swapCalls]);
    }
    const abiCoder = new AbiCoder();
    const encodedCallData = abiCoder.encode(["uint128"], [this.tokenAmountIn.raw.toString()]).replace("0x", "");
    const position = callData.indexOf(encodedCallData) + encodedCallData.length;
    this.callDataOffset = (position - 2) / 2;
    this.routerAddress = swap;
    this.callData = callData;
    this.route = tokens;
    return this;
  }
  async getCurrentPoolPoints({ fees, tokens }) {
    const addresses = IZUMI_ADDRESSES[this.tokenAmountIn.token.chainId];
    if (!addresses) {
      throw new Error("Unsupported chain");
    }
    const provider = this.symbiosis.getProvider(this.tokenAmountIn.token.chainId);
    const multicall = await getMulticall(provider);
    const factoryInterface = IzumiFactory__factory.createInterface();
    const getPoolAddressesCalls = [];
    for (let i = 0; i < fees.length; i++) {
      getPoolAddressesCalls.push({
        target: addresses.factory,
        callData: factoryInterface.encodeFunctionData("pool", [
          wrappedToken(tokens[i]).address,
          wrappedToken(tokens[i + 1]).address,
          fees[i]
        ])
      });
    }
    const getPoolAddressesResults = await multicall.callStatic.tryAggregate(false, getPoolAddressesCalls);
    const poolsAddresses = getPoolAddressesResults.map(
      ([, returnData]) => factoryInterface.decodeFunctionResult("pool", returnData)[0]
    );
    const poolInterface = IzumiPool__factory.createInterface();
    const statesResults = await multicall.callStatic.tryAggregate(
      false,
      poolsAddresses.map((poolAddress) => ({
        target: poolAddress,
        callData: poolInterface.encodeFunctionData("state")
      }))
    );
    const points = statesResults.map(
      ([, returnData]) => poolInterface.decodeFunctionResult("state", returnData).currentPoint
    );
    return points;
  }
};
function num2Hex(n) {
  if (n < 10) {
    return String(n);
  }
  const str = "ABCDEF";
  return str[n - 10];
}
function appendHex(hexString, newHexString) {
  return hexString + newHexString.slice(2);
}
function fee2Hex(fee) {
  const n0 = fee % 16;
  const n1 = Math.floor(fee / 16) % 16;
  const n2 = Math.floor(fee / 256) % 16;
  const n3 = Math.floor(fee / 4096) % 16;
  const n4 = 0;
  const n5 = 0;
  return "0x" + num2Hex(n5) + num2Hex(n4) + num2Hex(n3) + num2Hex(n2) + num2Hex(n1) + num2Hex(n0);
}
var getTokenChainPath = (tokenChain, feeChain) => {
  let hexString = wrappedToken(tokenChain[0]).address;
  for (let i = 0; i < feeChain.length; i++) {
    hexString = appendHex(hexString, fee2Hex(feeChain[i]));
    hexString = appendHex(hexString, wrappedToken(tokenChain[i + 1]).address);
  }
  return hexString;
};
var getTokenXYFromToken = (tokenA, tokenB) => {
  const addressA = wrappedToken(tokenA).address;
  const addressB = wrappedToken(tokenB).address;
  if (addressA.toLowerCase() < addressB.toLowerCase()) {
    return { tokenX: tokenA, tokenY: tokenB };
  }
  return { tokenX: tokenB, tokenY: tokenA };
};
var priceUndecimal2PriceDecimal = (tokenA, tokenB, priceUndecimalAByB) => {
  return Number(priceUndecimalAByB.times(10 ** tokenA.decimals).div(10 ** tokenB.decimals));
};
var point2PriceDecimal = (tokenA, tokenB, point) => {
  let priceDecimal = 0;
  let needReverse = false;
  const { tokenX, tokenY } = getTokenXYFromToken(tokenA, tokenB);
  const addressA = wrappedToken(tokenA).address;
  const addressB = wrappedToken(tokenB).address;
  if (point > 0) {
    priceDecimal = priceUndecimal2PriceDecimal(tokenX, tokenY, new BNJS(1.0001 ** point));
    needReverse = addressA.toLowerCase() > addressB.toLowerCase();
  } else {
    priceDecimal = priceUndecimal2PriceDecimal(tokenY, tokenX, new BNJS(1.0001 ** -point));
    needReverse = addressA.toLowerCase() < addressB.toLowerCase();
  }
  if (needReverse) {
    priceDecimal = 1 / priceDecimal;
  }
  return priceDecimal;
};
function getPriceDecimalEndByStart(route, points) {
  const { tokens, fees } = route;
  let decimalPriceEndByStart = 1;
  for (let i = 0; i < fees.length; i++) {
    const decimalPriceBackByFront = point2PriceDecimal(tokens[i + 1], tokens[i], points[i]);
    decimalPriceEndByStart *= decimalPriceBackByFront;
  }
  return decimalPriceEndByStart;
}

// src/crosschain/trade/wrapTrade.ts
var UNWRAP_ADDRESSES = {
  [1101 /* POLYGON_ZK */]: "0x8a7F930003BedD63A1ebD99C5917FD6aE7E3dedf",
  [42170 /* ARBITRUM_NOVA */]: "0x8a7F930003BedD63A1ebD99C5917FD6aE7E3dedf",
  [59144 /* LINEA_MAINNET */]: "0xE75C7E85FE6ADd07077467064aD15847E6ba9877",
  [534353 /* SCROLL_TESTNET */]: "0x2135c0ab678F25E9cbB4BbBd55B68DE1E36D1E81",
  [534351 /* SCROLL_SEPOLIA */]: "0x41151CEfFB743650E14425c7749019E491Fd1987",
  [5 /* ETH_GOERLI */]: "0xc9Fd2AF244FEfb31A62A5A33B9D6261Cec2cb7aA",
  [8453 /* BASE_MAINNET */]: "0xd8db4fb1fEf63045A443202d506Bcf30ef404160",
  [534352 /* SCROLL_MAINNET */]: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2"
};
var WrapTrade = class {
  constructor(tokenAmountIn, tokenOut, to) {
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.to = to;
    this.tradeType = "wrap";
    this.priceImpact = new Percent("0");
  }
  static isSupported(tokenAmountIn, tokenOut) {
    const wrappedInToken = wrappedToken(tokenAmountIn.token);
    if (tokenAmountIn.token.isNative && wrappedInToken.equals(tokenOut)) {
      return true;
    }
    const unwrapAddress = UNWRAP_ADDRESSES[tokenAmountIn.token.chainId];
    const wrappedOutToken = wrappedToken(tokenOut);
    return !!unwrapAddress && tokenOut.isNative && wrappedOutToken.equals(tokenAmountIn.token);
  }
  async init() {
    const wethInterface = Weth__factory.createInterface();
    if (this.tokenAmountIn.token.isNative) {
      const wethToken = wrappedToken(this.tokenAmountIn.token);
      this.route = [this.tokenAmountIn.token, wethToken];
      this.amountOut = new TokenAmount(wethToken, this.tokenAmountIn.raw);
      this.amountOutMin = this.amountOut;
      this.routerAddress = wethToken.address;
      this.callData = wethInterface.encodeFunctionData("deposit");
      return this;
    }
    const unwrapperAddress = UNWRAP_ADDRESSES[this.tokenAmountIn.token.chainId];
    if (!unwrapperAddress) {
      throw new Error("Cannot unwrap on this network");
    }
    const unwrapperInterface = Unwrapper__factory.createInterface();
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    this.amountOut = new TokenAmount(this.tokenOut, this.tokenAmountIn.raw);
    this.amountOutMin = this.amountOut;
    this.routerAddress = unwrapperAddress;
    this.callData = unwrapperInterface.encodeFunctionData("unwrap", [this.tokenAmountIn.raw.toString(), this.to]);
    this.callDataOffset = 4 + 32;
    return this;
  }
};

// src/crosschain/revert.ts
var RevertPending = class {
  constructor(symbiosis, request) {
    this.symbiosis = symbiosis;
    this.request = request;
    const omniPoolConfig = symbiosis.getOmniPoolByToken(this.request.fromTokenAmount.token);
    if (!omniPoolConfig) {
      throw new Error2("No omni pool found for token", 6 /* NO_TRANSIT_POOL */);
    }
    this.omniPoolConfig = omniPoolConfig;
    this.multicallRouter = this.symbiosis.multicallRouter(this.omniPoolConfig.chainId);
  }
  async revert(slippage, deadline) {
    this.slippage = slippage;
    this.deadline = deadline;
    this.transitTokenFrom = await this.symbiosis.transitToken(this.request.chainIdFrom, this.omniPoolConfig);
    this.transitTokenTo = await this.symbiosis.transitToken(this.request.chainIdTo, this.omniPoolConfig);
    const fee = await this.getFee();
    const feeV2 = this.request.type === "burn-v2" ? await this.getFeeV2() : void 0;
    const transactionRequest = await this.getTransactionRequest(fee, feeV2);
    if ("call_value" in transactionRequest) {
      return {
        type: "tron",
        fee,
        transactionRequest
      };
    }
    return {
      type: "evm",
      fee,
      transactionRequest,
      execute: (signer) => this.execute(transactionRequest, signer)
    };
  }
  async waitForCompleteV2() {
    const { chainIdFrom, internalId, chainIdTo, revertableAddress } = this.request;
    const externalId = getExternalId({
      internalId,
      chainId: chainIdTo,
      revertableAddress,
      contractAddress: this.symbiosis.portal(chainIdTo).address
    });
    const mChainSynthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    const revertBurnLog = await getLogWithTimeout({
      chainId: this.omniPoolConfig.chainId,
      filter: mChainSynthesis.filters.RevertBurnCompleted(externalId),
      symbiosis: this.symbiosis
    });
    const receipt = await mChainSynthesis.provider.getTransactionReceipt(revertBurnLog.transactionHash);
    const wfc = new WaitForComplete({
      direction: "burn",
      symbiosis: this.symbiosis,
      revertableAddress,
      chainIdIn: this.omniPoolConfig.chainId,
      chainIdOut: chainIdFrom
    });
    const log = await wfc.waitForComplete(receipt);
    return log.transactionHash;
  }
  async waitForCompleteV2Revert() {
    const { chainIdFrom, chainIdTo, revertableAddress } = this.request;
    const synthesis = this.symbiosis.synthesis(chainIdFrom);
    const externalId = this.getExternalId();
    const filter = synthesis.filters.RevertBurnCompleted(externalId);
    const revertBurnLog = await getLogWithTimeout({ chainId: chainIdFrom, filter, symbiosis: this.symbiosis });
    const receipt = await synthesis.provider.getTransactionReceipt(revertBurnLog.transactionHash);
    const wfc = new WaitForComplete({
      direction: "burn",
      symbiosis: this.symbiosis,
      revertableAddress,
      chainIdIn: chainIdFrom,
      chainIdOut: chainIdTo
    });
    const log = await wfc.waitForComplete(receipt);
    return log.transactionHash;
  }
  // Wait for the revert transaction to be mined on the original chain
  async waitForComplete() {
    const { type } = this.request;
    if (type === "burn-v2") {
      return this.waitForCompleteV2();
    }
    if (type === "burn-v2-revert") {
      return this.waitForCompleteV2Revert();
    }
    const { chainIdFrom } = this.request;
    const externalId = this.getExternalId();
    let filter;
    if (type === "synthesize" || type === "synthesize-v2") {
      const otherPortal = this.symbiosis.portal(chainIdFrom);
      filter = otherPortal.filters.RevertSynthesizeCompleted(externalId);
    } else {
      const otherSynthesis = this.symbiosis.synthesis(chainIdFrom);
      filter = otherSynthesis.filters.RevertBurnCompleted(externalId);
    }
    const log = await getLogWithTimeout({ chainId: chainIdFrom, filter, symbiosis: this.symbiosis });
    return log.transactionHash;
  }
  async getFeeV2() {
    const feeToken = this.transitTokenFrom;
    const [receiveSide, calldata] = await this.feeBurnCallDataV2();
    const fee = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom: this.omniPoolConfig.chainId,
      chainIdTo: this.request.chainIdFrom
    });
    return new TokenAmount(feeToken, fee.toString());
  }
  async feeBurnCallDataV2() {
    const chainIdIn = this.omniPoolConfig.chainId;
    const chainIdOut = this.request.chainIdFrom;
    const { revertableAddress, fromTokenAmount } = this.request;
    const synthesis = this.symbiosis.synthesis(chainIdIn);
    const portal = this.symbiosis.portal(chainIdOut);
    const internalId = getInternalId({
      contractAddress: synthesis.address,
      requestCount: MaxUint2562,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: portal.address,
      revertableAddress,
      chainId: chainIdOut
    });
    const calldata = portal.interface.encodeFunctionData("metaUnsynthesize", [
      "0",
      // _stableBridgingFee
      externalId,
      // _externalID,
      revertableAddress,
      // _to
      fromTokenAmount.raw.toString(),
      // _amount
      this.transitTokenFrom.address,
      // _rToken
      AddressZero2,
      // _finalReceiveSide
      [],
      // _finalCalldata
      0
      // _finalOffset
    ]);
    return [portal.address, calldata];
  }
  buildMetaBurnCalldata(feeV2) {
    const { from, chainIdFrom } = this.request;
    const synthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    const synth = this.getSyntheticToken(this.transitTokenFrom);
    if (!synth) {
      throw new Error2(`Cannot find synthetic token between mChain and ${chainIdFrom}`);
    }
    const metarouter = this.symbiosis.metaRouter(this.omniPoolConfig.chainId);
    let revertableAddress;
    if (isTronChainId(chainIdFrom)) {
      revertableAddress = this.symbiosis.getRevertableAddress(chainIdFrom);
    } else {
      revertableAddress = from;
    }
    const calldata = synthesis.interface.encodeFunctionData("metaBurnSyntheticToken", [
      {
        stableBridgingFee: feeV2 ? feeV2.raw.toString() : "0",
        amount: "0",
        syntCaller: metarouter.address,
        finalReceiveSide: AddressZero2,
        sToken: synth.address,
        finalCallData: [],
        finalOffset: 0,
        chain2address: from,
        // NOTE: funds will be returned there if got stuck
        receiveSide: this.symbiosis.portal(chainIdFrom).address,
        oppositeBridge: this.symbiosis.bridge(chainIdFrom).address,
        revertableAddress,
        chainID: chainIdFrom,
        clientID: this.symbiosis.clientId
      }
    ]);
    return [synth.address, calldata];
  }
  async getFee() {
    const { type, chainIdTo, chainIdFrom, internalId, revertableAddress } = this.request;
    const externalId = this.getExternalId();
    let receiveSide;
    let calldata;
    let advisorChainIdFrom = chainIdTo;
    let advisorChainIdTo = chainIdFrom;
    const feeToken = this.request.originalFromTokenAmount.token;
    if (type === "synthesize") {
      const portal = this.symbiosis.portal(chainIdFrom);
      calldata = portal.interface.encodeFunctionData("revertSynthesize", ["0", externalId]);
      receiveSide = portal.address;
    } else if (type === "burn") {
      const synthesis = this.symbiosis.synthesis(chainIdFrom);
      calldata = synthesis.interface.encodeFunctionData("revertBurn", ["0", externalId]);
      receiveSide = synthesis.address;
    } else if (type === "synthesize-v2") {
      advisorChainIdFrom = chainIdFrom;
      advisorChainIdTo = chainIdTo;
      const synthesis = this.symbiosis.synthesis(chainIdTo);
      calldata = synthesis.interface.encodeFunctionData("revertSynthesizeRequestByBridge", [
        "0",
        internalId,
        this.symbiosis.portal(chainIdFrom).address,
        // _receiveSide
        this.symbiosis.bridge(chainIdFrom).address,
        // _oppositeBridge
        chainIdFrom,
        // _chainId
        revertableAddress,
        // _sender
        this.symbiosis.clientId
        // _clientId
      ]);
      receiveSide = synthesis.address;
    } else if (type === "burn-v2") {
      advisorChainIdTo = this.omniPoolConfig.chainId;
      const synthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
      const [router, swapCalldata] = await this.buildSwapCalldata();
      const [burnToken, burnCalldata] = this.buildMetaBurnCalldata();
      calldata = synthesis.interface.encodeFunctionData("revertMetaBurn", [
        "0",
        // stableBridgingFee
        externalId,
        router,
        swapCalldata,
        synthesis.address,
        burnToken,
        burnCalldata
      ]);
      receiveSide = synthesis.address;
    } else {
      const synthesis = this.symbiosis.synthesis(chainIdFrom);
      calldata = synthesis.interface.encodeFunctionData("revertBurnAndBurn", [
        "0",
        // stableBridgingFee
        externalId,
        this.symbiosis.portal(chainIdTo).address,
        // _receiveSide
        this.symbiosis.bridge(chainIdTo).address,
        // _oppositeBridge
        chainIdTo,
        // _chainId
        revertableAddress
        // _revertableAddress
      ]);
      receiveSide = synthesis.address;
    }
    const fee = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom: advisorChainIdFrom,
      chainIdTo: advisorChainIdTo
    });
    const feeTokenAmount = new TokenAmount(feeToken, fee);
    if (this.request.originalFromTokenAmount.lessThan(feeTokenAmount)) {
      throw new Error2(
        `Amount ${this.request.fromTokenAmount.toSignificant()} ${this.request.fromTokenAmount.token.symbol} less than fee ${feeTokenAmount.toSignificant()} ${feeTokenAmount.token.symbol}`,
        4 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    return feeTokenAmount;
  }
  async getTransactionRequest(fee, feeV2) {
    if (this.request.type === "synthesize") {
      return this.getRevertSynthesizeTransactionRequest(fee);
    }
    if (this.request.type === "synthesize-v2") {
      return this.getRevertSynthesizeTransactionRequestV2(fee);
    }
    if (this.request.type === "burn") {
      return this.getRevertBurnTransactionRequest(fee);
    }
    if (this.request.type === "burn-v2") {
      return await this.getRevertBurnTransactionRequestV2(fee, feeV2);
    }
    return await this.getRevertBurnTransactionRequestV2Revert(fee);
  }
  getRevertSynthesizeTransactionRequestV2(fee) {
    const { internalId, chainIdFrom, revertableAddress } = this.request;
    const portal = this.symbiosis.portal(chainIdFrom);
    const params = {
      stableBridgingFee: fee.raw.toString(),
      internalID: internalId,
      receiveSide: portal.address,
      managerChainBridge: this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
      sourceChainBridge: this.symbiosis.bridge(chainIdFrom).address,
      managerChainId: this.omniPoolConfig.chainId,
      sourceChainId: chainIdFrom,
      router: AddressZero2,
      // multicall router
      swapCalldata: [],
      // swapCalldata,
      sourceChainSynthesis: this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
      burnToken: AddressZero2,
      //burnToken,
      burnCalldata: [],
      // burnCalldata,
      clientID: this.symbiosis.clientId
    };
    if (isTronChainId(chainIdFrom)) {
      return prepareTronTransaction({
        chainId: chainIdFrom,
        tronWeb: this.symbiosis.tronWeb(chainIdFrom),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "metaRevertRequest",
        params: [
          [
            fee.raw.toString(),
            internalId,
            portal.address,
            this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
            this.symbiosis.bridge(chainIdFrom).address,
            this.omniPoolConfig.chainId,
            chainIdFrom,
            AddressZero2,
            // multicall router
            [],
            // swapCalldata,
            this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
            AddressZero2,
            //burnToken,
            [],
            // burnCalldata,
            this.symbiosis.clientId
          ]
        ],
        ownerAddress: revertableAddress,
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("metaRevertRequest", [params]),
      chainId: chainIdFrom
    };
  }
  getRevertSynthesizeTransactionRequest(fee) {
    const { internalId, chainIdTo, chainIdFrom } = this.request;
    const synthesis = this.symbiosis.synthesis(chainIdTo);
    const otherPortal = this.symbiosis.portal(chainIdFrom);
    const otherBridge = this.symbiosis.bridge(chainIdFrom);
    return {
      to: synthesis.address,
      data: synthesis.interface.encodeFunctionData("revertSynthesizeRequest", [
        fee.raw.toString(),
        internalId,
        otherPortal.address,
        otherBridge.address,
        chainIdFrom,
        this.symbiosis.clientId
      ]),
      chainId: chainIdTo
    };
  }
  getRevertBurnTransactionRequest(fee) {
    const { internalId, chainIdTo, chainIdFrom } = this.request;
    const otherBridge = this.symbiosis.bridge(chainIdFrom);
    const portal = this.symbiosis.portal(chainIdTo);
    const otherSynthesis = this.symbiosis.synthesis(chainIdFrom);
    const params = [
      fee.raw.toString(),
      internalId,
      otherSynthesis.address,
      otherBridge.address,
      chainIdFrom,
      this.symbiosis.clientId
    ];
    if (isTronChainId(chainIdTo)) {
      return prepareTronTransaction({
        chainId: chainIdTo,
        tronWeb: this.symbiosis.tronWeb(chainIdTo),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "revertBurnRequest",
        params,
        ownerAddress: this.request.revertableAddress,
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("revertBurnRequest", params),
      chainId: chainIdTo
    };
  }
  getSyntheticToken(realToken) {
    return this.symbiosis.getRepresentation(realToken, this.omniPoolConfig.chainId);
  }
  async buildSwapCalldata(fee) {
    const { originalFromTokenAmount, chainIdFrom, chainIdTo } = this.request;
    const tokenIn = this.getSyntheticToken(this.transitTokenTo);
    if (!tokenIn) {
      throw new Error2(`Cannot find synthetic token between mChain and ${chainIdTo}`);
    }
    const tokenAmountIn = new TokenAmount(tokenIn, originalFromTokenAmount.raw);
    const amount = fee ? new TokenAmount(tokenIn, JSBI12.subtract(tokenAmountIn.raw, fee.raw)) : tokenAmountIn;
    const tokenOut = this.getSyntheticToken(this.transitTokenFrom);
    if (!tokenOut) {
      throw new Error2(`Cannot find synthetic token between mChain and ${chainIdFrom}`);
    }
    const to = this.symbiosis.metaRouter(this.omniPoolConfig.chainId).address;
    const omniTrade = new OmniTrade(
      amount,
      amount,
      // amountInMin
      tokenOut,
      this.slippage,
      this.deadline,
      this.symbiosis,
      to,
      this.omniPoolConfig
    );
    await omniTrade.init();
    return [
      this.multicallRouter.address,
      this.multicallRouter.interface.encodeFunctionData("multicall", [
        amount.raw.toString(),
        [omniTrade.callData],
        // calldata
        [omniTrade.pool.address],
        // receiveSides
        [tokenIn.address, tokenOut.address],
        // path
        [100],
        // offset
        to
      ])
    ];
  }
  async getRevertBurnTransactionRequestV2(fee, feeV2) {
    const { internalId, chainIdTo } = this.request;
    const mChainBridge = this.symbiosis.bridge(this.omniPoolConfig.chainId);
    const portal = this.symbiosis.portal(chainIdTo);
    const mChainSynthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    const [router, swapCalldata] = await this.buildSwapCalldata(fee);
    const [burnToken, burnCalldata] = this.buildMetaBurnCalldata(feeV2);
    const params = {
      stableBridgingFee: fee.raw.toString(),
      internalID: internalId,
      receiveSide: mChainSynthesis.address,
      managerChainBridge: mChainBridge.address,
      managerChainId: this.omniPoolConfig.chainId,
      sourceChainBridge: AddressZero2,
      sourceChainId: this.request.chainIdFrom,
      sourceChainSynthesis: mChainSynthesis.address,
      router,
      // multicall router
      swapCalldata,
      burnToken,
      burnCalldata,
      clientID: this.symbiosis.clientId
    };
    if (isTronChainId(chainIdTo)) {
      return prepareTronTransaction({
        chainId: chainIdTo,
        tronWeb: this.symbiosis.tronWeb(chainIdTo),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "metaRevertRequest",
        params: [
          [
            fee.raw.toString(),
            internalId,
            mChainSynthesis.address,
            mChainBridge.address,
            this.omniPoolConfig.chainId,
            AddressZero2,
            this.request.chainIdFrom,
            mChainSynthesis.address,
            router,
            // multicall router
            swapCalldata,
            burnToken,
            burnCalldata,
            this.symbiosis.clientId
          ]
        ],
        ownerAddress: this.request.revertableAddress,
        // correct??
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("metaRevertRequest", [params]),
      chainId: chainIdTo
    };
  }
  async getRevertBurnTransactionRequestV2Revert(fee) {
    const { internalId, chainIdTo } = this.request;
    const portal = this.symbiosis.portal(chainIdTo);
    const params = {
      stableBridgingFee: fee.raw.toString(),
      internalID: internalId,
      receiveSide: portal.address,
      managerChainBridge: this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
      sourceChainBridge: AddressZero2,
      managerChainId: this.omniPoolConfig.chainId,
      sourceChainId: chainIdTo,
      router: AddressZero2,
      // multicall router
      swapCalldata: [],
      sourceChainSynthesis: this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
      burnToken: AddressZero2,
      burnCalldata: "0x00",
      // any not empty calldata
      clientID: this.symbiosis.clientId
    };
    if (isTronChainId(chainIdTo)) {
      return prepareTronTransaction({
        chainId: chainIdTo,
        tronWeb: this.symbiosis.tronWeb(chainIdTo),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "metaRevertRequest",
        params: [
          [
            fee.raw.toString(),
            internalId,
            portal.address,
            this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
            AddressZero2,
            this.omniPoolConfig.chainId,
            chainIdTo,
            AddressZero2,
            // multicall router
            [],
            this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
            AddressZero2,
            "0x00",
            // any not empty calldata
            this.symbiosis.clientId
          ]
        ],
        ownerAddress: this.request.revertableAddress,
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("metaRevertRequest", [params]),
      chainId: chainIdTo
    };
  }
  async execute(transactionRequest, signer) {
    const preparedTransactionRequest = await prepareTransactionRequest(transactionRequest, signer);
    const transaction = await signer.sendTransaction(preparedTransactionRequest);
    return {
      waitForMined: (confirmations = 1) => this.waitForMined(confirmations, transaction),
      transaction
    };
  }
  async waitForMined(confirmations, response) {
    const receipt = await response.wait(confirmations);
    return {
      receipt,
      waitForComplete: () => this.waitForComplete()
    };
  }
  getExternalId() {
    const { type, internalId, chainIdTo, revertableAddress } = this.request;
    let contractAddress;
    if (type === "synthesize" || type === "synthesize-v2") {
      contractAddress = this.symbiosis.synthesis(chainIdTo).address;
    } else {
      contractAddress = this.symbiosis.portal(chainIdTo).address;
    }
    return getExternalId({ internalId, chainId: chainIdTo, revertableAddress, contractAddress });
  }
};

// src/crosschain/statelessWaitForComplete.ts
var TxNotFound = class extends Error {
  constructor(txId) {
    super(`Transaction ${txId} not found`);
  }
};
async function getTxBridgeInfo(symbiosis, chainId, txId) {
  const provider = symbiosis.getProvider(chainId);
  const receipt = await provider.getTransactionReceipt(txId);
  if (!receipt) {
    throw new TxNotFound(txId);
  }
  const portal = symbiosis.portal(chainId);
  const synthesis = symbiosis.synthesis(chainId);
  const revertBurnRequestTopic = portal.interface.getEventTopic("RevertBurnRequest");
  const revertSynthesizeRequestTopic = synthesis.interface.getEventTopic("RevertSynthesizeRequest");
  const revertLog = receipt.logs.find((log2) => {
    return !!log2.topics.find((topic) => topic === revertBurnRequestTopic || topic === revertSynthesizeRequestTopic);
  });
  if (revertLog) {
    const address = revertLog.address.toLowerCase();
    if (address !== portal.address.toLowerCase() && address !== synthesis.address.toLowerCase()) {
      throw new Error(`Transaction ${txId} is not a from synthesis or portal contract`);
    }
    const bridge = symbiosis.bridge(chainId);
    const oracleRequestTopic = bridge.interface.getEventTopic("OracleRequest");
    const oracleRequestLog = receipt.logs.find((log2) => log2.topics.includes(oracleRequestTopic));
    if (!oracleRequestLog) {
      throw new Error(`Transaction ${txId} have a OracleRequest call not from bridge contract`);
    }
    const { chainId: oracleRequestChainId } = bridge.interface.parseLog(oracleRequestLog).args;
    let contract2;
    let requestType2;
    if (revertLog.address.toLowerCase() === portal.address.toLowerCase()) {
      contract2 = portal;
      requestType2 = "RevertBurnCompleted";
    } else {
      contract2 = synthesis;
      requestType2 = "RevertSynthesizeCompleted";
    }
    const { id: internalId2, to: revertableAddress2 } = contract2.interface.parseLog(revertLog).args;
    const externalChainId2 = oracleRequestChainId.toNumber();
    const externalId2 = getExternalId({
      internalId: internalId2,
      contractAddress: contract2.address,
      revertableAddress: tronAddressToEvm(revertableAddress2),
      chainId
    });
    return { internalId: internalId2, externalId: externalId2, externalChainId: externalChainId2, requestType: requestType2 };
  }
  const synthesizeRequestTopic = portal.interface.getEventTopic("SynthesizeRequest");
  const burnRequestTopic = synthesis.interface.getEventTopic("BurnRequest");
  const log = receipt.logs.find((log2) => {
    return !!log2.topics.find((topic) => topic === synthesizeRequestTopic || topic === burnRequestTopic);
  });
  if (!log) {
    return null;
  }
  if (log.address.toLowerCase() !== portal.address.toLowerCase() && log.address.toLowerCase() !== synthesis.address.toLowerCase()) {
    throw new Error(`Transaction ${txId} is not a from synthesis or portal contract`);
  }
  let contract;
  let requestType;
  if (log.address.toLowerCase() === portal.address.toLowerCase()) {
    contract = portal;
    requestType = "SynthesizeRequest";
  } else {
    contract = synthesis;
    requestType = "BurnRequest";
  }
  const { id: internalId, chainID, revertableAddress } = contract.interface.parseLog(log).args;
  const externalChainId = chainID.toNumber();
  const contractAddress = requestType === "SynthesizeRequest" ? symbiosis.chainConfig(externalChainId).synthesis : symbiosis.chainConfig(externalChainId).portal;
  const externalId = getExternalId({
    internalId,
    contractAddress: tronAddressToEvm(contractAddress),
    revertableAddress: tronAddressToEvm(revertableAddress),
    chainId: externalChainId
  });
  return { internalId, externalId, externalChainId, requestType };
}
async function waitOversideTx(symbiosis, bridgeInfo) {
  const { requestType, externalChainId, externalId, internalId } = bridgeInfo;
  let filter;
  switch (requestType) {
    case "SynthesizeRequest": {
      const synthesis = symbiosis.synthesis(externalChainId);
      filter = synthesis.filters.SynthesizeCompleted(externalId);
      break;
    }
    case "BurnRequest": {
      const portal = symbiosis.portal(externalChainId);
      filter = portal.filters.BurnCompleted(externalId);
      break;
    }
    case "RevertSynthesizeRequest": {
      const synthesis = symbiosis.synthesis(externalChainId);
      filter = synthesis.filters.RevertSynthesizeRequest(internalId);
      break;
    }
    case "RevertSynthesizeCompleted": {
      const portal = symbiosis.portal(externalChainId);
      filter = portal.filters.RevertSynthesizeCompleted(externalId);
      break;
    }
    case "RevertBurnCompleted": {
      const synthesis = symbiosis.synthesis(externalChainId);
      filter = synthesis.filters.RevertBurnCompleted(externalId);
      break;
    }
  }
  const log = await getLogWithTimeout({ symbiosis, chainId: externalChainId, filter });
  return log.transactionHash;
}
async function statelessWaitForComplete(symbiosis, chainId, txId) {
  const txIdWithPrefix = isTronChainId(chainId) ? `0x${txId}` : txId;
  console.log("tx", txIdWithPrefix);
  const aBridgeInfo = await getTxBridgeInfo(symbiosis, chainId, txIdWithPrefix);
  if (!aBridgeInfo) {
    throw new Error(`Transaction ${txId} is not a bridge request`);
  }
  console.log("aBridgeInfo", aBridgeInfo);
  const bTxId = await waitOversideTx(symbiosis, aBridgeInfo);
  console.log("bTxId", bTxId);
  const bBridgeInfo = await getTxBridgeInfo(symbiosis, aBridgeInfo.externalChainId, bTxId);
  console.log("bBridgeInfo", bBridgeInfo);
  if (!bBridgeInfo) {
    return bTxId;
  }
  return waitOversideTx(symbiosis, bBridgeInfo);
}

// src/crosschain/baseSwapping.ts
import { AddressZero as AddressZero4, MaxUint256 as MaxUint2563 } from "@ethersproject/constants";
import { BigNumber as BigNumber6, utils as utils32 } from "ethers";
import JSBI13 from "jsbi";

// src/crosschain/dataProvider.ts
var DataProvider = class {
  constructor(symbiosis) {
    this.symbiosis = symbiosis;
    this.cache = /* @__PURE__ */ new Map();
  }
  async getPairs(tokenIn, tokenOut) {
    return this.fromCache(["getPairs", tokenIn.address, tokenIn.address], () => {
      const provider = this.symbiosis.getProvider(tokenIn.chainId);
      return UniLikeTrade.getPairs(provider, tokenIn, tokenOut);
    });
  }
  async getOneInchProtocols(chainId) {
    return this.fromCache(["getOneInchProtocols", chainId], () => {
      return OneInchTrade.getProtocols(chainId);
    });
  }
  async getOneInchRateToEth(tokens, oracle) {
    return this.fromCache(["getOneInchRateToEth", ...tokens.map((i) => i.address)], () => {
      return getRateToEth(tokens, oracle);
    });
  }
  async fromCache(key, func) {
    const stringKey = key.join("-");
    let value = this.cache.get(stringKey);
    if (value) {
      return value;
    }
    value = await func();
    this.cache.set(stringKey, value);
    return value;
  }
};

// src/crosschain/transit.ts
import { AddressZero as AddressZero3 } from "@ethersproject/constants/lib/addresses";
var Transit = class _Transit {
  constructor(symbiosis, amountIn, amountInMin, tokenOut, transitTokenIn, transitTokenOut, slippage, deadline, omniPoolConfig, fee) {
    this.symbiosis = symbiosis;
    this.amountIn = amountIn;
    this.amountInMin = amountInMin;
    this.tokenOut = tokenOut;
    this.transitTokenIn = transitTokenIn;
    this.transitTokenOut = transitTokenOut;
    this.slippage = slippage;
    this.deadline = deadline;
    this.omniPoolConfig = omniPoolConfig;
    this.fee = fee;
    this.direction = _Transit.getDirection(amountIn.token.chainId, tokenOut.chainId, omniPoolConfig.chainId);
    this.multicallRouter = this.symbiosis.multicallRouter(omniPoolConfig.chainId);
    this.route = [];
    this.receiveSide = AddressZero3;
    this.callData = [];
    this.priceImpact = new Percent("0");
  }
  async init() {
    this.feeToken = this.getFeeToken();
    this.trade = await this.buildTrade();
    this.receiveSide = this.multicallRouter.address;
    this.callData = this.buildCalldata();
    this.amountOut = this.getTradeAmountOut(this.trade.amountOut);
    this.amountOutMin = this.getTradeAmountOut(this.trade.amountOutMin);
    this.route = this.trade.route;
    this.priceImpact = this.trade.priceImpact;
    this.symbiosis.validateSwapAmounts(this.getBridgeAmountIn());
    return this;
  }
  isV2() {
    return this.direction === "v2";
  }
  /**
   * Amount in stables entering the bridge
   */
  getBridgeAmountIn() {
    if (this.direction === "mint" || this.isV2()) {
      return this.amountIn;
    }
    return this.trade ? this.trade.amountOut : this.amountIn;
  }
  /**
   * Amount in stables coming out of the bridge
   */
  getBridgeAmountOut(amount) {
    const amountOut = new TokenAmount(this.feeToken, amount.raw);
    if (!this.fee) {
      return amountOut;
    }
    if (amountOut.lessThan(this.fee)) {
      throw new Error2(
        `Amount ${amountOut.toSignificant()} ${amountOut.token.symbol} less than fee ${this.fee.toSignificant()} ${this.fee.token.symbol}`,
        4 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    return amountOut.subtract(this.fee);
  }
  // PROTECTED
  static getDirection(chainIdIn, chainIdOut, omniPoolChainId) {
    const withManagerChain = chainIdIn === omniPoolChainId || chainIdOut === omniPoolChainId;
    if (!withManagerChain) {
      return "v2";
    }
    const chainsPriorityWithMChain = [...CHAINS_PRIORITY, omniPoolChainId];
    const indexIn = chainsPriorityWithMChain.indexOf(chainIdIn);
    const indexOut = chainsPriorityWithMChain.indexOf(chainIdOut);
    if (indexIn === -1) {
      throw new Error2(`Chain ${chainIdIn} not found in chains priority`);
    }
    if (indexOut === -1) {
      throw new Error2(`Chain ${chainIdOut} not found in chains priority`);
    }
    return indexIn > indexOut ? "burn" : "mint";
  }
  buildCalldata() {
    if (!this.trade) {
      throw new Error2("buildCalldata: trade is undefined");
    }
    return this.multicallRouter.interface.encodeFunctionData("multicall", [
      this.amountIn.raw.toString(),
      [this.trade.callData],
      // calldata
      [this.trade.pool.address],
      // receiveSides
      [this.trade.tokenAmountIn.token.address, this.trade.amountOut.token.address],
      // path
      [100],
      // offset
      this.symbiosis.metaRouter(this.omniPoolConfig.chainId).address
    ]);
  }
  getTradeAmountIn(amount) {
    if (this.direction === "burn") {
      return amount;
    }
    return this.getBridgeAmountOut(amount);
  }
  getTradeAmountOut(tradeAmountOut) {
    if (!tradeAmountOut) {
      throw new Error2("There is no trade");
    }
    if (this.direction === "mint" || this.isV2()) {
      return tradeAmountOut;
    }
    const amountOut = new TokenAmount(this.transitTokenOut, tradeAmountOut.raw);
    if (!this.fee) {
      return amountOut;
    }
    if (amountOut.lessThan(this.fee)) {
      throw new Error2(
        `Amount ${amountOut.toSignificant()} ${amountOut.token.symbol} less than fee ${this.fee.toSignificant()} ${this.fee.token.symbol}`,
        4 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    return amountOut.subtract(this.fee);
  }
  getFeeToken() {
    const transitTokenOutChainId = this.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    if (this.direction === "burn") {
      return this.transitTokenOut;
    }
    const rep = this.symbiosis.getRepresentation(this.transitTokenIn, transitTokenOutChainId);
    if (!rep) {
      throw new Error2(
        `Representation of ${this.transitTokenIn.chainId}:${this.transitTokenIn.symbol} in chain ${transitTokenOutChainId} not found`,
        1 /* NO_ROUTE */
      );
    }
    return rep;
  }
  getTradeTokenOut() {
    if (this.direction === "mint") {
      return this.transitTokenOut;
    }
    const transitTokenInChainId = this.isV2() ? this.omniPoolConfig.chainId : this.amountIn.token.chainId;
    const rep = this.symbiosis.getRepresentation(this.transitTokenOut, transitTokenInChainId);
    if (!rep) {
      throw new Error2(
        `Representation of ${this.transitTokenOut.symbol} in chain ${transitTokenInChainId} not found`,
        1 /* NO_ROUTE */
      );
    }
    return rep;
  }
  async buildTrade() {
    const tokenAmountIn = this.getTradeAmountIn(this.amountIn);
    const tokenAmountInMin = this.getTradeAmountIn(this.amountInMin);
    const tokenOut = this.getTradeTokenOut();
    const to = this.symbiosis.metaRouter(this.omniPoolConfig.chainId).address;
    const trade = new OmniTrade(
      tokenAmountIn,
      tokenAmountInMin,
      tokenOut,
      this.slippage,
      this.deadline,
      this.symbiosis,
      to,
      this.omniPoolConfig
    );
    await trade.init();
    return trade;
  }
};

// src/crosschain/baseSwapping.ts
var BaseSwapping = class {
  constructor(symbiosis, omniPoolConfig) {
    this.omniPoolConfig = omniPoolConfig;
    this.symbiosis = symbiosis;
    this.dataProvider = new DataProvider(symbiosis);
  }
  async doExactIn({
    tokenAmountIn,
    tokenOut,
    from,
    to,
    slippage,
    deadline,
    oneInchProtocols
  }) {
    this.oneInchProtocols = oneInchProtocols;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.transitTokenIn = this.symbiosis.transitToken(this.tokenAmountIn.token.chainId, this.omniPoolConfig);
    this.transitTokenOut = this.symbiosis.transitToken(this.tokenOut.chainId, this.omniPoolConfig);
    this.from = tronAddressToEvm(from);
    this.to = tronAddressToEvm(to);
    this.slippage = this.buildDetailedSlippage(slippage);
    this.deadline = deadline;
    this.ttl = deadline - Math.floor(Date.now() / 1e3);
    this.synthesisV2 = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    if (isTronToken(this.tokenAmountIn.token) || isTronToken(this.tokenOut)) {
      this.revertableAddresses = {
        AB: this.symbiosis.getRevertableAddress(this.tokenAmountIn.token.chainId),
        BC: this.symbiosis.getRevertableAddress(this.tokenOut.chainId)
      };
    } else {
      this.revertableAddresses = { AB: this.from, BC: this.from };
    }
    if (!this.transitTokenIn.equals(tokenAmountIn.token)) {
      this.tradeA = this.buildTradeA();
      await this.tradeA.init();
    }
    this.transit = this.buildTransit();
    await this.transit.init();
    this.amountInUsd = this.transit.getBridgeAmountIn();
    if (!this.transitTokenOut.equals(tokenOut)) {
      this.tradeC = this.buildTradeC();
      await this.tradeC.init();
    }
    this.route = this.getRoute();
    const fee = await this.getFee(this.transit.feeToken);
    const feeV2 = this.transit.isV2() ? await this.getFeeV2() : void 0;
    this.feeV2 = feeV2;
    this.transit = this.buildTransit(fee);
    await this.transit.init();
    if (!this.transitTokenOut.equals(tokenOut)) {
      this.tradeC = this.buildTradeC(feeV2);
      await this.tradeC.init();
    }
    let crossChainFee = fee;
    if (feeV2) {
      const pow = BigNumber6.from(10).pow(fee.token.decimals);
      const powV2 = BigNumber6.from(10).pow(feeV2.token.decimals);
      const feeBase = BigNumber6.from(fee.raw.toString()).mul(powV2);
      const feeV2Base = BigNumber6.from(feeV2.raw.toString()).mul(pow);
      crossChainFee = new TokenAmount(feeV2.token, feeBase.add(feeV2Base).div(pow).toString());
    }
    const tokenAmountOut = this.tokenAmountOut(feeV2);
    const tokenAmountOutMin = new TokenAmount(
      tokenAmountOut.token,
      JSBI13.divide(JSBI13.multiply(this.transit.amountOutMin.raw, tokenAmountOut.raw), this.transit.amountOut.raw)
    );
    const swapInfo = {
      fee: crossChainFee,
      tokenAmountOut,
      tokenAmountOutMin,
      route: this.route,
      priceImpact: this.calculatePriceImpact(),
      amountInUsd: this.amountInUsd,
      approveTo: this.approveTo(),
      inTradeType: this.tradeA?.tradeType,
      outTradeType: this.tradeC?.tradeType
    };
    if (isTronToken(this.tokenAmountIn.token)) {
      const transactionRequest2 = this.getTronTransactionRequest(fee, feeV2);
      return {
        ...swapInfo,
        type: "tron",
        transactionRequest: transactionRequest2
      };
    }
    const transactionRequest = this.getEvmTransactionRequest(fee, feeV2);
    return {
      ...swapInfo,
      type: "evm",
      transactionRequest
    };
  }
  getRevertableAddress(side) {
    return this.revertableAddresses[side];
  }
  buildDetailedSlippage(totalSlippage) {
    const hasTradeA = !this.transitTokenIn.equals(this.tokenAmountIn.token);
    const hasTradeC = !this.transitTokenOut.equals(this.tokenOut);
    return splitSlippage(totalSlippage, hasTradeA, hasTradeC);
  }
  approveTo() {
    return this.symbiosis.chainConfig(this.tokenAmountIn.token.chainId).metaRouterGateway;
  }
  async waitForComplete(receipt) {
    if (!this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    if (this.transit.isV2()) {
      const wfc1 = new WaitForComplete({
        direction: "mint",
        symbiosis: this.symbiosis,
        revertableAddress: this.getRevertableAddress("AB"),
        chainIdIn: this.tokenAmountIn.token.chainId,
        chainIdOut: this.omniPoolConfig.chainId
      });
      const log = await wfc1.waitForComplete(receipt);
      const provider = this.symbiosis.getProvider(this.omniPoolConfig.chainId);
      const receipt2 = await provider.getTransactionReceipt(log.transactionHash);
      const wfc2 = new WaitForComplete({
        direction: "burn",
        symbiosis: this.symbiosis,
        revertableAddress: this.getRevertableAddress("BC"),
        chainIdIn: this.omniPoolConfig.chainId,
        chainIdOut: this.tokenOut.chainId
      });
      return wfc2.waitForComplete(receipt2);
    }
    return new WaitForComplete({
      direction: this.transit.direction,
      chainIdOut: this.tokenOut.chainId,
      symbiosis: this.symbiosis,
      revertableAddress: this.getRevertableAddress("AB"),
      chainIdIn: this.tokenAmountIn.token.chainId
    }).waitForComplete(receipt);
  }
  async findTransitTokenSent(transactionHash) {
    const chainId = this.tokenOut.chainId;
    const metarouter = this.symbiosis.metaRouter(chainId);
    const providerTo = this.symbiosis.getProvider(chainId);
    const receipt = await providerTo.getTransactionReceipt(transactionHash);
    if (!receipt) {
      return void 0;
    }
    const eventId = utils32.id("TransitTokenSent(address,uint256,address)");
    const log = receipt.logs.find((i) => {
      return i.topics[0] === eventId;
    });
    if (!log) {
      return void 0;
    }
    const parsedLog = metarouter.interface.parseLog(log);
    const token = this.symbiosis.tokens().find((i) => {
      return i.chainId === chainId && i.address.toLowerCase() === parsedLog.args.token.toLowerCase();
    });
    if (!token) {
      return void 0;
    }
    return new TokenAmount(token, parsedLog.args.amount.toString());
  }
  getEvmTransactionRequest(fee, feeV2) {
    const chainId = this.tokenAmountIn.token.chainId;
    const metaRouter = this.symbiosis.metaRouter(chainId);
    const [relayRecipient, otherSideCalldata] = this.otherSideData(fee, feeV2);
    const amount = this.tradeA ? this.tradeA.tokenAmountIn : this.tokenAmountIn;
    const value = this.tradeA && this.tokenAmountIn.token.isNative ? BigNumber6.from(this.tradeA.tokenAmountIn.raw.toString()) : void 0;
    const data = metaRouter.interface.encodeFunctionData("metaRoute", [
      {
        amount: amount.raw.toString(),
        nativeIn: amount.token.isNative,
        approvedTokens: this.approvedTokens().map(tronAddressToEvm),
        firstDexRouter: tronAddressToEvm(this.firstDexRouter()),
        firstSwapCalldata: this.firstSwapCalldata(),
        secondDexRouter: tronAddressToEvm(this.secondDexRouter()),
        secondSwapCalldata: this.transit.direction === "burn" ? this.secondSwapCalldata() : [],
        relayRecipient,
        otherSideCalldata
      }
    ]);
    return {
      chainId,
      to: metaRouter.address,
      data,
      value
    };
  }
  getTronTransactionRequest(fee, feeV2) {
    const { chainId } = this.tokenAmountIn.token;
    const { metaRouter } = this.symbiosis.chainConfig(chainId);
    const [relayRecipient, otherSideCalldata] = this.otherSideData(fee, feeV2);
    const amount = this.tradeA ? this.tradeA.tokenAmountIn : this.tokenAmountIn;
    const value = this.tradeA && this.tokenAmountIn.token.isNative ? BigNumber6.from(this.tradeA.tokenAmountIn.raw.toString()) : void 0;
    const tronWeb = this.symbiosis.tronWeb(chainId);
    return prepareTronTransaction({
      chainId,
      tronWeb,
      abi: TRON_METAROUTER_ABI,
      contractAddress: metaRouter,
      functionName: "metaRoute",
      params: [
        [
          this.firstSwapCalldata(),
          this.transit.direction === "burn" ? this.secondSwapCalldata() : [],
          this.approvedTokens().map(tronAddressToEvm),
          tronAddressToEvm(this.firstDexRouter()),
          this.secondDexRouter(),
          amount.raw.toString(),
          amount.token.isNative,
          tronAddressToEvm(relayRecipient),
          otherSideCalldata
        ]
      ],
      ownerAddress: this.from,
      value: value?.toString() ?? 0
    });
  }
  calculatePriceImpact() {
    const zero = new Percent(JSBI13.BigInt(0), BIPS_BASE);
    const pia = this.tradeA?.priceImpact || zero;
    const pib = this.transit.priceImpact || zero;
    const pic = this.tradeC?.priceImpact || zero;
    let pi = pia.add(pib).add(pic);
    const max = new Percent(JSBI13.BigInt(1e4), BIPS_BASE);
    if (pi.greaterThan(max))
      pi = max;
    return new Percent(pi.numerator, pi.denominator);
  }
  tokenAmountOut(feeV2) {
    if (this.tradeC) {
      return this.tradeC.amountOut;
    }
    if (this.transit.isV2()) {
      let amount = this.transit.amountOut.raw;
      if (feeV2) {
        if (JSBI13.lessThan(amount, feeV2.raw)) {
          throw new Error2(
            `Amount ${this.transit.amountOut.toSignificant()} ${feeV2.token.symbol} less than fee ${feeV2.toSignificant()} ${feeV2.token.symbol}`,
            4 /* AMOUNT_LESS_THAN_FEE */
          );
        }
        amount = JSBI13.subtract(amount, feeV2.raw);
      }
      return new TokenAmount(this.tokenOut, amount);
    }
    return this.transit.amountOut;
  }
  buildTradeA() {
    const tokenOut = this.transitTokenIn;
    if (WrapTrade.isSupported(this.tokenAmountIn, tokenOut)) {
      return new WrapTrade(this.tokenAmountIn, tokenOut, this.to);
    }
    const chainId = this.tokenAmountIn.token.chainId;
    const from = this.symbiosis.metaRouter(chainId).address;
    const to = from;
    if (AggregatorTrade.isAvailable(chainId)) {
      return new AggregatorTrade({
        tokenAmountIn: this.tokenAmountIn,
        tokenOut,
        from,
        to,
        slippage: this.slippage["A"],
        symbiosis: this.symbiosis,
        dataProvider: this.dataProvider,
        clientId: this.symbiosis.clientId,
        oneInchProtocols: this.oneInchProtocols
      });
    }
    if (IzumiTrade.isSupported(chainId)) {
      return new IzumiTrade({
        symbiosis: this.symbiosis,
        tokenAmountIn: this.tokenAmountIn,
        tokenOut,
        slippage: this.slippage["A"],
        ttl: this.ttl,
        to
      });
    }
    let routerA = this.symbiosis.uniLikeRouter(chainId);
    if (chainId === 43114 /* AVAX_MAINNET */) {
      routerA = this.symbiosis.avaxRouter(chainId);
    }
    if ([200101 /* MILKOMEDA_DEVNET */, 2001 /* MILKOMEDA_MAINNET */].includes(chainId)) {
      routerA = this.symbiosis.adaRouter(chainId);
    }
    if ([2222 /* KAVA_MAINNET */].includes(chainId)) {
      routerA = this.symbiosis.kavaRouter(chainId);
    }
    const dexFee = this.symbiosis.dexFee(chainId);
    return new UniLikeTrade(this.tokenAmountIn, tokenOut, to, this.slippage["A"], this.ttl, routerA, dexFee);
  }
  buildTransit(fee) {
    const amountIn = this.tradeA ? this.tradeA.amountOut : this.tokenAmountIn;
    const amountInMin = this.tradeA ? this.tradeA.amountOutMin : amountIn;
    return new Transit(
      this.symbiosis,
      amountIn,
      amountInMin,
      this.tokenOut,
      this.transitTokenIn,
      this.transitTokenOut,
      this.slippage["B"],
      this.deadline,
      this.omniPoolConfig,
      fee
    );
  }
  tradeCTo() {
    return this.to;
  }
  buildTradeC(feeV2) {
    let amountIn = this.transit.amountOut;
    if (this.transit.isV2()) {
      let amountRaw = amountIn.raw;
      if (feeV2) {
        if (amountIn.lessThan(feeV2)) {
          throw new Error2(
            `Amount ${amountIn.toSignificant()} ${amountIn.token.symbol} less than fee ${feeV2.toSignificant()} ${feeV2.token.symbol}`,
            4 /* AMOUNT_LESS_THAN_FEE */
          );
        }
        amountRaw = JSBI13.subtract(amountRaw, feeV2.raw);
      }
      amountIn = new TokenAmount(this.transitTokenOut, amountRaw);
    }
    const chainId = this.tokenOut.chainId;
    const dexFee = this.symbiosis.dexFee(chainId);
    if (WrapTrade.isSupported(amountIn, this.tokenOut)) {
      return new WrapTrade(amountIn, this.tokenOut, this.to);
    }
    if (IzumiTrade.isSupported(chainId)) {
      return new IzumiTrade({
        symbiosis: this.symbiosis,
        tokenAmountIn: amountIn,
        tokenOut: this.tokenOut,
        slippage: this.slippage["C"],
        ttl: this.ttl,
        to: this.to
      });
    }
    if (AggregatorTrade.isAvailable(chainId)) {
      const from = this.symbiosis.metaRouter(chainId).address;
      return new AggregatorTrade({
        tokenAmountIn: amountIn,
        tokenOut: this.tokenOut,
        from,
        to: this.tradeCTo(),
        slippage: this.slippage["C"],
        symbiosis: this.symbiosis,
        dataProvider: this.dataProvider,
        clientId: this.symbiosis.clientId,
        oneInchProtocols: this.oneInchProtocols
      });
    }
    let routerC = this.symbiosis.uniLikeRouter(chainId);
    if (chainId === 43114 /* AVAX_MAINNET */) {
      routerC = this.symbiosis.avaxRouter(chainId);
    }
    if ([200101 /* MILKOMEDA_DEVNET */, 2001 /* MILKOMEDA_MAINNET */].includes(chainId)) {
      routerC = this.symbiosis.adaRouter(chainId);
    }
    if ([2222 /* KAVA_MAINNET */].includes(chainId)) {
      routerC = this.symbiosis.kavaRouter(chainId);
    }
    return new UniLikeTrade(amountIn, this.tokenOut, this.tradeCTo(), this.slippage["C"], this.ttl, routerC, dexFee);
  }
  getRoute() {
    const started = this.tradeA ? [] : [this.tokenAmountIn.token];
    const terminated = this.tradeC ? [] : [this.tokenOut];
    return [
      ...started,
      ...this.tradeA ? this.tradeA.route : [],
      ...this.transit.route,
      ...this.tradeC ? this.tradeC.route : [],
      ...terminated
    ].reduce((acc, token) => {
      const found = acc.find((i) => i.equals(token));
      if (found)
        return acc;
      return [...acc, token];
    }, []);
  }
  metaBurnSyntheticToken(fee) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const synthesis = this.symbiosis.synthesis(this.tokenAmountIn.token.chainId);
    const amount = this.transit.getBridgeAmountIn();
    return [
      synthesis.address,
      synthesis.interface.encodeFunctionData("metaBurnSyntheticToken", [
        {
          stableBridgingFee: fee.raw.toString(),
          amount: amount.raw.toString(),
          syntCaller: tronAddressToEvm(this.from),
          finalReceiveSide: tronAddressToEvm(this.finalReceiveSide()),
          sToken: tronAddressToEvm(amount.token.address),
          finalCallData: this.finalCalldata(),
          finalOffset: this.finalOffset(),
          chain2address: tronAddressToEvm(this.to),
          receiveSide: tronAddressToEvm(this.symbiosis.portal(this.tokenOut.chainId).address),
          oppositeBridge: tronAddressToEvm(this.symbiosis.bridge(this.tokenOut.chainId).address),
          revertableAddress: this.getRevertableAddress("BC"),
          chainID: this.tokenOut.chainId,
          clientID: this.symbiosis.clientId
        }
      ])
    ];
  }
  metaSynthesize(fee, feeV2) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.transit.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    const tokenAmount = this.transit.getBridgeAmountIn();
    const portal = this.symbiosis.portal(chainIdIn);
    return [
      portal.address,
      portal.interface.encodeFunctionData("metaSynthesize", [
        {
          stableBridgingFee: fee.raw.toString(),
          amount: tokenAmount.raw.toString(),
          rtoken: tronAddressToEvm(tokenAmount.token.address),
          chain2address: this.to,
          receiveSide: tronAddressToEvm(this.symbiosis.synthesis(chainIdOut).address),
          oppositeBridge: tronAddressToEvm(this.symbiosis.bridge(chainIdOut).address),
          syntCaller: tronAddressToEvm(this.from),
          chainID: chainIdOut,
          swapTokens: this.swapTokens().map(tronAddressToEvm),
          secondDexRouter: tronAddressToEvm(this.secondDexRouter()),
          secondSwapCalldata: this.secondSwapCalldata(),
          finalReceiveSide: tronAddressToEvm(
            this.transit.isV2() ? this.finalReceiveSideV2() : this.finalReceiveSide()
          ),
          finalCalldata: this.transit.isV2() ? this.finalCalldataV2(feeV2) : this.finalCalldata(),
          finalOffset: this.transit.isV2() ? this.finalOffsetV2() : this.finalOffset(),
          revertableAddress: this.getRevertableAddress("AB"),
          clientID: this.symbiosis.clientId
        }
      ])
    ];
  }
  otherSideData(fee, feeV2) {
    return this.transit.direction === "burn" ? this.metaBurnSyntheticToken(fee) : this.metaSynthesize(fee, feeV2);
  }
  feeMintCallData() {
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.transit.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    const portalAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdIn).portal);
    const synthesisAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdOut).synthesis);
    const internalId = getInternalId({
      contractAddress: portalAddress,
      requestCount: MaxUint2563,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: synthesisAddress,
      revertableAddress: this.getRevertableAddress("AB"),
      chainId: chainIdOut
    });
    const amount = this.transit.getBridgeAmountIn();
    const synthesisInterface = Synthesis__factory.createInterface();
    const callData = synthesisInterface.encodeFunctionData("metaMintSyntheticToken", [
      {
        stableBridgingFee: "0",
        amount: amount.raw.toString(),
        externalID: externalId,
        tokenReal: tronAddressToEvm(amount.token.address),
        chainID: chainIdIn,
        to: tronAddressToEvm(this.to),
        swapTokens: this.swapTokens().map(tronAddressToEvm),
        secondDexRouter: tronAddressToEvm(this.secondDexRouter()),
        secondSwapCalldata: this.secondSwapCalldata(),
        finalReceiveSide: tronAddressToEvm(
          this.transit.isV2() ? this.finalReceiveSideV2() : this.finalReceiveSide()
        ),
        finalCalldata: this.transit.isV2() ? this.finalCalldataV2() : this.finalCalldata(),
        finalOffset: this.transit.isV2() ? this.finalOffsetV2() : this.finalOffset()
      }
    ]);
    return [synthesisAddress, callData];
  }
  feeBurnCallData() {
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.tokenOut.chainId;
    const synthesisAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdIn).synthesis);
    const portalAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdOut).portal);
    const internalId = getInternalId({
      contractAddress: synthesisAddress,
      requestCount: MaxUint2563,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: portalAddress,
      revertableAddress: this.getRevertableAddress("BC"),
      chainId: chainIdOut
    });
    const amount = this.transit.amountOut;
    const portalInterface = Portal__factory.createInterface();
    const calldata = portalInterface.encodeFunctionData("metaUnsynthesize", [
      "0",
      // _stableBridgingFee
      externalId,
      // _externalID,
      tronAddressToEvm(this.to),
      // _to
      amount.raw.toString(),
      // _amount
      tronAddressToEvm(amount.token.address),
      // _rToken
      tronAddressToEvm(this.finalReceiveSide()),
      // _finalReceiveSide
      this.finalCalldata(),
      // _finalCalldata
      this.finalOffset()
      // _finalOffset
    ]);
    return [portalAddress, calldata];
  }
  feeBurnCallDataV2() {
    const chainIdIn = this.omniPoolConfig.chainId;
    const chainIdOut = this.tokenOut.chainId;
    const synthesisAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdIn).synthesis);
    const portalAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdOut).portal);
    const internalId = getInternalId({
      contractAddress: synthesisAddress,
      requestCount: MaxUint2563,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: portalAddress,
      revertableAddress: this.getRevertableAddress("BC"),
      chainId: chainIdOut
    });
    const portalInterface = Portal__factory.createInterface();
    const calldata = portalInterface.encodeFunctionData("metaUnsynthesize", [
      "0",
      // _stableBridgingFee
      externalId,
      // _externalID,
      tronAddressToEvm(this.to),
      // _to
      this.transit.amountOut.raw.toString(),
      // _amount
      tronAddressToEvm(this.transitTokenOut.address),
      // _rToken
      tronAddressToEvm(this.finalReceiveSide()),
      // _finalReceiveSide
      this.finalCalldata(),
      // _finalCalldata
      this.finalOffset()
      // _finalOffset
    ]);
    return [portalAddress, calldata];
  }
  async getFee(feeToken) {
    const chainIdFrom = this.tokenAmountIn.token.chainId;
    const chainIdTo = this.transit.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    const [receiveSide, calldata] = this.transit.direction === "burn" ? this.feeBurnCallData() : this.feeMintCallData();
    const fee = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom,
      chainIdTo
    });
    return new TokenAmount(feeToken, fee.toString());
  }
  async getFeeV2() {
    const feeToken = this.transitTokenOut;
    const [receiveSide, calldata] = this.feeBurnCallDataV2();
    const fee = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom: this.omniPoolConfig.chainId,
      chainIdTo: this.tokenOut.chainId
    });
    return new TokenAmount(feeToken, fee.toString());
  }
  approvedTokens() {
    let firstToken = this.tradeA ? this.tradeA.tokenAmountIn.token.address : this.tokenAmountIn.token.address;
    if (!firstToken) {
      firstToken = AddressZero4;
    }
    let tokens;
    if (this.transit.direction === "burn") {
      tokens = [firstToken, ...this.transit.route.map((i) => i.address)];
    } else {
      tokens = [firstToken, this.tradeA ? this.tradeA.amountOut.token.address : this.tokenAmountIn.token.address];
    }
    return tokens;
  }
  firstDexRouter() {
    return this.tradeA?.routerAddress || AddressZero4;
  }
  firstSwapCalldata() {
    return this.tradeA?.callData || [];
  }
  secondDexRouter() {
    return this.transit.receiveSide;
  }
  secondSwapCalldata() {
    return this.transit.callData;
  }
  finalReceiveSide() {
    return this.tradeC?.routerAddress || AddressZero4;
  }
  finalReceiveSideV2() {
    return this.synthesisV2.address;
  }
  // C
  finalCalldata() {
    return this.tradeC?.callData || [];
  }
  finalCalldataV2(feeV2) {
    return this.synthesisV2.interface.encodeFunctionData("metaBurnSyntheticToken", [
      {
        stableBridgingFee: feeV2 ? feeV2?.raw.toString() : "0",
        // uint256 stableBridgingFee;
        amount: this.transit.amountOut.raw.toString(),
        // uint256 amount;
        syntCaller: tronAddressToEvm(this.symbiosis.metaRouter(this.omniPoolConfig.chainId).address),
        // address syntCaller;
        finalReceiveSide: tronAddressToEvm(this.finalReceiveSide()),
        // address finalReceiveSide;
        sToken: tronAddressToEvm(this.transit.amountOut.token.address),
        // address sToken;
        finalCallData: this.finalCalldata(),
        // bytes finalCallData;
        finalOffset: this.finalOffset(),
        // uint256 finalOffset;
        chain2address: tronAddressToEvm(this.to),
        // address chain2address;
        receiveSide: tronAddressToEvm(this.symbiosis.portal(this.tokenOut.chainId).address),
        oppositeBridge: tronAddressToEvm(this.symbiosis.bridge(this.tokenOut.chainId).address),
        revertableAddress: this.getRevertableAddress("BC"),
        chainID: this.tokenOut.chainId,
        clientID: this.symbiosis.clientId
      }
    ]);
  }
  finalOffset() {
    return this.tradeC?.callDataOffset || 0;
  }
  finalOffsetV2() {
    return 100;
  }
  swapTokens() {
    if (this.transit.route.length === 0) {
      return [];
    }
    const tokens = [this.transit.route[0].address, this.transit.route[this.transit.route.length - 1].address];
    if (this.transit.isV2()) {
      return tokens;
    }
    if (this.tradeC) {
      tokens.push(wrappedToken(this.tradeC.amountOut.token).address);
    } else {
      tokens.push(...this.extraSwapTokens());
    }
    return tokens;
  }
  extraSwapTokens() {
    return [];
  }
};

// src/crosschain/swapping.ts
var Swapping = class extends BaseSwapping {
  async exactIn(params) {
    return this.doExactIn(params);
  }
};

// src/crosschain/zapping.ts
import { AddressZero as AddressZero5 } from "@ethersproject/constants/lib/addresses";
import { MaxUint256 as MaxUint2564 } from "@ethersproject/constants";
import { BigNumber as BigNumber7 } from "ethers";
import JSBI14 from "jsbi";

// src/crosschain/omniLiquidity.ts
var OmniLiquidity = class {
  constructor(tokenAmountIn, to, slippage, deadline, pool, poolOracle) {
    this.tokenAmountIn = tokenAmountIn;
    this.to = to;
    this.slippage = slippage;
    this.deadline = deadline;
    this.pool = pool;
    this.poolOracle = poolOracle;
    this.callDataOffset = 4 + 32 * 2;
  }
  async init() {
    const network = await this.pool.provider.getNetwork();
    const index = await this.pool.assetToIndex(this.tokenAmountIn.token.address);
    const depositEstimate = await this.poolOracle.quoteDeposit(index, this.tokenAmountIn.raw.toString());
    const lpToken = new Token({
      address: this.pool.address,
      decimals: 18,
      chainId: network.chainId
    });
    this.amountOut = new TokenAmount(lpToken, depositEstimate.lpTokenToMint.toString());
    const slippageTolerance = basisPointsToPercent(this.slippage);
    const slippageAdjustedAmountOut = new Fraction(ONE).add(slippageTolerance).invert().multiply(this.amountOut.raw).quotient;
    this.callData = this.pool.interface.encodeFunctionData("deposit", [
      index,
      this.tokenAmountIn.raw.toString(),
      slippageAdjustedAmountOut.toString(),
      this.to,
      this.deadline
    ]);
    return this;
  }
};

// src/crosschain/zapping.ts
var Zapping = class {
  constructor(symbiosis, omniPoolConfig) {
    this.symbiosis = symbiosis;
    this.omniPoolConfig = omniPoolConfig;
    this.dataProvider = new DataProvider(symbiosis);
    this.pool = this.symbiosis.omniPool(omniPoolConfig);
    this.poolOracle = this.symbiosis.omniPoolOracle(omniPoolConfig);
  }
  async exactIn({ tokenAmountIn, from, to, slippage, deadline }) {
    this.tokenAmountIn = tokenAmountIn;
    this.from = tronAddressToEvm(from);
    this.to = tronAddressToEvm(to);
    this.slippage = slippage;
    this.deadline = deadline;
    this.ttl = deadline - Math.floor(Date.now() / 1e3);
    if (isTronToken(this.tokenAmountIn.token)) {
      this.revertableAddress = this.symbiosis.getRevertableAddress(this.omniPoolConfig.chainId);
    } else {
      this.revertableAddress = this.from;
    }
    const targetPool = this.symbiosis.getOmniPoolByConfig(this.omniPoolConfig);
    if (!targetPool) {
      throw new Error2(`Unknown omni pool ${this.omniPoolConfig.address}`);
    }
    const wrapped = wrappedToken(tokenAmountIn.token);
    const tokenPool = this.symbiosis.getOmniPoolByToken(wrapped);
    if (tokenPool?.id === targetPool.id) {
      this.transitTokenIn = wrapped;
    } else {
      this.transitTokenIn = this.symbiosis.transitToken(tokenAmountIn.token.chainId, this.omniPoolConfig);
    }
    let transitAmountIn;
    if (!this.transitTokenIn.equals(tokenAmountIn.token)) {
      this.tradeA = this.buildTradeA();
      await this.tradeA.init();
      transitAmountIn = this.tradeA.amountOut;
    } else {
      transitAmountIn = tokenAmountIn;
    }
    this.symbiosis.validateSwapAmounts(transitAmountIn);
    this.synthToken = await this.getSynthToken();
    this.omniLiquidity = this.buildOmniLiquidity();
    await this.omniLiquidity.init();
    const fee = await this.getFee();
    this.omniLiquidity = this.buildOmniLiquidity(fee);
    await this.omniLiquidity.init();
    const transactionRequest = this.getTransactionRequest(fee);
    const base = {
      fee,
      tokenAmountOut: this.omniLiquidity.amountOut,
      priceImpact: this.calculatePriceImpact(),
      amountInUsd: this.getSynthAmount(fee),
      transactionRequest,
      inTradeType: this.tradeA?.tradeType
    };
    if ("call_value" in transactionRequest) {
      return {
        ...base,
        type: "tron"
      };
    }
    return {
      ...base,
      type: "evm",
      execute: (signer) => this.execute(transactionRequest, signer)
    };
  }
  async waitForComplete(receipt) {
    return new WaitForComplete({
      direction: "mint",
      chainIdOut: this.omniLiquidity.amountOut.token.chainId,
      symbiosis: this.symbiosis,
      revertableAddress: this.revertableAddress,
      chainIdIn: this.tokenAmountIn.token.chainId
    }).waitForComplete(receipt);
  }
  getTransactionRequest(fee) {
    const chainId = this.tokenAmountIn.token.chainId;
    const metaRouter = this.symbiosis.metaRouter(chainId);
    const [relayRecipient, otherSideCalldata] = this.otherSideSynthCallData(fee);
    let firstToken = this.tradeA ? this.tradeA.tokenAmountIn.token.address : this.tokenAmountIn.token.address;
    if (!firstToken) {
      firstToken = AddressZero5;
    }
    const approvedTokens = [
      firstToken,
      this.tradeA ? this.tradeA.amountOut.token.address : this.tokenAmountIn.token.address
    ];
    const value = this.tradeA && this.tokenAmountIn.token.isNative ? BigNumber7.from(this.tradeA.tokenAmountIn.raw.toString()) : void 0;
    const params = {
      firstSwapCalldata: this.tradeA?.callData || [],
      secondSwapCalldata: [],
      approvedTokens,
      firstDexRouter: this.tradeA?.routerAddress || AddressZero5,
      secondDexRouter: AddressZero5,
      amount: this.tokenAmountIn.raw.toString(),
      nativeIn: this.tokenAmountIn.token.isNative,
      relayRecipient,
      otherSideCalldata
    };
    if (isTronChainId(chainId)) {
      return prepareTronTransaction({
        chainId,
        tronWeb: this.symbiosis.tronWeb(chainId),
        abi: TRON_METAROUTER_ABI,
        contractAddress: metaRouter.address,
        functionName: "metaRoute",
        params: [
          [
            this.tradeA?.callData || [],
            [],
            approvedTokens,
            this.tradeA?.routerAddress || AddressZero5,
            AddressZero5,
            this.tokenAmountIn.raw.toString(),
            this.tokenAmountIn.token.isNative,
            relayRecipient,
            otherSideCalldata
          ]
        ],
        ownerAddress: this.from,
        value: 0
      });
    }
    const data = metaRouter.interface.encodeFunctionData("metaRoute", [params]);
    return {
      chainId,
      to: metaRouter.address,
      data,
      value
    };
  }
  calculatePriceImpact() {
    const zero = new Percent(JSBI14.BigInt(0), BIPS_BASE);
    let pi = this.tradeA?.priceImpact || zero;
    const max = new Percent(JSBI14.BigInt(1e4), BIPS_BASE);
    if (pi.greaterThan(max))
      pi = max;
    return new Percent(pi.numerator, pi.denominator);
  }
  getSynthAmount(fee) {
    let synthAmount = new TokenAmount(
      this.synthToken,
      this.tradeA ? this.tradeA.amountOut.raw : this.tokenAmountIn.raw
    );
    if (fee) {
      synthAmount = synthAmount.subtract(fee);
    }
    return synthAmount;
  }
  buildTradeA() {
    const chainId = this.tokenAmountIn.token.chainId;
    const tokenOut = this.transitTokenIn;
    const from = this.symbiosis.metaRouter(chainId).address;
    const to = from;
    if (WrapTrade.isSupported(this.tokenAmountIn, tokenOut)) {
      return new WrapTrade(this.tokenAmountIn, tokenOut, this.to);
    }
    if (AggregatorTrade.isAvailable(chainId)) {
      return new AggregatorTrade({
        tokenAmountIn: this.tokenAmountIn,
        tokenOut,
        from,
        to,
        slippage: this.slippage / 100,
        dataProvider: this.dataProvider,
        symbiosis: this.symbiosis,
        clientId: this.symbiosis.clientId
      });
    }
    const dexFee = this.symbiosis.dexFee(chainId);
    let routerA = this.symbiosis.uniLikeRouter(chainId);
    if (chainId === 43114 /* AVAX_MAINNET */) {
      routerA = this.symbiosis.avaxRouter(chainId);
    }
    if ([200101 /* MILKOMEDA_DEVNET */, 2001 /* MILKOMEDA_MAINNET */].includes(chainId)) {
      routerA = this.symbiosis.adaRouter(chainId);
    }
    if ([2222 /* KAVA_MAINNET */].includes(chainId)) {
      routerA = this.symbiosis.kavaRouter(chainId);
    }
    return new UniLikeTrade(this.tokenAmountIn, tokenOut, to, this.slippage, this.ttl, routerA, dexFee);
  }
  buildOmniLiquidity(fee) {
    const tokenAmountIn = this.getSynthAmount(fee);
    return new OmniLiquidity(tokenAmountIn, this.to, this.slippage, this.deadline, this.pool, this.poolOracle);
  }
  otherSideSynthCallData(fee) {
    if (!this.tokenAmountIn) {
      throw new Error2("Token is not set");
    }
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.omniPoolConfig.chainId;
    const tokenAmount = this.tradeA ? this.tradeA.amountOut : this.tokenAmountIn;
    const portal = this.symbiosis.portal(chainIdIn);
    return [
      portal.address,
      portal.interface.encodeFunctionData("metaSynthesize", [
        {
          stableBridgingFee: fee.raw.toString(),
          amount: tokenAmount.raw.toString(),
          rtoken: tokenAmount.token.address,
          chain2address: this.to,
          receiveSide: this.symbiosis.synthesis(chainIdOut).address,
          oppositeBridge: this.symbiosis.bridge(chainIdOut).address,
          syntCaller: this.from,
          chainID: chainIdOut,
          swapTokens: [this.synthToken.address],
          secondDexRouter: AddressZero5,
          secondSwapCalldata: [],
          finalReceiveSide: this.pool.address,
          finalCalldata: this.omniLiquidity.callData,
          finalOffset: this.omniLiquidity.callDataOffset,
          revertableAddress: this.revertableAddress,
          clientID: this.symbiosis.clientId
        }
      ])
    ];
  }
  async execute(transactionRequest, signer) {
    const preparedTransactionRequest = await prepareTransactionRequest(transactionRequest, signer);
    const response = await signer.sendTransaction(preparedTransactionRequest);
    return {
      response,
      waitForMined: (confirmations = 1) => this.waitForMined(confirmations, response)
    };
  }
  async waitForMined(confirmations, response) {
    const receipt = await response.wait(confirmations);
    return {
      receipt,
      waitForComplete: () => this.waitForComplete(receipt)
    };
  }
  async getSynthToken() {
    const chainIdOut = this.omniPoolConfig.chainId;
    const rep = await this.symbiosis.getRepresentation(this.transitTokenIn, chainIdOut);
    if (!rep) {
      throw new Error2(
        `Representation of ${this.transitTokenIn.symbol} in chain ${chainIdOut} not found`,
        1 /* NO_ROUTE */
      );
    }
    return rep;
  }
  async getFee() {
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.omniPoolConfig.chainId;
    const portal = this.symbiosis.portal(chainIdIn);
    const synthesis = this.symbiosis.synthesis(chainIdOut);
    const amount = this.tradeA ? this.tradeA.amountOut : this.tokenAmountIn;
    const internalId = getInternalId({
      contractAddress: portal.address,
      requestCount: MaxUint2564,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: synthesis.address,
      revertableAddress: this.revertableAddress,
      chainId: chainIdOut
    });
    const calldata = synthesis.interface.encodeFunctionData("metaMintSyntheticToken", [
      {
        stableBridgingFee: "1",
        amount: amount.raw.toString(),
        externalID: externalId,
        tokenReal: amount.token.address,
        chainID: chainIdIn,
        to: this.to,
        swapTokens: [this.synthToken.address],
        secondDexRouter: AddressZero5,
        secondSwapCalldata: [],
        finalReceiveSide: this.pool.address,
        finalCalldata: this.omniLiquidity.callData,
        finalOffset: this.omniLiquidity.callDataOffset
      }
    ]);
    const fee = await this.symbiosis.getBridgeFee({
      receiveSide: synthesis.address,
      calldata,
      chainIdFrom: this.tokenAmountIn.token.chainId,
      chainIdTo: chainIdOut
    });
    return new TokenAmount(this.synthToken, fee.toString());
  }
};

// src/crosschain/zappingAave.ts
var ZappingAave = class extends BaseSwapping {
  async exactIn({
    tokenAmountIn,
    tokenOut,
    from,
    to,
    slippage,
    deadline
  }) {
    this.multicallRouter = this.symbiosis.multicallRouter(tokenOut.chainId);
    this.userAddress = to;
    this.aavePool = this.symbiosis.aavePool(tokenOut.chainId);
    const data = await this.aavePool.getReserveData(tokenOut.address);
    this.aToken = data.aTokenAddress;
    return this.doExactIn({
      tokenAmountIn,
      tokenOut: wrappedToken(tokenOut),
      from,
      to,
      slippage,
      deadline
    });
  }
  tradeCTo() {
    return this.multicallRouter.address;
  }
  finalReceiveSide() {
    return this.multicallRouter.address;
  }
  finalCalldata() {
    return this.buildMulticall();
  }
  finalOffset() {
    return 36;
  }
  extraSwapTokens() {
    return [this.aToken];
  }
  buildMulticall() {
    const callDatas = [];
    const receiveSides = [];
    const path = [];
    const offsets = [];
    let amount;
    let supplyToken;
    if (this.tradeC) {
      amount = this.tradeC.tokenAmountIn.raw.toString();
      supplyToken = this.tradeC.amountOut.token;
      callDatas.push(this.tradeC.callData);
      receiveSides.push(this.tradeC.routerAddress);
      path.push(this.tradeC.tokenAmountIn.token.address);
      offsets.push(this.tradeC.callDataOffset);
    } else {
      amount = this.transit.amountOut.raw.toString();
      if (this.transit.direction === "mint") {
        supplyToken = this.transit.amountOut.token;
      } else {
        supplyToken = this.transit.feeToken;
      }
    }
    const supplyCalldata = this.aavePool.interface.encodeFunctionData("supply", [
      supplyToken.address,
      "0",
      // amount will be patched
      this.userAddress,
      "0"
    ]);
    callDatas.push(supplyCalldata);
    receiveSides.push(this.aavePool.address);
    path.push(supplyToken.address);
    offsets.push(68);
    return this.multicallRouter.interface.encodeFunctionData("multicall", [
      amount,
      callDatas,
      receiveSides,
      path,
      offsets,
      this.userAddress
    ]);
  }
};

// src/crosschain/zappingBeefy.ts
import { Contract as Contract29 } from "@ethersproject/contracts";
var ZappingBeefy = class extends BaseSwapping {
  async exactIn({
    tokenAmountIn,
    vaultAddress,
    vaultChainId,
    from,
    to,
    slippage,
    deadline
  }) {
    this.multicallRouter = this.symbiosis.multicallRouter(vaultChainId);
    this.userAddress = to;
    this.beefyVault = this.symbiosis.beefyVault(vaultAddress, vaultChainId);
    const tokenAddress = await this.beefyVault.want();
    const tokenContract = new Contract29(tokenAddress, ERC20_default, this.symbiosis.providers.get(vaultChainId));
    const decimals = await tokenContract.decimals();
    const tokenOut = new Token({
      address: tokenAddress,
      chainId: vaultChainId,
      decimals
    });
    return this.doExactIn({
      tokenAmountIn,
      tokenOut,
      from,
      to,
      slippage,
      deadline
    });
  }
  tradeCTo() {
    return this.multicallRouter.address;
  }
  finalReceiveSide() {
    return this.multicallRouter.address;
  }
  finalCalldata() {
    return this.buildMulticall();
  }
  finalOffset() {
    return 36;
  }
  extraSwapTokens() {
    return [this.aToken];
  }
  buildMulticall() {
    const callDatas = [];
    const receiveSides = [];
    const path = [];
    const offsets = [];
    let amount;
    let supplyToken;
    if (this.tradeC) {
      amount = this.tradeC.tokenAmountIn.raw.toString();
      supplyToken = this.tradeC.amountOut.token;
      callDatas.push(this.tradeC.callData);
      receiveSides.push(this.tradeC.routerAddress);
      path.push(this.tradeC.tokenAmountIn.token.address);
      offsets.push(this.tradeC.callDataOffset);
    } else {
      amount = this.transit.amountOut.raw.toString();
      if (this.transit.direction === "mint") {
        supplyToken = this.transit.amountOut.token;
      } else {
        supplyToken = this.transit.feeToken;
      }
    }
    const beefyCalldata = this.beefyVault.interface.encodeFunctionData("deposit", ["0"]);
    callDatas.push(beefyCalldata);
    receiveSides.push(this.beefyVault.address);
    path.push(supplyToken.address, this.beefyVault.address);
    offsets.push(36);
    return this.multicallRouter.interface.encodeFunctionData("multicall", [
      amount,
      callDatas,
      receiveSides,
      path,
      offsets,
      this.userAddress
    ]);
  }
};

// src/crosschain/zappingCream.ts
var ZappingCream = class extends BaseSwapping {
  async getAllMarkets(chainId) {
    const comptroller = this.symbiosis.creamComptroller(chainId);
    const multicall = await getMulticall(comptroller.provider);
    const markets = await comptroller.getAllMarkets();
    const marketsWithUnderlying = await this.reduceUnderlying(multicall, markets);
    return this.reducePaused(multicall, comptroller.address, marketsWithUnderlying);
  }
  async reduceUnderlying(multicall, markets) {
    const creamCErc20Interface = CreamCErc20__factory.createInterface();
    const calls = markets.map((market) => {
      return {
        target: market,
        callData: creamCErc20Interface.encodeFunctionData("underlying")
      };
    });
    const aggregated = await multicall.callStatic.tryAggregate(false, calls);
    return aggregated.map(([success, returnData], i) => {
      if (!success || returnData === "0x")
        return;
      return {
        market: markets[i],
        underlying: creamCErc20Interface.decodeFunctionResult("underlying", returnData).toString().toLowerCase(),
        paused: false
      };
    }).filter((i) => i !== void 0);
  }
  async reducePaused(multicall, target, markets) {
    const comptrollerInterface = CreamComptroller__factory.createInterface();
    const calls = markets.map((marketWithUnderlying) => {
      return {
        target,
        callData: comptrollerInterface.encodeFunctionData("mintGuardianPaused", [marketWithUnderlying.market])
      };
    });
    const aggregated = await multicall.callStatic.tryAggregate(false, calls);
    return aggregated.map(([success, returnData], i) => {
      if (!success || returnData === "0x")
        return;
      const paused = comptrollerInterface.decodeFunctionResult("mintGuardianPaused", returnData)[0];
      return { ...markets[i], paused };
    }).filter((i) => !!i);
  }
  async exactIn({
    tokenAmountIn,
    tokenOut,
    from,
    to,
    slippage,
    deadline
  }) {
    const wrappedTokenOut = wrappedToken(tokenOut);
    const chainIdOut = wrappedTokenOut.chainId;
    this.multicallRouter = this.symbiosis.multicallRouter(chainIdOut);
    this.userAddress = to;
    const markets = await this.getAllMarkets(chainIdOut);
    const index = markets.map((i) => i.underlying).indexOf(wrappedTokenOut.address.toLowerCase());
    if (index === -1) {
      throw new Error(
        `Cream: cannot to find underlying token ${wrappedTokenOut.address} on chain ${wrappedTokenOut.chain?.name}`
      );
    }
    if (markets[index].paused) {
      throw new Error(`Cream: market ${markets[index].market} on chain ${wrappedTokenOut.chain?.name} is paused`);
    }
    this.creamPoolAddress = markets[index].market;
    return this.doExactIn({
      tokenAmountIn,
      tokenOut: wrappedTokenOut,
      from,
      to,
      slippage,
      deadline
    });
  }
  tradeCTo() {
    return this.multicallRouter.address;
  }
  finalReceiveSide() {
    return this.multicallRouter.address;
  }
  finalCalldata() {
    const { callData } = this.buildMulticall();
    return callData;
  }
  finalOffset() {
    return 36;
  }
  extraSwapTokens() {
    const { supplyAddress } = this.buildMulticall();
    return [supplyAddress];
  }
  buildMulticall() {
    const callDatas = [];
    const receiveSides = [];
    const path = [];
    const offsets = [];
    let amount;
    let supplyToken;
    if (this.tradeC) {
      amount = this.tradeC.tokenAmountIn.raw.toString();
      supplyToken = this.tradeC.amountOut.token;
      callDatas.push(this.tradeC.callData);
      receiveSides.push(this.tradeC.routerAddress);
      path.push(this.tradeC.tokenAmountIn.token.address);
      offsets.push(this.tradeC.callDataOffset);
    } else {
      amount = this.transit.amountOut.raw.toString();
      if (this.transit.direction === "mint") {
        supplyToken = this.transit.amountOut.token;
      } else {
        supplyToken = this.transit.feeToken;
      }
    }
    const cream = this.symbiosis.creamCErc20ByAddress(this.creamPoolAddress, supplyToken.chainId);
    const supplyCalldata = cream.interface.encodeFunctionData("mint", ["0"]);
    callDatas.push(supplyCalldata);
    receiveSides.push(cream.address);
    path.push(supplyToken.address);
    path.push(cream.address);
    offsets.push(36);
    const callData = this.multicallRouter.interface.encodeFunctionData("multicall", [
      amount,
      callDatas,
      receiveSides,
      path,
      offsets,
      this.userAddress
    ]);
    return {
      callData,
      supplyAddress: cream.address
    };
  }
};

// src/crosschain/config/mainnet.ts
var config = {
  advisor: {
    url: "https://api-v2.symbiosis.finance/calculations"
  },
  omniPools: [
    {
      chainId: 56288,
      address: "0x6148FD6C649866596C3d8a971fC313E5eCE84882",
      oracle: "0x7775b274f0C3fA919B756b22A4d9674e55927ab8"
    },
    {
      chainId: 56288,
      address: "0xBcc2637DFa64999F75abB53a7265b5B4932e40eB",
      oracle: "0x628613064b1902a1A422825cf11B687C6f17961E"
    }
  ],
  revertableAddress: {
    [728126428 /* TRON_MAINNET */]: "0xd99ac0681b904991169a4f398B9043781ADbe0C3",
    default: "0xd99ac0681b904991169a4f398B9043781ADbe0C3"
  },
  chains: [
    {
      id: 1,
      rpc: "https://ethereum.publicnode.com",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 12,
      stables: [
        {
          name: "USD Coin",
          address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
          symbol: "USDC",
          decimals: 6,
          chainId: 1,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9",
          chainId: 1,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          chainId: 1,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "Tether USD",
          symbol: "USDT",
          address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
          chainId: 1,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
      dexFee: 30,
      metaRouter: "0x1DCfbC3fA01b2a86bC3a3f43479cCe9E8D438Adc",
      metaRouterGateway: "0x0A0B7D1eea99e6189995432fec8172bB2dFFF847",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x49d3Fc00f3ACf80FABCb42D7681667B20F60889A",
      aavePool: "0x87870Bca3F3fD6335C3F4ce8392D69350B4fA4E2",
      aavePoolDataProvider: "0x7B4EB56E7CD4b454BA8ff71E4518426369a138a3",
      creamComptroller: "0x3d5BC3c8d13dcB8bF317092d84783c2697AE9258",
      creamCompoundLens: "0xd400e22dcA840CC7E342DF1d9945684bBd587659",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 56,
      rpc: "https://bsc.publicnode.com",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "BUSD Token",
          address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
          symbol: "BUSD",
          decimals: 18,
          chainId: 56,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
          }
        },
        {
          name: "USD Coin",
          address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
          symbol: "USDC",
          decimals: 18,
          chainId: 56,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Ethereum Token",
          symbol: "ETH",
          address: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
          chainId: 56,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
      dexFee: 25,
      metaRouter: "0x9A31bAC4b3B958C835C243800B474818D04393dd",
      metaRouterGateway: "0x83f71AabdDBb9F0E3B6462Cc7635b6fFAD0f2f2e",
      bridge: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      synthesis: "0x6B1bbd301782FF636601fC594Cd7Bfe74871bfaA",
      portal: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      fabric: "0xc17d768Bf4FdC6f20a4A0d8Be8767840D106D077",
      multicallRouter: "0x44b5d0F16Ad55c4e7113310614745e8771b963bB",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x589de0f0ccf905477646599bb3e5c622c84cc0ba",
      creamCompoundLens: "0x06fd4e17Dd35d0dE9FE17eeAE4e94fBA57fEF154",
      renGatewayRegistry: "0xf36666C230Fa12333579b9Bd6196CB634D6BC506",
      blocksPerYear: 0
    },
    {
      id: 43114,
      rpc: "https://avalanche-c-chain.publicnode.com",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 30,
      stables: [
        {
          name: "USD Coin",
          address: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
          symbol: "USDC.e",
          decimals: 6,
          chainId: 43114,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "USD Coin",
          address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
          symbol: "USDC",
          decimals: 6,
          chainId: 43114,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0xE54Ca86531e17Ef3616d22Ca28b0D458b6C89106",
      dexFee: 30,
      metaRouter: "0x7bD0a0549e546f4e1C2D8eC53F705f8f60559bb1",
      metaRouterGateway: "0x3006Dd3B40f33598A0a219602998D8C3715e75E5",
      bridge: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xE75C7E85FE6ADd07077467064aD15847E6ba9877",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xDc9a6a26209A450caC415fb78487e907c660cf6a",
      aavePool: "0x794a61358D6845594F94dc1DB02A252b5b4814aD",
      aavePoolDataProvider: "0x69FA688f1Dc47d4B5d8029D5a35FB7a548310654",
      creamComptroller: "0x486Af39519B4Dc9a7fCcd318217352830E8AD9b4",
      creamCompoundLens: "0x5b4058A9000e86fe136Ac896352C4DFD539E32a1",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 137,
      rpc: "https://polygon-bor.publicnode.com",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 60,
      stables: [
        {
          name: "USD Coin (PoS) (USDC.e)",
          address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
          symbol: "USDC.e",
          decimals: 6,
          chainId: 137,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
          chainId: 137,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
      dexFee: 30,
      metaRouter: "0xF951789c6A356BfbC3033648AA10b5Dd3e9d88C0",
      metaRouterGateway: "0x5d025432bcbe100354b5fb7b1a68d1641e677f6c",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xc5B61b9abC3C6229065cAD0e961aF585C5E0135c",
      aavePool: "0x794a61358D6845594F94dc1DB02A252b5b4814aD",
      aavePoolDataProvider: "0x69FA688f1Dc47d4B5d8029D5a35FB7a548310654",
      creamComptroller: "0x20CA53E2395FA571798623F1cFBD11Fe2C114c24",
      creamCompoundLens: "0xa7B0C2e904d597b89b4bf91927A3B90459f8bb9E",
      renGatewayRegistry: "0xf36666C230Fa12333579b9Bd6196CB634D6BC506",
      blocksPerYear: 0
    },
    {
      id: 40,
      rpc: "https://mainnet.telos.net/evm",
      filterBlockOffset: 3e3,
      waitForBlocksCount: 120,
      stables: [
        {
          name: "syUSDC",
          address: "0xe6E5f3d264117E030C21920356641DbD5B3d660c",
          symbol: "USDC",
          decimals: 6,
          chainId: 40,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x9b1adec00a25fffd87a5bb17f61916e1c26f6844",
      dexFee: 25,
      metaRouter: "0x7775b274f0c3fa919b756b22a4d9674e55927ab8",
      metaRouterGateway: "0xb52e582263c1d0189b3cc1402c1b7205b7f2e9ba",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x1a039cE63AE35a67Bf0E9F6DbFaE969639D59eC8",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x8a7F930003BedD63A1ebD99C5917FD6aE7E3dedf",
      multicallRouter: "0xcB28fbE3E9C0FEA62E0E63ff3f232CECfE555aD4",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 2222,
      rpc: "https://evm.kava.io/",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 30,
      stables: [
        {
          name: "Tether USDt",
          symbol: "USDT",
          address: "0x919C1c267BC06a7039e03fcc2eF738525769109c",
          chainId: 2222,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0xA7544C409d772944017BB95B99484B6E0d7B6388",
      dexFee: 30,
      metaRouter: "0x88139ad1199e8c78a0804d4bebf4fbad89ef9d89",
      metaRouterGateway: "0x3a696f9201bafadfded7953933ab2832b38fc023",
      bridge: "0xda8057acB94905eb6025120cB2c38415Fd81BfEB",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 288,
      rpc: "https://mainnet.boba.network",
      filterBlockOffset: 3e3,
      waitForBlocksCount: 0,
      stables: [
        {
          name: "USD Coin",
          address: "0x66a2A913e447d6b4BF33EFbec43aAeF87890FBbc",
          symbol: "USDC",
          decimals: 6,
          chainId: 288,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
      dexFee: 30,
      metaRouter: "0xbbad2fe9558e55ebfa04b3b5bff0b6c4e2ffdd2c",
      metaRouterGateway: "0xda411e3b9047ae198dfb7448e97ca900fe793035",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x506803495B1876FE1fA6Cd9dC65fB060057A4Cc3",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 56288,
      rpc: "https://symbiosis.bnb.boba.network",
      filterBlockOffset: 3e3,
      waitForBlocksCount: 0,
      stables: [
        {
          name: "USD Coin",
          address: "0x9F98f9F312D23d078061962837042b8918e6aff2",
          symbol: "USDC",
          decimals: 18,
          chainId: 56288,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
      dexFee: 30,
      metaRouter: "0xB79A4F5828eb55c10D7abF4bFe9a9f5d11aA84e0",
      metaRouterGateway: "0x37E44E4400A43F0c27ed42cF6EBEE3493A3e4d2f",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      multicallRouter: "0xcB28fbE3E9C0FEA62E0E63ff3f232CECfE555aD4",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 324,
      rpc: "https://mainnet.era.zksync.io",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 12,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4",
          chainId: 324,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x5aea5775959fbc2557cc8789bc1bf90a239d9a91",
          chainId: 324,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x8B791913eB07C32779a16750e3868aA8495F5964",
      dexFee: 30,
      metaRouter: "0x4f30036b5858f77F98d8D35c3b21BEb18916Ba9a",
      metaRouterGateway: "0x2F7c5901DeBFb7faD804Db800F226de3dd0cffd5",
      bridge: "0xb0D30aD9C1A7b303977DB7ea073a4329d930D94c",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x39dE19C9fF25693A2311AAD1dc5C790194084A39",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xe004DE550074856bD64Cc1A89A8B3b56bD3eAf31",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 42161,
      rpc: "https://arb1.arbitrum.io/rpc",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 240,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
          chainId: 42161,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          deprecated: true,
          name: "USD Coin (Arb1)",
          symbol: "USDC.e",
          address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
          chainId: 42161,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
          chainId: 42161,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xD01319f4b65b79124549dE409D36F25e04B3e551",
      dexFee: 30,
      metaRouter: "0xca506793A420E901BbCa8066be5661E3C52c84c2",
      metaRouterGateway: "0xd92ca299f1c2518e78e48c207b64591ba6e9b9a8",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xda8057acB94905eb6025120cB2c38415Fd81BfEB",
      aavePool: "0x794a61358D6845594F94dc1DB02A252b5b4814aD",
      aavePoolDataProvider: "0x69FA688f1Dc47d4B5d8029D5a35FB7a548310654",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 10,
      rpc: "https://optimism.publicnode.com",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 50,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
          chainId: 10,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x4200000000000000000000000000000000000006",
          chainId: 10,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x1a039ce63ae35a67bf0e9f6dbfae969639d59ec8",
      metaRouterGateway: "0x1e4bf3cabd7707089138dd5a545b077413fa83fc",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      aavePool: "0x794a61358D6845594F94dc1DB02A252b5b4814aD",
      aavePoolDataProvider: "0x69FA688f1Dc47d4B5d8029D5a35FB7a548310654",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 42170,
      rpc: "https://nova.arbitrum.io/rpc",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 60,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x750ba8b76187092B0D1E87E28daaf484d1b5273b",
          chainId: 42170,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x722e8bdd2ce80a4422e880164f2079488e115365",
          chainId: 42170,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xEe01c0CD76354C383B8c7B4e65EA88D00B06f36f",
      dexFee: 30,
      metaRouter: "0xf85fc807d05d3ab2309364226970aac57b4e1ea4",
      metaRouterGateway: "0xcd7c056b39ddfb568e451923abedb9b6a7aeb885",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 1101,
      rpc: "https://rpc.ankr.com/polygon_zkevm",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 0,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0xA8CE8aee21bC2A48a5EF670afCc9274C7bbbC035",
          chainId: 1101,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
          chainId: 1101,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 30,
      metaRouter: "0xDF41Ce9d15e9b6773ef20cA682AFE56af6Bb3F94",
      metaRouterGateway: "0x3b561BdeDf4Ebaa708633B73D58B57EB7CD970d3",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 59144,
      rpc: "https://rpc.linea.build",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 0,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
          chainId: 59144,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
          chainId: 59144,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0xc66149996d0263C0B42D3bC05e50Db88658106cE",
      dexFee: 30,
      metaRouter: "0x8a7F930003BedD63A1ebD99C5917FD6aE7E3dedf",
      metaRouterGateway: "0xe6e5f3d264117e030c21920356641dbd5b3d660c",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 5e3,
      rpc: "https://rpc.mantle.xyz",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 10,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9",
          chainId: 5e3,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0xdEAddEaDdeadDEadDEADDEAddEADDEAddead1111",
          chainId: 5e3,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xDd0840118bF9CCCc6d67b2944ddDfbdb995955FD",
      dexFee: 30,
      metaRouter: "0xA738e84fdE890Bc60b99AF7ccE43990E534304de",
      metaRouterGateway: "0x5074b7ca7162f793318b65d8becc5975df327c80",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 8453,
      rpc: "https://base.publicnode.com",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 30,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x4200000000000000000000000000000000000006",
          chainId: 8453,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "USD Base Coin",
          symbol: "USDbC",
          address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
          chainId: 8453,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x327Df1E6de05895d2ab08513aaDD9313Fe505d86",
      dexFee: 0,
      metaRouter: "0x6F0f6393e45fE0E7215906B6f9cfeFf53EA139cf",
      metaRouterGateway: "0x4cfA66497Fa84D739a0f785FBcEe9196f1C64e4a",
      bridge: "0x8097f0B9f06C27AF9579F75762F971D745bb222F",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xEE981B2459331AD268cc63CE6167b446AF4161f8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9",
      aavePool: "0xA238Dd80C259a72e81d7e4664a9801593F98d1c5",
      aavePoolDataProvider: "0x2d8A3C5677189723C4cB8873CfC9C8976FDF38Ac",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 728126428 /* TRON_MAINNET */,
      rpc: "https://api.trongrid.io",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "Tether USDt",
          symbol: "USDT",
          address: "0xa614f803b6fd780986a42c78ec9c7f77e6ded13c",
          chainId: 728126428 /* TRON_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0x6E0617948FE030A7E4970F8389D4AD295F249B7E",
      dexFee: 30,
      metaRouter: "0x7d2f60748310d51bf24aab58c382b204104d4504",
      metaRouterGateway: "0x09639856487b357d656d329b7a8800812b5d1114",
      bridge: "0x149b1992e1cb0839cdfa7493ebf1a04286eb6e4a",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x4badeb0ca175da3ac6a4c886ca31990688d2a260",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x354ed0e8616678f2829feb2e2e9a0e0869fa82fb",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 534352 /* SCROLL_MAINNET */,
      rpc: "https://scroll-mainnet-public.unifra.io",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x5300000000000000000000000000000000000004",
          chainId: 534352 /* SCROLL_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    }
  ]
};

// src/crosschain/config/testnet.ts
var config2 = {
  advisor: {
    url: "https://api.testnet.symbiosis.finance/calculations"
  },
  omniPools: [
    {
      chainId: 97,
      address: "0x569D2a232F5f2a462673fAf184ED9640e8A9F4D8",
      oracle: "0xcE29b84160fe8B6Fc1c6E5aD66F1F43279F2F1C9"
    },
    {
      chainId: 97,
      address: "0xc44AF80948B8a20bb781277559457ce0F2893b8b",
      oracle: "0x69cE6CA199c5Ca995C954c15F925D68ee0810153"
    }
  ],
  revertableAddress: {
    [2494104990 /* TRON_TESTNET */]: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5",
    default: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5"
  },
  chains: [
    {
      id: 5,
      rpc: "https://rpc.ankr.com/eth_goerli",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 5,
      stables: [
        {
          name: "USD Coin",
          address: "0x07865c6E87B9F70255377e024ace6630C1Eaa37F",
          symbol: "USDC",
          decimals: 6,
          chainId: 5,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped ETH",
          address: "0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6",
          symbol: "WETH",
          decimals: 18,
          chainId: 5,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
      dexFee: 30,
      metaRouter: "0x5302358dCFbF2881e5b5E537316786d8Ea242008",
      metaRouterGateway: "0x438D14b1Fd3C20C33Fa7EF6331AA3fC36bc0347E",
      bridge: "0x9f81fAcae42a7312f49A3E27098fC4d39e2c550d",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x7d8B7b5f663E93D7F8970d0A61081Af03c63bB86",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xd655C2c9D558Bf8E3382f98eDADb84e866665139",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 97,
      rpc: "https://rpc.ankr.com/bsc_testnet_chapel",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "Binance USD",
          address: "0x9a01bf917477dd9f5d715d188618fc8b7350cd22",
          symbol: "BUSD",
          decimals: 18,
          chainId: 97,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
          }
        }
      ],
      router: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
      dexFee: 30,
      metaRouter: "0xd3F98c243374D79Bfd9a8ac03964623221D53F0f",
      metaRouterGateway: "0x4Ee7B1e8Ad6E1682318f1c47F83634dAa1197eEf",
      bridge: "0xB299eee0Ed46b7a34C01F2a01fc83a0B45aA88AF",
      synthesis: "0x08f5c28ff0622FeF758c2C3c2a5EAEeb63D60D4c",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x9B8D0e0765cDa999910ff31A2204080E1192EfC7",
      multicallRouter: "0x086D8d30822086941729DF294f0e52E42EdC17F9",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 43113,
      rpc: "https://rpc.ankr.com/avalanche_fuji",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "USDT",
          symbol: "USDT",
          address: "0x9a01bf917477dd9f5d715d188618fc8b7350cd22",
          chainId: 43113,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0x4F86a87985a2eD1E843c0b93755Ac06A3DbCc55E",
      dexFee: 30,
      metaRouter: "0x8eC5387A2CdFA5315c05Fd7296C11406AeC2559e",
      metaRouterGateway: "0x80cD2d214ccBdcB214DEA5bC040c8c2002Dc9380",
      bridge: "0xcC0DB081360Eb259bdf6911976c51cAF1B72e845",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x78Bb4D4872121f162BB3e938F0d10cf34E999648",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x8C9D3CE1D59d73259018dBC9859F6eBe62Bbf862",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 80001,
      rpc: "https://rpc.ankr.com/polygon_mumbai",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 60,
      stables: [
        {
          name: "USDT",
          symbol: "USDT",
          address: "0x9a01bf917477dd9f5d715d188618fc8b7350cd22",
          chainId: 80001,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0xca33f6D096BDD7FcB28d708f631cD76E73Ecfc2d",
      dexFee: 30,
      metaRouter: "0x2636F6A85aB7bD438631a03e6E7cC6d6ae712642",
      metaRouterGateway: "0x85aDa6757f383577A8AB2a3492ac3E721CcFEAbb",
      bridge: "0x2578412aECCcc32f270A03cfBa25f6557aF4017b",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x9ad7e9A0D18cC56303277dC5bF77D1910570509a",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xEc36ED7f5Be3006CF04F85d4851DbDB85b60C19E",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 534353,
      rpc: "https://alpha-rpc.scroll.io/l2",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "Circle USD",
          symbol: "USDC",
          address: "0x67aE69Fd63b4fc8809ADc224A9b82Be976039509",
          chainId: 534353,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped ETH",
          address: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
          symbol: "WETH",
          decimals: 18,
          chainId: 534353,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xDe886ff69fE234c8db2e2694788e73aa6be8d0c7",
      dexFee: 30,
      metaRouter: "0xAED47A51AeFa6f95A388aDA3c459d94FF46fC4BB",
      metaRouterGateway: "0x8Daf3F19dD8a27554BaE525075E90Df4E56a4c46",
      bridge: "0x6fa0a77Bb9FC5AC9e9D9C26c101067486291d2B5",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x7739E567B9626ca241bdC5528343F92F7e59Af37",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x9D15297f42fEf485f2d061a012cfE699Cc49132B",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 2336e3,
      renGatewayRegistry: "0x0000000000000000000000000000000000000000"
    },
    {
      id: 534351,
      rpc: "https://sepolia-rpc.scroll.io",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 1,
      stables: [
        {
          name: "Wrapped ETH",
          address: "0x5300000000000000000000000000000000000004",
          symbol: "WETH",
          decimals: 18,
          chainId: 534351,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 30,
      metaRouter: "0xAED47A51AeFa6f95A388aDA3c459d94FF46fC4BB",
      metaRouterGateway: "0x8Daf3F19dD8a27554BaE525075E90Df4E56a4c46",
      bridge: "0x6fa0a77Bb9FC5AC9e9D9C26c101067486291d2B5",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x7739E567B9626ca241bdC5528343F92F7e59Af37",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x9D15297f42fEf485f2d061a012cfE699Cc49132B",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 2336e3,
      renGatewayRegistry: "0x0000000000000000000000000000000000000000"
    },
    {
      id: 59140,
      rpc: "https://rpc.goerli.linea.build",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 5,
      stables: [
        {
          name: "Tether",
          symbol: "USDT",
          address: "0xAED47A51AeFa6f95A388aDA3c459d94FF46fC4BB",
          chainId: 59140,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      dexFee: 30,
      router: "0x106c6743C1f8ED9c5c824887AadAc8215294f8b6",
      metaRouter: "0xE52e3c838CC91C60a701E78B5043ba9eeEeb55db",
      metaRouterGateway: "0x13fF611B06bEb2A29a49cc3c825cD0eE74967bE3",
      bridge: "0x9D15297f42fEf485f2d061a012cfE699Cc49132B",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xc098feAc51a186d3E0B446146007e1d87E34D6f2",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x7dc13B605508F91Fcd3bf7803C2b96B43941B4E8",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 5001,
      rpc: "https://rpc.testnet.mantle.xyz",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 5,
      stables: [
        {
          name: "Tether",
          symbol: "USDT",
          address: "0xAED47A51AeFa6f95A388aDA3c459d94FF46fC4BB",
          chainId: 5001,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      dexFee: 30,
      router: "0x45e6f621c5ED8616cCFB9bBaeBAcF9638aBB0033",
      metaRouter: "0xE52e3c838CC91C60a701E78B5043ba9eeEeb55db",
      metaRouterGateway: "0x13fF611B06bEb2A29a49cc3c825cD0eE74967bE3",
      bridge: "0x9D15297f42fEf485f2d061a012cfE699Cc49132B",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xc098feAc51a186d3E0B446146007e1d87E34D6f2",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x7dc13B605508F91Fcd3bf7803C2b96B43941B4E8",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 2336e3,
      renGatewayRegistry: "0x0000000000000000000000000000000000000000"
    },
    {
      id: 2494104990,
      rpc: "https://api.shasta.trongrid.io",
      filterBlockOffset: 3e3,
      waitForBlocksCount: 19,
      stables: [
        {
          name: "USDT",
          symbol: "USDT",
          address: "TG3XXyExBkPp9nzdajDZsozEu4BkaSJozs",
          chainId: 2494104990,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0x623209682018f557a5255390f3158cf5fc8a855c",
      dexFee: 25,
      metaRouter: "0x3d8ea18ce50759cf9a41f580d47b54e2bf608b45",
      metaRouterGateway: "0xb7b2a08e6b49d5a0c05f93d715f84518f8c06f8a",
      bridge: "0x4002f99b8452218320e5b0dbb7aea31b8d51028c",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xa598d68e8199e147552915fef169108158a99971",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x0000000000000000000000000000000000000000",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0,
      creamCompoundLens: "0x0000000000000000000000000000000000000000"
    }
  ]
};

// src/crosschain/config/dev.ts
var config3 = {
  advisor: {
    url: "https://api.dev.symbiosis.finance/calculations"
  },
  omniPools: [
    {
      chainId: 97,
      address: "0x789001A80a8EdBBEE07876b0dF58c3eAdEE89877",
      oracle: "0x2cD94CB0F4cBC4a51c3e9c4b88d03B982bE24608"
    }
  ],
  revertableAddress: {
    [2494104990 /* TRON_TESTNET */]: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5",
    default: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5"
  },
  chains: [
    {
      id: 5,
      rpc: "https://rpc.ankr.com/eth_goerli",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 5,
      stables: [
        {
          name: "Wrapped ETH",
          address: "0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6",
          symbol: "WETH",
          decimals: 18,
          chainId: 5,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
      dexFee: 30,
      metaRouter: "0xd70077A7e64473F2B606fDeE43014d63d3F8dFB2",
      metaRouterGateway: "0x44f841Fa855a2f4B3091fACaE91D73b485bc675c",
      bridge: "0x823389FfdF5F1BAD10eB52089E7195772A54ccBa",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xd85d934E4b73Fd93f56BEAE55eF7cdD3eAecBf4D",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xee328E4ba6579B7003A60cf740C8f8198B08491D",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 97,
      rpc: "https://rpc.ankr.com/bsc_testnet_chapel",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [],
      router: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
      dexFee: 30,
      metaRouter: "0x87BFB71bBd221a57826489DD247EB103a0cc7482",
      metaRouterGateway: "0x27022ad33b09f49BEE2dCC482F4604FD2560A862",
      bridge: "0x9708C5b89F9B166c080B8F5BBcDEC27D5Fa92eE8",
      synthesis: "0xD67940D8414E09F84eBEa85cd021dbc011A94Bc8",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x167C52B035D7cfA2D8199A2Af450B3493C51576C",
      multicallRouter: "0xF77c766DEB09f424228Be0b679E3F8326b9d7741",
      aavePool: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 534353,
      rpc: "https://alpha-rpc.scroll.io/l2",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "Wrapped ETH",
          address: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
          symbol: "WETH",
          decimals: 18,
          chainId: 534353,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xDe886ff69fE234c8db2e2694788e73aa6be8d0c7",
      dexFee: 30,
      metaRouter: "0x81d80bEcFD9a6A64bB0602d79E8Bd45844083626",
      metaRouterGateway: "0xfB4e7A087b24Dfc583C56F53026D7270B378182F",
      bridge: "0xcC9DBA9AF9ce104e150654B21436584b8e74b236",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xCFae8104e76C9BFcf9A9035B83e907DFfD109A55",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xFcaf6b41397c93032C43E5C37256350d679B3Bbe",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 2336e3,
      renGatewayRegistry: "0x0000000000000000000000000000000000000000"
    }
  ]
};

// src/crosschain/config/bridge.ts
var config4 = {
  advisor: {
    url: "https://api.bridge.symbiosis.finance/calculations"
  },
  omniPools: [
    {
      chainId: 56288,
      address: "0x566E412387AE3FaB8b5Aa3A77178B120BCfF5Af8",
      oracle: "0x851B43189de721dD94AbA767AAd9E6F6d6a95CCA"
    },
    {
      chainId: 56288,
      address: "0xE7e68D336F90f98D22A479253eafA5f2424aCaD8",
      oracle: "0xDdD4F712F43e26eaDc10e88A0050552c196b0403"
    }
  ],
  revertableAddress: {
    [728126428 /* TRON_MAINNET */]: "0x93541c07bE765B4012c5ca81c2CAA88258Dd356A",
    default: "0x93541c07bE765B4012c5ca81c2CAA88258Dd356A"
  },
  chains: [
    {
      id: 1,
      rpc: "https://rpc.ankr.com/eth",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 12,
      stables: [
        {
          name: "XDAO",
          address: "0x71eebA415A523F5C952Cc2f06361D5443545Ad28",
          symbol: "XDAO",
          decimals: 18,
          chainId: 1,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9",
          chainId: 1,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        }
      ],
      router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
      dexFee: 30,
      metaRouter: "0x0f91052dc5B4baE53d0FeA5DAe561A117268f5d2",
      metaRouterGateway: "0x200a0fe876421DC49A26508e3Efd0a1008fD12B5",
      bridge: "0x7B4E28E7273aA8CB64C56fF191ebF43b64f409F9",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x42Cd64f48496dDdfEfF8F3704df9175dbe20d325",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x49d3Fc00f3ACf80FABCb42D7681667B20F60889A",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 56,
      rpc: "https://rpc.ankr.com/bsc",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 20,
      stables: [
        {
          name: "XDAO",
          address: "0x71eebA415A523F5C952Cc2f06361D5443545Ad28",
          symbol: "XDAO",
          decimals: 18,
          chainId: 56,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
          }
        },
        {
          name: "Symbiosis",
          address: "0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835",
          symbol: "SIS",
          chainId: 56,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        }
      ],
      router: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
      dexFee: 25,
      metaRouter: "0xbbA322c98601b707cFfb98092010e0b95d538bB7",
      metaRouterGateway: "0x346163578c731C0849F98f34fa61545Dd10eEbd5",
      bridge: "0xEE981B2459331AD268cc63CE6167b446AF4161f8",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xb91d3060C90aac7c4c706aef2B37997b3b2a1DcF",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x44b5d0F16Ad55c4e7113310614745e8771b963bB",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 137,
      rpc: "https://rpc.ankr.com/polygon",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 60,
      stables: [
        {
          name: "XDAO",
          address: "0x71eebA415A523F5C952Cc2f06361D5443545Ad28",
          symbol: "XDAO",
          decimals: 18,
          chainId: 137,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
          }
        }
      ],
      router: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
      dexFee: 30,
      metaRouter: "0xb657f823fd8c4B94901e78b75481D5b39D59ec61",
      metaRouterGateway: "0x51d47A870cF9A8584f3FF850A50925E0CB930CD7",
      bridge: "0xfeC09BE39F82b13471D2e0E7d72e6ee589c631c6",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x3338BE49A5f60e2593337919F9aD7098e9a7Dd7E",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xc5B61b9abC3C6229065cAD0e961aF585C5E0135c",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 324,
      rpc: "https://mainnet.era.zksync.io",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 12,
      stables: [
        {
          name: "Symbiosis",
          address: "0xdd9f72afED3631a6C85b5369D84875e6c42f1827",
          symbol: "SIS",
          chainId: 324,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        }
      ],
      router: "0x8B791913eB07C32779a16750e3868aA8495F5964",
      dexFee: 30,
      metaRouter: "0x2a2114691965cF1dAa95BfCcCADDF038b0743c74",
      metaRouterGateway: "0x11Ec3f119bA9fdA6d87317E505B33Cb379c265D9",
      bridge: "0x82c67f8E4d05Bb6794E40281056e4476a0B89806",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x97b99f47b086a074f214f4A62A3b041599726DC2",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xe004DE550074856bD64Cc1A89A8B3b56bD3eAf31",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 42161,
      rpc: "https://arb1.arbitrum.io/rpc",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 240,
      stables: [
        {
          name: "Symbiosis",
          address: "0x9E758B8a98a42d612b3D38B66a22074DC03D7370",
          symbol: "SIS",
          chainId: 42161,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        }
      ],
      router: "0xD01319f4b65b79124549dE409D36F25e04B3e551",
      dexFee: 30,
      metaRouter: "0x4F82CAA8F34564Ab22371f3c5d22868ab8eDD5E3",
      metaRouterGateway: "0x2A223EB19085E0AB286205403951F3863A9d45DE",
      bridge: "0x844e4a0ade23b1BA5642A8d0010E42aE4434Df30",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x0425841529882628880fBD228AC90606e0c2e09A",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xF951789c6A356BfbC3033648AA10b5Dd3e9d88C0",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 59144,
      rpc: "https://rpc.linea.build",
      filterBlockOffset: 2e3,
      waitForBlocksCount: 0,
      stables: [
        {
          name: "Symbiosis",
          address: "0x6EF95B6f3b0F39508e3E04054Be96D5eE39eDE0d",
          symbol: "SIS",
          chainId: 59144,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        }
      ],
      router: "0xc66149996d0263C0B42D3bC05e50Db88658106cE",
      dexFee: 30,
      metaRouter: "0x1DCfbC3fA01b2a86bC3a3f43479cCe9E8D438Adc",
      metaRouterGateway: "0x0A0B7D1eea99e6189995432fec8172bB2dFFF847",
      bridge: "0x17efC1d70eA32eb04c6979c6500d12eEE9e3Dcbd",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x7f6fb9f3ce785F3d85772c038Fda58eC9432D421",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xbbA322c98601b707cFfb98092010e0b95d538bB7",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    },
    {
      id: 56288,
      rpc: "https://symbiosis.bnb.boba.network",
      filterBlockOffset: 3e3,
      waitForBlocksCount: 0,
      stables: [],
      router: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
      dexFee: 30,
      metaRouter: "0x906C9b4802AeC01d565b0412422224D1a2932D76",
      metaRouterGateway: "0x5F010D019e4D4f9b1CbA682e055A622BF76c0575",
      bridge: "0xe1f16F6C5cCbF9BA32E0fd1E668a133AFAe0f105",
      synthesis: "0xF818D26215BB22B79F8501530bd6d54FfE166735",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x6BB1864d4e5A58dfcD142d9f560bB6389742822E",
      multicallRouter: "0xcB28fbE3E9C0FEA62E0E63ff3f232CECfE555aD4",
      aavePool: "0x0000000000000000000000000000000000000000",
      aavePoolDataProvider: "0x0000000000000000000000000000000000000000",
      creamComptroller: "0x0000000000000000000000000000000000000000",
      creamCompoundLens: "0x0000000000000000000000000000000000000000",
      renGatewayRegistry: "0x0000000000000000000000000000000000000000",
      blocksPerYear: 0
    }
  ]
};

// src/crosschain/bestPoolSwapping.ts
var BestPoolSwapping = class {
  constructor(symbiosis) {
    this.symbiosis = symbiosis;
  }
  async exactIn({ tokenAmountIn, tokenOut, from, to, slippage, deadline, oneInchProtocols }) {
    const omniPools = this.symbiosis.config.omniPools;
    const results = await Promise.allSettled(
      omniPools.map(async (omniPoolConfig) => {
        const action = this.symbiosis.newSwapping(omniPoolConfig);
        const actionResult2 = await action.exactIn({
          tokenAmountIn,
          tokenOut,
          from,
          to,
          slippage,
          deadline,
          oneInchProtocols
        });
        return { action, actionResult: actionResult2 };
      })
    );
    let swapping;
    let actionResult;
    let actionError;
    for (const item of results) {
      if (item.status !== "fulfilled") {
        if (!actionError || item.reason.code !== 5 /* NO_TRANSIT_TOKEN */) {
          actionError = item.reason;
        }
        console.error("error: ", item);
        continue;
      }
      const { value } = item;
      if (actionResult && actionResult.tokenAmountOut.greaterThan(value.actionResult.tokenAmountOut)) {
        continue;
      }
      swapping = value.action;
      actionResult = value.actionResult;
    }
    if (!actionResult) {
      throw actionError;
    }
    this.swapping = swapping;
    return actionResult;
  }
  // Need to backward compatibility to Swapping
  get amountInUsd() {
    if (!this.swapping) {
      return void 0;
    }
    return this.swapping.amountInUsd;
  }
  // Need to backward compatibility to Swapping
  async waitForComplete(...args) {
    if (!this.swapping) {
      throw new Error("Swapping is not started");
    }
    return this.swapping.waitForComplete(...args);
  }
  // Need to backward compatibility to Swapping
  async findTransitTokenSent(...args) {
    if (!this.swapping) {
      throw new Error("Swapping is not started");
    }
    return this.swapping.findTransitTokenSent(...args);
  }
};

// src/crosschain/config/cache/mainnet.json
var mainnet_default = {
  omniPools: [
    {
      chainId: 56288,
      address: "0x6148FD6C649866596C3d8a971fC313E5eCE84882",
      oracle: "0x7775b274f0C3fA919B756b22A4d9674e55927ab8",
      id: 0,
      tokens: [
        { index: 0, tokenId: 38 },
        { index: 1, tokenId: 41 },
        { index: 2, tokenId: 44 },
        { index: 3, tokenId: 46 },
        { index: 4, tokenId: 14 },
        { index: 5, tokenId: 50 },
        { index: 10, tokenId: 42 },
        { index: 11, tokenId: 51 },
        { index: 12, tokenId: 54 },
        { index: 13, tokenId: 56 },
        { index: 14, tokenId: 58 },
        { index: 15, tokenId: 60 },
        { index: 16, tokenId: 53 },
        { index: 17, tokenId: 45 },
        { index: 18, tokenId: 64 },
        { index: 19, tokenId: 49 },
        { index: 20, tokenId: 67 },
        { index: 21, tokenId: 63 },
        { index: 22, tokenId: 48 },
        { index: 23, tokenId: 68 }
      ]
    },
    {
      chainId: 56288,
      address: "0xBcc2637DFa64999F75abB53a7265b5B4932e40eB",
      oracle: "0x628613064b1902a1A422825cf11B687C6f17961E",
      id: 1,
      tokens: [
        { index: 1, tokenId: 52 },
        { index: 2, tokenId: 61 },
        { index: 3, tokenId: 55 },
        { index: 5, tokenId: 47 },
        { index: 6, tokenId: 43 },
        { index: 7, tokenId: 57 },
        { index: 8, tokenId: 59 },
        { index: 9, tokenId: 40 },
        { index: 10, tokenId: 62 },
        { index: 11, tokenId: 65 },
        { index: 12, tokenId: 66 },
        { index: 13, tokenId: 69 }
      ]
    }
  ],
  tokens: [
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      id: 0
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9",
      id: 1
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      id: 2
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      id: 3
    },
    {
      decimals: 18,
      symbol: "BUSD",
      name: "BUSD Token",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
      },
      deprecated: false,
      address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
      id: 4
    },
    {
      decimals: 18,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      id: 5
    },
    {
      decimals: 18,
      symbol: "ETH",
      name: "Ethereum Token",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
      id: 6
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin",
      chainId: 43114,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
      id: 7
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 43114,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
      id: 8
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin (PoS) (USDC.e)",
      chainId: 137,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      id: 9
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 137,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
      id: 10
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "syUSDC",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xe6E5f3d264117E030C21920356641DbD5B3d660c",
      id: 11
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether USDt",
      chainId: 2222,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0x919C1c267BC06a7039e03fcc2eF738525769109c",
      id: 12
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x66a2A913e447d6b4BF33EFbec43aAeF87890FBbc",
      id: 13
    },
    {
      decimals: 18,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x9F98f9F312D23d078061962837042b8918e6aff2",
      id: 14
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4",
      id: 15
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91",
      id: 16
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      id: 17
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin (Arb1)",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: true,
      address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
      id: 18
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      id: 19
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 10,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
      id: 20
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 10,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4200000000000000000000000000000000000006",
      id: 21
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 42170,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x750ba8b76187092B0D1E87E28daaf484d1b5273b",
      id: 22
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 42170,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x722E8BdD2ce80A4422E880164f2079488e115365",
      id: 23
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 1101,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xA8CE8aee21bC2A48a5EF670afCc9274C7bbbC035",
      id: 24
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 1101,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4F9A0e7FD2Bf6067db6994CF12E4495Df938E6e9",
      id: 25
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 59144,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
      id: 26
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 59144,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
      id: 27
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 5e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9",
      id: 28
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 5e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xdEAddEaDdeadDEadDEADDEAddEADDEAddead1111",
      id: 29
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 8453,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4200000000000000000000000000000000000006",
      id: 30
    },
    {
      decimals: 6,
      symbol: "USDbC",
      name: "USD Base Coin",
      chainId: 8453,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
      id: 31
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether USDt",
      chainId: 728126428,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0xa614f803b6fd780986a42c78ec9c7f77e6ded13c",
      id: 32
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 534352,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x5300000000000000000000000000000000000004",
      id: 33
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835",
      id: 34,
      originalId: 1
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "syUSDC",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xe6E5f3d264117E030C21920356641DbD5B3d660c",
      id: 35,
      originalId: 0
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "syWETH",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x63d71E79AdF0886c989A23b04a0E86F1489b6BC3",
      id: 36,
      originalId: 2
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "syUSDT",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x7bD3ffe9f0C9CF08FD60e102FEa455A6EA580276",
      id: 37,
      originalId: 3
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin from Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x7d6EC42b5d9566931560411a8652Cea00b90d982",
      id: 38,
      originalId: 0
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x4E985A18B4Ac70a1C3d986a5f55CB4c5BC8f65AE",
      id: 39,
      originalId: 1
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Ethereum)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x1CE4E75E2Bd6bbbACDE1E10D6813228138337E86",
      id: 40,
      originalId: 2
    },
    {
      decimals: 18,
      symbol: "sBUSD",
      name: "Synthetic Binance-Peg BUSD Token from BSC",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x1a25BEB8E75626ADDb983d46fbDfcE5fdC29Ae58",
      id: 41,
      originalId: 4
    },
    {
      decimals: 18,
      symbol: "sUSDC",
      name: "Synthetic Binance-Peg USD Coin from BSC",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x5e19eFc6AC9C80bfAA755259c9fab2398A8E87eB",
      id: 42,
      originalId: 5
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Binance)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x424190072b7Db5352bB91cC70DabD82F547AE003",
      id: 43,
      originalId: 6
    },
    {
      decimals: 6,
      symbol: "sUSDC.e",
      name: "Synthetic USD Coin from Avalanche",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 43114,
      deprecated: false,
      address: "0x6dF9C221F52537DFD63d70721EEAA0C4d4472C18",
      id: 44,
      originalId: 7
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Avalanche",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 43114,
      deprecated: false,
      address: "0x04967F713aca02039EA18c2E5805a863b5eC25A0",
      id: 45,
      originalId: 8
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin from Polygon",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 137,
      deprecated: false,
      address: "0x59AA2e5F628659918A4890A2a732E6C8bD334E7A",
      id: 46,
      originalId: 9
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Arbitrum Nova)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 137,
      deprecated: false,
      address: "0x93A973297E492d4E7a2b4aBaB3bFB4f140D1E3Bb",
      id: 47,
      originalId: 10
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic syUSDC From Telos",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 40,
      deprecated: false,
      address: "0x2c679B79d8F40049d68CaA879Bf643F37E75F704",
      id: 48,
      originalId: 11
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "Synthetic USDT From Kava",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 2222,
      deprecated: false,
      address: "0xCdc9C3e0fc1909205aC96EC98795aCAa29a6A1E3",
      id: 49,
      originalId: 12
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin from Boba ETH",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 288,
      deprecated: false,
      address: "0x1a3d48492Cd334AD140587091AC382E5695a4934",
      id: 50,
      originalId: 13
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From ZkSync Era Mainnet",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 324,
      deprecated: false,
      address: "0xC6CC7E50A0F20268DB1BAb041ff18b2c7E97a9d3",
      id: 51,
      originalId: 15
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (zkSync Era)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 324,
      deprecated: false,
      address: "0xE3dB9aD5A3c6387beCe39fAfc26Dbb2b594fb7ff",
      id: 52,
      originalId: 16
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Arbitrum One",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0xeeAE2132f2e21f68D862c535D7d9857803FBcF3f",
      id: 53,
      originalId: 17
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Arbitrum One",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 42161,
      deprecated: true,
      address: "0xA8d058ed41B216175400E8B2CC8cD55853596462",
      id: 54,
      originalId: 18
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Arbitrum One)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0x4994b8bb0b58708Cc6A66079d22db35c95650B4b",
      id: 55,
      originalId: 19
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Optimism",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 10,
      deprecated: false,
      address: "0xf072f11Bf151038BD8732cd1088b7C98762b839C",
      id: 56,
      originalId: 20
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Optimism)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 10,
      deprecated: false,
      address: "0x983e6839e84004E78FBfE76431D879cf9cF2f084",
      id: 57,
      originalId: 21
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Arbitrum Nova",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 42170,
      deprecated: false,
      address: "0x9d152fcb9692B5b2d31b81a4A5F86Aa1BaB42677",
      id: 58,
      originalId: 22
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Arbitrum Nova)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 42170,
      deprecated: false,
      address: "0xe0B51250bE54fEaF51BDdfAE0828D29BDc7fE87C",
      id: 59,
      originalId: 23
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Polygon zkEVM",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1101,
      deprecated: false,
      address: "0xa5CA3277041Bf6e8D6eEC2740010B7C6d10E4012",
      id: 60,
      originalId: 24
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Polygon zkEVM)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1101,
      deprecated: false,
      address: "0x52B50A6f8564B4895C7EdC9AD3B232bBA0108bA6",
      id: 61,
      originalId: 25
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Linea)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 59144,
      deprecated: false,
      address: "0x6ca6FCbD2fe65F0CB7671f5F0638867fdC991462",
      id: 62,
      originalId: 26
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Linea",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 59144,
      deprecated: false,
      address: "0xD2f5B8525758857aF3553142F59e2b35CbFa0aBE",
      id: 63,
      originalId: 27
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Mantle",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 5e3,
      deprecated: false,
      address: "0x85EC8DA79Bd2e54724ab8aa4a7a209B1f66D6eC0",
      id: 64,
      originalId: 28
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Mantle)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 5e3,
      deprecated: false,
      address: "0xA6e6c78746F873dB8545B7571DD1C5d87cC95763",
      id: 65,
      originalId: 29
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Base)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 8453,
      deprecated: false,
      address: "0x8eFFD39D090C756Db49A8154Db7BD05f59A62193",
      id: 66,
      originalId: 30
    },
    {
      decimals: 6,
      symbol: "sUSDbC",
      name: "Synthetic USDbC From Base",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 8453,
      deprecated: false,
      address: "0xDD1a897f92c14cDA3aB7023b094615A7068d01fA",
      id: 67,
      originalId: 31
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "Synthetic USDT From Tron",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 728126428,
      deprecated: false,
      address: "0x2dF311E049a839E1011507ccE20Afb6f871a81a1",
      id: 68,
      originalId: 32
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Scroll)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 534352,
      deprecated: false,
      address: "0xC66d177BDa9ef1d9278948FcD86C2C4420ca708C",
      id: 69,
      originalId: 33
    }
  ],
  thresholds: [
    { tokenId: 0, type: "Portal", value: "8000000" },
    { tokenId: 1, type: "Portal", value: "0" },
    { tokenId: 2, type: "Portal", value: "0" },
    { tokenId: 3, type: "Portal", value: "0" },
    { tokenId: 4, type: "Portal", value: "8000000000000000000" },
    { tokenId: 5, type: "Portal", value: "10000000000000000000" },
    { tokenId: 6, type: "Portal", value: "5000000000000000" },
    { tokenId: 34, type: "Portal", value: "0" },
    { tokenId: 4, type: "Synthesis", value: "0" },
    { tokenId: 5, type: "Synthesis", value: "0" },
    { tokenId: 6, type: "Synthesis", value: "0" },
    { tokenId: 34, type: "Synthesis", value: "0" },
    { tokenId: 7, type: "Portal", value: "8000000" },
    { tokenId: 8, type: "Portal", value: "10000000" },
    { tokenId: 9, type: "Portal", value: "8000000" },
    { tokenId: 10, type: "Portal", value: "5000000000000000" },
    { tokenId: 11, type: "Portal", value: "0" },
    { tokenId: 35, type: "Portal", value: "0" },
    { tokenId: 36, type: "Portal", value: "0" },
    { tokenId: 37, type: "Portal", value: "0" },
    { tokenId: 11, type: "Synthesis", value: "0" },
    { tokenId: 35, type: "Synthesis", value: "0" },
    { tokenId: 36, type: "Synthesis", value: "0" },
    { tokenId: 37, type: "Synthesis", value: "0" },
    { tokenId: 12, type: "Portal", value: "10000000" },
    { tokenId: 13, type: "Portal", value: "8000000" },
    { tokenId: 14, type: "Synthesis", value: "0" },
    { tokenId: 38, type: "Synthesis", value: "0" },
    { tokenId: 39, type: "Synthesis", value: "0" },
    { tokenId: 40, type: "Synthesis", value: "0" },
    { tokenId: 41, type: "Synthesis", value: "0" },
    { tokenId: 42, type: "Synthesis", value: "0" },
    { tokenId: 43, type: "Synthesis", value: "0" },
    { tokenId: 44, type: "Synthesis", value: "0" },
    { tokenId: 45, type: "Synthesis", value: "0" },
    { tokenId: 46, type: "Synthesis", value: "0" },
    { tokenId: 47, type: "Synthesis", value: "0" },
    { tokenId: 48, type: "Synthesis", value: "0" },
    { tokenId: 49, type: "Synthesis", value: "0" },
    { tokenId: 50, type: "Synthesis", value: "0" },
    { tokenId: 51, type: "Synthesis", value: "0" },
    { tokenId: 52, type: "Synthesis", value: "0" },
    { tokenId: 53, type: "Synthesis", value: "0" },
    { tokenId: 54, type: "Synthesis", value: "0" },
    { tokenId: 55, type: "Synthesis", value: "0" },
    { tokenId: 56, type: "Synthesis", value: "0" },
    { tokenId: 57, type: "Synthesis", value: "0" },
    { tokenId: 58, type: "Synthesis", value: "0" },
    { tokenId: 59, type: "Synthesis", value: "0" },
    { tokenId: 60, type: "Synthesis", value: "0" },
    { tokenId: 61, type: "Synthesis", value: "0" },
    { tokenId: 62, type: "Synthesis", value: "0" },
    { tokenId: 63, type: "Synthesis", value: "0" },
    { tokenId: 64, type: "Synthesis", value: "0" },
    { tokenId: 65, type: "Synthesis", value: "0" },
    { tokenId: 66, type: "Synthesis", value: "0" },
    { tokenId: 67, type: "Synthesis", value: "0" },
    { tokenId: 68, type: "Synthesis", value: "0" },
    { tokenId: 69, type: "Synthesis", value: "0" },
    { tokenId: 15, type: "Portal", value: "10000000" },
    { tokenId: 16, type: "Portal", value: "5000000000000000" },
    { tokenId: 17, type: "Portal", value: "10000000" },
    { tokenId: 18, type: "Portal", value: "10000000" },
    { tokenId: 19, type: "Portal", value: "5000000000000000" },
    { tokenId: 20, type: "Portal", value: "10000000" },
    { tokenId: 21, type: "Portal", value: "5000000000000000" },
    { tokenId: 22, type: "Portal", value: "10000000" },
    { tokenId: 23, type: "Portal", value: "5000000000000000" },
    { tokenId: 24, type: "Portal", value: "10000000" },
    { tokenId: 25, type: "Portal", value: "5000000000000000" },
    { tokenId: 26, type: "Portal", value: "5000000000000000" },
    { tokenId: 27, type: "Portal", value: "10000000" },
    { tokenId: 28, type: "Portal", value: "10000000" },
    { tokenId: 29, type: "Portal", value: "5000000000000000" },
    { tokenId: 30, type: "Portal", value: "5000000000000000" },
    { tokenId: 31, type: "Portal", value: "10000000" },
    { tokenId: 32, type: "Portal", value: "8000000" },
    { tokenId: 33, type: "Portal", value: "5000000000000000" }
  ]
};

// src/crosschain/config/cache/testnet.json
var testnet_default = {
  omniPools: [
    {
      chainId: 97,
      address: "0x569D2a232F5f2a462673fAf184ED9640e8A9F4D8",
      oracle: "0xcE29b84160fe8B6Fc1c6E5aD66F1F43279F2F1C9",
      id: 0,
      tokens: [
        { index: 0, tokenId: 11 },
        { index: 1, tokenId: 14 },
        { index: 2, tokenId: 13 },
        { index: 5, tokenId: 2 },
        { index: 6, tokenId: 15 },
        { index: 7, tokenId: 20 },
        { index: 9, tokenId: 18 },
        { index: 10, tokenId: 19 }
      ]
    },
    {
      chainId: 97,
      address: "0xc44AF80948B8a20bb781277559457ce0F2893b8b",
      oracle: "0x69cE6CA199c5Ca995C954c15F925D68ee0810153",
      id: 1,
      tokens: [
        { index: 0, tokenId: 16 },
        { index: 1, tokenId: 12 },
        { index: 2, tokenId: 17 }
      ]
    }
  ],
  tokens: [
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 5,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x07865c6E87B9F70255377e024ace6630C1Eaa37F",
      id: 0
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 5,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
      id: 1
    },
    {
      decimals: 18,
      symbol: "BUSD",
      name: "Binance USD",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
      },
      deprecated: false,
      address: "0x9a01bf917477dD9F5D715D188618fc8B7350cd22",
      id: 2
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "USDT",
      chainId: 43113,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0x9a01bf917477dD9F5D715D188618fc8B7350cd22",
      id: 3
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "USDT",
      chainId: 80001,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0x9a01bf917477dD9F5D715D188618fc8B7350cd22",
      id: 4
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "Circle USD",
      chainId: 534353,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x67aE69Fd63b4fc8809ADc224A9b82Be976039509",
      id: 5
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 534353,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
      id: 6
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 534351,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x5300000000000000000000000000000000000004",
      id: 7
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether",
      chainId: 59140,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0xAED47A51AeFa6f95A388aDA3c459d94FF46fC4BB",
      id: 8
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether",
      chainId: 5001,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0xAED47A51AeFa6f95A388aDA3c459d94FF46fC4BB",
      id: 9
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "USDT",
      chainId: 2494104990,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0x42a1e39aefa49290f2b3f9ed688d7cecf86cd6e0",
      id: 10
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "sUSDC from Goerli",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 5,
      deprecated: false,
      address: "0x32Ac07C5D3D6002B853836a48EE8538C9CF29ad4",
      id: 11,
      originalId: 0
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "sWETH from Goerli",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 5,
      deprecated: false,
      address: "0x70470021F81e30497F86962e889BC732CA70aeE1",
      id: 12,
      originalId: 1
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "sUSDT from Fuji",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 43113,
      deprecated: false,
      address: "0x9505A4F9108aE474c8fAeC17a22e68566c6C12C8",
      id: 13,
      originalId: 3
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "sUSDT from Mumbai",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 80001,
      deprecated: false,
      address: "0xA4bd5C28114341c53e347b17b67d551AFd455516",
      id: 14,
      originalId: 4
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "sUSDC from Scroll Testnet",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 534353,
      deprecated: false,
      address: "0xe586751BAED5b49Ba521e8169051b11A85b79007",
      id: 15,
      originalId: 5
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "sWETH from Scroll",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 534353,
      deprecated: false,
      address: "0xabbEf7E6d201e03368DBA03BD7D87B350915f6EE",
      id: 16,
      originalId: 6
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "sWETH from Scroll Sepolia",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 534351,
      deprecated: false,
      address: "0x20A121bdFaa7657e94c06B77c7f3EB0AFf9751ab",
      id: 17,
      originalId: 7
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "sUSDT from Linea Testnet",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 59140,
      deprecated: false,
      address: "0x0f6aAc42997Df922C1b7ae12D0b7c873dbC97fE3",
      id: 18,
      originalId: 8
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "sUSDT from Mantle Testnet",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 5001,
      deprecated: false,
      address: "0x5165BdcF32eCFC6de38B69C0b366ad317bc44f91",
      id: 19,
      originalId: 9
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "sUSDT from Shasta (Tron)",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 2494104990,
      deprecated: false,
      address: "0x519663f7B0a8d4eb9cbA0A8dEBB70e26159539AF",
      id: 20,
      originalId: 10
    }
  ],
  thresholds: [
    { tokenId: 0, type: "Portal", value: "0" },
    { tokenId: 1, type: "Portal", value: "0" },
    { tokenId: 2, type: "Synthesis", value: "0" },
    { tokenId: 11, type: "Synthesis", value: "0" },
    { tokenId: 12, type: "Synthesis", value: "0" },
    { tokenId: 13, type: "Synthesis", value: "0" },
    { tokenId: 14, type: "Synthesis", value: "0" },
    { tokenId: 15, type: "Synthesis", value: "0" },
    { tokenId: 16, type: "Synthesis", value: "0" },
    { tokenId: 17, type: "Synthesis", value: "0" },
    { tokenId: 18, type: "Synthesis", value: "0" },
    { tokenId: 19, type: "Synthesis", value: "0" },
    { tokenId: 20, type: "Synthesis", value: "0" },
    { tokenId: 3, type: "Portal", value: "0" },
    { tokenId: 4, type: "Portal", value: "0" },
    { tokenId: 5, type: "Portal", value: "0" },
    { tokenId: 6, type: "Portal", value: "0" },
    { tokenId: 7, type: "Portal", value: "0" },
    { tokenId: 8, type: "Portal", value: "0" },
    { tokenId: 9, type: "Portal", value: "0" },
    { tokenId: 10, type: "Portal", value: "0" }
  ]
};

// src/crosschain/config/cache/dev.json
var dev_default = {
  omniPools: [
    {
      chainId: 97,
      address: "0x789001A80a8EdBBEE07876b0dF58c3eAdEE89877",
      oracle: "0x2cD94CB0F4cBC4a51c3e9c4b88d03B982bE24608",
      id: 0,
      tokens: [
        { index: 2, tokenId: 3 },
        { index: 3, tokenId: 2 }
      ]
    }
  ],
  tokens: [
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 5,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
      id: 0
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 534353,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
      id: 1
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Wrapped Ether from Goerli",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 5,
      deprecated: false,
      address: "0xb1c5691B3Cb5e1B673Ef9Aa2599740a1cC76F928",
      id: 2,
      originalId: 0
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Wrapped Ether from Scroll Testnet",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 534353,
      deprecated: false,
      address: "0x3624b5e063405e7724cBbC24f504eA3da3e08b81",
      id: 3,
      originalId: 1
    }
  ],
  thresholds: [
    { tokenId: 0, type: "Portal", value: "0" },
    { tokenId: 2, type: "Synthesis", value: "0" },
    { tokenId: 3, type: "Synthesis", value: "0" },
    { tokenId: 1, type: "Portal", value: "0" }
  ]
};

// src/crosschain/config/cache/bridge.json
var bridge_default = {
  omniPools: [
    {
      chainId: 56288,
      address: "0x566E412387AE3FaB8b5Aa3A77178B120BCfF5Af8",
      oracle: "0x851B43189de721dD94AbA767AAd9E6F6d6a95CCA",
      id: 0,
      tokens: [
        { index: 0, tokenId: 8 },
        { index: 1, tokenId: 10 },
        { index: 2, tokenId: 12 }
      ]
    },
    {
      chainId: 56288,
      address: "0xE7e68D336F90f98D22A479253eafA5f2424aCaD8",
      oracle: "0xDdD4F712F43e26eaDc10e88A0050552c196b0403",
      id: 1,
      tokens: [
        { index: 0, tokenId: 9 },
        { index: 1, tokenId: 11 },
        { index: 2, tokenId: 14 },
        { index: 3, tokenId: 15 },
        { index: 4, tokenId: 13 }
      ]
    }
  ],
  tokens: [
    {
      decimals: 18,
      symbol: "XDAO",
      name: "XDAO",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
      },
      deprecated: false,
      address: "0x71eebA415A523F5C952Cc2f06361D5443545Ad28",
      id: 0
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9",
      id: 1
    },
    {
      decimals: 18,
      symbol: "XDAO",
      name: "XDAO",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
      },
      deprecated: false,
      address: "0x71eebA415A523F5C952Cc2f06361D5443545Ad28",
      id: 2
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835",
      id: 3
    },
    {
      decimals: 18,
      symbol: "XDAO",
      name: "XDAO",
      chainId: 137,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
      },
      deprecated: false,
      address: "0x71eebA415A523F5C952Cc2f06361D5443545Ad28",
      id: 4
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0xdd9f72afED3631a6C85b5369D84875e6c42f1827",
      id: 5
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0x9E758B8a98a42d612b3D38B66a22074DC03D7370",
      id: 6
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 59144,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0x6EF95B6f3b0F39508e3E04054Be96D5eE39eDE0d",
      id: 7
    },
    {
      decimals: 18,
      symbol: "sXDAO",
      name: "Synthetic XDAO from Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x9D9D79E32fA6A7214Ad79702a36bD520c3c42915",
      id: 8,
      originalId: 0
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x36Bf038c530f151C430c77663bB0EE0Bd8B6EE02",
      id: 9,
      originalId: 1
    },
    {
      decimals: 18,
      symbol: "sXDAO",
      name: "Synthetic XDAO from BSC",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x263308d316F07815C077C017e9481994d0a0C6Fe",
      id: 10,
      originalId: 2
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Binance",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x787F2a2A883B59E756B707D3f6b8c503Dc064493",
      id: 11,
      originalId: 3
    },
    {
      decimals: 18,
      symbol: "sXDAO",
      name: "Synthetic XDAO from Polygon",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21760.png"
      },
      chainFromId: 137,
      deprecated: false,
      address: "0xeca9F12Ba3E5c2a822d1441C8FFD8C9A90659AF5",
      id: 12,
      originalId: 4
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from zkSync Era",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 324,
      deprecated: false,
      address: "0xe517857bEC19d1d534339bA32a43F15E33CE6b8d",
      id: 13,
      originalId: 5
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Arbitrum One",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0x2460F2c6533e4E191e2466CE07aC3b3C45703256",
      id: 14,
      originalId: 6
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Linea",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 59144,
      deprecated: false,
      address: "0x880b78dde4baCcdD5089aE1383AE9ca30ea7AA6D",
      id: 15,
      originalId: 7
    }
  ],
  thresholds: [
    { tokenId: 0, type: "Portal", value: "0" },
    { tokenId: 1, type: "Portal", value: "0" },
    { tokenId: 2, type: "Portal", value: "0" },
    { tokenId: 3, type: "Portal", value: "0" },
    { tokenId: 4, type: "Portal", value: "0" },
    { tokenId: 5, type: "Portal", value: "0" },
    { tokenId: 6, type: "Portal", value: "0" },
    { tokenId: 7, type: "Portal", value: "0" },
    { tokenId: 8, type: "Synthesis", value: "0" },
    { tokenId: 9, type: "Synthesis", value: "0" },
    { tokenId: 10, type: "Synthesis", value: "0" },
    { tokenId: 11, type: "Synthesis", value: "0" },
    { tokenId: 12, type: "Synthesis", value: "0" },
    { tokenId: 13, type: "Synthesis", value: "0" },
    { tokenId: 14, type: "Synthesis", value: "0" },
    { tokenId: 15, type: "Synthesis", value: "0" }
  ]
};

// src/crosschain/config/cache/cache.ts
import { BigNumber as BigNumber8 } from "ethers";
var ConfigCache = class {
  constructor(configName) {
    if (configName === "mainnet") {
      this.cache = mainnet_default;
    } else if (configName === "testnet") {
      this.cache = testnet_default;
    } else if (configName === "dev") {
      this.cache = dev_default;
    } else if (configName === "bridge") {
      this.cache = bridge_default;
    } else {
      throw new Error2("Unknown config name");
    }
  }
  tokens() {
    return this.cache.tokens.map((attributes) => {
      return new Token(attributes);
    });
  }
  getRepresentation(token, chainId) {
    if (token.isSynthetic) {
      const original = this.getOriginalToken(token);
      if (original?.chainId !== chainId) {
        return;
      }
      return original;
    }
    return this.getSynthTokens(token).find((i) => i.chainId === chainId);
  }
  getTokenThreshold(token) {
    const tokenInfo = this.getTokenInfoByToken(token);
    const type = token.isSynthetic ? "Synthesis" : "Portal";
    const threshold = this.cache.thresholds.find((i) => {
      return i.tokenId === tokenInfo.id && i.type === type;
    });
    if (!threshold) {
      throw new Error2(`There is no threshold for token ${token.address}`);
    }
    return BigNumber8.from(threshold.value);
  }
  getOmniPoolByConfig(omniPoolConfig) {
    return this.cache.omniPools.find((i) => {
      return i.address.toLowerCase() === omniPoolConfig.address.toLowerCase() && i.chainId === omniPoolConfig.chainId;
    });
  }
  getOmniPoolById(id) {
    return this.cache.omniPools.find((i) => i.id === id);
  }
  // FIXME
  // It works correctly if the `token` in ONLY ONE pool
  // If there are more than one pool then FIRST pool will be selected
  getOmniPoolByToken(token) {
    let synths;
    if (token.isSynthetic) {
      synths = [token];
    } else {
      synths = this.getSynthTokens(token);
    }
    const ids = synths.map((i) => {
      return this.getTokenInfoByToken(i).id;
    });
    return this.cache.omniPools.find((pool) => {
      return pool.tokens.find((i) => {
        return ids.includes(i.tokenId);
      });
    });
  }
  getOmniPoolTokenIndex(omniPoolConfig, token) {
    const omniPool = this.getOmniPoolByConfig(omniPoolConfig);
    if (!omniPool) {
      throw new Error2(`getOmniPoolIndex: cannot find omniPoolByConfig ${omniPoolConfig}`);
    }
    const tokenInfo = this.getTokenInfoByToken(token);
    const found = omniPool.tokens.find((pool) => {
      return pool.tokenId === tokenInfo.id;
    });
    if (found === void 0) {
      throw new Error2(
        `There is no token ${tokenInfo.address} in omniPool ${omniPool.address}`,
        5 /* NO_TRANSIT_TOKEN */
      );
    }
    return found.index;
  }
  getOmniPoolTokens(omniPoolConfig) {
    const pool = this.getOmniPoolByConfig(omniPoolConfig);
    if (!pool) {
      throw new Error2("Cannot find omniPool");
    }
    return pool.tokens.map((i) => {
      const tokenInfo = this.getTokenInfoById(i.tokenId);
      return new Token(tokenInfo);
    });
  }
  // PRIVATE
  getTokenInfoById(id) {
    const tokenInfo = this.cache.tokens.find((i) => i.id === id);
    if (!tokenInfo) {
      throw new Error2(`Can't get tokenInfo for id ${id}`);
    }
    return tokenInfo;
  }
  getTokenInfoByToken(token) {
    const found = this.cache.tokens.find((i) => {
      return i.address.toLowerCase() === token.address.toLowerCase() && i.chainId === token.chainId && i.chainFromId === token.chainFromId;
    });
    if (!found) {
      throw new Error2(`Can't get tokenInfo by token ${token.address} ${token.chainId}`);
    }
    return found;
  }
  getOriginalToken(token) {
    if (!token.isSynthetic) {
      return;
    }
    const tokenInfo = this.getTokenInfoByToken(token);
    if (tokenInfo.originalId === void 0) {
      return;
    }
    const original = this.getTokenInfoById(tokenInfo.originalId);
    return new Token(original);
  }
  getSynthTokens(token) {
    if (token.isSynthetic) {
      return [];
    }
    const wrapped = wrappedToken(token);
    const tokenInfo = this.getTokenInfoByToken(wrapped);
    return this.cache.tokens.filter((i) => {
      return i.originalId === tokenInfo.id;
    }).map((i) => {
      return new Token(i);
    });
  }
};

// src/crosschain/symbiosis.ts
var Symbiosis = class {
  constructor(config5, clientId, overrideConfig) {
    if (config5 === "mainnet") {
      this.config = config;
    } else if (config5 === "testnet") {
      this.config = config2;
    } else if (config5 === "dev") {
      this.config = config3;
    } else if (config5 === "bridge") {
      this.config = config4;
    } else {
      throw new Error2("Unknown config name");
    }
    if (overrideConfig) {
      this.config.chains = this.config.chains.map((chainConfig) => {
        const found = overrideConfig.chains.find((i) => i.id === chainConfig.id);
        if (found) {
          chainConfig.rpc = found.rpc;
        }
        return chainConfig;
      });
    }
    this.configCache = new ConfigCache(config5);
    this.clientId = utils33.formatBytes32String(clientId);
    this.providers = new Map(
      this.config.chains.map((chain) => {
        const rpc = isTronChainId(chain.id) ? `${chain.rpc}/jsonrpc` : chain.rpc;
        return [chain.id, new StaticJsonRpcProvider(rpc, chain.id)];
      })
    );
  }
  validateSwapAmounts(amount) {
    const { token } = amount;
    const wrapped = wrappedToken(token);
    const threshold = this.configCache.getTokenThreshold(wrapped);
    if (BigNumber9.from(amount.raw.toString()).lt(threshold)) {
      const formattedThreshold = utils33.formatUnits(threshold, token.decimals);
      throw new Error2(
        `The amount is too low: ${amount.toFixed(2)}. Min amount: ${formattedThreshold}`,
        2 /* AMOUNT_TOO_LOW */
      );
    }
  }
  chains() {
    const ids = this.config.chains.map((i) => i.id);
    return chains.filter((i) => ids.includes(i.id));
  }
  newBridging() {
    return new Bridging(this);
  }
  newSwapping(omniPoolConfig) {
    return new Swapping(this, omniPoolConfig);
  }
  bestPoolSwapping() {
    return new BestPoolSwapping(this);
  }
  newRevertPending(request) {
    return new RevertPending(this, request);
  }
  newZapping(omniPoolConfig) {
    return new Zapping(this, omniPoolConfig);
  }
  newZappingAave(omniPoolConfig) {
    return new ZappingAave(this, omniPoolConfig);
  }
  newZappingCream(omniPoolConfig) {
    return new ZappingCream(this, omniPoolConfig);
  }
  newZappingBeefy(omniPoolConfig) {
    return new ZappingBeefy(this, omniPoolConfig);
  }
  getProvider(chainId) {
    const provider = this.providers.get(chainId);
    if (!provider) {
      throw new Error2("No provider for given chainId");
    }
    return provider;
  }
  portal(chainId, signer) {
    const address = this.chainConfig(chainId).portal;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Portal__factory.connect(address, signerOrProvider);
  }
  synthesis(chainId, signer) {
    const address = this.chainConfig(chainId).synthesis;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Synthesis__factory.connect(address, signerOrProvider);
  }
  bridge(chainId, signer) {
    const address = this.chainConfig(chainId).bridge;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Bridge__factory.connect(address, signerOrProvider);
  }
  fabric(chainId, signer) {
    const address = this.chainConfig(chainId).fabric;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Fabric__factory.connect(address, signerOrProvider);
  }
  uniLikeRouter(chainId, signer) {
    const address = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return UniLikeRouter__factory.connect(address, signerOrProvider);
  }
  avaxRouter(chainId, signer) {
    const address = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return AvaxRouter__factory.connect(address, signerOrProvider);
  }
  adaRouter(chainId, signer) {
    const address = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return AdaRouter__factory.connect(address, signerOrProvider);
  }
  kavaRouter(chainId, signer) {
    const address = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return KavaRouter__factory.connect(address, signerOrProvider);
  }
  creamCErc20ByAddress(address, chainId, signer) {
    const signerOrProvider = signer || this.getProvider(chainId);
    return CreamCErc20__factory.connect(address, signerOrProvider);
  }
  benqiQiErc20ByAddress(address, chainId, signer) {
    const signerOrProvider = signer || this.getProvider(chainId);
    return BenqiQiErc20__factory.connect(address, signerOrProvider);
  }
  creamComptroller(chainId, signer) {
    const address = this.chainConfig(chainId).creamComptroller;
    const signerOrProvider = signer || this.getProvider(chainId);
    return CreamComptroller__factory.connect(address, signerOrProvider);
  }
  aavePool(chainId, signer) {
    const address = this.chainConfig(chainId).aavePool;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Aave__factory.connect(address, signerOrProvider);
  }
  multicallRouter(chainId, signer) {
    const address = this.chainConfig(chainId).multicallRouter;
    const signerOrProvider = signer || this.getProvider(chainId);
    return MulticallRouter__factory.connect(address, signerOrProvider);
  }
  metaRouter(chainId, signer) {
    const address = this.chainConfig(chainId).metaRouter;
    const signerOrProvider = signer || this.getProvider(chainId);
    return MetaRouter__factory.connect(address, signerOrProvider);
  }
  omniPool(config5, signer) {
    const { address, chainId } = config5;
    const signerOrProvider = signer || this.getProvider(chainId);
    return OmniPool__factory.connect(address, signerOrProvider);
  }
  omniPoolOracle(config5, signer) {
    const { oracle, chainId } = config5;
    const signerOrProvider = signer || this.getProvider(chainId);
    return OmniPoolOracle__factory.connect(oracle, signerOrProvider);
  }
  oneInchOracle(chainId, signer) {
    const address = ONE_INCH_ORACLE_MAP[chainId];
    if (!address) {
      throw new Error2(`Could not find oneInch off-chain oracle on chain ${chainId}`);
    }
    const signerOrProvider = signer || this.getProvider(chainId);
    return OneInchOracle__factory.connect(address, signerOrProvider);
  }
  beefyVault(address, chainId, signer) {
    const signerOrProvider = signer || this.getProvider(chainId);
    return BeefyVault__factory.connect(address, signerOrProvider);
  }
  syncSwapLaunchPool(address, chainId, signer) {
    const signerOrProvider = signer || this.getProvider(chainId);
    return SyncSwapLaunchPool__factory.connect(address, signerOrProvider);
  }
  getRepresentation(token, chainId) {
    return this.configCache.getRepresentation(token, chainId);
  }
  getOmniPoolTokenIndex(omniPoolConfig, token) {
    return this.configCache.getOmniPoolTokenIndex(omniPoolConfig, token);
  }
  async getBridgeFee({
    calldata,
    receiveSide,
    chainIdFrom,
    chainIdTo
  }) {
    const params = {
      chain_id_from: chainIdFrom,
      chain_id_to: chainIdTo,
      receive_side: receiveSide,
      call_data: calldata,
      client_id: utils33.parseBytes32String(this.clientId)
    };
    return fetch(`${this.config.advisor.url}/v1/swap/price`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    }).then(async (response) => {
      if (!response.ok) {
        return Promise.reject(new Error2(await response.text()));
      }
      return response.json();
    }).then(({ price }) => JSBI15.BigInt(price));
  }
  filterBlockOffset(chainId) {
    return this.chainConfig(chainId).filterBlockOffset;
  }
  async getFromBlockWithOffset(chainId) {
    const provider = this.getProvider(chainId);
    const blockNumber = await provider.getBlockNumber();
    const offset = this.filterBlockOffset(chainId);
    return Math.max(0, blockNumber - offset);
  }
  dexFee(chainId) {
    return this.chainConfig(chainId).dexFee;
  }
  chainConfig(chainId) {
    const config5 = this.config.chains.find((item) => {
      return item.id === chainId;
    });
    if (!config5)
      throw new Error2(`Could not config by given chainId: ${chainId}`);
    return config5;
  }
  // === stables ===
  tokens() {
    return this.configCache.tokens();
  }
  findToken(address, chainId, chainFromId) {
    return this.tokens().find((token) => {
      const condition = token.address.toLowerCase() === address.toLowerCase() && token.chainId === chainId;
      if (chainFromId === void 0)
        return condition;
      return condition && token.chainFromId === chainFromId;
    });
  }
  transitToken(chainId, omniPoolConfig) {
    const tokens = this.configCache.tokens().filter((token) => {
      return token.chainId === chainId;
    });
    if (tokens.length === 0) {
      throw new Error2(`Cannot find token for chain ${chainId}`);
    }
    const omniPool = this.configCache.getOmniPoolByConfig(omniPoolConfig);
    if (!omniPool) {
      throw new Error2(`Cannot find omniPool ${omniPool}`);
    }
    if (chainId === omniPoolConfig.chainId) {
      return tokens[0];
    }
    const transitToken = tokens.find((token) => {
      return this.getOmniPoolByToken(token)?.id === omniPool.id;
    });
    if (!transitToken) {
      throw new Error2(
        `Cannot find transitToken for chain ${chainId}. Pool: ${omniPool.id}`,
        5 /* NO_TRANSIT_TOKEN */
      );
    }
    return transitToken;
  }
  getOmniPoolByConfig(config5) {
    return this.configCache.getOmniPoolByConfig(config5);
  }
  getOmniPoolByToken(token) {
    return this.configCache.getOmniPoolByToken(token);
  }
  getOmniPoolTokens(omniPoolConfig) {
    return this.configCache.getOmniPoolTokens(omniPoolConfig);
  }
  tronWeb(chainId) {
    if (!isTronChainId(chainId)) {
      throw new Error2(`Chain ${chainId} is not Tron chain`);
    }
    const config5 = this.chainConfig(chainId);
    if (!config5) {
      throw new Error2(`Could not find Tron config for chain ${chainId}`);
    }
    return new TronWeb2({ fullHost: config5.rpc, eventNode: config5.rpc, solidityNode: config5.rpc });
  }
  async waitForComplete(chainId, txId) {
    return statelessWaitForComplete(this, chainId, txId);
  }
  async tronWaitForMined(chainId, txId) {
    let info;
    const tronWeb = this.tronWeb(chainId);
    const TRIES = 10;
    for (let i = 0; i < TRIES; i++) {
      const response = await getTransactionInfoById(tronWeb, txId);
      if (response) {
        info = response;
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 1e3));
    }
    if (!info) {
      throw new Error2("Transaction not found");
    }
    return info;
  }
  getRevertableAddress(chainId) {
    const address = this.config.revertableAddress[chainId];
    if (address) {
      return address;
    }
    return this.config.revertableAddress.default;
  }
};

// src/crosschain/getRepresentation.ts
import { AddressZero as AddressZero6 } from "@ethersproject/constants";
async function getRepresentation(symbiosis, token, chainId) {
  const fabricChainId = token.isSynthetic ? token.chainId : chainId;
  const fabric = symbiosis.fabric(fabricChainId);
  if (fabric.address === AddressZero6) {
    return void 0;
  }
  const wrapped = wrappedToken(token);
  let tokenAddress;
  if (isTronToken(wrapped)) {
    tokenAddress = tronAddressToEvm(wrapped.address);
  } else {
    tokenAddress = wrapped.address;
  }
  try {
    let representation;
    if (token.isSynthetic) {
      representation = await fabric.getRealRepresentation(tokenAddress);
    } else {
      representation = await fabric.getSyntRepresentation(tokenAddress, wrapped.chainId);
    }
    if (representation === AddressZero6) {
      return void 0;
    }
    return symbiosis.findToken(representation, chainId);
  } catch (e) {
    console.error(`Error while getting representation of ${token.address} in chain ${chainId}`, e);
    return void 0;
  }
}

// src/crosschain/zappingSyncSwapLaunchPool.ts
import JSBI16 from "jsbi";
var ZappingSyncSwapLaunchPool = class extends BaseSwapping {
  constructor({ address, chainId, symbiosis, token, omniPoolConfig }) {
    super(symbiosis, omniPoolConfig);
    this.chainId = chainId;
    this.address = address;
    this.tokenOut = token;
  }
  async exactIn({
    tokenAmountIn,
    from,
    to,
    slippage,
    deadline
  }) {
    this.multicallRouter = this.symbiosis.multicallRouter(this.chainId);
    this.userAddress = to;
    this.pool = SyncSwapLaunchPool__factory.connect(this.address, this.symbiosis.getProvider(this.chainId));
    return this.doExactIn({
      tokenAmountIn,
      tokenOut: wrappedToken(this.tokenOut),
      from,
      to,
      slippage,
      deadline
    });
  }
  tradeCTo() {
    return this.multicallRouter.address;
  }
  finalReceiveSide() {
    return this.multicallRouter.address;
  }
  finalCalldata() {
    return this.buildMulticall();
  }
  finalOffset() {
    return 36;
  }
  extraSwapTokens() {
    return [];
  }
  buildMulticall() {
    const callDatas = [];
    const receiveSides = [];
    const path = [];
    const offsets = [];
    let amount;
    let supplyToken;
    if (this.tradeC) {
      amount = this.tradeC.tokenAmountIn.raw.toString();
      supplyToken = this.tradeC.amountOut.token;
      callDatas.push(this.tradeC.callData);
      receiveSides.push(this.tradeC.routerAddress);
      path.push(this.tradeC.tokenAmountIn.token.address);
      offsets.push(this.tradeC.callDataOffset);
    } else {
      if (this.transit.isV2()) {
        let rawAmount = this.transit.amountOut.raw;
        if (this.feeV2) {
          rawAmount = JSBI16.subtract(rawAmount, this.feeV2.raw);
        }
        amount = rawAmount.toString();
        supplyToken = this.tokenOut;
      } else {
        amount = this.transit.amountOut.raw.toString();
        supplyToken = this.transit.amountOut.token;
      }
    }
    const supplyCalldata = this.pool.interface.encodeFunctionData("contribute", [
      "0",
      // will be patched
      this.to
    ]);
    callDatas.push(supplyCalldata);
    receiveSides.push(this.pool.address);
    path.push(supplyToken.address);
    offsets.push(36);
    return this.multicallRouter.interface.encodeFunctionData("multicall", [
      amount,
      callDatas,
      receiveSides,
      path,
      offsets,
      this.userAddress
    ]);
  }
};
export {
  BASES_TO_CHECK_TRADES_AGAINST,
  BIPS_BASE,
  BestPoolSwapping,
  Bridging,
  CHAINS_PRIORITY,
  CUSTOM_BASES,
  Chain,
  ChainId,
  DEFAULT_EXCEED_DELAY,
  DEX_TOKENS_TO_CHECK_TRADES_AGAINST,
  DataProvider,
  Error2 as Error,
  ErrorCode,
  FACTORY_ADDRESS,
  Fetcher,
  Field,
  Fraction,
  GAS_TOKEN,
  GetLogTimeoutExceededError,
  INIT_CODE_HASH,
  InsufficientInputAmountError,
  InsufficientReservesError,
  IzumiTrade,
  JSBI17 as JSBI,
  MINIMUM_LIQUIDITY,
  MULTICALL_ADDRESSES,
  NoMulticallAddressError,
  ONE_BIPS,
  ONE_INCH_CHAINS,
  ONE_INCH_ORACLE_MAP,
  OmniLiquidity,
  Pair,
  PendingRequestState,
  Percent,
  Price,
  RevertPending,
  RevertRequest,
  Rounding,
  Route,
  Router,
  Symbiosis,
  TRON_PORTAL_ABI,
  TRON_TRC20_ABI,
  Token,
  TokenAmount,
  Trade,
  TradeType,
  TransactionStuckError,
  WETH,
  WETH_ONLY,
  WaitForComplete,
  ZERO,
  Zapping,
  ZappingSyncSwapLaunchPool,
  basisPointsToPercent,
  calculateGasMargin,
  calculatePriceImpact,
  canOneInch,
  chains,
  computeSlippageAdjustedAmounts,
  computeTradePriceBreakdown,
  findSourceChainData,
  getAllPairCombinations,
  getChainById,
  getExternalId,
  getInternalId,
  getLogWithTimeout,
  getMinAmount,
  getMulticall,
  getRepresentation,
  getTradePriceImpact,
  inputOutputComparator,
  isSynthesizeV2,
  isTronChain,
  isTronChainId,
  isTronToken,
  prepareTransactionRequest,
  prepareTronTransaction,
  splitSlippage,
  tokenEquals,
  tradeComparator,
  tronAddressToEvm,
  wrappedAmount,
  wrappedToken
};
//# sourceMappingURL=index.esm.js.map